(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _detectElementResize = require('../modules/detectElementResize');

var _uPopup2 = require('../modules/uPopup');

var _regAuth = require('../modules/regAuth');

var _ready = require('../modules/ready');

var _ready2 = _interopRequireDefault(_ready);

var _scriptonload = require('../modules/scriptonload');

var _Thetop = require('../modules/Thetop');

var _chooseCity2 = require('../modules/chooseCity');

var _ChooseCitySwitch2 = require('../modules/ChooseCitySwitch');

var _svg = require('../modules/svg');

var _svg2 = _interopRequireDefault(_svg);

var _Fav2 = require('../modules/Fav');

var _Fav3 = _interopRequireDefault(_Fav2);

var _Watch2 = require('../modules/Watch');

var _Watch3 = _interopRequireDefault(_Watch2);

var _AboutFav = require('../modules/AboutFav');

var _AboutFav2 = _interopRequireDefault(_AboutFav);

var _Rating2 = require('../modules/Rating');

var _Rating3 = _interopRequireDefault(_Rating2);

var _Vote2 = require('../modules/Vote');

var _Vote3 = _interopRequireDefault(_Vote2);

var _OpeningUnit2 = require('../modules/OpeningUnit');

var _Player2 = require('../modules/Player');

var _CombinedPlayer2 = require('../modules/CombinedPlayer');

var _fullscreenGallery2 = require('../modules/fullscreenGallery');

var _NavMonth2 = require('../modules/NavMonth');

var _TheaterMap2 = require('../modules/TheaterMap');

var _ClubMap2 = require('../modules/ClubMap');

var _rightContent2 = require('../modules/rightContent');

var _vk2 = require('../modules/vk');

var _yt2 = require('../modules/yt');

var _fb2 = require('../modules/fb');

var _YaShare2 = require('../modules/YaShare2');

var _Embeds2 = require('../modules/Embeds');

var _Embeds3 = _interopRequireDefault(_Embeds2);

var _Comments2 = require('../modules/Comments');

var _Avatar2 = require('../modules/Avatar');

var _AjaxContent2 = require('../modules/AjaxContent');

var _MovieList3 = require('../modules/MovieList');

var _MovieList4 = require('../modules/MovieList2');

var _popupFormSimple2 = require('../modules/popupFormSimple');

var _SubContent2 = require('../modules/SubContent');

var _showSubContent2 = require('../modules/showSubContent');

var _SearchCity2 = require('../modules/SearchCity');

var _Tabs2 = require('../modules/Tabs');

var _scheme2 = require('../modules/scheme');

var _QuizForm2 = require('../modules/QuizForm');

var _More2 = require('../modules/More');

var _More3 = _interopRequireDefault(_More2);

var _AllAjax2 = require('../modules/AllAjax');

var _banners2 = require('../modules/banners');

var _ads2 = require('../modules/ads');

var _MyWidgetFilms2 = require('../modules/MyWidgetFilms');

var _mainLogo2 = require('../modules/mainLogo');

var _notificationPopup2 = require('../modules/notificationPopup');

var _disableHover2 = require('../modules/disableHover');

var _clipboardData2 = require('../modules/clipboardData');

var _SearchMain2 = require('../modules/SearchMain');

var _Accordion2 = require('../modules/Accordion');

var _Title2 = require('../modules/Title');

var _ToBuy2 = require('../modules/ToBuy');

var _cat2 = require('../modules/cat');

var _header2 = require('../modules/header');

var _CommentsForm2 = require('../modules/CommentsForm');

var _CommentsItem2 = require('../modules/CommentsItem');

var _PremiereReminder2 = require('../modules/PremiereReminder');

var _buyTicketsPopup2 = require('../modules/buyTicketsPopup');

var _Trailer2 = require('../modules/Trailer');

var _UPlayerWrapper = require('../modules/UPlayerWrapper');

var _RegAuthBtn2 = require('../modules/RegAuthBtn');

var _PageForm2 = require('../modules/PageForm');

var _ScrollSlider2 = require('../modules/ScrollSlider');

var _ScrollTo2 = require('../modules/ScrollTo');

var _ScrollSmooth2 = require('../modules/ScrollSmooth');

var _novelties2 = require('../modules/novelties');

var _bcontentForm2 = require('../modules/bcontentForm');

var _raskhlop2 = require('../modules/raskhlop');

var _cityMap2 = require('../modules/cityMap');

var _ReloadForm2 = require('../modules/ReloadForm');

var _filterRange2 = require('../modules/filterRange');

var _filterSchedule2 = require('../modules/filterSchedule');

var _nearFilter2 = require('../modules/nearFilter');

var _geography2 = require('../modules/geography');

var _onlinePlayer2 = require('../modules/onlinePlayer');

var _fixSelect2 = require('../modules/fixSelect');

var _VoteResults2 = require('../modules/VoteResults');

var _VoteResults3 = _interopRequireDefault(_VoteResults2);

var _dynamicIframe2 = require('../modules/dynamicIframe');

var _bbutton2 = require('../modules/bbutton');

var _codeInsert2 = require('../modules/codeInsert');

var _kinoafisha = require('../modules/kinoafisha2');

var _ratingBlock2 = require('../modules/ratingBlock');

var _reloadingIframe2 = require('../modules/reloadingIframe');

var _helpers = require('../modules/helpers');

var _showPopup2 = require('../modules/showPopup');

var _poll2 = require('../modules/poll');

var _thumbGallery2 = require('../modules/thumbGallery');

var _userAgent = require('../modules/userAgent');

var _dynamicPage2 = require('../modules/dynamicPage');

var _sticky2 = require('../modules/sticky');

var _show2 = require('../modules/show');

var _pageBtn2 = require('../modules/pageBtn');

var _xhrForm2 = require('../modules/xhrForm');

var _clamp2 = require('../modules/clamp');

var _multiRange2 = require('../modules/multiRange');

var _SeriesGallery2 = require('../modules/SeriesGallery');

var _SeriesGallery3 = _interopRequireDefault(_SeriesGallery2);

var _seriesSwitch2 = require('../modules/seriesSwitch');

var _seriesSwitch3 = _interopRequireDefault(_seriesSwitch2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _detectElementResize.detectElementResizeFunc)();
(0, _uPopup2.uPopupFunc)(window, document);
var _fullscreenGallery = (0, _fullscreenGallery2.fullscreenGalleryFunc)(window, document); /* TODO */
(0, _kinoafisha.kinoafisha2)();

APP.objects = {
    /* comeToFavPopup: undefined*/
};

APP.vars.topPadding = 170;

APP.pages = {};

if (APP.vars.isDev) {
    APP.pagesParam = {
        'support': { 'ajax': '/_src/layouts/pageModule/support/' },
        'howFav': { 'ajax': '/_src/layouts/pageModule/howFav/' },
        'mistake': { 'ajax': '/_src/layouts/pageModule/descMistake/' },
        'newMail': { 'ajax': '' }, //TODO
        'changePwd': { 'ajax': '/_src/layouts/pageModule/changePwd/' },
        'subscribe': { 'ajax': '/_src/layouts/pageModule/subscribe/' },
        'marvell': { 'ajax': '/_src/layouts/pageModule/marvelldd/', "cls": "popup-middle popup-socialMarvell" },
        'allcafe': { 'ajax': '/_src/layouts/pageModule/allcafe/?cinema=[CINEMAID]' }
    };
} else {
    APP.pagesParam = {
        'support': { 'ajax': '/service/popup/feedback/' },
        'howFav': { 'ajax': '/service/popup/howfav/' },
        'mistake': { 'ajax': '/service/popup/mistake/' },
        'newMail': { 'ajax': '/service/popup/newmail/' },
        'changePwd': { 'ajax': '/service/popup/changepwd/' },
        'subscribe': { 'ajax': '/service/popup/subscribe/' },
        'allcafe': { 'ajax': '/service/popup/allcafe/?cinema=[CINEMAID]' }
    };
}

APP.helpers = (0, _helpers.helpers)();
APP.userAgent = (0, _userAgent.userAgent)();

APP.modules = {
    actions: {
        Player: function Player(el) {
            new _Player2.Player(el);
        },
        CombinedPlayer: function CombinedPlayer(el) {
            new _CombinedPlayer2.CombinedPlayer(el);
        },
        fullscreenGallery: function fullscreenGallery(el) {
            _fullscreenGallery(el);
        },
        NavMonth: function NavMonth(el) {
            new _NavMonth2.NavMonth(el);
        },
        TheaterMap: function TheaterMap(el) {
            var initMap = function initMap() {
                ymaps.ready(createMap);
            },
                createMap = function createMap() {
                new _TheaterMap2.TheaterMap(el);
            };
            (0, _scriptonload.scriptonload)(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], initMap);
        },
        ClubMap: function ClubMap(el) {
            var initMap = function initMap() {
                ymaps.ready(createMap);
            },
                createMap = function createMap() {
                new _ClubMap2.ClubMap(el);
            };
            (0, _scriptonload.scriptonload)(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], initMap);
        },
        rightContent: function rightContent(el) {
            (0, _rightContent2.rightContent)(el);
        },
        vk: function vk(el) {
            (0, _vk2.vk)(el);
        },
        yt: function yt(el) {
            (0, _yt2.yt)(el);
        },
        fb: function fb(el) {
            (0, _fb2.fb)(el);
        },
        showPopup: function showPopup(el) {
            (0, _showPopup2.showPopup)(el);
        },
        Avatar: function Avatar(el) {
            (0, _scriptonload.scriptonload)('//yandex.st/jquery/2.0.3/jquery.min.js', function () {
                (0, _scriptonload.scriptonload)('/static/js/vendors/jquery.Jcrop.min.js', function () {
                    new _Avatar2.Avatar(el);
                });
            });
        },
        AjaxContent: function AjaxContent(el) {
            new _AjaxContent2.AjaxContent(el);
        },
        uidatepicker: function uidatepicker(el) {
            var init = function init() {
                $.datepicker.regional['ru'] = {
                    closeText: 'Закрыть',
                    prevText: '&#x3c;Пред',
                    nextText: 'След&#x3e;',
                    currentText: 'Сегодня',
                    monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                    monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                    dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
                    dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
                    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                    dateFormat: 'yy-mm-dd',
                    firstDay: 1,
                    isRTL: false,
                    showOtherMonths: true,
                    selectOtherMonths: true,
                    changeMonth: true,
                    changeYear: true
                };
                $.datepicker.setDefaults($.datepicker.regional['ru']);
                $(el).datepicker({
                    yearRange: "-100:-5"
                });
            },
                checkUI = function checkUI() {
                (0, _scriptonload.scriptonload)('/static/js/vendors/jquery-ui.js', init);
            };

            if (!window.jQuery) (0, _scriptonload.scriptonload)('/static/js/vendors/jquery-1.12.0.min.js', checkUI);else checkUI();
        },
        MovieList: function MovieList(el) {
            new _MovieList3.MovieList(el);
        },
        MovieList2: function MovieList2(el) {
            new _MovieList4.MovieList2(el);
        },
        popupFormSimple: function popupFormSimple(el) {
            (0, _popupFormSimple2.popupFormSimple)(el);
        },
        SubContent: function SubContent(el) {
            if (!APP.objects.SubContent) APP.objects.SubContent = new _SubContent2.SubContent(el);
        },
        showSubContent: function showSubContent(el) {
            (0, _showSubContent2.showSubContent)(el);
        },
        Tabs: function Tabs(el) {
            new _Tabs2.Tabs(el);
        },
        scheme: function scheme(el) {
            (0, _scheme2.scheme)(el);
        },
        QuizForm: function QuizForm(el) {
            new _QuizForm2.QuizForm(el);
        },
        AllAjax: function AllAjax(el) {
            return new _AllAjax2.AllAjax(el);
        },
        MyWidgetFilms: function MyWidgetFilms(el) {
            new _MyWidgetFilms2.MyWidgetFilms(el);
        },
        mainLogo: function mainLogo(el) {
            (0, _mainLogo2.mainLogo)(el);
        },
        notificationPopup: function notificationPopup(el) {
            (0, _notificationPopup2.notificationPopup)(el);
        },
        disableHover: function disableHover(el) {
            (0, _disableHover2.disableHover)(el);
        },
        clipboardData: function clipboardData(el) {
            (0, _clipboardData2.clipboardData)(el);
        },
        SearchMain: function SearchMain(el) {
            new _SearchMain2.SearchMain(el);
        },
        Accordion: function Accordion(el) {
            new _Accordion2.Accordion(el);
        },
        Title: function Title(el) {
            new _Title2.Title(el);
        },
        PageForm: function PageForm(el) {
            new _PageForm2.PageForm(el);
        },
        uPopup: function (_uPopup) {
            function uPopup(_x) {
                return _uPopup.apply(this, arguments);
            }

            uPopup.toString = function () {
                return _uPopup.toString();
            };

            return uPopup;
        }(function (el) {
            var param = JSON.parse(el.getAttribute('data-param'));
            param.content = el;
            uPopup(param);
        }),
        ToBuy: function ToBuy(el) {
            new _ToBuy2.ToBuy(el);
        },
        cat: function cat(el) {
            (0, _cat2.cat)(el);
        },
        header: function header(el) {
            (0, _header2.header)(el);
        },
        PremiereReminder: function PremiereReminder(el) {
            new _PremiereReminder2.PremiereReminder(el);
        },
        buyTicketsPopup: function buyTicketsPopup(el) {
            new _buyTicketsPopup2.buyTicketsPopup(el);
        },
        Trailer: function Trailer(el) {
            new _Trailer2.Trailer(el);
        },
        ScrollSlider: function ScrollSlider(el) {
            return new _ScrollSlider2.ScrollSlider(el);
        },
        ScrollTo: function ScrollTo(el) {
            return new _ScrollTo2.ScrollTo(el);
        },
        novelties: function novelties(el) {
            (0, _novelties2.novelties)(el);
        },
        bcontentForm: function bcontentForm(el) {
            (0, _bcontentForm2.bcontentForm)(el);
        },
        raskhlop: function raskhlop(el) {
            (0, _raskhlop2.raskhlop)(el);
        },
        bcontent: function (_bcontent) {
            function bcontent(_x2) {
                return _bcontent.apply(this, arguments);
            }

            bcontent.toString = function () {
                return _bcontent.toString();
            };

            return bcontent;
        }(function (el) {
            var init = function init() {
                var bcontentObj = bcontent(el);
                /*document.getElementById('saveBtn').onclick = function(){
                    var html = bcontentObj.getHTML();
                    alert(html);
                }*/
            };

            (0, _scriptonload.scriptonload)(APP.vendors.bcontent, init);
        }),
        cityMap: function cityMap(el) {
            (0, _cityMap2.cityMap)(el, false);
        },
        browserDetect: function (_browserDetect) {
            function browserDetect(_x3) {
                return _browserDetect.apply(this, arguments);
            }

            browserDetect.toString = function () {
                return _browserDetect.toString();
            };

            return browserDetect;
        }(function (el) {
            browserDetect();
        }),
        nearFilter: function nearFilter(el) {
            return (0, _nearFilter2.nearFilter)(el);
        },
        ReloadForm: function ReloadForm(el) {
            return new _ReloadForm2.ReloadForm(el);
        },
        chooseCity: function chooseCity(el) {
            return (0, _chooseCity2.chooseCity)(el);
        },
        geography: function geography(el) {
            return (0, _geography2.geography)(el);
        },
        fixSelect: function fixSelect(el) {
            return (0, _fixSelect2.fixSelect)(el);
        },
        bbutton: function bbutton(el) {
            return (0, _bbutton2.bbutton)(el);
        },
        codeInsert: function codeInsert(el) {
            return (0, _codeInsert2.codeInsert)(el);
        },
        reloadingIframe: function reloadingIframe(el) {
            return (0, _reloadingIframe2.reloadingIframe)(el);
        },
        CommentsItem: function CommentsItem(el, data) {
            return new _CommentsItem2.CommentsItem(el, data);
        },
        CommentsForm: function CommentsForm(el, data) {
            return new _CommentsForm2.CommentsForm(el, data);
        },
        Comments: function Comments(el) {
            return new _Comments2.Comments(el);
        },
        Rating: function Rating(el, data) {
            return new _Rating3.default(el, data);
        },
        Fav: function Fav(el, data) {
            return new _Fav3.default(el, data);
        },
        Watch: function Watch(el, data) {
            return new _Watch3.default(el, data);
        },
        Vote: function Vote(el, data) {
            return new _Vote3.default(el, data);
        },
        YaShare2: function YaShare2(el, data) {
            return new _YaShare2.YaShare2(el, data);
        },
        uPlayer: function uPlayer(el, data) {
            return new _UPlayerWrapper.UPlayerWrapper(el, data);
        },
        More: function More(el, data) {
            return new _More3.default(el, data);
        },
        ScrollSmooth: function ScrollSmooth(el) {
            return new _ScrollSmooth2.ScrollSmooth(el);
        },
        filterRange: function filterRange(el, data) {
            return new _filterRange2.filterRange(el, data);
        },
        filterSchedule: function filterSchedule(el, data) {
            return new _filterSchedule2.filterSchedule(el, data);
        },
        ChooseCitySwitch: function ChooseCitySwitch(el) {
            return new _ChooseCitySwitch2.ChooseCitySwitch(el);
        },
        SearchCity: function SearchCity(el) {
            return new _SearchCity2.SearchCity(el);
        },
        onlinePlayer: function onlinePlayer(el) {
            return (0, _onlinePlayer2.onlinePlayer)(el);
        },
        VoteResults: function VoteResults(el) {
            return new _VoteResults3.default(el);
        },
        ratingBlock: function ratingBlock(el) {
            return (0, _ratingBlock2.ratingBlock)(el);
        },
        dynamicPage: function dynamicPage(el) {
            return (0, _dynamicPage2.dynamicPage)(el);
        },
        thumbGallery: function thumbGallery(el) {
            return (0, _thumbGallery2.thumbGallery)(el);
        },
        poll: function poll(el) {
            return (0, _poll2.poll)(el);
        },
        banners: function banners(el) {
            return (0, _banners2.banners)(el);
        },
        ads: function ads(el) {
            return (0, _ads2.ads)(el);
        },
        dynamicIframe: function dynamicIframe(el) {
            return (0, _dynamicIframe2.dynamicIframe)(el);
        },
        sticky: function sticky(el) {
            return (0, _sticky2.sticky)(el);
        },
        show: function show(el) {
            return (0, _show2.show)(el);
        },
        RegAuthBtn: function RegAuthBtn(el) {
            return new _RegAuthBtn2.RegAuthBtn(el);
        },
        pageBtn: function pageBtn(el) {
            return (0, _pageBtn2.pageBtn)(el);
        },
        xhrForm: function xhrForm(el) {
            return (0, _xhrForm2.xhrForm)(el);
        },
        Embeds: function Embeds(el) {
            return new _Embeds3.default(el);
        },
        SeriesGallery: function SeriesGallery(el) {
            return new _SeriesGallery3.default(el);
        },
        seriesSwitch: function seriesSwitch(el) {
            return new _seriesSwitch3.default(el);
        },
        OpeningUnit: function OpeningUnit(el) {
            return new _OpeningUnit2.OpeningUnit(el);
        },
        clamp: function clamp(el) {
            return (0, _clamp2.clamp)(el);
        },
        multiRange: function multiRange(el) {
            return (0, _multiRange2.multiRange)(el);
        }
    },
    run: function run(wrapper, attr, data) {
        var wrapper = wrapper || document,
            attr = attr || 'data-modules',
            elementAll = wrapper.querySelectorAll('[' + attr + ']'),
            moduleAll = {}; /* ключи - названия модулей, значения - сами модули */

        for (var i = 0, j = elementAll.length; i < j; i++) {
            var el = elementAll[i],
                nameAll = el.getAttribute(attr).split(' ');

            for (var m = 0, n = nameAll.length; m < n; m++) {
                var name = nameAll[m];

                if (!this.actions[name]) {
                    try {
                        console.error('модуль ' + name + ' не найден');
                    } catch (e) {};
                    continue;
                }

                if (!moduleAll[name]) moduleAll[name] = [];
                moduleAll[name].push(this.actions[name](el, data));
            }
        }
        return moduleAll;
    },
    destroy: function destroy(moduleAll) {
        for (var name in moduleAll) {
            var arr = moduleAll[name];
            for (var i = 0, j = arr.length; i < j; i++) {
                var module = arr[i];
                if (module && module.del) module.del();else if (module && module.destroy) module.destroy();
            }
        }
    }
};

APP.isLoading = true;

(0, _ready2.default)(function () {

    APP.header = document.getElementById('header');
    APP.headerHeight = APP.header ? APP.header.getBoundingClientRect().height : 0;

    if (APP.vars.isUserAuth !== 'notNeed' && !window.regAuthObj) window.regAuthObj = (0, _regAuth.regAuth)();else window.regAuthObj = false;

    if (regAuthObj && regAuthObj.isAuth && /#\!(reg|auth|recover|support)$/.test(window.location.hash)) {
        window.location.replace('https://www.kinoafisha.info/profile/settings/');
        return false;
    }

    APP.modules.run();

    //Блок об избранном, справа
    (function () {
        var item = document.querySelector('[data-aboutFav]');
        if (item && item.className.indexOf('js-active') != -1) new _AboutFav2.default(item);
    })();
});

(0, _svg2.default)(document, document.getElementsByTagName('use'), window.requestAnimationFrame || window.setTimeout, {}, /Trident\/[567]\b/.test(navigator.userAgent) || /Edge\/12/.test(navigator.userAgent) || (navigator.userAgent.match(/AppleWebKit\/(\d+)/) || [])[1] < 538);

},{"../modules/AboutFav":2,"../modules/Accordion":3,"../modules/AjaxContent":6,"../modules/AllAjax":7,"../modules/Avatar":8,"../modules/ChooseCitySwitch":9,"../modules/ClubMap":10,"../modules/CombinedPlayer":11,"../modules/Comments":12,"../modules/CommentsForm":13,"../modules/CommentsItem":14,"../modules/Embeds":16,"../modules/Fav":17,"../modules/More":22,"../modules/MovieList":23,"../modules/MovieList2":24,"../modules/MyWidgetFilms":25,"../modules/NavMonth":26,"../modules/OpeningUnit":27,"../modules/PageForm":28,"../modules/Player":29,"../modules/PremiereReminder":33,"../modules/QuizForm":34,"../modules/Rating":35,"../modules/RegAuthBtn":36,"../modules/ReloadForm":37,"../modules/ScrollSlider":38,"../modules/ScrollSmooth":39,"../modules/ScrollTo":40,"../modules/SearchCity":41,"../modules/SearchMain":42,"../modules/SeriesGallery":44,"../modules/SubContent":45,"../modules/Tabs":46,"../modules/TheaterMap":47,"../modules/Thetop":48,"../modules/Title":50,"../modules/ToBuy":51,"../modules/Trailer":52,"../modules/UPlayerWrapper":54,"../modules/Vote":55,"../modules/VoteResults":56,"../modules/Watch":57,"../modules/YaShare2":58,"../modules/ads":60,"../modules/banners":62,"../modules/bbutton":63,"../modules/bcontentForm":64,"../modules/buyTicketsPopup":65,"../modules/cat":66,"../modules/chooseCity":68,"../modules/cityMap":69,"../modules/clamp":70,"../modules/clipboardData":71,"../modules/codeInsert":72,"../modules/detectElementResize":75,"../modules/disableHover":76,"../modules/dynamicIframe":77,"../modules/dynamicPage":78,"../modules/fb":80,"../modules/filterRange":81,"../modules/filterSchedule":82,"../modules/fixSelect":83,"../modules/fullscreenGallery":84,"../modules/geography":85,"../modules/header":86,"../modules/helpers":87,"../modules/kinoafisha2":88,"../modules/mainLogo":89,"../modules/multiRange":90,"../modules/nearFilter":91,"../modules/notificationPopup":92,"../modules/novelties":93,"../modules/onlinePlayer":94,"../modules/pageBtn":96,"../modules/poll":97,"../modules/popupFormSimple":98,"../modules/raskhlop":99,"../modules/ratingBlock":100,"../modules/ready":101,"../modules/regAuth":102,"../modules/reloadingIframe":103,"../modules/rightContent":104,"../modules/scheme":105,"../modules/scriptonload":106,"../modules/seriesSwitch":107,"../modules/show":108,"../modules/showPopup":109,"../modules/showSubContent":110,"../modules/sticky":111,"../modules/svg":112,"../modules/thumbGallery":116,"../modules/uPopup":117,"../modules/userAgent":118,"../modules/vk":119,"../modules/xhrForm":120,"../modules/yt":121}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	function _class(container) {
		_classCallCheck(this, _class);

		this._createElements(container);
		this._addEvents();
	}

	_createClass(_class, [{
		key: '_createElements',
		value: function _createElements(container) {
			this.container = container;
			this.closeBtn = this.container.querySelector('[data-aboutFav-close]');
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;
			this.closeBtn.onclick = function () {
				self.container.className = self.container.className.replace(/\s*js-active/, '');
				return false;
			};
		}
	}]);

	return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Accordion = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _scriptonload = require('../modules/scriptonload');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Accordion = function () {
    function Accordion(wrapper) {
        _classCallCheck(this, Accordion);

        this._declare(wrapper);
        this._addEvents();
    }

    _createClass(Accordion, [{
        key: '_declare',
        value: function _declare(wrapper) {
            this.wrapper = wrapper;
            this.btnAll = wrapper.querySelectorAll('[data-Accordion-btn]');
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this,
                l = this.btnAll.length,
                i = 0;

            for (i; i < l; i++) {
                this.btnAll[i].onclick = function () {
                    self._toggleItem.call(self, this);
                    return false;
                };
            }
        }
    }, {
        key: '_toggleItem',
        value: function _toggleItem(btn) {
            var item = btn.parentElement,
                cls = item.className;

            if (cls.indexOf(' js-active') === -1) item.className = cls + ' js-active';else item.className = cls.replace(' js-active', '');
        }
    }]);

    return Accordion;
}();

exports.Accordion = Accordion;

},{"../modules/event":79,"../modules/scriptonload":106}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	function _class(wrapper) {
		_classCallCheck(this, _class);

		this._createElements(wrapper);
		this._addEventsName();
		this._addEvents();
	}

	_createClass(_class, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			this.wrapper = wrapper;
			this.video = this.wrapper.querySelector('[data-js="adv-video"]');
			this.clickingBtn = this.wrapper.querySelector('[data-js="adv-clicking-btn"]');
			this.skipBtn = this.wrapper.querySelector('[data-js="adv-skip-btn"]');
			this.advLeft = this.wrapper.querySelector('[data-js="adv-left"]');
			this.format = 'mp4';
			this.userAgent = this._defineUserAgent();
		}
	}, {
		key: '_defineUserAgent',
		value: function _defineUserAgent() {
			var agentAll = ['ipod', 'iphone', 'ipad', 'android', 'blackberry'],
			    i = 0;

			for (i; i < agentAll.length; i++) {
				var re = new RegExp(agentAll[i], 'i');
				if (re.test(navigator.userAgent)) return agentAll[i];
			}
			return false;
		}
	}, {
		key: '_addEventsName',
		value: function _addEventsName() {
			this.eNames = {};
			if (window.navigator.pointerEnabled) this.eNames = { 'down': 'pointerdown', 'move': 'pointermove', 'enter': 'pointerenter', 'leave': 'pointerleave', 'up': 'pointerup' };else if (window.navigator.msPointerEnabled) this.eNames = { 'down': 'MSPointerDown', 'move': 'MSPointerMove', 'enter': 'MSPointerEnter', 'leave': 'MSPointerLeave', 'up': 'MSPointerUp' };else if ('ontouchstart' in document.documentElement) {
				this.eNames = { 'down': 'touchstart', 'move': 'touchmove', 'enter': 'touchstart', 'leave': 'touchend', 'up': 'touchend' };
			} else this.eNames = { 'down': 'mousedown', 'move': 'mousemove', 'enter': 'mouseenter', 'leave': 'mouseleave', 'up': 'mouseup' };
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;

			this.video.onloadedmetadata = function (event) {
				self._updateTimeCur.call(self, 0);
				self._ready.call(self);
			};

			this.video.ontimeupdate = function () {
				self._updateTimeCur.call(self, this.currentTime);
			};

			this.video.onended = function () {
				self._end.call(self);
			};

			this.skipBtn.onclick = function () {
				self._skip.call(self);
				return false;
			};

			this.clickingBtn.onclick = function () {
				self._clicking.call(self);
			};
		}
	}, {
		key: '_skip',
		value: function _skip() {
			if (this.skipBtn.innerHTML !== 'Пропустить') return false;

			this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
			this.video.pause();
			this.afterSkip();
		}
	}, {
		key: '_clicking',
		value: function _clicking() {
			this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
			this.video.pause();
			this.afterClicking();
		}
	}, {
		key: '_end',
		value: function _end() {
			this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
			this.afterEnd(); //определяется в основном плеере
		}
	}, {
		key: '_reloadVideo',
		value: function _reloadVideo() {
			this.wrapper.className = 'advPlayer advPlayer-active  advPlayer-waiting';

			this.video.innerHTML = '';
			var source = document.createElement('SOURCE');
			source.setAttribute('src', this.wrapper.getAttribute('data-param') + '.' + this.format);
			source.setAttribute('type', 'video/' + this.format);
			this.video.appendChild(source);
			this.video.load();
		}
	}, {
		key: '_updateTimeCur',
		value: function _updateTimeCur(sec) {
			var leftTime = Math.floor(this.video.duration - sec),
			    text = leftTime ? 'Осталось ' + leftTime + 'сек' : '&nbsp;',
			    skipTime = Math.round(2 - sec);

			this.advLeft.innerHTML = text;

			if (skipTime > 0 && this.userAgent !== 'iphone') this.skipBtn.innerHTML = 'Пропустить через ' + skipTime; //В айфоне всегда можно закрыть
			else this.skipBtn.innerHTML = 'Пропустить';
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var self = this;

			//this.video.currentTime = 2;

			if (this.userAgent === 'iphone') {
				this.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active advPlayer-before';
				setTimeout(function () {
					self.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active';
					self.video.play();
				}, 1500);
			} else {
				this.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active';
				this.video.play();
			}
		}
	}, {
		key: 'initialize',
		value: function initialize() {
			this.video.innerHTML = '';
			this.video.load();
		}
	}, {
		key: 'show',
		value: function show() {
			var self = this;
			self._reloadVideo.call(self);
		}
	}]);

	return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	function _class(wrapper, insert) {
		_classCallCheck(this, _class);

		this._createElements(wrapper, insert);
		this._addEventsName();
		this._addEvents();
	}

	_createClass(_class, [{
		key: '_getHtml',
		value: function _getHtml() {
			var data = {};
			data.advVideo = 'http://video.kinoafisha.info/branding/kinoafisha/kinoafisha-youtube3';
			data.advLink = 'https://www.youtube.com/channel/UCNuQyDGBj28VwMRhCy_hTOw';

			return '<div data-js="adv-player" data-param="' + data.advVideo + '" class="advPlayer">' + '<video data-js="adv-video" class="advPlayer_video"></video>' + '<a data-js="adv-clicking-btn" class="advPlayer_link" target="_blank" href="' + data.advLink + '"></a>' + '<div class="advPlayer_controls">' + '<div class="advPlayer_controlsCell">' + '<span class="advPlayer_param">Реклама.</span> <span data-js="adv-left" class="advPlayer_param">&nbsp;</span>' + '</div>' + '<div class="advPlayer_controlsCell">' + '<a data-js="adv-skip-btn" class="advPlayer_param" href="#">&nbsp;</a>' + '</div>' + '</div>' + '<div class="advPlayer_before">' + '<div class="advPlayer_beforeContent">' + '<div class="advPlayer_beforeContentItem">Реклама</div>' + '</div>' + '</div>' + '<div class="advPlayer_preloader"></div>' + '</div>';
		}
	}, {
		key: '_createElements',
		value: function _createElements(wrapper, insert) {
			/* wrapper - общий контейнер, пока не используется */
			this.insert = insert;
			insert.innerHTML = this._getHtml();
			this.wrapper = insert.firstChild; /* wrapper - здесь - внутренний блок  */
			this.video = this.wrapper.querySelector('[data-js="adv-video"]');
			this.clickingBtn = this.wrapper.querySelector('[data-js="adv-clicking-btn"]');
			this.skipBtn = this.wrapper.querySelector('[data-js="adv-skip-btn"]');
			this.advLeft = this.wrapper.querySelector('[data-js="adv-left"]');
			this.format = 'mp4';
			this.userAgent = this._defineUserAgent();
		}
	}, {
		key: '_defineUserAgent',
		value: function _defineUserAgent() {
			var agentAll = ['ipod', 'iphone', 'ipad', 'android', 'blackberry'],
			    i = 0;

			for (i; i < agentAll.length; i++) {
				var re = new RegExp(agentAll[i], 'i');
				if (re.test(navigator.userAgent)) return agentAll[i];
			}
			return false;
		}
	}, {
		key: '_addEventsName',
		value: function _addEventsName() {
			this.eNames = {};
			if (window.navigator.pointerEnabled) this.eNames = { 'down': 'pointerdown', 'move': 'pointermove', 'enter': 'pointerenter', 'leave': 'pointerleave', 'up': 'pointerup' };else if (window.navigator.msPointerEnabled) this.eNames = { 'down': 'MSPointerDown', 'move': 'MSPointerMove', 'enter': 'MSPointerEnter', 'leave': 'MSPointerLeave', 'up': 'MSPointerUp' };else if ('ontouchstart' in document.documentElement) {
				this.eNames = { 'down': 'touchstart', 'move': 'touchmove', 'enter': 'touchstart', 'leave': 'touchend', 'up': 'touchend' };
			} else this.eNames = { 'down': 'mousedown', 'move': 'mousemove', 'enter': 'mouseenter', 'leave': 'mouseleave', 'up': 'mouseup' };
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;

			this.video.onloadedmetadata = function (event) {
				self._updateTimeCur.call(self, 0);
				self._ready.call(self);
			};

			this.video.ontimeupdate = function () {
				self._updateTimeCur.call(self, this.currentTime);
			};

			this.video.onended = function () {
				self._end.call(self);
			};

			this.skipBtn.onclick = function () {
				self._skip.call(self);
				return false;
			};

			this.clickingBtn.onclick = function () {
				self._clicking.call(self);
			};
		}
	}, {
		key: '_skip',
		value: function _skip() {
			if (this.skipBtn.innerHTML !== 'Пропустить') return false;

			this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
			this.video.pause();
			this.afterSkip();
		}
	}, {
		key: '_clicking',
		value: function _clicking() {
			this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
			this.video.pause();
			this.afterClicking();
		}
	}, {
		key: '_end',
		value: function _end() {
			this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
			this.afterEnd(); //определяется в основном плеере
		}
	}, {
		key: '_reloadVideo',
		value: function _reloadVideo() {
			this.wrapper.className = 'advPlayer advPlayer-active  advPlayer-waiting';

			this.video.innerHTML = '';
			var source = document.createElement('SOURCE');
			source.setAttribute('src', this.wrapper.getAttribute('data-param') + '.' + this.format);
			source.setAttribute('type', 'video/' + this.format);
			this.video.appendChild(source);
			this.video.load();
		}
	}, {
		key: '_updateTimeCur',
		value: function _updateTimeCur(sec) {
			var leftTime = Math.floor(this.video.duration - sec),
			    text = leftTime ? 'Осталось ' + leftTime + 'сек' : '&nbsp;',
			    skipTime = Math.round(2 - sec);

			this.advLeft.innerHTML = text;

			if (skipTime > 0 && this.userAgent !== 'iphone') this.skipBtn.innerHTML = 'Пропустить через ' + skipTime; //В айфоне всегда можно закрыть
			else this.skipBtn.innerHTML = 'Пропустить';
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var self = this;

			//this.video.currentTime = 2;

			if (this.userAgent === 'iphone') {
				this.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active advPlayer-before';
				setTimeout(function () {
					self.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active';
					self.video.play();
				}, 1500);
			} else {
				this.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active';
				this.video.play();
			}
		}
	}, {
		key: 'initialize',
		value: function initialize() {
			this.video.innerHTML = '';
			this.video.load();
		}
	}, {
		key: 'show',
		value: function show() {
			var self = this;
			self._reloadVideo.call(self);
		}
	}, {
		key: 'del',
		value: function del() {
			this.video.onloadedmetadata = function () {};
			this.video.innerHTML = '';
			this.video.setAttribute('src', '');
			this.insert.innerHTML = '';
		}
	}]);

	return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.AjaxContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

var _Fav2 = require('../modules/Fav');

var _Fav3 = _interopRequireDefault(_Fav2);

var _Rating2 = require('../modules/Rating');

var _Rating3 = _interopRequireDefault(_Rating2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* По кнопке "Дальше" подгружаем пункты меню
* */

var AjaxContent = function () {
	function AjaxContent(wrapper) {
		_classCallCheck(this, AjaxContent);

		this._createElements(wrapper);
		this._addEvents();
	}

	_createClass(AjaxContent, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			this.wrapper = wrapper;
			this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
			this.btn = document.querySelector('[data-AjaxContent-btn="' + this.param.type + '"]');
			this.isSending = false;
			this.ajaxPath = this._defineAjaxPath();
			this.ajaxData = this._getAjaxData();
			this.actions = {
				Rating: function Rating(el) {
					return new _Rating3.default(el);
				},
				Fav: function Fav(el) {
					return new _Fav3.default(el);
				}
			};
		}
	}, {
		key: '_defineAjaxPath',
		value: function _defineAjaxPath() {
			var part = (window.location + '').indexOf('/build/') === -1 ? '' : 'layouts',
			    ajaxPath = part + this.btn.getAttribute('href').split('?')[0];

			return ajaxPath;
		}
	}, {
		key: '_getAjaxData',
		value: function _getAjaxData() {
			var search = this.btn.getAttribute('href').split('?')[1].split('&'),
			    data = {};

			for (var i = 0, j = search.length; i < j; i++) {
				var item = search[i].split('=');
				data[item[0]] = item[1];
			}

			return data;
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;

			_event.event.add(this.btn, 'click', function (e) {
				e.preventDefault();

				if (self.isSending) return false;
				if (this.className.indexOf('js-delete') !== -1) return false;

				self.isSending = true;

				(0, _ajax.ajax)({
					data: self.ajaxData,
					url: self.ajaxPath,
					callback: function callback(msg) {
						self._checkMsg.call(self, msg);
					}
				});
			});
		}
	}, {
		key: '_checkMsg',
		value: function _checkMsg(msg) {
			var msg = JSON.parse(msg);

			if (!msg.moreFrom) {
				if (this.btn.className.indexOf('js-delete') === -1) this.btn.className = this.btn.className + ' js-delete';
				return false;
			}
			this.ajaxData.offset = msg.moreFrom;

			var container = document.createElement('div');
			container.innerHTML = msg.content;

			var subModulesAll = container.querySelectorAll('[data-modules]');
			for (var i = 0, j = subModulesAll.length; i < j; i++) {
				var nameAll = subModulesAll[i].getAttribute('data-modules').split(' ');
				for (var m = 0, n = nameAll.length; m < n; m++) {
					if (this.actions[nameAll[m]]) {
						this.actions[nameAll[m]](subModulesAll[i]);
					}
				}
			}

			while (container.firstChild) {
				this.wrapper.appendChild(container.firstChild);
			}

			this.isSending = false;
		}
	}]);

	return AjaxContent;
}();

;

exports.AjaxContent = AjaxContent;

},{"../modules/Fav":17,"../modules/Rating":35,"../modules/ajax":61,"../modules/event":79}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AllAjax = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ajax = require('../modules/ajax');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
*
*
* */

var AllAjax = function () {
    function AllAjax(wrapper) {
        _classCallCheck(this, AllAjax);

        this._createElements(wrapper);
        this._addEvents();
    }

    _createClass(AllAjax, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.wrapper = wrapper;
            this.param = JSON.parse(wrapper.getAttribute('data-param'));
            this.btn = this.wrapper.nextElementSibling.querySelector('[data-allAjax-btn="' + this.param.name + '"]');
            this.modules = APP.modules.run(this.wrapper, 'data-allAjax-modules');
            this.isSending = false;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            this.btn.onclick = function (e) {
                self._getContent.call(self, e);
            };
        }
    }, {
        key: '_getContent',
        value: function _getContent(e) {
            e.preventDefault();
            var self = this;

            if (this.isSending) return;
            this.isSending = true;

            (0, _ajax.ajax)({
                url: this.btn.href,
                callback: function callback(msg) {
                    self._addContent.call(self, msg);
                }
            });
        }
    }, {
        key: '_addContent',
        value: function _addContent(msg) {
            APP.modules.destroy(this.modules);
            this.wrapper.innerHTML = msg;
            this.modules = APP.modules.run(this.wrapper, 'data-allAjax-modules');
            this.btn.onclick = null;
            this.btn.style.display = 'none';
        }
    }, {
        key: 'del',
        value: function del() {
            APP.modules.destroy(this.modules);
            this.btn.onclick = null;
            for (var key in this) {
                delete this[key];
            }
        }
    }]);

    return AllAjax;
}();

;

exports.AllAjax = AllAjax;

},{"../modules/ajax":61}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Avatar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _scriptonload = require('../modules/scriptonload');

var _PopupForm = require('../modules/PopupForm');

var _Transform = require('../modules/Transform');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Avatar = function () {
    function Avatar(wrapper) {
        _classCallCheck(this, Avatar);

        this._createElements(wrapper);
        this._addEvents();
    }

    _createClass(Avatar, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;
            this.wrapper = wrapper;
            this.popupFormObj = new _PopupForm.PopupForm({
                wrapper: this.wrapper,
                onsuccess: function onsuccess(data) {
                    self._showLoadedPhoto.call(self, data);
                    return false;
                },
                onerror: function onerror(data) {
                    uPopup({
                        content: data.message,
                        onclose: function onclose() {
                            self.form.className = 'avatarChange';
                        }
                    });
                    return false;
                },
                beforeShowPopup: function beforeShowPopup() {
                    self.form.className = 'avatarChange';
                }
            });

            this.form = this.wrapper.querySelector('[data-Avatar-form]');

            this.curBox = this.form.querySelector('[data-Avatar-curBox]');
            this.avatarImage = this.curBox.querySelector('[data-Avatar-image]');
            this.file = this.curBox.querySelector('[data-Avatar-file]');

            this.loadedBox = this.form.querySelector('[data-Avatar-loadedBox]');
            this.transform = this.loadedBox.querySelector('[data-Avatar-transform]');
            this.loadingFrame = this.loadedBox.querySelector('[data-Avatar-loadingFrame]');
            this.transformObj = new _Transform.Transform(this.transform);
            this.readyBtn = this.loadedBox.querySelector('[data-Avatar-ready]');

            this.hiddens = {};
            this.hiddens.uploadedField = this.form.querySelector('[data-Avatar-uploadedField]');
            this.hiddens.areaField = this.form.querySelector('[data-Avatar-areaField]');
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            _event.event.add(this.file, 'change', function (e) {
                e.preventDefault();
                self.hiddens.uploadedField.setAttribute('value', '');
                self.form.className = 'avatarChange js-loading';
                self.form.submit();
            });

            _event.event.add(this.readyBtn, 'click', function (e) {
                e.preventDefault();
                self.transformObj.getArea();
                self.hiddens.areaField.setAttribute('value', JSON.stringify(self.transformObj.area));
                self.popupFormObj.initData.onsuccess = function (data) {
                    self._showNewAvatar.call(self, data);
                    return true;
                };
                self.form.submit();
                self.form.className = 'avatarChange js-loading';
            });
        }
    }, {
        key: '_resetAvatarChange',
        value: function _resetAvatarChange() {
            this.form.className = 'avatarChange';
        }
    }, {
        key: '_showLoadedPhoto',
        value: function _showLoadedPhoto(data) {
            var self = this,
                image = document.createElement('img'),
                path = (window.location + '').indexOf('/_src/') === -1 ? '' : '../img/tmp/avatar/',
                pathUploaded = (window.location + '').indexOf('/_src/') === -1 ? '' : '../',
                src = path + data.name;

            image.className = 'avatarChange_loadingPhoto';
            image.onload = function () {

                self.loadingFrame.innerHTML = '';
                self.loadingFrame.appendChild(image);

                self.hiddens.uploadedField.setAttribute('value', pathUploaded + src);

                self.transformObj.reset();

                self.form.className = 'avatarChange js-loaded';
            };
            image.setAttribute('src', src);
        }
    }, {
        key: '_showNewAvatar',
        value: function _showNewAvatar(data) {
            var self = this;
            var url = 'url(' + data.src + '?rnd=' + new Date().getTime() + ')';

            /*
             * TODO
             * всего одна кнопка вызова аватарки - это сама аватарка в ЛК
             * если когда нить доавится еще - нужно предусматривать этот момент
             * и заменять аватарку только в нужной кнопке
              *
              * */
            for (var i = 0, j = this.popupFormObj.btnAll.length; i < j; i++) {
                var btn = this.popupFormObj.btnAll[i];
                btn.style.backgroundImage = url;
                btn.innerHTML = ''; /* удаляем svg иконку, если не было аватарки */
            }

            this.avatarImage.style.backgroundImage = url;
            this.avatarImage.innerHTML = ''; /* удаляем svg иконку, если не было аватарки */
            this.hiddens.uploadedField.setAttribute('value', '');
            this.form.className = 'avatarChange';
            this.popupFormObj.initData.onsuccess = function (data) {
                self._showLoadedPhoto.call(self, data);
                return false;
            };
        }
    }]);

    return Avatar;
}();

exports.Avatar = Avatar;

},{"../modules/PopupForm":31,"../modules/Transform":53,"../modules/event":79,"../modules/scriptonload":106}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChooseCitySwitch = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _cityMap = require('../modules/cityMap');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChooseCitySwitch = function () {
    function ChooseCitySwitch(wrapper) {
        _classCallCheck(this, ChooseCitySwitch);

        this._createElements(wrapper);
        this._addEvents();
    }

    _createClass(ChooseCitySwitch, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.wrapper = wrapper;
            this.nav = wrapper.querySelector('[data-ChooseCitySwitch-nav]');
            this.btnAll = this.nav.querySelectorAll('[data-ChooseCitySwitch-btn]');
            /* TODO */
            this.line2 = document.querySelector('.contact_line2');
            this.chooseCity = this.line2.querySelector('.chooseCity');
            this.frame = this.chooseCity.querySelector('[data-js="frame"]');
        }

        /*
         * в любом случае при клике создаем карту, ибо всего два пункта меню
         * Если будет больше - надо будет создавать при клике на соотв пункт
         * */

    }, {
        key: '_createAdditionally',
        value: function _createAdditionally() {
            var self = parent = this,
                param = JSON.parse(this.wrapper.getAttribute('data-param')),
                l = this.btnAll.length,
                i = 0;

            //
            for (i; i < l; i++) {
                var name = this.btnAll[i].getAttribute('data-ChooseCitySwitch-btn');
                this.btnAll[i].frame = this.wrapper.querySelector('[data-ChooseCitySwitch-frame="' + name + '"]');

                if (name === 'map') {
                    var wrapper = this.btnAll[i].frame;

                    (0, _cityMap.cityMap)(wrapper, param, function (map) {
                        //console.log(map);
                    });
                }
            }
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this,
                l = this.btnAll.length,
                i = 0;

            for (i; i < l; i++) {
                this.btnAll[i].onclick = function () {
                    self._showItem.call(self, this);
                    return false;
                };
            }
        }
    }, {
        key: '_showItem',
        value: function _showItem(btn) {
            if (btn.className.indexOf('js-active') !== -1) return false;
            if (!btn.frame) this._createAdditionally();
            this._addActive(btn);
            this.line2.scrollTop = 0;
            this._changeHeight();
        }
    }, {
        key: '_addActive',
        value: function _addActive(btn) {
            var l = this.btnAll.length,
                i = 0;

            for (i; i < l; i++) {
                if (this.btnAll[i] === btn) {
                    this.btnAll[i].className = this.btnAll[i].className + ' js-active';
                    this.btnAll[i].frame.className = this.btnAll[i].frame.className + ' js-active';
                } else if (this.btnAll[i].className.indexOf('js-active') !== -1) {
                    this.btnAll[i].className = this.btnAll[i].className.replace(' js-active', '');
                    this.btnAll[i].frame.className = this.btnAll[i].frame.className.replace(' js-active', '');
                }
            }
        }
    }, {
        key: '_changeHeight',
        value: function _changeHeight() {
            var h = this.frame.getBoundingClientRect().height;
            this.chooseCity.style.height = h + 'px';
        }
    }]);

    return ChooseCitySwitch;
}();

exports.ChooseCitySwitch = ChooseCitySwitch;

},{"../modules/cityMap":69,"../modules/event":79}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClubMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Fav = require('../modules/Fav');

var _Fav2 = _interopRequireDefault(_Fav);

var _Rating = require('../modules/Rating');

var _Rating2 = _interopRequireDefault(_Rating);

var _event = require('../modules/event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClubMap = function () {
    function ClubMap(wrapper) {
        _classCallCheck(this, ClubMap);

        this._declare(wrapper);
        this._createMap();
        this._createPlacemarkAll();
        this._addEvents();
    }

    _createClass(ClubMap, [{
        key: '_declare',
        value: function _declare(wrapper) {
            this.wrapper = wrapper;
            this.data = JSON.parse(wrapper.getAttribute('data-param'));
            this.myMap;
            this.baseUrl = (window.location + '').indexOf('/build/') === -1 ? '/static/' : '';
            this.oPlacemarkAll = {};
        }
    }, {
        key: '_createMap',
        value: function _createMap() {
            this.myMap = new ymaps.Map(this.wrapper, {
                center: [this.data.lat, this.data.lon],
                zoom: this.data.zoom,
                controls: ["zoomControl"],
                behaviors: ['default', 'scrollZoom']
            }, {
                searchControlProvider: 'yandex#search'
            });
            this.myMap.behaviors.disable(['scrollZoom']);
        }
    }, {
        key: '_createPlacemarkAll',
        value: function _createPlacemarkAll() {
            var parent = this,
                placemarkAll = parent.data.placemarkAll,
                Placemark = function () {
                function Placemark(data) {
                    _classCallCheck(this, Placemark);

                    this.data = data;
                    this.isFav = this.data.isFav;
                    this.balloonLayout = this._createBalloonLayout();
                    this.balloonContentLayout = this._createBalloonContentLayout();
                    this.placemark = this._createPlacemark();
                }

                _createClass(Placemark, [{
                    key: '_getPlacemarkData',
                    value: function _getPlacemarkData() {
                        var placemarkData = {};
                        if (this.isFav) {
                            placemarkData.href = parent.baseUrl + 'img/symbols/map-icon-fav.png';
                            placemarkData.size = [45, 48];
                            placemarkData.imageOffset = [-17, -48];
                            placemarkData.balloonOffset = [-21, 19];
                        } else {
                            placemarkData.href = parent.baseUrl + 'img/symbols/map-icon.png';
                            placemarkData.size = [16, 16];
                            placemarkData.imageOffset = [-8, -8];
                            placemarkData.balloonOffset = [-21, 19];
                        }
                        return placemarkData;
                    }
                }, {
                    key: '_createBalloonLayout',
                    value: function _createBalloonLayout() {
                        var self = this,
                            MyBalloonLayout = ymaps.templateLayoutFactory.createClass('<div class="layer layer-reverse  balloon">' + '<a data-js="close" class="balloon_close" href="#">' + '<svg class="symbol symbol-x symbol-balloon" role="img"><use xlink:href="/static/img/symbols/sprite.svg#x"></use></svg>' + '</a>' + '<div class="balloon_wrapper">' + '$[[options.contentLayout observeSize maxWidth=380]]' + '</div>' + '</div>', {
                            build: function build() {
                                var selfParam = this;

                                this.constructor.superclass.build.call(this);

                                this._$element = $('.balloon', this.getParentElement());

                                var closeBtn = this._$element[0].querySelector('[data-js="close"]');
                                _event.event.add(closeBtn, 'click', function (e) {
                                    selfParam.onCloseClick.call(selfParam, e);
                                });

                                self._buildBalloonContent.call(self, this._$element.find('.balloon_inner')[0]);

                                this.applyElementOffset();
                            },
                            clear: function clear() {
                                this.constructor.superclass.clear.call(this);
                                if (self.favBalloon) self.favBalloon.del();
                                self.ratingBalloon.del();
                            },
                            onSublayoutSizeChange: function onSublayoutSizeChange() {
                                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                                if (!this._isElement(this._$element)) {
                                    return;
                                }

                                this.applyElementOffset();

                                this.events.fire('shapechange');
                            },
                            applyElementOffset: function applyElementOffset() {
                                this._$element.css({
                                    left: 0,
                                    top: -this._$element[0].offsetHeight - 40
                                });
                            },
                            onCloseClick: function onCloseClick(e) {
                                e.preventDefault();
                                this.events.fire('userclose');
                            },
                            getShape: function getShape() {
                                if (!this._isElement(this._$element)) {
                                    return MyBalloonLayout.superclass.getShape.call(this);
                                }

                                var position = this._$element.position();

                                return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([[position.left, position.top], [position.left + this._$element[0].offsetWidth, position.top + this._$element[0].offsetHeight]]));
                            },
                            _isElement: function _isElement(element) {
                                return element && element[0];
                            }
                        });
                        return MyBalloonLayout;
                    }
                }, {
                    key: '_buildBalloonContent',
                    value: function _buildBalloonContent(wrapper) {
                        wrapper.innerHTML = this._createBalloonHtml();

                        var box = wrapper.firstChild;

                        if (this.isFav !== undefined) this.favBalloon = this._addFav(box);
                        this.ratingBalloon = this._addRating(box);
                    }
                }, {
                    key: '_createBalloonContentLayout',
                    value: function _createBalloonContentLayout() {
                        var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass('<div class="balloon_inner">' + '$[properties.content]' + '</div>');
                        return MyBalloonContentLayout;
                    }
                }, {
                    key: '_createPlacemark',
                    value: function _createPlacemark() {
                        var data = this._getPlacemarkData(),
                            myPlacemark = new ymaps.Placemark([this.data.lat, this.data.lon], {}, {
                            iconLayout: 'default#image',
                            iconImageHref: data.href,
                            iconImageSize: data.size,
                            iconImageOffset: data.imageOffset,
                            balloonShadow: false,
                            balloonLayout: this.balloonLayout,
                            balloonContentLayout: this.balloonContentLayout,
                            balloonPanelMaxMapArea: 0,
                            hideIconOnBalloonOpen: true,
                            balloonOffset: data.balloonOffset
                        });

                        parent.myMap.geoObjects.add(myPlacemark);
                        return myPlacemark;
                    }
                }, {
                    key: '_createBalloonHtml',
                    value: function _createBalloonHtml() {
                        var self = this,
                            favClass = function () {
                            if (self.isFav === undefined) return '';
                            if (self.isFav === false) return 'fav fav-club';
                            return 'fav fav-club js-fav';
                        }(),
                            ratingClass = this.data.ratingAllow ? 'js-allowVote' : '',
                            ratingWidth = this.data.rating * 10,
                            balloonContent = '<div data-param=\'{"uid":"' + this.data.uid + '", "type":"' + this.data.type + '"}\' class="clubBalloon ' + favClass + '">' + '<a class="link link-default" href="' + this.data.link + '"><span class="link_border">' + this.data.name + '</span></a>' + '<div class="clubBalloon_desc color-desc">' + this.data.desc + '</div>' + '<div class="clubBalloon_footer">' + '<div class="clubBalloon_footer_cell">' + '<div data-js="rating-box" class="rating ' + ratingClass + ' rating-mini">' + '<span class="rating_vote">' + '<span data-js="stars" class="rating_stars" style="width:' + ratingWidth + '%;"></span >' + '<a data-star="1" class="rating_star rating_star-1" href="#"></a>' + '<a data-star="2" class="rating_star rating_star-2" href="#"></a>' + '<a data-star="3" class="rating_star rating_star-3" href="#"></a>' + '<a data-star="4" class="rating_star rating_star-4" href="#"></a>' + '<a data-star="5" class="rating_star rating_star-5" href="#"></a>' + '<a data-star="6" class="rating_star rating_star-6" href="#"></a>' + '<a data-star="7" class="rating_star rating_star-7" href="#"></a>' + '<a data-star="8" class="rating_star rating_star-8" href="#"></a>' + '<a data-star="9" class="rating_star rating_star-9" href="#"></a>' + '<a data-star="10" class="rating_star rating_star-10" href="#"></a>' + '</span>' + '</div>' + '</div>' + '<div class="clubBalloon_footer_cell">' + '<a data-js="fav-btn" class="fav_btn" href="#">' + '<svg class="fav_symbol symbol symbol-health" role="img"><use xlink:href="' + parent.baseUrl + 'img/symbols/sprite.svg#health"></use></svg>' + '</a> ' + '<a class="btn btn-active btn-view4 btn-view4-club" href="' + this.data.linkAfisha + '">Афиша</a>' + '</div>' + '</div>' + '</div>';
                        return balloonContent;
                    }
                }, {
                    key: '_addFav',
                    value: function _addFav(wrapper) {
                        var self = this,
                            obj = new _Fav2.default(wrapper),
                            data;

                        obj.onchange = function (isFav) {
                            if (self.isFav === isFav) return;
                            self.isFav = isFav;
                            self.changeView.call(self);
                        };
                        return obj;
                    }
                }, {
                    key: 'changeView',
                    value: function changeView() {
                        data = this._getPlacemarkData();
                        this.placemark.options.set('iconImageHref', data.href);
                        this.placemark.options.set('iconImageSize', data.size);
                        this.placemark.options.set('iconImageOffset', data.imageOffset);
                        this.placemark.options.set('balloonOffset', data.balloonOffset);
                    }
                }, {
                    key: '_addRating',
                    value: function _addRating(wrapper) {
                        var self = this,
                            obj = new _Rating2.default(wrapper),
                            data;

                        obj.onchange = function (rating) {
                            if (!self.data.ratingAllow) return;

                            self.data.ratingAllow = false;
                            self.data.rating = rating;
                            //self.theater.setAttribute('data-param', JSON.stringify(self.data));
                        };
                        return obj;
                    }
                }]);

                return Placemark;
            }();

            for (var i = 0, j = placemarkAll.length; i < j; i++) {
                var data = placemarkAll[i];
                this.oPlacemarkAll[data.uid] = new Placemark(data);
            }
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;
            document.addEventListener("cinemaChangeFav", function (event) {
                var placeMark = self.oPlacemarkAll[event.uid];
                if (placeMark && placeMark.isFav !== event.isFav) {
                    placeMark.isFav = event.isFav;
                    placeMark.changeView.call(placeMark);
                }
            }, false);
        }
    }]);

    return ClubMap;
}();

exports.ClubMap = ClubMap;

},{"../modules/Fav":17,"../modules/Rating":35,"../modules/event":79}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CombinedPlayer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _HTMLPlayer = require('../modules/HTMLPlayer2');

var _HTMLPlayer2 = _interopRequireDefault(_HTMLPlayer);

var _AdvPlayer = require('../modules/AdvPlayer2');

var _AdvPlayer2 = _interopRequireDefault(_AdvPlayer);

var _scriptonload = require('../modules/scriptonload');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CombinedPlayer = function () {
    function CombinedPlayer(wrapper) {
        _classCallCheck(this, CombinedPlayer);

        this._createElements(wrapper);
        this._getDataApi();
        this._addEvents();
    }

    _createClass(CombinedPlayer, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.wrapper = wrapper;
            this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.dataApi = undefined, this.btn = this.wrapper.querySelector('[data-CombinedPlayer-btn]');
            this.insert = this.wrapper.querySelector('[data-CombinedPlayer-insert]');
            this.isMobileAgent = this._defineUserAgent();
            this.advBreak = 12; //рекламу показываем каждые 12 часов
            this.isAdvCookie = this._defineAdvCookie();
            this.oAdvPlayer;
            this.oHTMLPlayer;
            this.oYoutubePlayer;
        }
    }, {
        key: '_defineUserAgent',
        value: function _defineUserAgent() {
            var agentAll = ['ipod', 'iphone', 'ipad', 'android', 'blackberry'],
                i = 0;

            for (i; i < agentAll.length; i++) {
                var re = new RegExp(agentAll[i], 'i');
                if (re.test(navigator.userAgent)) return agentAll[i];
            }
            return false;
        }
    }, {
        key: '_defineAdvCookie',
        value: function _defineAdvCookie() {
            var curTime = new Date().getTime();

            if (!localStorage || !localStorage.isKinoafishaVideoAdv || (curTime - parseFloat(localStorage.isKinoafishaVideoAdv)) / 1000 / 60 / 60 < this.advBreak) {
                localStorage.isKinoafishaVideoAdv = curTime;
                return false;
            }
            return true;
        }
    }, {
        key: '_getDataApi',
        value: function _getDataApi() {
            var self = this,
                path = window.location.hostname.indexOf('kinoafishaspb.ru') === -1 ? 'kinoafisha.info' : 'kinoafisha.info',
                _onSuccess = function _onSuccess(dataApi) {
                self.dataApi = dataApi;
            },
                _onerror = function _onerror() {};
            GLOBALS.scriptRequest('http://api.' + path + '/player/info/' + this.data.trailer_id + '/', function (dataApi) {
                _onSuccess(dataApi);
            }, function () {
                _onError();
            });
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            _event.event.add(this.btn, 'click', function (e) {
                e.preventDefault();

                if (self.isAdvCookie || self.isMobileAgent) {
                    /* на мобильниках реклама не будет показываться, нужно плееры загружать заранее */
                    if (self.data.youtube) self._createYoutubePlayer.call(self);else self._createHTMLPlayer.call(self);
                } else {
                    localStorage.isKinoafishaVideoAdv = 'ok';
                    self._createAdvPlayer.call(self);
                }

                if (self.wrapper.className.indexOf('js-active') === -1) self.wrapper.className = self.wrapper.className + ' js-active';
            });
        }
    }, {
        key: '_createYoutubePlayer',
        value: function _createYoutubePlayer() {
            var self = this,
                player,
                onPlayerReady = function onPlayerReady(event) {
                event.target.playVideo();
            },
                onPlayerStateChange = function onPlayerStateChange(event) {
                if (event.data === 0) del();
            },
                del = function del() {
                self.wrapper.className = self.wrapper.className.replace(' js-active', '');
                self.oYoutubePlayer.destroy();
                delete self.oYoutubePlayer;
                self.insert.innerHTML = '';
            },
                checkLoading = function checkLoading() {
                if (window.isYouTubeIframeAPIReady) addApi();else {
                    setTimeout(function () {
                        checkLoading();
                    }, 200);
                }
            },
                addApi = function addApi() {
                self.oYoutubePlayer = new YT.Player(self.insert.firstChild, {
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                });
            };

            this.insert.innerHTML = '<iframe id="qwe" class="combinedPlayer_youtube" src="' + this.data.youtube + '?enablejsapi=1" allowfullscreen="" frameborder="0"></iframe>';

            if (!window.onYouTubeIframeAPIReady) {
                window.onYouTubeIframeAPIReady = function () {
                    window.isYouTubeIframeAPIReady = true;
                };
                (0, _scriptonload.scriptonload)(['https://www.youtube.com/iframe_api']);
            }

            checkLoading();
        }
    }, {
        key: '_createAdvPlayer',
        value: function _createAdvPlayer() {
            var self = this;

            this.oAdvPlayer = new _AdvPlayer2.default(this.wrapper, this.insert);

            this.oAdvPlayer.afterEnd = function () {
                self.oAdvPlayer.del();
                delete self.oAdvPlayer;
                if (self.data.youtube) self._createYoutubePlayer.call(self);else self._createHTMLPlayer.call(self);
            };
            this.oAdvPlayer.afterSkip = function () {
                self.oAdvPlayer.del();
                delete self.oAdvPlayer;
                if (self.data.youtube) self._createYoutubePlayer.call(self);else self._createHTMLPlayer.call(self);
            };
            this.oAdvPlayer.afterClicking = function () {
                self.wrapper.className = self.wrapper.className.replace(' js-active', '');
                self.oAdvPlayer.del();
                delete self.oAdvPlayer;
            };

            this.oAdvPlayer.initialize();
            this.oAdvPlayer.show();
        }
    }, {
        key: '_createHTMLPlayer',
        value: function _createHTMLPlayer() {
            var self = this,
                checkDataApi = function checkDataApi() {
                if (self.dataApi) create();else {
                    setTimeout(function () {
                        checkDataApi();
                    }, 200);
                }
            },
                create = function create() {
                self.oHTMLPlayer = new _HTMLPlayer2.default(self.wrapper, self.insert, self.dataApi);
                self.oHTMLPlayer.afterEnd = function () {
                    self.wrapper.className = self.wrapper.className.replace(' js-active', '');
                    self.oHTMLPlayer.del();
                    delete self.oHTMLPlayer;
                };
            };

            //
            checkDataApi();
        }
    }, {
        key: 'del',
        value: function del() {
            if (this.oAdvPlayer) this.oAdvPlayer.del();
            if (this.oHTMLPlayer) this.oHTMLPlayer.del();
            if (this.oYoutubePlayer) this.oYoutubePlayer.del();
        }
    }]);

    return CombinedPlayer;
}();

exports.CombinedPlayer = CombinedPlayer;

},{"../modules/AdvPlayer2":5,"../modules/HTMLPlayer2":20,"../modules/event":79,"../modules/scriptonload":106}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Comments = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

var _Form = require('../modules/Form');

var _CommentsForm = require('../modules/CommentsForm');

var _CommentsItem = require('../modules/CommentsItem');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Comments = function () {
    function Comments(wrapper) {
        _classCallCheck(this, Comments);

        this._createElements(wrapper);
    }

    _createClass(Comments, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;
            this.wrapper = wrapper;
            this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.moduleAll = APP.modules.run(this.wrapper, 'data-comments-modules', this);
        }
    }, {
        key: 'addNewComment',
        value: function addNewComment(wrapper) {
            /*  */
            if (!this.moduleAll.CommentsItem) this.moduleAll.CommentsItem = [];

            var obj = new _CommentsItem.CommentsItem(wrapper, this);
            this.moduleAll.CommentsItem.push(obj);

            return obj;
        }
    }, {
        key: 'del',
        value: function del() {
            APP.modules.destroy(this.moduleAll);
        }
    }]);

    return Comments;
}();

exports.Comments = Comments;

},{"../modules/CommentsForm":13,"../modules/CommentsItem":14,"../modules/Form":18,"../modules/ajax":61,"../modules/event":79}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CommentsForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

var _Form = require('../modules/Form');

var _CommentsItem = require('../modules/CommentsItem');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* Не используется как отдельный модуль
* Отвечает за форму в комментариях
* */

var CommentsForm = function () {
    function CommentsForm(wrapper, CommentsObj) {
        _classCallCheck(this, CommentsForm);

        this._createElements(wrapper, CommentsObj);
        this._addEvents();
    }

    _createClass(CommentsForm, [{
        key: '_createElements',
        value: function _createElements(wrapper, CommentsObj) {
            var self = this;
            this.wrapper = wrapper;
            this.CommentsObj = CommentsObj;
            this.forForm = this.wrapper.querySelector('[data-CommentsForm-forForm]');
            this.formBox = this.wrapper.querySelector('[data-CommentsForm-formBox]');
            this.writeBtn = this.wrapper.querySelector('[data-CommentsForm-writeBtn]');
            this.smileBtn = this.wrapper.querySelector('[data-CommentsForm-smileBtn]');
            this.textarea = this.wrapper.querySelector('[data-CommentsForm-textarea]');
            this.smileBox = this.wrapper.querySelector('[data-CommentsForm-smileBox]');
            this.answerField = this.wrapper.querySelector('[data-CommentsForm-answerField]');
            this.emojiAll = this.smileBox.querySelectorAll('.emoji');
            this.successBox = this.wrapper.querySelector('[data-CommentsForm-susccess]');
            this.commentItemObj = false; /* если нажимаем на ответить в коменте, ответ нужно вставить сразу за ним и форму вниз */
            this.moduleAll = APP.modules.run(this.wrapper, 'data-commentsForm-modules');
            this.formObj = new _Form.Form({
                wrapper: this.formBox,
                onsuccess: function onsuccess(data) {
                    //location.replace(location.protocol + '//' + location.host + location.pathname);
                    var comment; /* блок с коментом */

                    self.formObj.resetCaptcha();
                    self.formObj.resetForm();

                    /* если это ответ */
                    /*if(self.commentItemObj){
                        self.commentItemObj.wrapper.insertAdjacentHTML("afterEnd", data.message);
                        comment = self.commentItemObj.wrapper.nextElementSibling;
                    } else {
                        self.wrapper.insertAdjacentHTML("beforeBegin", data.message);
                        comment = self.wrapper.previousElementSibling;
                    }*/

                    self.wrapper.insertAdjacentHTML("beforeBegin", data.message);
                    comment = self.wrapper.previousElementSibling;

                    var newComment = self.CommentsObj.addNewComment(comment);
                    newComment.forForm.appendChild(self.successBox);
                    var cls = self.successBox.className;
                    if (cls.indexOf(' js-disabled') !== -1) self.successBox.className = cls.replace(' js-disabled', '');

                    /* если это ответ */
                    if (self.commentItemObj) {
                        var offset = newComment.wrapper.getBoundingClientRect().top - self.commentItemObj.wrapper.getBoundingClientRect().bottom;
                        self._onClickWriteBtn.call(self, false);
                        window.scrollBy(0, offset);
                    }

                    // analyticts
                    self._sendStat();
                },
                onerror: function onerror(data) {
                    self.formObj.resetCaptcha();
                    uPopup({
                        content: data.message
                    });
                }
            });
        }
    }, {
        key: '_sendStat',
        value: function _sendStat() {
            try {
                gtag('event', 'send_form', {
                    'event_category': 'engagement',
                    'event_label': 'leave_comment'
                });
                console.log('gtag success!');
            } catch (error) {
                console.error('gtag error:', error);
            }
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            _event.event.add(this.smileBtn, 'click', function () {
                if (self.smileBox.className.indexOf('js-active') === -1) {
                    self.smileBox.className = self.smileBox.className + ' js-active';
                } else self.smileBox.className = self.smileBox.className.replace(/\s*js-active/, '');
            });

            _event.event.add(this.smileBox, 'scroll', function (e) {
                e.stopPropagation();
            });

            this.writeBtn.addEventListener('click', function (e) {
                self._onClickWriteBtn.call(self, e);
            }, false);

            for (var i = 0, j = this.emojiAll.length; i < j; i++) {
                _event.event.add(this.emojiAll[i], 'click', function () {
                    self.textarea.value = self.textarea.value + ' ' + this.firstChild.nodeValue + ' ';
                    self.textarea.focus();
                });
            }
        }
    }, {
        key: '_onClickWriteBtn',
        value: function _onClickWriteBtn(e) {
            /* если нет события - значит мы просто возвращаем форму на место после ответа */
            if (e) e.preventDefault();
            var cls = this.writeBtn.className;
            this.writeBtn.className = cls + ' js-disabled';
            this.answerField.value = '';
            this.forForm.appendChild(this.formBox);
            if (e) this.textarea.focus();
            this.commentItemObj = false;
        }
    }, {
        key: 'onClickAnswerBtn',
        value: function onClickAnswerBtn(commentItemObj) {
            var commentUid = commentItemObj.param.uid,
                wrapper = commentItemObj.forForm,
                writeBtnCls = this.writeBtn.className;

            //
            if (writeBtnCls.indexOf(' js-disabled') !== -1) this.writeBtn.className = writeBtnCls.replace(' js-disabled', '');

            this.answerField.value = commentUid;
            wrapper.appendChild(this.formBox);
            this.textarea.focus();

            this.commentItemObj = commentItemObj;
        }
    }, {
        key: 'del',
        value: function del() {
            this.formObj.del();
            APP.modules.destroy(this.moduleAll);
        }
    }]);

    return CommentsForm;
}();

exports.CommentsForm = CommentsForm;

},{"../modules/CommentsItem":14,"../modules/Form":18,"../modules/ajax":61,"../modules/event":79}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CommentsItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ajax = require('../modules/ajax');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommentsItem = function () {
    function CommentsItem(wrapper, CommentsObj) {
        _classCallCheck(this, CommentsItem);

        this._createElements(wrapper, CommentsObj);
        this._addEvents();
    }

    _createClass(CommentsItem, [{
        key: '_createElements',
        value: function _createElements(wrapper, CommentsObj) {
            this.wrapper = wrapper;
            this.CommentsObj = CommentsObj;
            this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.upBtn = this.wrapper.querySelector('[data-CommentsItem-up]');
            this.downBtn = this.wrapper.querySelector('[data-CommentsItem-down]');
            this.answerBtn = this.wrapper.querySelector('[data-CommentsItem-answerBtn]');
            this.replyToBtn = this.wrapper.querySelector('[data-CommentsItem-replyToBtn]');
            this.forForm = this.wrapper.querySelector('[data-CommentsItem-forForm]');
            this.numUp;
            this.numDown;
            this.voteAjaxPath = this._defineAjaxPath();
            this.isSending = false;
        }
    }, {
        key: '_defineAjaxPath',
        value: function _defineAjaxPath() {
            var part = (window.location + '').indexOf('/_src/') === -1 ? '' : '/_src/layouts',
                path = part + '/' + this.CommentsObj.param.type + '/' + this.CommentsObj.param.uid + '/votecomment';

            return path;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            if (this.answerBtn) {
                this.answerBtn.addEventListener('click', function (e) {
                    self._onClickAnswerBtn.call(self, e, 0);
                }, false);
            }

            if (this.replyToBtn) {
                this.replyToBtn.addEventListener('click', function (e) {
                    self._onClickReplyToBtn.call(self, e);
                }, false);
            }
            if (this.upBtn) {
                this.upBtn.addEventListener('click', function (e) {
                    self._onClickVoteBtn.call(self, e, 1);
                }, false);
            }
            if (this.downBtn) {
                this.downBtn.addEventListener('click', function (e) {
                    self._onClickVoteBtn.call(self, e, 0);
                }, false);
            }
        }
    }, {
        key: '_onClickAnswerBtn',
        value: function _onClickAnswerBtn(e) {
            e.preventDefault();

            if (!regAuthObj.isAuth) {
                regAuthObj.authForm.showPopup();
                return false;
            }

            this.CommentsObj.moduleAll['CommentsForm'][0].onClickAnswerBtn(this);
        }
    }, {
        key: '_onClickReplyToBtn',
        value: function _onClickReplyToBtn(e) {
            e.preventDefault();
            var curTop = this.replyToBtn.getBoundingClientRect().top,
                uid = this.replyToBtn.getAttribute('data-CommentsItem-replyToBtn'),
                comment = document.getElementById(uid),
                commentTop = comment.getBoundingClientRect().top,
                delta = commentTop - curTop;

            //
            window.scrollBy(0, delta);
        }
    }, {
        key: '_onClickVoteBtn',
        value: function _onClickVoteBtn(e, vote) {
            e.preventDefault();

            if (!regAuthObj.isAuth) {
                regAuthObj.authForm.showPopup();
                return false;
            }

            if (this.isSending) return false;
            this.isSending = true;

            var self = this;
            (0, _ajax.ajax)({
                data: { "vote": vote, "commentid": this.param.uid },
                url: this.voteAjaxPath,
                callback: function callback(msg) {
                    self._checkAnswer.call(self, msg);
                }
            });
        }
    }, {
        key: '_checkAnswer',
        value: function _checkAnswer(msg) {
            var msg = JSON.parse(msg);

            if (msg.auth === false) {
                uPopup({
                    content: 'Вам нужно авторизоваться повторно.',
                    oncloseBefore: function oncloseBefore() {
                        location.replace(location.protocol + '//' + location.host + location.pathname);
                    }
                });
            } else if (!msg.status) {
                uPopup({
                    content: msg.message
                });
            } else {
                this._addVote(msg);
            }

            this.isSending = false;
        }
    }, {
        key: '_addVote',
        value: function _addVote(msg) {
            var adCls = '',
                curCls = this.wrapper.className;

            adCls = msg.data.state == 'normal' ? '' : ' js-' + msg.data.state;
            adCls += msg.data.mark ? ' js-vote-' + msg.data.mark : '';

            if (!this.numUp) {
                this.numUp = this.upBtn.querySelector('[data-CommentsItem-numUp]');
                this.numDown = this.downBtn.querySelector('[data-CommentsItem-numDown]');
            }

            this.numUp.innerHTML = msg.data.likes;
            this.numDown.innerHTML = msg.data.dislikes;
            this.wrapper.className = curCls.replace(/js-(low|high|vote-yes|vote-no)/g, '') + adCls;

            try {
                gtag('event', 'click', {
                    'event_category': 'engagement',
                    'event_label': 'comment_like_or_dislike'
                });
                console.log('gtag success!');
            } catch (error) {
                console.error('gtag error:', error);
            }
        }
    }, {
        key: 'del',
        value: function del() {}
    }]);

    return CommentsItem;
}();

exports.CommentsItem = CommentsItem;

},{"../modules/ajax":61}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CrossDomainTransport = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Porthole = require('../modules/Porthole');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CrossDomainTransport = function () {
    function CrossDomainTransport(frameUrl, frameId, callbacks) {
        var _this = this;

        _classCallCheck(this, CrossDomainTransport);

        this._portal = null;
        this._callbacks = callbacks;

        frameUrl && typeof frameUrl === 'string' && frameId && typeof frameId === 'string' ? this._portal = new _Porthole.Porthole.WindowProxy(frameUrl, frameId) : this._portal = new _Porthole.Porthole.WindowProxy(frameUrl);

        if (!this._portal) return;

        this._portal.addEventListener(this.onMessage.bind(this));

        return {
            setCallback: this._setCallback.bind(this),
            post: this._post.bind(this),
            destroy: this._destroy.bind(this),
            callbacks: function callbacks() {
                return _this._callbacks;
            }
        };
    }

    _createClass(CrossDomainTransport, [{
        key: 'onMessage',
        value: function onMessage(_ref) {
            var _ref$data = _ref.data,
                data = _ref$data === undefined ? {} : _ref$data;
            var cmd = data.cmd,
                value = data.value;

            if (this._callbacks[cmd] != null) {
                this._callbacks[cmd](value);
            } else {
                console.log('Callback for \'' + cmd + '\' is not defined.');
            }
        }
    }, {
        key: '_setCallback',
        value: function _setCallback(name, fn) {
            var _this2 = this;

            (function (name, fn) {
                _this2._callbacks[name] = fn;
            })(name, fn);
        }
    }, {
        key: '_post',
        value: function _post(fnName, value) {
            var _this3 = this;

            (function (fnName, value) {
                var msg = { cmd: fnName, value: value };
                _this3._portal.post(msg);
            })(fnName, value);
        }
    }, {
        key: '_destroy',
        value: function _destroy() {
            var _this4 = this;

            (function () {
                _Porthole.Porthole.WindowProxyDispatcher.stop();
                _this4._portal.removeEventListener(_this4.onMessage);
                _this4._callbacks = null;
                _this4._portal = null;
            })();
        }
    }]);

    return CrossDomainTransport;
}();

exports.CrossDomainTransport = CrossDomainTransport;

},{"../modules/Porthole":32}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
    function _class(el) {
        _classCallCheck(this, _class);

        this.filmId = el.getAttribute('data-embeds-filmId');
        this.trailerId = el.getAttribute('data-embeds-trailerClipboard');
        this.seriesId = el.getAttribute('data-embed-seriesId');

        this._insertEmbed(this.filmId);
    }

    _createClass(_class, [{
        key: '_showDropdown',
        value: function _showDropdown(e) {
            document.querySelector('.embedsDropdown').classList.toggle('as-none');
        }
    }, {
        key: 'copyStringToClipboard',
        value: function copyStringToClipboard(str, msg) {
            var el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style = { position: 'absolute', left: '-9999px' };

            document.body.appendChild(el);

            el.select();

            document.execCommand('copy');
            document.body.removeChild(el);

            alert(msg);
        }
    }, {
        key: '_inserSeriesToClipBoad',
        value: function _inserSeriesToClipBoad() {
            var thanks = 'Код для вставки сериала успешно скопирован.';

            this.copyStringToClipboard('<iframe border="0" frameborder="0" height="300" id="ka-embed-' + this.seriesId + '" src="https://api.kinoafisha.info/embed/series/' + this.seriesId + '" width="100%"></iframe><script type="text/javascript" src="https://api.kinoafisha.info/embed.js"></script>', thanks);
        }
    }, {
        key: '_insertTrailerToClipboard',
        value: function _insertTrailerToClipboard() {
            var thanks = 'Код для вставки трейлера успешно скопирован.';

            this.copyStringToClipboard('<iframe title="Kinoafisha player" width="100%" height="296" src="https://api.kinoafisha.info/player/embed/' + this.trailerId + '" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" allowfullscreen></iframe>', thanks);
        }
    }, {
        key: '_insertFilmCardToClipboard',
        value: function _insertFilmCardToClipboard() {
            var thanks = 'Код для вставки карточки фильма успешно скопирован.';
            this.copyStringToClipboard('<iframe border="0" frameborder="0" height="300" id="ka-embed-' + this.filmId + '" src="https://api.kinoafisha.info/embed/movie/' + this.filmId + '/" width="100%"></iframe><script type="text/javascript" src="https://api.kinoafisha.info/embed.js"></script>', thanks);
        }
    }, {
        key: '_createDropDownItems',
        value: function _createDropDownItems(dropdown) {
            var texts = [];
            var that = this;

            if (this.filmId) {
                texts.push('Код для вставки карточки фильма');
            }

            if (this.trailerId) {
                texts.push('Код для вставки карточки трейлера');
            }

            if (this.seriesId) {
                texts.push('Код для вставки карточки сериала');
            }

            texts.forEach(function (txt, ind) {
                var item = document.createElement('div');
                item.classList.add('embedsDropdown_item');
                item.setAttribute('data-emdedsDropdownItem', '');
                var icon = document.createElement('div');
                icon.classList.add('embedsDropdown_icon');

                if (txt.indexOf('трейлера') >= 0) {
                    icon.classList.add('embedsDropdown_icon-trailer');
                }
                if (txt.indexOf('фильма') >= 0 || txt.indexOf('сериала') >= 0) {
                    icon.classList.add('embedsDropdown_icon-film');
                }

                item.appendChild(icon);
                var text = document.createElement('span');
                text.classList.add('embedsDropdown_text');
                text.innerText = txt;
                item.appendChild(text);

                dropdown.appendChild(item);

                item.addEventListener('click', function (e) {
                    var filmTest = e.currentTarget.querySelector('.embedsDropdown_icon-film');
                    var trailerTest = e.currentTarget.querySelector('.embedsDropdown_icon-trailer');

                    if (that.filmId && filmTest) {
                        that._insertFilmCardToClipboard();
                    }

                    if (that.seriesId && filmTest) {
                        that._inserSeriesToClipBoad();
                    }

                    if (that.trailerId && trailerTest) {
                        that._insertTrailerToClipboard();
                    }
                });
            });
        }
    }, {
        key: '_createDropdown',
        value: function _createDropdown(button) {
            var div = document.createElement('div');
            div.classList.add('embedsDropdown');
            div.classList.add('as-none');
            var wrap = document.createElement('div');
            wrap.classList.add('embedsDropdown_wrap');
            this._createDropDownItems(wrap);
            div.appendChild(wrap);

            button.appendChild(div);
        }
    }, {
        key: '_insertEmbed',
        value: function _insertEmbed() {
            var that = this;

            var div = document.createElement('div');
            div.classList.add('ya-share2__item_service_embed');

            var img = document.createElement('div');
            img.classList.add('ya-share2__item_service_embed-image');

            var dest = document.querySelector('.yaShareWrapper-stretch');

            dest.appendChild(div);
            div.appendChild(img);

            div.addEventListener('click', function (e) {
                if (e.target === e.currentTarget || e.target.classList.value.indexOf(e.currentTarget.classList.value) >= 0) {
                    that._showDropdown(e);
                }
            });

            this._createDropdown(div);
        }
    }]);

    return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

var _page = require('./page');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
    function _class(wrapper) {
        _classCallCheck(this, _class);

        this._createElements(wrapper);
        this._getBtn();
        this._defineAjaxPath();
        this._addEvent();
        this._addToGlobal();
    }

    _createClass(_class, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;
            this.wrapper = wrapper;
            this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.btn;
            this.isFav = this.wrapper.className.indexOf('js-fav') === -1 ? false : true;
            this.isSending = false;
            this.onchange = function () {};
        }
    }, {
        key: '_getBtn',
        value: function _getBtn() {
            if (this.wrapper.getAttribute('data-js') === 'fav-btn') this.btn = this.wrapper;else this.btn = this.wrapper.querySelector('[data-js="fav-btn"]');
        }

        /*_defineAjaxPath(){
            var part = (window.location + '').indexOf('/_src/') === -1 ? '' : '/_src/layouts';
            this.ajaxPath = part + '/' + this.data.type + '/' + this.data.uid + '/fav/';
        }*/

    }, {
        key: '_defineAjaxPath',
        value: function _defineAjaxPath() {
            var self = this;
            self.data = JSON.parse(self.wrapper.getAttribute('data-param'));
            var part = APP.vars.isDev ? '/_src/layouts' : '',
                part2 = '/' + self.data.type + '/' + self.data.uid + '/fav/';
            self.ajaxPath = part + part2;
        }
    }, {
        key: '_addEvent',
        value: function _addEvent() {
            var self = this;
            _event.event.add(this.btn, 'click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                self._defineAjaxPath();
                self._addToGlobal();

                if (!self._checkAuth.call(self)) return false;

                if (self.isSending) return false;
                self.isSending = true;

                (0, _ajax.ajax)({
                    data: { "fav": !self.isFav },
                    url: self.ajaxPath,
                    callback: function callback(msg) {
                        self._checkMsg.call(self, msg);
                    }
                });
            });
        }
    }, {
        key: '_checkAuth',
        value: function _checkAuth() {
            if (APP.vars.isMobile) {
                if (!('isUserAuth' in window) || !window.isUserAuth) {
                    var $popup = $('#favoriteStartPopup');
                    $popup.show();
                    APP.touchDisable();
                    return false;
                }
            } else if (!regAuthObj.isAuth) {
                this._showFavPopup();
                return false;
            }
            return true;
        }
    }, {
        key: '_showFavPopup',
        value: function _showFavPopup() {
            (0, _page.page)('howFav');

            /*uPopup.closeAll();
            uPopup({
                addClass:'popup-middle',
                name:'howFav',
                content: document.getElementById('howFavPopup')
            });*/
        }
    }, {
        key: '_checkMsg',
        value: function _checkMsg(msg) {
            var msg = JSON.parse(msg);

            if (msg.auth === false) {
                uPopup({
                    content: 'Вам нужно авторизоваться повторно.',
                    oncloseBefore: function oncloseBefore() {
                        location.replace(location.protocol + '//' + location.host + location.pathname);
                    }
                });
            } else if (!msg.status) {
                uPopup({
                    content: msg.message
                });
            } else {
                if (msg.data) {
                    this.addToFav();
                    this._sendStat();
                } else {
                    this._removeFromFav();
                }
            }

            this.isSending = false;
        }
    }, {
        key: '_sendStat',
        value: function _sendStat() {
            if (this.data.type) {
                try {
                    gtag('event', 'click', {
                        'event_category': 'favourite',
                        'event_label': 'add_' + this.data.type + '_to_favourite'
                    });
                } catch (e) {}
            } else {
                console.error('gtag unknown type');
            }
        }
    }, {
        key: 'addToFav',
        value: function addToFav() {
            /*
            Добавляем в избранное (фильм, кинотеатр итд) сразу ко всем одинаковым id
            Ф-я может вызываться из глобального объекта - если мы щелкнули на пойду у фильма - то автоматом добаляется избранное
            */
            var key = 'uid-' + this.data.uid,
                type = this.data.type,
                all = window.GLOBALS[type + 'FavAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                all[i].wrapper.className = all[i].wrapper.className.replace(/\s*js-fav/, '') + ' js-fav';
                all[i].isFav = true;
            }
            this.onchange(true);

            this._addCustomEvent({ isFav: true, typeFav: type, uid: this.data.uid });
        }
    }, {
        key: '_removeFromFav',
        value: function _removeFromFav() {
            var key = 'uid-' + this.data.uid,
                type = this.data.type,
                all = window.GLOBALS[type + 'FavAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                all[i].wrapper.className = all[i].wrapper.className.replace(/\s*js-fav/, '');
                all[i].isFav = false;
            }
            this.onchange(false);

            this._addCustomEvent({ isFav: false, typeFav: type, uid: this.data.uid });
        }
    }, {
        key: '_addCustomEvent',
        value: function _addCustomEvent(data) {
            if (window.CustomEvent) {
                var event = new Event(data.typeFav + 'ChangeFav');
                event.isFav = data.isFav;
                event.uid = data.uid;
                document.dispatchEvent(event);
            }
        }
    }, {
        key: '_addToGlobal',
        value: function _addToGlobal() {
            var key = 'uid-' + this.data.uid;
            var type = this.data.type;

            if (!window.GLOBALS) window.GLOBALS = {};
            if (!window.GLOBALS[type + 'FavAll']) window.GLOBALS[type + 'FavAll'] = {};
            if (!window.GLOBALS[type + 'FavAll'][key]) window.GLOBALS[type + 'FavAll'][key] = [];

            window.GLOBALS[type + 'FavAll'][key].push(this);
        }
    }, {
        key: 'isDOM',
        value: function isDOM() {
            if (this.wrapper.getClientRects().length) return true;else return false;
        }
    }, {
        key: 'del',
        value: function del() {
            var key = 'uid-' + this.data.uid;
            var type = this.data.type;
            var all = window.GLOBALS[type + 'FavAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                if (all[i] === this) {
                    all.splice(i, 1);
                    if (!all.length) delete window.GLOBALS[type + 'FavAll'][key];
                    return false;
                }
            }
        }
    }]);

    return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{"../modules/ajax":61,"../modules/event":79,"./page":95}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Form = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * вспомогательный класс для всех форм (на страницах, в попапах итд), сам по себе не используется.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * форма отправляется по атрибуту actionв, результат возвращается php скриптом в ифрейм, откуда вызвается
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * window.message родительского окна
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * echo '<script>parent.top.postMessage(\'{"type":"form",  "name": "' . $checkName . '", "data":' . $data . '}\', "*")
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * У формы обяз должно быть название оно передается в скрытое поле name="check-name",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * чтобы можно было потом вернуть его ($checkName) для индетификации текущей формы в  обраотчике window.message
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * auth
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * reg
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * subscribe
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * email
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * recover
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * announce
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * класс  регистрирует обработчик window.message, работает с гугл капчей;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * */

var _scriptonload = require('../modules/scriptonload');

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Form = function () {
	/*
 * param.isNeedAuth boolen - нужна или нет авторизация для формы
 * */
	function Form(param) {
		_classCallCheck(this, Form);

		this._createElements(param);
		this._checkAction();
		this._createLabel();
		this._addEvents();
		this._addCallback();
		this._addCaptcha();
	}

	_createClass(Form, [{
		key: '_createElements',
		value: function _createElements(param) {
			var self = this;
			this.param = param;

			/* Форма может быть в контейнере (чисто оформительский момент), контейнер здесь нужен для придания вида отправляемой формы */
			this.wrapper = param.wrapper;
			this.form = this.wrapper.nodeName == 'FORM' ? this.wrapper : this.wrapper.querySelector('form');

			this.submitBtn = this.form.querySelector('[type="submit"]');
			this.param.name = this.form.getAttribute('name');
			this.googleRecaptchaEl = this.form.querySelector('[data-js="googleRecaptcha"]');
			this.input;
			this.captcha = false;
			this._messageOnCircuit = function (e) {
				self._messageOn.call(self, e);
			};
			this.isSending = false;
		}
	}, {
		key: '_checkAction',
		value: function _checkAction() {
			var path = this.form.getAttribute('data-action');
			if (path) this.form.setAttribute('action', path);
		}
	}, {
		key: '_createLabel',
		value: function _createLabel() {
			var input = document.createElement('INPUT');
			input.name = "check-name";
			input.value = this.param.name;
			input.type = "hidden";
			this.input = input;
			this.form.appendChild(this.input);
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;
			_event.event.add(this.form, 'submit', function (e) {
				// ЗДесь будут проверки, если будут
				if (self.isSending || self.param.beforeSubmit && !self.param.beforeSubmit()) {
					e.preventDefault();
				} else {
					self.wrapper.className = self.wrapper.className + ' js-sending';
					self.isSending = true;
				}
			});
		}
	}, {
		key: '_addCallback',
		value: function _addCallback() {
			_event.event.add(window, 'message', this._messageOnCircuit);
		}
	}, {
		key: '_messageOn',
		value: function _messageOn(e) {
			try {
				var data = JSON.parse(e.data);
			} catch (e) {
				return false;
			}
			if (data.type != 'form' || data.name != this.param.name) return false;

			var answer = data.data;
			if (answer.status) this.param.onsuccess(answer);else this.param.onerror(answer);

			this.wrapper.className = this.wrapper.className.replace(' js-sending', '');
			this.isSending = false;
		}
	}, {
		key: '_addCaptcha',
		value: function _addCaptcha() {
			if (!this.googleRecaptchaEl) return false;

			//Гугл запускает onload c одной и той же функцией, замыкание не помогает, поэтому так
			if (!window.googleRecaptchaOnload) {
				window.googleRecaptchaOnload = function () {
					window.googleRecaptchaIsLoading = true;
				};
				(0, _scriptonload.scriptonload)(['https://www.google.com/recaptcha/api.js?onload=googleRecaptchaOnload&render=explicit&hl=ru']);
			}

			var self = this,
			    checkLoading = function checkLoading() {
				if (window.googleRecaptchaIsLoading) self._showCaptcha.call(self);else {
					setTimeout(function () {
						checkLoading();
					}, 200);
				}
			};

			checkLoading();
		}
	}, {
		key: '_showCaptcha',
		value: function _showCaptcha() {
			this.captcha = grecaptcha.render(this.googleRecaptchaEl, {
				'sitekey': '6LelIhcTAAAAAJVEzzD7smhyGcJhJUiMlYoH-2f6',
				callback: function callback(response) {
					//console.log(response);
				}
			});
		}
	}, {
		key: 'resetCaptcha',
		value: function resetCaptcha() {
			try {
				grecaptcha.reset(this.captcha);
			} catch (e) {};
		}
	}, {
		key: 'resetForm',
		value: function resetForm() {
			this.form.reset();
		}
	}, {
		key: 'del',
		value: function del() {
			_event.event.remove(window, 'message', this._messageOnCircuit);
			this.form.removeChild(this.input);
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.del();
		}
	}]);

	return Form;
}();

;

exports.Form = Form;

},{"../modules/event":79,"../modules/scriptonload":106}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Meter = require('../modules/Meter');

var _Meter2 = _interopRequireDefault(_Meter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	function _class(wrapper, advPlayer, param) {
		_classCallCheck(this, _class);

		this.paramPlayer = param;
		this._createElements(wrapper);
		this._resetStat();
		this._checkAdv(advPlayer);
		this._addEventsName();

		if (!this._defineTech()) {
			//this.wrapper.className = this.wrapper.className + ' htmlPlayer-native';
			this.isCanPlay = false;
			return false;
		}

		if (this.isMobileAgent) {
			this.wrapper.className = this.wrapper.className + ' htmlPlayer-mobile';
		}

		this._resetNativeVideo();
		this._initPoster();
		this._initMute();
		this._initVolume();
		this._initRewind();
		this._initBuffered();
		this._initEmbed();
		this._addEvents();
		this._addToggle();
		this._getQuality();
		this._addQuality();
		this._addFullscreen();
		this._addSharePanel();
		this._addFooterPanel();
		this._reloadVideo();
	}

	_createClass(_class, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			var self = this;
			this.wrapper = wrapper;
			this.poster = this.wrapper.querySelector('[data-js="poster"]');
			this.video = this.wrapper.querySelector('[data-js="video"]');
			this.footer = this.wrapper.querySelector('[data-js="footer"]');
			this.controls = this.footer.querySelector('[data-js="controls"]');
			this.clearControls; //таймаут для скрытия подвала
			this.playBtn = this.controls.querySelector('[data-js="play"]');
			this.pauseBtn = this.controls.querySelector('[data-js="pause"]');
			this.qualityBtn = this.controls.querySelector('[data-js="quality"]');
			this.timeDur = this.controls.querySelector('[data-js="timeDur"]');
			this.timeCur = this.controls.querySelector('[data-js="timeCur"]');
			this.buffered = this.controls.querySelector('[data-js="buffered"]');
			this._onBuffered = function (event) {
				try {
					var buffered = Math.floor(self.video.buffered.end(0) / self.video.duration * 100);
					self.buffered.style.width = buffered + '%';
				} catch (e) {};
			};
			this.toggle = this.wrapper.querySelector('[data-js="toggle"]');
			this.shareBtn = this.controls.querySelector('[data-js="share-btn"]'); //кнопка для показа/скрытия панели "Поделиться"
			this.share = this.footer.querySelector('[data-js="share"]'); //Панель поделиться
			this.embedField = this.share.querySelector('[data-js="embed"]');
			this.embedWidthField = this.share.querySelector('[data-js="embed-width"]');
			this.embedHeightField = this.share.querySelector('[data-js="embed-height"]');
			this.embedTemplate = this.embedField.value;
			this.embedWidth = 640; // ширина по умолчанию для кода ифрейма
			this.aspectRatio = .5625; //если не удается определить размер видео, по умолчанию используется соотношение сторон 16/9
			this.controlsDur = 3000;
			this.format;
			this.quality;
			this.dataQuality = JSON.parse(this.wrapper.getAttribute('data-quality'));
			this.isMobileAgent = this._defineUserAgent();
			this.isShowAdv; //показывать или нет плеер с рекламой
			this.isCanPlay = true; //можем проигрывать или нет. Если нет - будет грузиться флеш
			this.keyFrameAll; //массив времени в %  когда отпраляется стата - 0% 50% 90% 100%
		}
	}, {
		key: '_resetStat',
		value: function _resetStat() {
			this.keyFrameAll = [0, 50, 90, 100];
		}
	}, {
		key: '_checkStat',
		value: function _checkStat() {
			/* делаем по аналогии с флеш-плеером, где даже при перемотке статистика считается */
			if (!this.keyFrameAll.length) return false;

			var persent = Math.round(this.video.currentTime / this.video.duration * 100);
			if (this.keyFrameAll[0] === persent || this.keyFrameAll[0] < persent) {
				this._sendStat(this.keyFrameAll[0]);
				this.keyFrameAll.shift();
				this._checkStat();
			}
		}
	}, {
		key: '_sendStat',
		value: function _sendStat(persent) {
			var image = document.createElement('IMG'),
			    path = window.location.hostname.indexOf('kinoafishaspb.ru') === -1 ? 'kinoafisha.info' : 'kinoafishaspb.ru';
			image.src = 'http://api.' + path + '/player/stat/?trailer_id=' + this.paramPlayer.trailer_id + '&host=' + this.paramPlayer.host + '&percent=' + persent;
			image.style.cssText = 'visibility:hidden;position:absolute;left:-9999px;top:-9999px;display:block;width:1px;height:1px;overflow:hidden;';
			document.body.appendChild(image);
		}
	}, {
		key: '_checkAdv',
		value: function _checkAdv(advPlayer) {
			if (advPlayer) {
				this._createAdv(advPlayer);
				this.isShowAdv = true;
			} else this.isShowAdv = false;
		}
	}, {
		key: '_createAdv',
		value: function _createAdv(advPlayer) {
			var self = this;

			this.advPlayer = advPlayer;
			this.advPlayer.afterEnd = function () {
				self.isAutoPlay = true;
				self._reloadVideo.call(self);
			};
			this.advPlayer.afterSkip = function () {
				self.isAutoPlay = true;
				self._reloadVideo.call(self);
			};
			this.advPlayer.afterClicking = function () {
				self._reloadVideo.call(self);
			};
		}
	}, {
		key: '_addEventsName',
		value: function _addEventsName() {
			this.eNames = {};
			if (window.navigator.pointerEnabled) this.eNames = { 'down': 'pointerdown', 'move': 'pointermove', 'enter': 'pointerenter', 'leave': 'pointerleave', 'up': 'pointerup' };else if (window.navigator.msPointerEnabled) this.eNames = { 'down': 'MSPointerDown', 'move': 'MSPointerMove', 'enter': 'MSPointerEnter', 'leave': 'MSPointerLeave', 'up': 'MSPointerUp' };else if ('ontouchstart' in document.documentElement) {
				this.eNames = { 'down': 'touchstart', 'move': 'touchmove', 'enter': 'touchstart', 'leave': 'touchend', 'up': 'touchend' };
			} else this.eNames = { 'down': 'mousedown', 'move': 'mousemove', 'enter': 'mouseenter', 'leave': 'mouseleave', 'up': 'mouseup' };
		}
	}, {
		key: '_defineUserAgent',
		value: function _defineUserAgent() {
			var agentAll = ['ipod', 'iphone', 'ipad', 'android', 'blackberry'],
			    i = 0;

			for (i; i < agentAll.length; i++) {
				var re = new RegExp(agentAll[i], 'i');
				if (re.test(navigator.userAgent)) return agentAll[i];
			}
			return false;
		}
	}, {
		key: '_defineFormat',
		value: function _defineFormat() {
			if (!this.video.canPlayType) this.format = false;else if (this.video.canPlayType('video/mp4')) this.format = 'mp4';else this.format = false;

			if (this.format) return true;else return false;
		}
	}, {
		key: '_defineTech',
		value: function _defineTech() {
			if (!document.addEventListener || !this._defineFormat()) return false;else return true;
		}
	}, {
		key: '_resetNativeVideo',
		value: function _resetNativeVideo() {
			this.video.removeAttribute('controls');
			this.video.removeAttribute('poster');
			this.video.innerHTML = '';
		}
	}, {
		key: '_initPoster',
		value: function _initPoster() {
			var self = this;

			this.poster.onclick = function (event) {
				if (self.isShowAdv) {
					self.isShowAdv = false;
					self._initialize.call(self);
					self.advPlayer.initialize();
					self._showAdv.call(self);
				} else {
					self.isAutoPlay = true;
					self._ready.call(self);
				}
			};
			this.poster.onmousemove = function (event) {
				event = event || window.event;
				event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
			};
		}
	}, {
		key: '_initMute',
		value: function _initMute() {
			this.mute = this.controls.querySelector('[data-js="mute"]');
			this.muteOn = this.mute.querySelector('[data-js="mute-on"]');
			this.muteOff = this.mute.querySelector('[data-js="mute-off"]');

			var self = this;
			this.muteOn.onclick = function () {
				self.video.muted = true;
				localStorage.videoMuted = 'on';
			};
			this.muteOff.onclick = function () {
				self.video.muted = false;
				localStorage.videoMuted = 'off';
			};

			this.video.onvolumechange = function () {
				self.mute.className = self.video.muted === true ? self.mute.className.replace(/\s*htmlPlayer_mute_off/, '') + ' htmlPlayer_mute_off' : self.mute.className.replace(/\s*htmlPlayer_mute_off/, '');
			};

			if (localStorage.videoMuted === 'on') self.video.muted = true;else self.video.muted = false;

			this.video.onvolumechange();
		}
	}, {
		key: '_initVolume',
		value: function _initVolume() {
			var el = this.controls.querySelector('[data-js="volume"]');
			var self = this;

			if (localStorage.videoVolume !== undefined) {
				el.setAttribute('data-meter', '{"value": ' + localStorage.videoVolume + '}');
				self.video.volume = localStorage.videoVolume;
			}

			var volume = new _Meter2.default(el);
			volume.callback = function (status, value) {
				self.video.volume = value;
				if (status === 'up') localStorage.videoVolume = value;
			};
		}
	}, {
		key: '_initRewind',
		value: function _initRewind() {
			var el, self;

			el = this.controls.querySelector('[data-js="rewind"]');
			self = this;

			this.rewind = new _Meter2.default(el);
			this.rewind.callback = function (status, value) {
				if (status === 'down') {
					self.isRewind = self.video.paused === true ? 'paused' : 'playing';
					self.video.pause();
					self.video.currentTime = value;
				} else if (status === 'move') {
					self.video.currentTime = value;
				} else if (status === 'up') {
					self.video.currentTime = value;
					if (self.isRewind === 'playing') {
						self.video.play();
					}
					self.isRewind = false;
				}
			};
		}
	}, {
		key: '_initBuffered',
		value: function _initBuffered() {
			this.video.addEventListener("progress", this._onBuffered, false);
		}
	}, {
		key: '_initEmbed',
		value: function _initEmbed() {
			var self = this;

			this.embedTemplate = this.embedTemplate.replace(/\|LEFT\|/g, '<').replace(/\|RIGHT\|/g, '>');

			this.embedWidthField.onkeyup = function () {
				var w = parseInt(this.value) || 0;
				self._changeEmbed.call(self, w, w * self.aspectRatio);
			};
			this.embedHeightField.onkeyup = function () {
				var h = parseInt(this.value) || 0;
				self._changeEmbed.call(self, h / self.aspectRatio, h);
			};
		}
	}, {
		key: '_changeEmbed',
		value: function _changeEmbed(w, h) {
			var w = parseInt(w) || '',
			    h = parseInt(h) || '';

			this.embedWidthField.value = w;
			this.embedHeightField.value = h;
			this.embedField.value = this.embedTemplate.replace(/width_height/, 'width="' + w + '" height="' + h + '"');
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;
			this.playBtn.onclick = function () {
				self.video.play();
			};
			this.pauseBtn.onclick = function () {
				self.video.pause();
			};
			this.video.onloadedmetadata = function (event) {
				self._reloadTime.call(self);
				self._reloadRewind.call(self);
				self._reloadBuffered.call(self);
				self._reloadAspectRatio.call(self);
				self._reloadEmbed.call(self);
				self._ready.call(self);
			};
			this.video.onpause = function () {
				if (!self.isRewind) self._pauseCallback.call(self);
			};
			this.video.onplaying = function () {
				self._playingCallback.call(self);
			};
			this.video.onended = function () {
				if (!self.isRewind) {
					self._endCallback.call(self);
				}
			};
			this.video.ontimeupdate = function () {
				self._timeupdateCallback.call(self);
			};
			this.video.onwaiting = function () {
				console.log('waiting');
			};
		}
	}, {
		key: '_addToggle',
		value: function _addToggle() {
			var self = this;

			if (!this.isMobileAgent) {
				this.toggle.onclick = function () {
					self._toggle.call(self);
				};
			}
		}
	}, {
		key: '_addFooterPanel',
		value: function _addFooterPanel() {
			var self = this;
			this.wrapper['on' + this.eNames.enter] = function () {
				self._showControlsAtTime.call(self);
			};
			this.wrapper['on' + this.eNames.leave] = function () {
				self._hideControlsAtTime.call(self);
			};
			this.wrapper['on' + this.eNames.move] = function () {
				self._showControlsAtTime.call(self);
			};
			this.footer['on' + this.eNames.enter] = function () {
				self.wrapper['on' + self.eNames.enter] = function () {};
				self.wrapper['on' + self.eNames.move] = function () {};
				self._showControls.call(self);
			};
			this.footer['on' + this.eNames.leave] = function () {
				self.wrapper['on' + self.eNames.enter] = function () {
					self._showControlsAtTime.call(self);
				};
				self.wrapper['on' + self.eNames.move] = function () {
					self._showControlsAtTime.call(self);
				};
			};
		}
	}, {
		key: '_toggle',
		value: function _toggle() {
			this.video.paused ? this.video.play() : this.video.pause();
		}
	}, {
		key: '_playingCallback',
		value: function _playingCallback() {
			this.wrapper.className = this.wrapper.className.replace(/\s*(htmlPlayer-pause|htmlPlayer-playing)/g, '') + ' htmlPlayer-playing';
		}
	}, {
		key: '_pauseCallback',
		value: function _pauseCallback() {
			this.wrapper.className = this.wrapper.className.replace(/\s*(htmlPlayer-pause|htmlPlayer-playing)/g, '') + ' htmlPlayer-pause';
		}
	}, {
		key: '_endCallback',
		value: function _endCallback() {
			this.wrapper.className = this.wrapper.className.replace(/\s*(htmlPlayer-pause|htmlPlayer-playing)/g, '');
			this._hideControls.call(this);
			this._updateTimeCur(0);
			this._resetStat();
			this._ready();
		}
	}, {
		key: '_timeupdateCallback',
		value: function _timeupdateCallback() {
			this._updateTimeCur(this.video.currentTime);
			if (!this.isRewind) {
				this.rewind.update({ value: this.video.currentTime, max: this.video.duration });
				this._checkStat();
			}
		}
	}, {
		key: '_showControls',
		value: function _showControls() {
			this._clearControlsAtTime();
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-footer/, '') + ' htmlPlayer-footer';
		}
	}, {
		key: '_showControlsAtTime',
		value: function _showControlsAtTime() {
			var self = this;
			this._clearControlsAtTime();
			this._showControls();
			this._hideControlsAtTime();
		}
	}, {
		key: '_clearControlsAtTime',
		value: function _clearControlsAtTime() {
			try {
				clearTimeout(this.clearControls);
			} catch (e) {}
		}
	}, {
		key: '_hideControls',
		value: function _hideControls() {
			this._clearControlsAtTime();
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-(footer|share)/g, '');
		}
	}, {
		key: '_hideControlsAtTime',
		value: function _hideControlsAtTime() {
			var self = this;
			this._clearControlsAtTime();
			this.clearControls = setTimeout(function () {
				self._hideControls.call(self);
			}, this.controlsDur);
		}
	}, {
		key: '_getQuality',
		value: function _getQuality() {
			if (Object.keys(this.dataQuality).length > 1) {
				if (localStorage.videoQuality && this.dataQuality[localStorage.videoQuality]) this.quality = localStorage.videoQuality;else if (this.dataQuality.HQ && screen.height > 1079) this.quality = 'HQ';else this.quality = 'LQ';
			} else this.quality = 'LQ';
		}
	}, {
		key: '_addQuality',
		value: function _addQuality() {
			if (Object.keys(this.dataQuality).length > 1) {
				var self = this;

				this.qualityBtn.className = this.qualityBtn.className + ' htmlPlayer_qualityBtn-' + this.quality;

				this.qualityBtn.onclick = function () {
					self._changeQuality.call(self);
				};
			} else this.qualityBtn.style.display = 'none';
		}
	}, {
		key: '_changeQuality',
		value: function _changeQuality() {
			var cls = this.qualityBtn.className.replace(' htmlPlayer_qualityBtn-' + this.quality, '');
			this.quality = this.quality === 'HQ' ? 'LQ' : 'HQ';
			localStorage.videoQuality = this.quality;
			this.qualityBtn.className = cls + ' htmlPlayer_qualityBtn-' + this.quality;
			this.isAutoPlay = true;
			this._reloadVideo();
		}
	}, {
		key: '_addFullscreen',
		value: function _addFullscreen() {
			this.fullscreen = this.controls.querySelector('[data-js="fullscreen"]');
			this.fullscreenRequest = this.fullscreen.querySelector('[data-js="fullscreen-request"]');
			this.fullscreenExit = this.fullscreen.querySelector('[data-js="fullscreen-exit"]');

			var enabledName = function (doc) {
				if ('fullscreenEnabled' in doc) return 'fullscreenEnabled';
				if ('mozFullScreenEnabled' in doc) return 'mozFullScreenEnabled';
				if ('webkitFullscreenEnabled' in doc) return 'webkitFullscreenEnabled';
				if ('msFullscreenEnabled' in doc) return 'msFullscreenEnabled';
				return false;
			}(document);

			if (!enabledName) {
				this.fullscreen.style.display = 'none';
				return false;
			}

			var self = this;

			var eName = function (doc) {
				if ('onfullscreenchange' in doc) return 'fullscreenchange';
				if ('onmozfullscreenchange' in doc) return 'mozfullscreenchange';
				if ('onwebkitfullscreenchange' in doc) return 'webkitfullscreenchange';
				if ('onmsfullscreenchange' in doc) return 'msfullscreenchange'; //MSFullscreenChange
				return false;
			}(document);

			var fullscreenElement = function (doc) {
				if ('fullscreenElement' in doc) return 'fullscreenElement';
				if ('mozFullScreenElement' in doc) return 'mozFullScreenElement';
				if ('webkitFullscreenElement' in doc) return 'webkitFullscreenElement';
				if ('msFullscreenElement' in doc) return 'msFullscreenElement';
				return false;
			}(document);

			var request = function (el) {
				if (el.requestFullscreen) return 'requestFullscreen';
				if (el.mozRequestFullScreen) return 'mozRequestFullScreen';
				if (el.webkitRequestFullscreen) return 'webkitRequestFullscreen';
				if (el.msRequestFullscreen) return 'msRequestFullscreen';
				return false;
			}(this.wrapper);

			var exit = function () {
				if (document.exitFullscreen) return 'exitFullscreen';else if (document.mozCancelFullScreen) return 'mozCancelFullScreen';else if (document.webkitCancelFullScreen) return 'webkitCancelFullScreen';else if (document.msExitFullscreen) return 'msExitFullscreen';
				return false;
			}();

			document['on' + eName] = function (event) {
				event.preventDefault();
				if (document[fullscreenElement]) self._showFullscreen.call(self);else self._hideFullscreen.call(self);
			};

			this.fullscreenRequest.onclick = function () {
				if (request) {
					self.wrapper[request]();
				} else alert('К сожалению, ваш браузер не поддерживает фуллскрин');
			};

			this.fullscreenExit.onclick = function () {
				if (exit) {
					document[exit]();
				} else alert('Нажмите кнопку ESC для выхода из полноэкранного режима');
			};
		}
	}, {
		key: '_showFullscreen',
		value: function _showFullscreen() {
			var self = this;
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-fullscreen/, '') + ' htmlPlayer-fullscreen';
		}
	}, {
		key: '_hideFullscreen',
		value: function _hideFullscreen() {
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-fullscreen/, '');
		}
	}, {
		key: '_addSharePanel',
		value: function _addSharePanel() {
			var self = this;

			this.shareBtn.onclick = function () {
				if (self.wrapper.className.indexOf('htmlPlayer-share') !== -1) {
					self.wrapper.className = self.wrapper.className.replace(/\s*htmlPlayer-share/, '');
				} else self.wrapper.className = self.wrapper.className + ' htmlPlayer-share';
			};
		}
	}, {
		key: '_reloadVideo',
		value: function _reloadVideo() {
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-(ready|poster|playing|pause)/g, '');

			this.video.innerHTML = '';
			var source = document.createElement('SOURCE');
			source.setAttribute('src', this.dataQuality[this.quality] + '.' + this.format);
			source.setAttribute('type', 'video/' + this.format);
			this.video.appendChild(source);
			this.video.load();
		}
	}, {
		key: '_reloadTime',
		value: function _reloadTime() {
			this._updateTimeDur(this.video.duration);
			this._updateTimeCur(0);
		}
	}, {
		key: '_reloadRewind',
		value: function _reloadRewind() {
			this.rewind.update({ "value": 0, "max": this.video.duration });
		}
	}, {
		key: '_reloadBuffered',
		value: function _reloadBuffered() {
			this.buffered.style.width = '0%';
		}
	}, {
		key: '_reloadAspectRatio',
		value: function _reloadAspectRatio() {
			if (this.video.videoWidth) this.aspectRatio = this.video.videoHeight / this.video.videoWidth;else this.aspectRatio = .5625;
			this.wrapper.style.paddingTop = this.aspectRatio * 100 + '%';

			if (this.onsetSize) {
				var box = this.wrapper.getBoundingClientRect();
				this.onsetSize({ width: box.right - box.left, height: box.bottom - box.top });
			}
		}
	}, {
		key: '_reloadEmbed',
		value: function _reloadEmbed() {
			var h = this.embedWidth * this.aspectRatio;
			this._changeEmbed(this.embedWidth, h);
		}
	}, {
		key: '_updateTimeCur',
		value: function _updateTimeCur(sec) {
			this.timeCur.innerHTML = this._convertTime(sec);
		}
	}, {
		key: '_updateTimeDur',
		value: function _updateTimeDur(sec) {
			this.timeDur.innerHTML = this._convertTime(sec);
		}
	}, {
		key: '_convertTime',
		value: function _convertTime(sec) {
			function num(val) {
				val = Math.floor(val);
				return val < 10 ? '0' + val : val;
			}

			var hours = num(sec / 3600 % 24),
			    minutes = num(sec / 60 % 60),
			    seconds = num(sec % 60);

			hours = hours === '00' ? '' : hours + ':';
			return hours + minutes + ':' + seconds;
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var cls = this.wrapper.className.replace(/\s*htmlPlayer-(ready|poster|disabled)/g, '') + ' htmlPlayer-ready';

			if (this.isAutoPlay || this.paramPlayer.autoplay === true) {
				this.isAutoPlay = false;
				this.paramPlayer.autoplay = false;

				this._showControlsAtTime();
				this.video.play();
			} else cls = cls + ' htmlPlayer-poster';

			this.wrapper.className = cls;
		}
	}, {
		key: '_showAdv',
		value: function _showAdv() {
			this.wrapper.className = this.wrapper.className + ' htmlPlayer-disabled';
			this.advPlayer.show();
		}
	}, {
		key: '_hideAdv',
		value: function _hideAdv() {}
	}, {
		key: '_initialize',
		value: function _initialize() {
			this.video.innerHTML = '';
			this.video.load();
		}
	}]);

	return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{"../modules/Meter":21}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Meter = require('../modules/Meter');

var _Meter2 = _interopRequireDefault(_Meter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	function _class(parentWrapper, insert, dataApi) {
		_classCallCheck(this, _class);

		this.paramPlayer = JSON.parse(parentWrapper.getAttribute('data-param'));
		this._createElements(parentWrapper, insert, dataApi);
		this._resetStat();
		this._addEventsName();

		if (!this._defineTech()) {
			//this.wrapper.className = this.wrapper.className + ' htmlPlayer-native';
			this.isCanPlay = false;
			return false;
		}

		if (this.isMobileAgent) {
			this.wrapper.className = this.wrapper.className + ' htmlPlayer-mobile';
		}

		this._resetNativeVideo();
		this._initPoster();
		this._initMute();
		this._initVolume();
		this._initRewind();
		this._initBuffered();
		this._initEmbed();
		this._addEvents();
		this._addToggle();
		this._getQuality();
		this._addQuality();
		this._addFullscreen();
		this._addSharePanel();
		this._addFooterPanel();
		this._reloadVideo();
	}

	_createClass(_class, [{
		key: '_getHtml',
		value: function _getHtml(data) {

			var LQ = data.files.low ? data.files.low.path.replace(/\.mp4$/, '') : false;
			var HQ = data.files.high ? data.files.high.path.replace(/\.mp4$/, '') : false;
			var quality = '"LQ": "' + LQ + '"' + (HQ ? ', "HQ": "' + HQ + '"' : '');

			return '<div data-js="html-player" data-quality=\'{' + quality + '}\' class="htmlPlayer">' + '<video data-js="video" preload="metadata" class="htmlPlayer_video" controls="controls" poster="' + data.poster + '" webkit-playsinline>' + '<source src="' + data.files.low.path + '" type="video/mp4" />' + '<a class="htmlPlayer_altVideo" href="' + data.files.low.path + '"  style="background-image:url(' + data.poster + ')">' + '<img class="htmlPlayer_altVideoPoster" src="' + data.poster + '" alt="" />' + '<img class="htmlPlayer_altVideoBtn" src="http://video.kinoafisha.info/i/player/play-btn.png" alt="" />' + '</a>' + '</video>' + '<div data-js="toggle" class="htmlPlayer_toggle">' + '<img class="htmlPlayer_bigPauseBtn" src="http://video.kinoafisha.info/i/player/pause-btn.png" alt="" />' + '</div>' + '<div data-js="footer" class="htmlPlayer_footer">' + '<div data-js="controls" class="htmlPlayer_controls">' + '<div class="htmlPlayer_controlsCell htmlPlayer_controlsCell-shrink">' + '<div class="htmlPlayer_playback htmlPlayer_controlsBtn">' + '<img data-js="play"  class="htmlPlayer_playBtn" src="http://video.kinoafisha.info/i/player/play.png" alt="" />' + '<img data-js="pause"  class="htmlPlayer_pauseBtn" src="http://video.kinoafisha.info/i/player/pause.png" alt="" />' + '</div>' + '<div class="htmlPlayer_time">' + '<span data-js="timeCur" class="htmlPlayer_timeCur"></span>' + '<span class="htmlPlayer_timeSep">/</span>' + '<span data-js="timeDur" class="htmlPlayer_timeDur"></span>' + '</div>' + '</div>' + '<div class="htmlPlayer_controlsCell">' + '<div data-js="rewind" data-meter = \'{}\'  class="playerMeter  htmlPlayer_controlsBtn">' + '<div class="playerMeter-strip"></div>' + '<div data-js="buffered" class="playerMeter-buffered"></div>' + '<div data-js="progress" class="playerMeter-progress"></div>' + '<div data-js="slider" class="playerMeter-slider"></div>' + '</div>' + '</div>' + '<div class="htmlPlayer_controlsCell  htmlPlayer_controlsCell-shrink">' + '<span data-js="quality" class="htmlPlayer_qualityBtn htmlPlayer_controlsBtn">hq</span>' + '<div data-js="mute" class="htmlPlayer_mute htmlPlayer_controlsBtn">' + '<img  data-js="mute-on" data-js="mute-on"  class="htmlPlayer_muteOn" src="http://video.kinoafisha.info/i/player/mute-on.png" alt="" />' + '<img  data-js="mute-off" data-js="mute-off"  class="htmlPlayer_muteOff" src="http://video.kinoafisha.info/i/player/mute-off.png" alt="" />' + '</div>' + '<div data-js="volume" data-meter = \'{"value": 1}\'  class="playerMeter playerMeter_volume htmlPlayer_controlsBtn">' + '<div class="playerMeter-strip"></div>' + '<div data-js="progress" class="playerMeter-progress"></div>' + '<div data-js="slider" class="playerMeter-slider"></div>' + '</div>' + '<div data-js="fullscreen" class="htmlPlayer_fullscreen htmlPlayer_controlsBtn"> ' + '<img data-js="fullscreen-request"  class="htmlPlayer_fullscreenRequest" src="http://video.kinoafisha.info/i/player/fullscreen-request.png" alt="" />' + '<img data-js="fullscreen-exit"  class="htmlPlayer_fullscreenExit" src="http://video.kinoafisha.info/i/player/fullscreen-exit.png" alt="" />' + '</div>' + '<div data-js="share-btn" class="htmlPlayer_shareBtn htmlPlayer_controlsBtn">&lt;/&gt;</div>' + '</div>' + '</div>' + '<div data-js="share" class="htmlPlayer_share">' + '<div class="htmlPlayer_shareItem">' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-title">' + 'Ссылка на ролик' + '</div>' + '<div class="htmlPlayer_shareCell">' + '<input readonly class="htmlPlayer_shareField htmlPlayer_shareField-insert" type="text" value="' + data.trailer_url + '" />' + '</div>' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">' + '&nbsp;' + '</div>' + '</div>' + '<div class="htmlPlayer_shareItem">' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-title">' + 'Код для вставки' + '</div>' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">' + '<span class="htmlPlayer_shareNote">ширина</span>' + '<input data-js="embed-width" class="htmlPlayer_shareField htmlPlayer_shareField-size" type="text" value="640" />' + '<span class="htmlPlayer_shareNote">высота</span>' + '<input data-js="embed-height" class="htmlPlayer_shareField htmlPlayer_shareField-size" type="text" value="360" />' + '</div>' + '<div class="htmlPlayer_shareCell">' + '<input data-js="embed" readonly class="htmlPlayer_shareField htmlPlayer_shareField-insert" type="text" value=\'' + data.embed_url + '\' />' + '</div>' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">' + '&nbsp;' + '</div>' + '</div>' + '</div>' + '</div>' + '<img  class="htmlPlayer_logo" src="http://video.kinoafisha.info/i/player/logo.png" alt="" />' + '<div data-js="poster" class="htmlPlayer_poster" style="background-image:url(' + data.poster + ')">' + '<div class="htmlPlayer_posterInfo">' + '<span class="htmlPlayer_posterCat">' + data.title + '</span>' + '<span class="htmlPlayer_posterName">' + data.movie_name + '</span>' + '</div>' + '<img  class="htmlPlayer_posterBtn" src="http://video.kinoafisha.info/i/player/play-btn.png" alt="" />' + '</div>' + '<div class="htmlPlayer_preloader"></div>' + '</div>';
		}
	}, {
		key: '_createElements',
		value: function _createElements(parentWrapper, insert, dataApi) {
			/* wrapper - общий контейнер, пока не используется */
			this.parentWrapper = parentWrapper;
			this.insert = insert;
			insert.innerHTML = this._getHtml(dataApi);
			this.wrapper = insert.firstChild; /* wrapper - здесь - внутренний блок  */

			var self = this;

			this.poster = this.wrapper.querySelector('[data-js="poster"]');
			this.video = this.wrapper.querySelector('[data-js="video"]');
			this.footer = this.wrapper.querySelector('[data-js="footer"]');
			this.controls = this.footer.querySelector('[data-js="controls"]');
			this.clearControls; //таймаут для скрытия подвала
			this.playBtn = this.controls.querySelector('[data-js="play"]');
			this.pauseBtn = this.controls.querySelector('[data-js="pause"]');
			this.qualityBtn = this.controls.querySelector('[data-js="quality"]');
			this.timeDur = this.controls.querySelector('[data-js="timeDur"]');
			this.timeCur = this.controls.querySelector('[data-js="timeCur"]');
			this.buffered = this.controls.querySelector('[data-js="buffered"]');
			this._onBuffered = function (event) {
				try {
					var buffered = Math.floor(self.video.buffered.end(0) / self.video.duration * 100);
					self.buffered.style.width = buffered + '%';
				} catch (e) {};
			};
			this.toggle = this.wrapper.querySelector('[data-js="toggle"]');
			this.shareBtn = this.controls.querySelector('[data-js="share-btn"]'); //кнопка для показа/скрытия панели "Поделиться"
			this.share = this.footer.querySelector('[data-js="share"]'); //Панель поделиться
			this.embedField = this.share.querySelector('[data-js="embed"]');
			this.embedWidthField = this.share.querySelector('[data-js="embed-width"]');
			this.embedHeightField = this.share.querySelector('[data-js="embed-height"]');
			this.embedTemplate = this.embedField.value;
			this.embedWidth = 640; // ширина по умолчанию для кода ифрейма
			this.aspectRatio = .5625; //если не удается определить размер видео, по умолчанию используется соотношение сторон 16/9
			this.controlsDur = 3000;
			this.format;
			this.quality;
			this.dataQuality = JSON.parse(this.wrapper.getAttribute('data-quality'));
			this.isMobileAgent = this._defineUserAgent();
			this.isCanPlay = true; //можем проигрывать или нет. Если нет - будет грузиться флеш
			this.keyFrameAll; //массив времени в %  когда отпраляется стата - 0% 50% 90% 100%4
			this.isAutoPlay = true; //теперь постер отдельно и при вызове объекта сразу начинаем проигрывание
		}
	}, {
		key: '_resetStat',
		value: function _resetStat() {
			this.keyFrameAll = [0, 50, 90, 100];
		}
	}, {
		key: '_checkStat',
		value: function _checkStat() {
			/* делаем по аналогии с флеш-плеером, где даже при перемотке статистика считается */
			if (!this.keyFrameAll.length) return false;

			var persent = Math.round(this.video.currentTime / this.video.duration * 100);
			if (this.keyFrameAll[0] === persent || this.keyFrameAll[0] < persent) {
				this._sendStat(this.keyFrameAll[0]);
				this.keyFrameAll.shift();
				this._checkStat();
			}
		}
	}, {
		key: '_sendStat',
		value: function _sendStat(persent) {
			var image = document.createElement('IMG'),
			    path = window.location.hostname.indexOf('kinoafishaspb.ru') === -1 ? 'kinoafisha.info' : 'kinoafishaspb.ru';
			image.src = 'http://api.' + path + '/player/stat/?trailer_id=' + this.paramPlayer.trailer_id + '&host=' + this.paramPlayer.host + '&percent=' + persent;
			image.style.cssText = 'visibility:hidden;position:absolute;left:-9999px;top:-9999px;display:block;width:1px;height:1px;overflow:hidden;';
			document.body.appendChild(image);
		}
	}, {
		key: '_addEventsName',
		value: function _addEventsName() {
			this.eNames = {};
			if (window.navigator.pointerEnabled) this.eNames = { 'down': 'pointerdown', 'move': 'pointermove', 'enter': 'pointerenter', 'leave': 'pointerleave', 'up': 'pointerup' };else if (window.navigator.msPointerEnabled) this.eNames = { 'down': 'MSPointerDown', 'move': 'MSPointerMove', 'enter': 'MSPointerEnter', 'leave': 'MSPointerLeave', 'up': 'MSPointerUp' };else if ('ontouchstart' in document.documentElement) {
				this.eNames = { 'down': 'touchstart', 'move': 'touchmove', 'enter': 'touchstart', 'leave': 'touchend', 'up': 'touchend' };
			} else this.eNames = { 'down': 'mousedown', 'move': 'mousemove', 'enter': 'mouseenter', 'leave': 'mouseleave', 'up': 'mouseup' };
		}
	}, {
		key: '_defineUserAgent',
		value: function _defineUserAgent() {
			var agentAll = ['ipod', 'iphone', 'ipad', 'android', 'blackberry'],
			    i = 0;

			for (i; i < agentAll.length; i++) {
				var re = new RegExp(agentAll[i], 'i');
				if (re.test(navigator.userAgent)) return agentAll[i];
			}
			return false;
		}
	}, {
		key: '_defineFormat',
		value: function _defineFormat() {
			if (!this.video.canPlayType) this.format = false;else if (this.video.canPlayType('video/mp4')) this.format = 'mp4';else this.format = false;

			if (this.format) return true;else return false;
		}
	}, {
		key: '_defineTech',
		value: function _defineTech() {
			if (!document.addEventListener || !this._defineFormat()) return false;else return true;
		}
	}, {
		key: '_resetNativeVideo',
		value: function _resetNativeVideo() {
			this.video.removeAttribute('controls');
			this.video.removeAttribute('poster');
			this.video.innerHTML = '';
		}
	}, {
		key: '_initPoster',
		value: function _initPoster() {
			var self = this;

			this.poster.onclick = function (event) {
				self.isAutoPlay = true;
				self._ready.call(self);
			};
			this.poster.onmousemove = function (event) {
				event = event || window.event;
				event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
			};
		}
	}, {
		key: '_initMute',
		value: function _initMute() {
			this.mute = this.controls.querySelector('[data-js="mute"]');
			this.muteOn = this.mute.querySelector('[data-js="mute-on"]');
			this.muteOff = this.mute.querySelector('[data-js="mute-off"]');

			var self = this;
			this.muteOn.onclick = function () {
				self.video.muted = true;
				localStorage.videoMuted = 'on';
			};
			this.muteOff.onclick = function () {
				self.video.muted = false;
				localStorage.videoMuted = 'off';
			};

			this.video.onvolumechange = function () {
				self.mute.className = self.video.muted === true ? self.mute.className.replace(/\s*htmlPlayer_mute_off/, '') + ' htmlPlayer_mute_off' : self.mute.className.replace(/\s*htmlPlayer_mute_off/, '');
			};

			if (localStorage.videoMuted === 'on') self.video.muted = true;else self.video.muted = false;

			this.video.onvolumechange();
		}
	}, {
		key: '_initVolume',
		value: function _initVolume() {
			var el = this.controls.querySelector('[data-js="volume"]');
			var self = this;

			if (localStorage.videoVolume !== undefined) {
				el.setAttribute('data-meter', '{"value": ' + localStorage.videoVolume + '}');
				self.video.volume = localStorage.videoVolume;
			}

			var volume = new _Meter2.default(el);
			volume.callback = function (status, value) {
				self.video.volume = value;
				if (status === 'up') localStorage.videoVolume = value;
			};
		}
	}, {
		key: '_initRewind',
		value: function _initRewind() {
			var el, self;

			el = this.controls.querySelector('[data-js="rewind"]');
			self = this;

			this.rewind = new _Meter2.default(el);
			this.rewind.callback = function (status, value) {
				if (status === 'down') {
					self.isRewind = self.video.paused === true ? 'paused' : 'playing';
					self.video.pause();
					self.video.currentTime = value;
				} else if (status === 'move') {
					self.video.currentTime = value;
				} else if (status === 'up') {
					self.video.currentTime = value;
					if (self.isRewind === 'playing') {
						self.video.play();
					}
					self.isRewind = false;
				}
			};
		}
	}, {
		key: '_initBuffered',
		value: function _initBuffered() {
			this.video.addEventListener("progress", this._onBuffered, false);
		}
	}, {
		key: '_initEmbed',
		value: function _initEmbed() {
			var self = this;

			this.embedTemplate = this.embedTemplate.replace(/\|LEFT\|/g, '<').replace(/\|RIGHT\|/g, '>');

			this.embedWidthField.onkeyup = function () {
				var w = parseInt(this.value) || 0;
				self._changeEmbed.call(self, w, w * self.aspectRatio);
			};
			this.embedHeightField.onkeyup = function () {
				var h = parseInt(this.value) || 0;
				self._changeEmbed.call(self, h / self.aspectRatio, h);
			};
		}
	}, {
		key: '_changeEmbed',
		value: function _changeEmbed(w, h) {
			var w = parseInt(w) || '',
			    h = parseInt(h) || '';

			this.embedWidthField.value = w;
			this.embedHeightField.value = h;
			this.embedField.value = this.embedTemplate.replace(/width_height/, 'width="' + w + '" height="' + h + '"');
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;
			this.playBtn.onclick = function () {
				self.video.play();
			};
			this.pauseBtn.onclick = function () {
				self.video.pause();
			};
			this.video.onloadedmetadata = function (event) {
				self._reloadTime.call(self);
				self._reloadRewind.call(self);
				self._reloadBuffered.call(self);
				self._reloadAspectRatio.call(self);
				self._reloadEmbed.call(self);
				self._ready.call(self);
			};
			this.video.onpause = function () {
				if (!self.isRewind) self._pauseCallback.call(self);
			};
			this.video.onplaying = function () {
				self._playingCallback.call(self);
			};
			this.video.onended = function () {
				if (!self.isRewind) {
					self._endCallback.call(self);
				}
			};
			this.video.ontimeupdate = function () {
				self._timeupdateCallback.call(self);
			};
			this.video.onwaiting = function () {
				console.log('waiting');
			};
		}
	}, {
		key: '_addToggle',
		value: function _addToggle() {
			var self = this;

			if (!this.isMobileAgent) {
				this.toggle.onclick = function () {
					self._toggle.call(self);
				};
			}
		}
	}, {
		key: '_addFooterPanel',
		value: function _addFooterPanel() {
			var self = this;
			this.wrapper['on' + this.eNames.enter] = function () {
				self._showControlsAtTime.call(self);
			};
			this.wrapper['on' + this.eNames.leave] = function () {
				self._hideControlsAtTime.call(self);
			};
			this.wrapper['on' + this.eNames.move] = function () {
				self._showControlsAtTime.call(self);
			};
			this.footer['on' + this.eNames.enter] = function () {
				self.wrapper['on' + self.eNames.enter] = function () {};
				self.wrapper['on' + self.eNames.move] = function () {};
				self._showControls.call(self);
			};
			this.footer['on' + this.eNames.leave] = function () {
				self.wrapper['on' + self.eNames.enter] = function () {
					self._showControlsAtTime.call(self);
				};
				self.wrapper['on' + self.eNames.move] = function () {
					self._showControlsAtTime.call(self);
				};
			};
		}
	}, {
		key: '_toggle',
		value: function _toggle() {
			this.video.paused ? this.video.play() : this.video.pause();
		}
	}, {
		key: '_playingCallback',
		value: function _playingCallback() {
			this.wrapper.className = this.wrapper.className.replace(/\s*(htmlPlayer-pause|htmlPlayer-playing)/g, '') + ' htmlPlayer-playing';
		}
	}, {
		key: '_pauseCallback',
		value: function _pauseCallback() {
			this.wrapper.className = this.wrapper.className.replace(/\s*(htmlPlayer-pause|htmlPlayer-playing)/g, '') + ' htmlPlayer-pause';
		}
	}, {
		key: '_endCallback',
		value: function _endCallback() {
			this.wrapper.className = this.wrapper.className.replace(/\s*(htmlPlayer-pause|htmlPlayer-playing)/g, '');
			this.afterEnd(); //определяется в основном плеере
		}
	}, {
		key: '_timeupdateCallback',
		value: function _timeupdateCallback() {
			this._updateTimeCur(this.video.currentTime);
			if (!this.isRewind) {
				this.rewind.update({ value: this.video.currentTime, max: this.video.duration });
				this._checkStat();
			}
		}
	}, {
		key: '_showControls',
		value: function _showControls() {
			this._clearControlsAtTime();
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-footer/, '') + ' htmlPlayer-footer';
		}
	}, {
		key: '_showControlsAtTime',
		value: function _showControlsAtTime() {
			var self = this;
			this._clearControlsAtTime();
			this._showControls();
			this._hideControlsAtTime();
		}
	}, {
		key: '_clearControlsAtTime',
		value: function _clearControlsAtTime() {
			try {
				clearTimeout(this.clearControls);
			} catch (e) {}
		}
	}, {
		key: '_hideControls',
		value: function _hideControls() {
			this._clearControlsAtTime();
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-(footer|share)/g, '');
		}
	}, {
		key: '_hideControlsAtTime',
		value: function _hideControlsAtTime() {
			var self = this;
			this._clearControlsAtTime();
			this.clearControls = setTimeout(function () {
				self._hideControls.call(self);
			}, this.controlsDur);
		}
	}, {
		key: '_getQuality',
		value: function _getQuality() {
			if (Object.keys(this.dataQuality).length > 1) {
				if (localStorage.videoQuality && this.dataQuality[localStorage.videoQuality]) this.quality = localStorage.videoQuality;else if (this.dataQuality.HQ && screen.height > 1079) this.quality = 'HQ';else this.quality = 'LQ';
			} else this.quality = 'LQ';
		}
	}, {
		key: '_addQuality',
		value: function _addQuality() {
			if (Object.keys(this.dataQuality).length > 1) {
				var self = this;

				this.qualityBtn.className = this.qualityBtn.className + ' htmlPlayer_qualityBtn-' + this.quality;

				this.qualityBtn.onclick = function () {
					self._changeQuality.call(self);
				};
			} else this.qualityBtn.style.display = 'none';
		}
	}, {
		key: '_changeQuality',
		value: function _changeQuality() {
			var cls = this.qualityBtn.className.replace(' htmlPlayer_qualityBtn-' + this.quality, '');
			this.quality = this.quality === 'HQ' ? 'LQ' : 'HQ';
			localStorage.videoQuality = this.quality;
			this.qualityBtn.className = cls + ' htmlPlayer_qualityBtn-' + this.quality;
			this.isAutoPlay = true;
			this._reloadVideo();
		}
	}, {
		key: '_addFullscreen',
		value: function _addFullscreen() {
			this.fullscreen = this.controls.querySelector('[data-js="fullscreen"]');
			this.fullscreenRequest = this.fullscreen.querySelector('[data-js="fullscreen-request"]');
			this.fullscreenExit = this.fullscreen.querySelector('[data-js="fullscreen-exit"]');

			var enabledName = function (doc) {
				if ('fullscreenEnabled' in doc) return 'fullscreenEnabled';
				if ('mozFullScreenEnabled' in doc) return 'mozFullScreenEnabled';
				if ('webkitFullscreenEnabled' in doc) return 'webkitFullscreenEnabled';
				if ('msFullscreenEnabled' in doc) return 'msFullscreenEnabled';
				return false;
			}(document);

			if (!enabledName) {
				this.fullscreen.style.display = 'none';
				return false;
			}

			var self = this;

			var eName = function (doc) {
				if ('onfullscreenchange' in doc) return 'fullscreenchange';
				if ('onmozfullscreenchange' in doc) return 'mozfullscreenchange';
				if ('onwebkitfullscreenchange' in doc) return 'webkitfullscreenchange';
				if ('onmsfullscreenchange' in doc) return 'msfullscreenchange'; //MSFullscreenChange
				return false;
			}(document);

			var fullscreenElement = function (doc) {
				if ('fullscreenElement' in doc) return 'fullscreenElement';
				if ('mozFullScreenElement' in doc) return 'mozFullScreenElement';
				if ('webkitFullscreenElement' in doc) return 'webkitFullscreenElement';
				if ('msFullscreenElement' in doc) return 'msFullscreenElement';
				return false;
			}(document);

			var request = function (el) {
				if (el.requestFullscreen) return 'requestFullscreen';
				if (el.mozRequestFullScreen) return 'mozRequestFullScreen';
				if (el.webkitRequestFullscreen) return 'webkitRequestFullscreen';
				if (el.msRequestFullscreen) return 'msRequestFullscreen';
				return false;
			}(this.wrapper);

			var exit = function () {
				if (document.exitFullscreen) return 'exitFullscreen';else if (document.mozCancelFullScreen) return 'mozCancelFullScreen';else if (document.webkitCancelFullScreen) return 'webkitCancelFullScreen';else if (document.msExitFullscreen) return 'msExitFullscreen';
				return false;
			}();

			document['on' + eName] = function (event) {
				event.preventDefault();
				if (document[fullscreenElement]) self._showFullscreen.call(self);else self._hideFullscreen.call(self);
			};

			this.fullscreenRequest.onclick = function () {
				if (request) {
					self.wrapper[request]();
				} else alert('К сожалению, ваш браузер не поддерживает фуллскрин');
			};

			this.fullscreenExit.onclick = function () {
				if (exit) {
					document[exit]();
				} else alert('Нажмите кнопку ESC для выхода из полноэкранного режима');
			};
		}
	}, {
		key: '_showFullscreen',
		value: function _showFullscreen() {
			var self = this;
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-fullscreen/, '') + ' htmlPlayer-fullscreen';
		}
	}, {
		key: '_hideFullscreen',
		value: function _hideFullscreen() {
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-fullscreen/, '');
		}
	}, {
		key: '_addSharePanel',
		value: function _addSharePanel() {
			var self = this;

			this.shareBtn.onclick = function () {
				if (self.wrapper.className.indexOf('htmlPlayer-share') !== -1) {
					self.wrapper.className = self.wrapper.className.replace(/\s*htmlPlayer-share/, '');
				} else self.wrapper.className = self.wrapper.className + ' htmlPlayer-share';
			};
		}
	}, {
		key: '_reloadVideo',
		value: function _reloadVideo() {
			this.wrapper.className = this.wrapper.className.replace(/\s*htmlPlayer-(ready|poster|playing|pause)/g, '');

			this.video.innerHTML = '';
			var source = document.createElement('SOURCE');
			source.setAttribute('src', this.dataQuality[this.quality] + '.' + this.format);
			source.setAttribute('type', 'video/' + this.format);
			this.video.appendChild(source);
			this.video.load();
		}
	}, {
		key: '_reloadTime',
		value: function _reloadTime() {
			this._updateTimeDur(this.video.duration);
			this._updateTimeCur(0);
		}
	}, {
		key: '_reloadRewind',
		value: function _reloadRewind() {
			this.rewind.update({ "value": 0, "max": this.video.duration });
		}
	}, {
		key: '_reloadBuffered',
		value: function _reloadBuffered() {
			this.buffered.style.width = '0%';
		}
	}, {
		key: '_reloadAspectRatio',
		value: function _reloadAspectRatio() {
			if (this.video.videoWidth) this.aspectRatio = this.video.videoHeight / this.video.videoWidth;else this.aspectRatio = .5625;
			//this.wrapper.style.paddingTop = this.aspectRatio * 100 + '%';

			if (this.onsetSize) {
				var box = this.wrapper.getBoundingClientRect();
				this.onsetSize({ width: box.right - box.left, height: box.bottom - box.top });
			}
		}
	}, {
		key: '_reloadEmbed',
		value: function _reloadEmbed() {
			var h = this.embedWidth * this.aspectRatio;
			this._changeEmbed(this.embedWidth, h);
		}
	}, {
		key: '_updateTimeCur',
		value: function _updateTimeCur(sec) {
			this.timeCur.innerHTML = this._convertTime(sec);
		}
	}, {
		key: '_updateTimeDur',
		value: function _updateTimeDur(sec) {
			this.timeDur.innerHTML = this._convertTime(sec);
		}
	}, {
		key: '_convertTime',
		value: function _convertTime(sec) {
			function num(val) {
				val = Math.floor(val);
				return val < 10 ? '0' + val : val;
			}

			var hours = num(sec / 3600 % 24),
			    minutes = num(sec / 60 % 60),
			    seconds = num(sec % 60);

			hours = hours === '00' ? '' : hours + ':';
			return hours + minutes + ':' + seconds;
		}
	}, {
		key: '_ready',
		value: function _ready() {
			/* нафиг теперь не нужно, нужно сразу запускать */
			var cls = this.wrapper.className.replace(/\s*htmlPlayer-(ready|poster|disabled)/g, '') + ' htmlPlayer-ready';

			if (this.isAutoPlay) {
				this.isAutoPlay = false;
				this.paramPlayer.autoplay = false;

				this._showControlsAtTime();
				this.video.play();
			}
			this.wrapper.className = cls;
		}
	}, {
		key: '_initialize',
		value: function _initialize() {
			this.video.innerHTML = '';
			this.video.load();
		}
	}, {
		key: 'del',
		value: function del() {
			this.video.onloadedmetadata = function () {};
			this.video.innerHTML = '';
			this.video.setAttribute('src', '');
			this.insert.innerHTML = '';
		}
	}]);

	return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{"../modules/Meter":21}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	function _class(wrapper) {
		_classCallCheck(this, _class);

		this.console = document.getElementById('console');
		this._createElements(wrapper);
		this._addEventsName();
		this._updateData(JSON.parse(this.wrapper.getAttribute('data-meter')));
		this._addProgress('init', this._calculateRatioByValue());
		this._addEvents();
	}

	_createClass(_class, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			this.wrapper = wrapper;
			this.progress = this.wrapper.querySelector('[data-js="progress"]');
			this.slider = this.wrapper.querySelector('[data-js="slider"]');
			this.data = { min: 0, max: 1, value: 0 }; //by default
		}
	}, {
		key: '_addEventsName',
		value: function _addEventsName() {
			this.eNames = {};
			if (window.navigator.pointerEnabled) this.eNames = { 'down': 'pointerdown', 'move': 'pointermove', 'leave': 'pointerleave', 'up': 'pointerup' };else if (window.navigator.msPointerEnabled) this.eNames = { 'down': 'MSPointerDown', 'move': 'MSPointerMove', 'leave': 'MSPointerLeave', 'up': 'MSPointerUp' };else if ('ontouchstart' in document.documentElement) {
				this.eNames = { 'down': 'touchstart', 'move': 'touchmove', 'leave': 'touchend', 'up': 'touchend' };
			} else this.eNames = { 'down': 'mousedown', 'move': 'mousemove', 'leave': 'mouseleave', 'up': 'mouseup' };
		}
	}, {
		key: '_updateData',
		value: function _updateData(data) {
			for (var key in this.data) {
				this.data[key] = data[key] === undefined ? this.data[key] : data[key];
			}
			this.curValue = this.data.value;
			this.data.delta = this.data.max - this.data.min;
		}
	}, {
		key: '_addProgress',
		value: function _addProgress(status, ratio) {

			var per = ratio * 100 + '%';
			this.slider.style.left = per;
			this.progress.style.width = per;

			this.curValue = ratio * this.data.delta + this.data.min;
			try {
				this.callback(status, this.curValue);
			} catch (e) {}
		}
	}, {
		key: '_addEvent',
		value: function _addEvent(elem, type, handler) {
			if (elem.addEventListener) {
				elem.addEventListener(type, handler, false);
			} else {
				elem.attachEvent("on" + type, handler);
			}
		}
	}, {
		key: '_removeEvent',
		value: function _removeEvent(elem, type, handler) {
			if (elem.removeEventListener) {
				elem.removeEventListener(type, handler, false);
			} else {
				elem.detachEvent("on" + type, handler);
			}
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;

			self._circuitStartChange = function (event) {
				self._startChange.call(self, event);
			};
			self._circuitChange = function (event) {
				self._change.call(self, event);
			};
			self._circuit_stopChange = function (event) {
				self._stopChange.call(self, event);
			};

			this._addEvent(this.wrapper, this.eNames.down, function (event) {
				event = event || window.event;
				event.preventDefault(); // Для андройда, чтобы срабатывало touchend

				self._startChange.call(self, event);
				self._addEvent(document.body, self.eNames.move, self._circuitChange);
				self._addEvent(document.body, self.eNames.leave, self._circuit_stopChange);
				self._addEvent(document.body, self.eNames.up, self._circuit_stopChange);
			});
		}
	}, {
		key: '_startChange',
		value: function _startChange(event) {
			event = event || window.event;
			event = event.touches ? event.touches[0] : event;
			this.startX = event.clientX;
			this.wrapperWidth = this.wrapper.getBoundingClientRect().right - this.wrapper.getBoundingClientRect().left;
			this.progressWidth = this.startX - this.wrapper.getBoundingClientRect().left;

			var ratio = Math.min(Math.max(0, this.progressWidth / this.wrapperWidth), 1);
			this._addProgress('down', ratio);
		}
	}, {
		key: '_change',
		value: function _change(event) {
			event = event || window.event;
			event = event.targetTouches ? event.targetTouches[0] : event;

			this._addProgress('move', this._calculateRatioByEvent(event));
		}
	}, {
		key: '_stopChange',
		value: function _stopChange(event) {
			event = event || window.event;
			event = event.changedTouches ? event.changedTouches[0] : event;

			this._removeEvent(document.body, this.eNames.move, this._circuitChange);
			this._removeEvent(document.body, this.eNames.leave, this._circuit_stopChange);
			this._removeEvent(document.body, this.eNames.up, this._circuit_stopChange);

			this._addProgress('up', this._calculateRatioByEvent(event));
		}
	}, {
		key: '_calculateRatioByEvent',
		value: function _calculateRatioByEvent(event) {
			var offset = event.clientX - this.startX;
			var ratio = (this.progressWidth + offset) / this.wrapperWidth;
			ratio = Math.min(Math.max(0, ratio), 1);
			return ratio;
		}
	}, {
		key: '_calculateRatioByValue',
		value: function _calculateRatioByValue() {
			var ratio = this.data.delta ? (this.data.value - this.data.min) / this.data.delta : 0;
			return ratio;
		}
	}, {
		key: 'update',
		value: function update(data) {

			this._updateData(data);
			this._addProgress('update', this._calculateRatioByValue());
		}
	}, {
		key: 'getValue',
		value: function getValue() {
			return this.curValue;
		}
	}]);

	return _class;
}();

exports.default = _class;
;
module.exports = exports.default;

},{}],22:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* кнопка еще в фильме и кинотеатре и в гармошке
*
* */

var _class = function () {
    function _class(wrapper) {
        _classCallCheck(this, _class);

        var self = this;
        this.wrapper = wrapper;
        this.btn = this.wrapper.getAttribute('data-More-btn') === null ? this.wrapper.querySelector('[data-More-btn]') : this.wrapper;
        _event.event.add(this.btn, 'click', function (e) {
            e.preventDefault();
            self._showMore.call(self);
        });
    }

    _createClass(_class, [{
        key: '_createElements',
        value: function _createElements() {
            this.fullDesc = this.wrapper.nextSibling.nodeType == 1 ? this.wrapper.nextSibling : this.wrapper.nextSibling.nextSibling;

            var prev = this.wrapper.previousSibling.nodeType == 1 ? this.wrapper.previousSibling : this.wrapper.previousSibling.previousSibling;
            if (prev && prev.id == 'movieInfo-secondMenu') {
                this.menu = prev;
            }
        }
    }, {
        key: '_showMore',
        value: function _showMore() {
            if (!this.fullDesc) this._createElements();
            this.wrapper.style.display = 'none';
            this.fullDesc.className = this.fullDesc.className + ' js-active';
            if (this.menu) this.menu.className = this.menu.className + ' js-active';
        }
    }]);

    return _class;
}();

exports.default = _class;
;

/*export {More};*/

module.exports = exports.default;

},{"../modules/event":79}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
                value: true
});
exports.MovieList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _Player = require('../modules/Player');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* TODO
 * delete
  * */

var MovieList = function () {
                function MovieList(wrapper) {
                                _classCallCheck(this, MovieList);

                                this._createElements(wrapper);
                                this._addEvents();
                }

                _createClass(MovieList, [{
                                key: '_createElements',
                                value: function _createElements(wrapper) {
                                                this.wrapper = wrapper;
                                                this.frame = this.wrapper.querySelector('[data-MovieList-frame]');
                                                this.itemAll = this.wrapper.querySelectorAll('[data-MovieList-item]');
                                                this.curInd;
                                                this.player;
                                }
                }, {
                                key: '_addEvents',
                                value: function _addEvents() {
                                                var self = this;

                                                for (var i = 0, j = this.itemAll.length; i < j; i++) {
                                                                var item = this.itemAll[i];
                                                                if (item.className.indexOf('js-active') !== -1) this.curInd = i;

                                                                _event.event.add(item, 'click', function (i) {
                                                                                return function (e) {
                                                                                                e.preventDefault();
                                                                                                if (this.className.indexOf('js-active') !== -1) return false;

                                                                                                self.itemAll[self.curInd].className = self.itemAll[self.curInd].className.replace(/\s*js-active/, '');
                                                                                                this.className = this.className + ' js-active';
                                                                                                self.curInd = i;

                                                                                                var data = JSON.parse(this.getAttribute('data-MovieList-item'));

                                                                                                self.frame.removeChild(self.frame.firstChild);

                                                                                                var btn = this;

                                                                                                try {
                                                                                                                self.player.del();
                                                                                                } catch (e) {};
                                                                                                delete self.player;

                                                                                                if (data.youtube) {
                                                                                                                self.frame.innerHTML = '<div class="youtubePlayer">' + '<iframe class="youtubePlayer_iframe" src="' + data.youtube + '?autoplay=true" allowfullscreen="" frameborder="0"></iframe>' + '</div>';
                                                                                                } else {
                                                                                                                self.frame.innerHTML = '<div data-param=\'' + btn.getAttribute('data-MovieList-item') + '\' class="player"></div>';
                                                                                                                self.player = new _Player.Player(self.frame.firstChild);
                                                                                                }
                                                                                };
                                                                }(i));
                                                }
                                }
                }]);

                return MovieList;
}();

exports.MovieList = MovieList;

},{"../modules/Player":29,"../modules/event":79}],24:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
                value: true
});
exports.MovieList2 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _scriptonload = require('../modules/scriptonload');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MovieList2 = function () {
                function MovieList2(wrapper) {
                                _classCallCheck(this, MovieList2);

                                this._createElements(wrapper);
                                this._addEvents();
                }

                _createClass(MovieList2, [{
                                key: '_createElements',
                                value: function _createElements(wrapper) {
                                                this.wrapper = wrapper;
                                                this.frame = this.wrapper.querySelector('[data-MovieList-frame]');
                                                this.itemAll = this.wrapper.querySelectorAll('[data-MovieList-item]');
                                                this.curInd;
                                                this.player;
                                }
                }, {
                                key: '_addEvents',
                                value: function _addEvents() {
                                                var self = this;

                                                for (var i = 0, j = this.itemAll.length; i < j; i++) {
                                                                var item = this.itemAll[i];
                                                                if (item.className.indexOf('js-active') !== -1) this.curInd = i;

                                                                _event.event.add(item, 'click', function (i) {
                                                                                return function (e) {
                                                                                                e.preventDefault();
                                                                                                if (this.className.indexOf('js-active') !== -1) return false;

                                                                                                self.itemAll[self.curInd].className = self.itemAll[self.curInd].className.replace(/\s*js-active/, '');
                                                                                                this.className = this.className + ' js-active';
                                                                                                self.curInd = i;

                                                                                                var data = JSON.parse(this.getAttribute('data-MovieList-item'));

                                                                                                self.frame.removeChild(self.frame.firstChild);

                                                                                                var btn = this;

                                                                                                try {
                                                                                                                self.player.del();
                                                                                                } catch (e) {};
                                                                                                delete self.player;

                                                                                                self.frame.innerHTML = '<div data-param=\'' + btn.getAttribute('data-MovieList-item') + '\' class="combinedPlayer"></div>';

                                                                                                var init = function init() {
                                                                                                                self.player = uPlayer(self.frame.firstChild);
                                                                                                };
                                                                                                if (!window.uPlayer) (0, _scriptonload.scriptonload)(APP.vendors.uPlayer, init);else init();
                                                                                };
                                                                }(i));
                                                }
                                }
                }]);

                return MovieList2;
}();

exports.MovieList2 = MovieList2;

},{"../modules/event":79,"../modules/scriptonload":106}],25:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MyWidgetFilms = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ajax = require('../modules/ajax');

var _event = require('../modules/event');

var _Vote2 = require('../modules/Vote');

var _Vote3 = _interopRequireDefault(_Vote2);

var _Rating2 = require('../modules/Rating');

var _Rating3 = _interopRequireDefault(_Rating2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyWidgetFilms = function () {
    function MyWidgetFilms(wrapper) {
        _classCallCheck(this, MyWidgetFilms);

        this._createElements(wrapper);
        this._createFilmAll();
    }

    _createClass(MyWidgetFilms, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var parent = this;
            this.wrapper = wrapper;
            this.filmAll = this.wrapper.querySelectorAll('[data-myWidgetFilms-modules]');
            this.ajaxUrl = this._defineAjaxPart() + '/widget/';
            this.ajaxParamAll = ['release', 'premiere'], this.xmlhttp = false;
            this.actions = {
                Vote: function Vote(el) {
                    return new _Vote3.default(el);
                },
                Rating: function Rating(el) {
                    return new _Rating3.default(el);
                }
            };
            this.Film = function () {
                function _class(wrapper) {
                    _classCallCheck(this, _class);

                    this._createElements(wrapper);
                    this._createModules(wrapper);
                }

                _createClass(_class, [{
                    key: '_createElements',
                    value: function _createElements(wrapper) {
                        this.wrapper = wrapper;
                        this.moduleAll = [];
                        //например, голосовать можно много раз и  тогда можно отправить несколько запров - полуится три фильиа в виджете, повторно не отправляем..
                        this.isSending = false;
                    }
                }, {
                    key: '_createModules',
                    value: function _createModules() {
                        var self = this,
                            nameAll = this.wrapper.getAttribute('data-myWidgetFilms-modules').split(' ');

                        for (var m = 0, n = nameAll.length; m < n; m++) {
                            if (parent.actions[nameAll[m]]) {
                                var module = parent.actions[nameAll[m]](this.wrapper);
                                module.successExec = function () {

                                    if (self.isSending) return false;
                                    self.isSending = true;

                                    parent._showOther.call(parent, self);
                                };
                                this.moduleAll.push(module);
                            }
                        }
                    }
                }, {
                    key: '_delModuleAll',
                    value: function _delModuleAll() {
                        for (var i = 0, j = this.moduleAll.length; i < j; i++) {
                            if (this.moduleAll[i].del) this.moduleAll[i].del();
                        }
                        this.moduleAll = [];
                    }
                }, {
                    key: 'del',
                    value: function del() {
                        parent.wrapper.removeChild(this.wrapper);
                        this._delModuleAll();
                        delete this.wrapper;
                        delete this.filmAll;
                    }
                }]);

                return _class;
            }();
        }
    }, {
        key: '_createFilmAll',
        value: function _createFilmAll() {
            for (var i = 0, j = this.filmAll.length; i < j; i++) {
                new this.Film(this.filmAll[i]);
            }
        }
    }, {
        key: '_defineAjaxPart',
        value: function _defineAjaxPart() {
            var part = (window.location + '').indexOf('/build/') === -1 ? '' : 'layouts';
            return part;
        }
    }, {
        key: '_showOther',
        value: function _showOther(film) {
            var self = this;
            (0, _ajax.ajax)({
                url: this.ajaxUrl + this.ajaxParamAll[Math.round(Math.random())],
                method: 'POST',
                callback: function callback(msg) {
                    var msg = JSON.parse(msg);
                    if (msg.status) {
                        var container = document.createElement('div'),
                            newFilmEl;

                        container.innerHTML = msg.content;
                        newFilmEl = container.firstChild;
                        new self.Film(newFilmEl);
                        self.wrapper.appendChild(newFilmEl);
                        container = false;
                        film.del();
                    } else {
                        film.isSending = false;
                    }
                    film = null;
                }
            });
        }
    }]);

    return MyWidgetFilms;
}();

;

exports.MyWidgetFilms = MyWidgetFilms;

},{"../modules/Rating":35,"../modules/Vote":55,"../modules/ajax":61,"../modules/event":79}],26:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.NavMonth = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _scriptonload = require('../modules/scriptonload');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavMonth = function () {
	function NavMonth(wrapper) {
		_classCallCheck(this, NavMonth);

		this._createElements(wrapper);
		this._sortYear();
		this._sortMonth();
		this._sortAnchor();
		this._addEvents();
		this._checkSticky();
		//this._scrollToAnchor(false, this.curAnchor); Убираем прокрутку при загрузке
		(0, _scriptonload.scriptonload)('/static/js/vendors/stickyfill.min.js', function () {
			Stickyfill.add(wrapper);
		});
	}

	_createClass(NavMonth, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			this.wrapper = wrapper;
			this.strip = this.wrapper.querySelector('[data-NavMonth-strip]');
			this.topBtn = this.wrapper.querySelector('[data-navMonth-topBtn]');
			this.wrapperHeight = this.wrapper.getBoundingClientRect().height;
			this.footer = document.getElementById('footer');
			this.yearAllByAnchor = {}; //хэш всех годов по ссылке
			this.yearAllByYear = {};
			this.monthAllByAnchor = {};
			this.monthByYear = {}; //хэш первых месяцев в каждом году. Необходимо, чтобы двигать меню при изменении  года
			this.anchorAll = {}; // хэш всех якорных заголовков
			this.curAnchor; //активный на данный момент элемент
			this.curYear; //активный на данный момент год
			this.scrollDelay = 100;
			this.isChanging = false;
		}
	}, {
		key: '_sortYear',
		value: function _sortYear() {
			var all = this.wrapper.querySelectorAll('[data-NavMonth-year]');
			for (var i = 0, j = all.length; i < j; i++) {
				var anchor = all[i].getAttribute('data-NavMonth-year');
				var year = anchor.split('_')[1];

				//
				this.yearAllByAnchor[anchor] = all[i];
				this.yearAllByYear[year] = all[i];

				if (all[i].className.indexOf('g-active') !== -1) this.curYear = year;
			}
		}
	}, {
		key: '_sortMonth',
		value: function _sortMonth() {
			var all = this.wrapper.querySelectorAll('[data-NavMonth-month]');
			for (var i = 0, j = all.length; i < j; i++) {

				var data = JSON.parse(all[i].getAttribute('data-NavMonth-month')),
				    anchor = data.anchor,
				    year = data.year;

				this.monthAllByAnchor[anchor] = all[i];

				if (year) {
					this.monthByYear[year] = all[i];
				}

				if (all[i].className.indexOf('g-active') !== -1) this.curAnchor = anchor;
			}
		}
	}, {
		key: '_sortAnchor',
		value: function _sortAnchor() {
			var all = document.querySelectorAll('[data-NavMonth-anchor]');
			for (var i = 0, j = all.length; i < j; i++) {
				var anchor = all[i].getAttribute('id');
				this.anchorAll[anchor] = all[i];
			}
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {
			var self = this;
			_event.event.add(window, 'scroll', function (e) {
				self._changeCallback.call(self);
			});
			_event.event.add(window, 'resize', function (e) {
				self._changeCallback.call(self);
			});

			_event.event.add(this.topBtn, 'click', function (e) {
				e.preventDefault();
				/* TODO
     *
      *  координату x
      * */
				window.scrollTo(0, 0);
			});

			for (var key in this.yearAllByAnchor) {
				_event.event.add(this.yearAllByAnchor[key], 'click', function (key) {
					return function (e) {
						self._scrollToAnchor.call(self, e, key);
					};
				}(key));
			}

			for (var key in this.monthAllByAnchor) {
				_event.event.add(this.monthAllByAnchor[key], 'click', function (key) {
					return function (e) {
						self._scrollToAnchor.call(self, e, key);
					};
				}(key));
			}
		}
	}, {
		key: '_changeCallback',
		value: function _changeCallback() {
			if (this.isChanging) return false;
			this.isChanging = true;
			var self = this;

			this._checkSticky();
			this._findActiveAnchor();

			try {
				requestAnimationFrame(function () {
					self.isChanging = false;
				});
			} catch (e) {
				this.isChanging = false;
			}
		}
	}, {
		key: '_checkSticky',
		value: function _checkSticky() {
			var boxTop = this.wrapper.getBoundingClientRect().top,
			    footerTop = this.footer.getBoundingClientRect().top,
			    clientHeight = document.documentElement.clientHeight;

			if (boxTop <= APP.headerHeight) {
				/* && (footerTop > clientHeight) */
				if (this.wrapper.className.indexOf('js-sticky') === -1) this.wrapper.className = this.wrapper.className + ' js-sticky';
			} else if (this.wrapper.className.indexOf('js-sticky') !== -1) this.wrapper.className = this.wrapper.className.replace(/\s*js-sticky/, '');
		}
	}, {
		key: '_findActiveAnchor',
		value: function _findActiveAnchor() {
			var point = this.wrapper.getBoundingClientRect().bottom;
			var delta = false;
			var curAnchor = this.curAnchor;

			for (var key in this.anchorAll) {
				var top = this.anchorAll[key].getBoundingClientRect().top;
				var newDelta = Math.abs(top - point);
				if (!delta || newDelta < delta) {
					delta = newDelta;
					curAnchor = key;
				}
			}

			this._checkChangeMenu(curAnchor);
		}
	}, {
		key: '_checkChangeMenu',
		value: function _checkChangeMenu(curAnchor) {
			var year = curAnchor.split('_')[1];

			//смотрим поменялся ли якорь
			if (this.curAnchor !== curAnchor) {
				//меняем месяц
				this.monthAllByAnchor[this.curAnchor].className = this.monthAllByAnchor[this.curAnchor].className.replace(/ g-active/, '');

				this.curAnchor = curAnchor;
				this.monthAllByAnchor[this.curAnchor].className = this.monthAllByAnchor[this.curAnchor].className.replace(/ g-active/, '') + ' g-active';
			}

			//смотрим поменялся ли год
			if (year !== this.curYear) {
				this.yearAllByYear[this.curYear].className = this.yearAllByYear[this.curYear].className.replace(/ g-active/, '');
				this._changeStripPosition(year);

				this.curYear = year;
				this.yearAllByYear[this.curYear].className = this.yearAllByYear[this.curYear].className.replace(/ g-active/, '') + ' g-active';
			}
		}
	}, {
		key: '_changeStripPosition',
		value: function _changeStripPosition(year) {
			this.strip.style.left = this.strip.getBoundingClientRect().left - this.monthByYear[year].getBoundingClientRect().left + 'px';
		}
	}, {
		key: '_scrollToAnchor',
		value: function _scrollToAnchor(e, curAnchor) {
			if (e) e.preventDefault();

			//if(this.curAnchor === curAnchor) return;

			var target = this.anchorAll[curAnchor];
			var top = target.getBoundingClientRect().top - this.wrapperHeight - 10 - APP.headerHeight;
			window.scrollBy(0, top);
		}
	}]);

	return NavMonth;
}();

;

exports.NavMonth = NavMonth;

},{"../modules/event":79,"../modules/scriptonload":106}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OpeningUnit = function () {
	function OpeningUnit(wrapper) {
		_classCallCheck(this, OpeningUnit);

		this._createElements(wrapper);
		this._add();
	}

	_createClass(OpeningUnit, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			this.wrapper = wrapper;
			this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
			this.btn = document.querySelector('[data-openingUnit-btn="' + this.param.name + '"]');
			this.frame = this.wrapper.querySelector('[data-openingUnit-frame]');
			this.isOpen = false;
		}
	}, {
		key: '_add',
		value: function _add() {
			var self = this;
			this.btn.onclick = function () {
				self._shangeShow.call(self);
				return false;
			};
		}
	}, {
		key: '_shangeShow',
		value: function _shangeShow() {
			if (this.isOpen) {
				this.isOpen = false;
				this.wrapper.style.height = '0px';
				this.btn.className = this.btn.className.replace(/\s*g-active/, '');
			} else {
				this.isOpen = true;
				var h = this.frame.getBoundingClientRect().bottom - this.frame.getBoundingClientRect().top;
				this.wrapper.style.height = h + 'px';
				this.btn.className = this.btn.className.replace(/\s*g-active/, '') + ' g-active';
			}
			return false;
		}
	}]);

	return OpeningUnit;
}();

;

exports.OpeningUnit = OpeningUnit;

},{}],28:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Класс для проверки формы на странице.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * например, формы:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * - announce
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * - user-review
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * - donate
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Form = require('../modules/Form');

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageForm = function () {
    function PageForm(wrapper) {
        _classCallCheck(this, PageForm);

        var self = this,
            param = JSON.parse(wrapper.getAttribute('data-param')) || {};

        this.oForm = new _Form.Form({
            wrapper: wrapper,
            beforeSubmit: function beforeSubmit() {
                if (param.isNeedAuth) {
                    //check auth
                    if (APP.vars.isMobile) {
                        if (APP.auth.tryAuth()) return true;else return false;
                    } else {
                        if (!regAuthObj.isAuth) {
                            regAuthObj.authForm.showPopup();
                            return false;
                        }
                        return true;
                    }
                }
                return true;
            },
            onsuccess: function onsuccess(data) {
                if (data.link) window.location.assign(data.link);else {
                    self.oForm.resetCaptcha();
                    if (APP.vars.isMobile) {
                        alert(data.message);
                    } else {
                        uPopup({
                            content: data.message
                        });
                    }
                    self.oForm.resetForm();
                }
            },
            onerror: function onerror(data) {
                self.oForm.resetCaptcha();
                if (APP.vars.isMobile) {
                    alert(data.message);
                } else {
                    uPopup({
                        content: data.message
                    });
                }
            }
        });
    }

    _createClass(PageForm, [{
        key: 'del',
        value: function del() {
            this.oForm.del();
        }
    }]);

    return PageForm;
}();

exports.PageForm = PageForm;

},{"../modules/Form":18,"../modules/event":79}],29:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Player = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _addGlobals = require('../modules/addGlobals');

var _HTMLPlayer = require('../modules/HTMLPlayer');

var _HTMLPlayer2 = _interopRequireDefault(_HTMLPlayer);

var _AdvPlayer = require('../modules/AdvPlayer');

var _AdvPlayer2 = _interopRequireDefault(_AdvPlayer);

var _swfobject = require('../modules/swfobject');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Player = function () {
	function Player(player) {
		_classCallCheck(this, Player);

		this.player = player;
		this.data = JSON.parse(this.player.getAttribute('data-param'));
		this._getData();
	}

	_createClass(Player, [{
		key: '_getHtml',
		value: function _getHtml(data) {

			var LQ = data.files.low ? data.files.low.path.replace(/\.mp4$/, '') : false;
			var HQ = data.files.high ? data.files.high.path.replace(/\.mp4$/, '') : false;
			var quality = '"LQ": "' + LQ + '"' + (HQ ? ', "HQ": "' + HQ + '"' : '');

			return '<div data-js="html-player" data-quality=\'{' + quality + '}\' class="htmlPlayer">' + '<video data-js="video" preload="metadata" class="htmlPlayer_video" controls="controls" poster="' + data.poster + '" webkit-playsinline>' + '<source src="' + data.files.low.path + '" type="video/mp4" />' + '<a class="htmlPlayer_altVideo" href="' + data.files.low.path + '"  style="background-image:url(' + data.poster + ')">' + '<img class="htmlPlayer_altVideoPoster" src="' + data.poster + '" alt="" />' + '<img class="htmlPlayer_altVideoBtn" src="http://video.kinoafisha.info/i/player/play-btn.png" alt="" />' + '</a>' + '</video>' + '<div data-js="toggle" class="htmlPlayer_toggle">' + '<img class="htmlPlayer_bigPauseBtn" src="http://video.kinoafisha.info/i/player/pause-btn.png" alt="" />' + '</div>' + '<div data-js="footer" class="htmlPlayer_footer">' + '<div data-js="controls" class="htmlPlayer_controls">' + '<div class="htmlPlayer_controlsCell htmlPlayer_controlsCell-shrink">' + '<div class="htmlPlayer_playback htmlPlayer_controlsBtn">' + '<img data-js="play"  class="htmlPlayer_playBtn" src="http://video.kinoafisha.info/i/player/play.png" alt="" />' + '<img data-js="pause"  class="htmlPlayer_pauseBtn" src="http://video.kinoafisha.info/i/player/pause.png" alt="" />' + '</div>' + '<div class="htmlPlayer_time">' + '<span data-js="timeCur" class="htmlPlayer_timeCur"></span>' + '<span class="htmlPlayer_timeSep">/</span>' + '<span data-js="timeDur" class="htmlPlayer_timeDur"></span>' + '</div>' + '</div>' + '<div class="htmlPlayer_controlsCell">' + '<div data-js="rewind" data-meter = \'{}\'  class="playerMeter  htmlPlayer_controlsBtn">' + '<div class="playerMeter-strip"></div>' + '<div data-js="buffered" class="playerMeter-buffered"></div>' + '<div data-js="progress" class="playerMeter-progress"></div>' + '<div data-js="slider" class="playerMeter-slider"></div>' + '</div>' + '</div>' + '<div class="htmlPlayer_controlsCell  htmlPlayer_controlsCell-shrink">' + '<span data-js="quality" class="htmlPlayer_qualityBtn htmlPlayer_controlsBtn">hq</span>' + '<div data-js="mute" class="htmlPlayer_mute htmlPlayer_controlsBtn">' + '<img  data-js="mute-on" data-js="mute-on"  class="htmlPlayer_muteOn" src="http://video.kinoafisha.info/i/player/mute-on.png" alt="" />' + '<img  data-js="mute-off" data-js="mute-off"  class="htmlPlayer_muteOff" src="http://video.kinoafisha.info/i/player/mute-off.png" alt="" />' + '</div>' + '<div data-js="volume" data-meter = \'{"value": 1}\'  class="playerMeter playerMeter_volume htmlPlayer_controlsBtn">' + '<div class="playerMeter-strip"></div>' + '<div data-js="progress" class="playerMeter-progress"></div>' + '<div data-js="slider" class="playerMeter-slider"></div>' + '</div>' + '<div data-js="fullscreen" class="htmlPlayer_fullscreen htmlPlayer_controlsBtn"> ' + '<img data-js="fullscreen-request"  class="htmlPlayer_fullscreenRequest" src="http://video.kinoafisha.info/i/player/fullscreen-request.png" alt="" />' + '<img data-js="fullscreen-exit"  class="htmlPlayer_fullscreenExit" src="http://video.kinoafisha.info/i/player/fullscreen-exit.png" alt="" />' + '</div>' + '<div data-js="share-btn" class="htmlPlayer_shareBtn htmlPlayer_controlsBtn">&lt;/&gt;</div>' + '</div>' + '</div>' + '<div data-js="share" class="htmlPlayer_share">' + '<div class="htmlPlayer_shareItem">' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-title">' + 'Ссылка на ролик' + '</div>' + '<div class="htmlPlayer_shareCell">' + '<input readonly class="htmlPlayer_shareField htmlPlayer_shareField-insert" type="text" value="' + data.trailer_url + '" />' + '</div>' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">' + '&nbsp;' + '</div>' + '</div>' + '<div class="htmlPlayer_shareItem">' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-title">' + 'Код для вставки' + '</div>' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">' + '<span class="htmlPlayer_shareNote">ширина</span>' + '<input data-js="embed-width" class="htmlPlayer_shareField htmlPlayer_shareField-size" type="text" value="640" />' + '<span class="htmlPlayer_shareNote">высота</span>' + '<input data-js="embed-height" class="htmlPlayer_shareField htmlPlayer_shareField-size" type="text" value="360" />' + '</div>' + '<div class="htmlPlayer_shareCell">' + '<input data-js="embed" readonly class="htmlPlayer_shareField htmlPlayer_shareField-insert" type="text" value=\'' + data.embed_url + '\' />' + '</div>' + '<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">' + '&nbsp;' + '</div>' + '</div>' + '</div>' + '</div>' + '<img  class="htmlPlayer_logo" src="http://video.kinoafisha.info/i/player/logo.png" alt="" />' + '<div data-js="poster" class="htmlPlayer_poster" style="background-image:url(' + data.poster + ')">' + '<div class="htmlPlayer_posterInfo">' + '<span class="htmlPlayer_posterCat">' + data.title + '</span>' + '<span class="htmlPlayer_posterName">' + data.movie_name + '</span>' + '</div>' + '<img  class="htmlPlayer_posterBtn" src="http://video.kinoafisha.info/i/player/play-btn.png" alt="" />' + '</div>' + '<div class="htmlPlayer_preloader"></div>' + '</div>' + '<div data-js="adv-player" data-param="' + data.advVideo + '" class="advPlayer">' + '<video data-js="adv-video" class="advPlayer_video"></video>' + '<a data-js="adv-clicking-btn" class="advPlayer_link" target="_blank" href="' + data.advLink + '"></a>' + '<div class="advPlayer_controls">' + '<div class="advPlayer_controlsCell">' + '<span class="advPlayer_param">Реклама.</span> <span data-js="adv-left" class="advPlayer_param">&nbsp;</span>' + '</div>' + '<div class="advPlayer_controlsCell">' + '<a data-js="adv-skip-btn" class="advPlayer_param" href="#">&nbsp;</a>' + '</div>' + '</div>' + '<div class="advPlayer_before">' + '<div class="advPlayer_beforeContent">' + '<div class="advPlayer_beforeContentItem">Реклама</div>' + '</div>' + '</div>' + '<div class="advPlayer_preloader"></div>' + '</div>';
		}
	}, {
		key: '_getData',
		value: function _getData() {
			var self = this,
			    path = window.location.hostname.indexOf('kinoafishaspb.ru') === -1 ? 'kinoafisha.info' : 'kinoafishaspb.ru';

			GLOBALS.scriptRequest('http://api.' + path + '/player/info/' + this.data.trailer_id + '/', function (data) {
				self._onSuccess.call(self, data);
			}, function () {
				self._onError.call(self);
			});
		}
	}, {
		key: '_onSuccess',
		value: function _onSuccess(dataApi) {
			this.player.innerHTML = this._getHtml(this._checkAdv(dataApi));
			this._initHTMLPlayer();
		}
	}, {
		key: '_onError',
		value: function _onError() {}
	}, {
		key: '_checkAdv',
		value: function _checkAdv(dataApi) {
			//var num = Math.floor(Math.random() * (4 - 1 + 1)) + 1;
			//var num = 6;

			//dataApi.advVideo = 'http://video.kinoafisha.info/branding/binomo/binomo-' + num;
			//dataApi.advLink = 'http://t.trafdsp.com/in/kinoafisha'+ num +'/';
			dataApi.advVideo = 'http://video.kinoafisha.info/branding/kinoafisha/kinoafisha-youtube';
			dataApi.advLink = 'https://www.youtube.com/channel/UCNuQyDGBj28VwMRhCy_hTOw';

			return dataApi;
		}
	}, {
		key: '_initFlashPlayer',
		value: function _initFlashPlayer() {
			var self = this;

			this.player.innerHTML = '<div id="' + 'flash-' + this.data.trailer_id + '"></div>';
			this.player.className += ' player-flash';

			_swfobject.swfobject.embedSWF('http://v0.kinoafisha.org/swf/ka_player/v10_player.swf', 'flash-' + this.data.trailer_id, "100%", "100%", "9.0.0", "http://v0.kinoafisha.org/swf/expressInstall.swf", {
				"trailer_id": this.data.trailer_id,
				"host": this.data.host,
				"bottom_vote": this.data.bottom_vote,
				"autostart": "false"
			}, {
				"quality": "high",
				"wmode": "opaque",
				"allowFullScreen": "true",
				"allowScriptAccess": "always"
			}, null, function (e) {
				//if(!e.success) self._initHTMLPlayer.call(self);
			});
		}
	}, {
		key: '_initHTMLPlayer',
		value: function _initHTMLPlayer() {
			var htmlPlayerWrapper = this.player.querySelector('[data-js="html-player"]');
			var advPlayerWrapper = this.player.querySelector('[data-js="adv-player"]');
			var advPlayer = this.data.isHideAdv ? false : new _AdvPlayer2.default(advPlayerWrapper);
			//var advPlayer = false;

			this.htmlPlayer = new _HTMLPlayer2.default(htmlPlayerWrapper, advPlayer, this.data);

			if (!this.htmlPlayer.isCanPlay) this._initFlashPlayer();
		}
	}, {
		key: 'del',
		value: function del() {
			this.htmlPlayer.video.onloadedmetadata = function () {};
			this.htmlPlayer.video.innerHTML = '';
			this.htmlPlayer.video.setAttribute('src', '');
			delete this.htmlPlayer;
		}
	}]);

	return Player;
}();

//window.Player = Player;


exports.Player = Player;

},{"../modules/AdvPlayer":4,"../modules/HTMLPlayer":19,"../modules/addGlobals":59,"../modules/swfobject":113}],30:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Popup = function () {
	function Popup(param) {
		_classCallCheck(this, Popup);

		this.byDefault = {
			btnConfirm: 'Ок',
			btnCancel: 'Отмена'
		};
		this.create(param);
		this._add(param);
	}

	_createClass(Popup, [{
		key: '_add',
		value: function _add(data) {
			var obj = this;
			this.name = this.param.name || 'popup-' + new Date().getTime();

			if (typeof data == 'string') this.content.innerHTML = data;else if (typeof data.content == 'string') this.content.innerHTML = data.content;else if (_typeof(data.content) == 'object') {
				this.popupInner = data.content;
				this.content.appendChild(data.content);
			}

			if (data.title) {
				this.title.innerHTML = data.title;
				this.title.style.display = 'block';
			} else {
				this.title.innerHTML = '';
				this.title.style.display = 'none';
			}

			this.isShowBtn(data.btnConfirm, 'btnConfirm');
			this.isShowBtn(data.btnCancel, 'btnCancel');

			if (data.btnConfirm || data.btnCancel) this.table.className = this.table.className + ' popup-controls';

			this.showX(data);

			this.table.className = this.table.className + ' ' + (data.addClass || '');
		}
	}, {
		key: 'showX',
		value: function showX(param) {
			var self = this;
			for (var i = 0, j = this.btnCloseAll.length; i < j; i++) {
				this.btnCloseAll[i].onclick = function (event) {
					event = event || window.event;
					event.preventDefault ? event.preventDefault() : event.returnValue = false;
					self.close.call(self);
				};
			}
			if (param.autoClose) {
				//если шаблон прогрессбар запускаем таймер
				this.runTimer(param);
			}
		}
	}, {
		key: 'isShowBtn',
		value: function isShowBtn(btn, name) {
			var obj = this;
			if (btn) {
				if (typeof btn == 'boolean') {
					this[name].innerHTML = this.byDefault[name];
					this[name].onclick = function (event) {
						event = event || window.event;
						event.preventDefault ? event.preventDefault() : event.returnValue = false;
						obj.close.call(obj);return false;
					};
				} else if (typeof btn == 'string') {
					this[name].innerHTML = btn;
					this[name].onclick = function (event) {
						event = event || window.event;
						event.preventDefault ? event.preventDefault() : event.returnValue = false;
						obj.close.call(obj);return false;
					};
				} else {
					this[name].innerHTML = btn.name || this.byDefault[name];

					this[name].onclick = function (event) {
						event = event || window.event;
						event.preventDefault ? event.preventDefault() : event.returnValue = false;

						if (btn.callback == undefined) obj.close.call(obj);else {
							if (!btn.callback()) obj.close.call(obj);
						}

						return false;
					};
				}
				//доб класс
				if (btn.className) var className = this[name].defaultClass + ' ' + btn.className;else var className = this[name].defaultClass;
				this[name].className = className;

				this[name].className = this[name].className.replace(/ disabled/, '');
			} else this[name].className = this[name].className.replace(/ disabled/, '') + ' disabled';
		}
	}, {
		key: 'create',
		value: function create(param) {
			var obj = this;
			this.param = param;
			var popupClassName = 'popup ' + (this.param.addClass || '');

			this.disabled = false;
			this.countdownInterval = false;
			this.clearOpen = false; //
			this.clearClose = false; //чтобы избежать двойного закрытия
			this.mainFrame = document.getElementById('main-frame');
			//this.rightContent  = document.getElementById('right-content');
			this.table = document.createElement('DIV');
			this.table.className = popupClassName;

			//шаблон с прогрессбаром, шаблон с крестиком
			if (param.autoClose) {
				this.table.innerHTML = '<div class="popup_frame">' + '<div class="popup_cell">' + '<div data-js="close" class="popup_bg"></div>' + '<div data-popup-opened data-popup-closed class="popup_container layer layer-reverse">' + '<a data-js="close" class="popup_close popup_progress" href="#">' + '<div class="popup_layer"></div>' + '<div class="popup_info">' + '<span class="popup_info_text">Реклама скроется через</span>' + '<div class="popup_info_countdown"></div>' + '<div class="popup_info_close as-none js-deactivate"></div>' + '</div>' + '</a>' + '<span class="popup_title">' + '<!-- Заголовок -->' + '</span>' + '<div class="popup_content">' + '<!-- Содержимое -->' + '</div>' + '<div class="popup_btns">' + '<a href="#" class="popup_confirm popup_btn disabled">' + this.byDefault.btnConfirm + '</a>' + '<a href="#" class="popup_cancel popup_btn disabled">' + this.byDefault.btnCancel + '</a>' + '</div>' + '</div>' + '</div>' + '</div>';
			} else {
				this.table.innerHTML = '<div class="popup_frame">' + '<div class="popup_cell">' + '<div data-js="close" class="popup_bg"></div>' + '<div data-popup-opened data-popup-closed class="popup_container layer layer-reverse">' + '<a data-js="close" class="popup_close" href="#">' + '<svg class="symbol symbol-x symbol-x-popup" role="img"><use xlink:href="/static/img/symbols/sprite.svg#x"></use></svg>' + '</a>' + '<span class="popup_title">' + '<!-- Заголовок -->' + '</span>' + '<div class="popup_content">' + '<!-- Содержимое -->' + '</div>' + '<div class="popup_btns">' + '<a href="#" class="popup_confirm popup_btn disabled">' + this.byDefault.btnConfirm + '</a>' + '<a href="#" class="popup_cancel popup_btn disabled">' + this.byDefault.btnCancel + '</a>' + '</div>' + '</div>' + '</div>' + '</div>';
			}

			document.body.appendChild(this.table);
			this.container = this.table.querySelector('.popup_container');
			this.title = this.table.querySelector('.popup_title');
			this.content = this.table.querySelector('.popup_content');
			this.btnConfirm = this.table.querySelector('.popup_confirm');
			this.btnConfirm.defaultClass = this.btnConfirm.className;
			this.btnCancel = this.table.querySelector('.popup_cancel');
			this.btnCancel.defaultClass = this.btnCancel.className;
			this.btnCloseAll = this.table.querySelectorAll('[data-js="close"]');
			//this.closedElement = this.table.querySelector('[data-popup-closed]');
			//this.openedElement = this.table.querySelector('[data-popup-opened]');
			this.scrollWidth = window.innerWidth - document.body.clientWidth;
		}
	}, {
		key: 'open',
		value: function open() {
			if (this.disabled || this.clearOpen) return false;
			try {
				clearTimeout(this.clearClose);
			} catch (e) {}

			if (this.param.onopenBefore && !this.param.onopenBefore()) return false;

			var self = this;

			if (uPopup.count === 0) {
				document.body.className = document.body.className + ' js-popup';
				document.body.style.paddingRight = this.scrollWidth + 'px';
				//this.rightContent.style.left = -this.scrollWidth/2 + 'px';
			}
			this.table.className = this.table.className.replace(/\s*active/, '') + ' active';
			//this.container.className='popup_container'; //for ie<10

			uPopup.count += 1;

			this.clearOpen = setTimeout(function () {
				if (self.param.onopen) self.param.onopen(self.content);
				self.clearOpen = false;
			}, 600);
		}
	}, {
		key: 'close',
		value: function close() {
			if (this.disabled || this.clearClose) return false;
			try {
				clearTimeout(this.clearOpen);
				clearInterval(this.countdownInterval);
			} catch (e) {
				console.error(e);
			}

			this.clearClose = true;

			if (this.param.oncloseBefore) {
				if (!this.param.oncloseBefore()) {
					this.clearClose = false;
					return false;
				}
			}

			var self = this;
			this.table.className = this.table.className.replace(/\s*active/, '');

			this.clearClose = setTimeout(function () {
				document.body.removeChild(self.table);
				try {
					document.body.appendChild(self.popupInner);
				} catch (e) {};
				if (self.param.onclose) self.param.onclose();
				self.clearClose = false;
				if (uPopup.count === 1) {
					document.body.className = document.body.className.replace(/\s*js-popup/, '');
					document.body.style.paddingRight = '0px';
					//self.rightContent.style.left = '0px';
				}

				uPopup.count -= 1;
				delete uPopup.all[self.param.name];
			}, 600);
		}
	}, {
		key: 'runTimer',
		value: function runTimer(param) {
			var _this = this;

			var bar, countdownNumberEl, layer, startTime, countdown;
			//показываем тогглер в последнюю секунду
			countdown = param.autoClose / 1000;
			bar = document.querySelector('.popup_progress');
			countdownNumberEl = bar.querySelector('.popup_info_countdown');
			var close = bar.querySelector('.popup_info_close');
			//Запускаем обратный отсчет
			countdownNumberEl.textContent = countdown;
			layer = bar.querySelector('.popup_layer');
			startTime = param.autoClose / 1000;

			this.countdownInterval = setInterval(function () {
				countdown = --countdown <= 0 ? 0 : countdown;
				countdownNumberEl.textContent = countdown;
				//показываем крестик после 2 секунд
				if (startTime - 2 >= countdown) {
					close.classList.remove('as-none');
				}
				if (countdown <= 0) {
					_this.close.call(_this);
				}
			}, 900);
			//запускаем полосу
			layer.style.transition = 'width ' + countdown + 's';
			layer.style.width = '100%';
		}
	}]);

	return Popup;
}();

exports.Popup = Popup;

},{}],31:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PopupForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Form = require('../modules/Form');

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopupForm = function () {
    function PopupForm(initData) {
        _classCallCheck(this, PopupForm);

        this._createElements(initData);
        this._addEvents();
        this._checkHash();
    }

    _createClass(PopupForm, [{
        key: '_createElements',
        value: function _createElements(initData) {
            this.initData = initData;
            this.wrapper = initData.wrapper;
            this.name = this.wrapper ? this.wrapper.getAttribute('data-popupForm') : this.initData.name;
            this.btnAll = []; /* кнопки могут добавляться и удаляться, например когда мы преходим на вкладку комменты */
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this,
                all = document.querySelectorAll('[data-popupForm-btn="' + this.name + '"]');

            for (var i = 0, j = all.length; i < j; i++) {
                this.addBtn(all[i]);
            }
        }
    }, {
        key: 'addBtn',
        value: function addBtn(btn) {
            var self = this;
            this._onBtnClick = function (e) {
                e.preventDefault();
                if (self.initData.beforeShowPopup) self.initData.beforeShowPopup();
                self.showPopup.call(self);
            };

            _event.event.add(btn, 'click', this._onBtnClick);
            this.btnAll.push(btn);
        }
    }, {
        key: 'removeBtn',
        value: function removeBtn(btn) {
            _event.event.remove(btn, 'click', this._onBtnClick);

            var arr = this.btnAll,
                i = arr.indexOf(btn);

            arr.splice(i, 1);
        }

        /*
        	TODO - оформить по людски
         * data.cls - Дополнительный класс
          * */

    }, {
        key: 'getContent',
        value: function getContent() {
            var _this = this;

            if (this.initData.ajax) {
                return new Promise(function (resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", _this.initData.ajax, true);
                    xhr.setRequestHeader("X-Request-Ajax", "1");
                    xhr.setRequestHeader("X-Request-Referer", window.location.toString());
                    xhr.onload = function () {
                        resolve(xhr.responseText);
                    };
                    xhr.send('');
                });
            } else {
                return Promise.resolve(this.wrapper);
            }
        }
    }, {
        key: 'processing\u0421ontent',
        value: function processingOntent(content) {
            return Promise.resolve(content);
        }
    }, {
        key: 'showPopup',
        value: function showPopup(data) {
            var _this2 = this;

            var self = this,
                cls = 'popup-middle ' + (data ? data.cls || '' : '');

            this.getContent().then(function (content) {
                _this2.processingСontent(content).then(function (content) {
                    uPopup.closeAll();
                    _this2.popup = uPopup({
                        addClass: cls,
                        name: _this2.name,
                        content: content,
                        onopen: function onopen(wrapper) {
                            _this2.moduleAll = APP.modules.run(wrapper, 'data-PopupForm-modules');
                            //
                            self.formObj = new _Form.Form({
                                wrapper: wrapper.querySelector('form'),
                                onsuccess: function onsuccess(data) {
                                    self.formObj.resetCaptcha();
                                    self._sendStat();

                                    if (self.initData.onsuccess) self.initData.onsuccess(data);else location.replace(location.protocol + '//' + location.host + location.pathname);
                                },
                                onerror: function onerror(data) {
                                    if (self.initData.onerror && !self.initData.onerror(data)) return false;

                                    self.formObj.resetCaptcha();
                                    uPopup({
                                        content: data.message
                                    });
                                }
                            });
                        },
                        oncloseBefore: function oncloseBefore() {
                            APP.modules.destroy(_this2.moduleAll);
                            self.formObj.destroy();
                            return true;
                        }
                    });
                });
            });
        }
    }, {
        key: '_sendStat',
        value: function _sendStat() {
            if (this.name === 'reg') {
                try {
                    gtag('event', 'send_form', {
                        'event_category': 'auth',
                        'event_label': 'send_sign_up_form'
                    });
                    console.log('gtag success!');
                } catch (error) {
                    console.error('gtag error:', error);
                }
            } else if (this.name === 'auth') {
                try {
                    gtag('event', 'sign_in', {
                        'event_category': 'auth',
                        'event_label': 'log_in_via_email'
                    });
                    console.log('gtag success!');
                } catch (error) {
                    console.error('gtag error:', error);
                }
            }
        }
    }, {
        key: '_checkHash',
        value: function _checkHash() {
            if (location.hash === '#!' + this.name) this.showPopup();
        }
    }]);

    return PopupForm;
}();

exports.PopupForm = PopupForm;

},{"../modules/Form":18,"../modules/event":79}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Porthole = function (window) {
	'use strict';

	var initializing = false,
	    fnTest = /xyz/.test(function () {
		xyz;
	}) ? /\b_super\b/ : /.*/;

	// The base Class implementation (does nothing)
	var PortholeClass = function PortholeClass() {};

	// Create a new Class that inherits from this class
	PortholeClass.extend = function (prop) {
		var _super = this.prototype;

		// Instantiate a base class (but only create the instance,
		// don't run the init constructor)
		initializing = true;
		var prototype = new this();
		initializing = false;

		// Copy the properties over onto the new prototype
		for (var name in prop) {
			// Check if we're overwriting an existing function
			prototype[name] = typeof prop[name] == "function" && typeof _super[name] == "function" && fnTest.test(prop[name]) ? function (name, fn) {
				return function () {
					var tmp = this._super;

					// Add a new ._super() method that is the same method
					// but on the super-class
					this._super = _super[name];

					// The method only need to be bound temporarily, so we
					// remove it when we're done executing
					var ret = fn.apply(this, arguments);
					this._super = tmp;

					return ret;
				};
			}(name, prop[name]) : prop[name];
		}

		// The dummy class constructor
		function Class() {
			// All construction is actually done in the init method
			if (!initializing && this.init) this.init.apply(this, arguments);
		}

		// Populate our constructed prototype object
		Class.prototype = prototype;

		// Enforce the constructor to be what we expect
		Class.prototype.constructor = Class;

		// And make this class extendable
		Class.extend = PortholeClass.extend;

		return Class;
	};

	/**
  * @overview Porthole, JavaScript Library for Secure Cross Domain iFrame Communication.
  * @author <a href="mailto:georges@ternarylabs.com">Georges Auberger</a>
  * @copyright 2011-2012 Ternary Labs, All Rights Reserved.
  *
  * Namespace for Porthole
  * @module Porthole
  */
	var Porthole = {
		debug: false,

		/**
   * Utility function to trace to console
   * @private
   */
		trace: function trace(s) {
			if (this.debug && window.console !== undefined) {
				window.console.log('Porthole: ' + s);
			}
		},

		/**
   * Utility function to send errors to console
   * @private
   */
		error: function error(s) {
			if (_typeof(window.console) !== undefined && typeof window.console.error === 'function') {
				window.console.error('Porthole: ' + s);
			}
		}
	};

	/**
  * @class
  * @classdesc Proxy window object to post message to target window
  * @param {string} proxyIFrameUrl - Fully qualified url to proxy iframe, or null to create a receiver only window
  * @param {string} targetWindowName - Name of the proxy iframe window
  */
	Porthole.WindowProxy = function () {};

	Porthole.WindowProxy.prototype = {
		/**
   * Post a message to the target window only if the content comes from the target origin.
   * <code>targetOrigin</code> can be a url or *
   * @public
   * @param {Object} data - Payload
   * @param {String} targetOrigin
   */
		post: function post(data, targetOrigin) {},
		/**
   * Add an event listener to receive messages.
   * @public
   * @param {Function} eventListenerCallback
   * @returns {Function} eventListenerCallback
   */
		addEventListener: function addEventListener(f) {},
		/**
   * Remove an event listener.
   * @public
   * @param {Function} eventListenerCallback
   */
		removeEventListener: function removeEventListener(f) {}
	};

	Porthole.WindowProxyBase = PortholeClass.extend({
		init: function init(targetWindowName) {
			if (targetWindowName === undefined) {
				targetWindowName = '';
			}
			this.targetWindowName = targetWindowName;
			this.origin = window.location.protocol + '//' + window.location.host;
			this.eventListeners = [];
		},

		getTargetWindowName: function getTargetWindowName() {
			return this.targetWindowName;
		},

		getOrigin: function getOrigin() {
			return this.origin;
		},

		/**
   * Lookup window object based on target window name
   * @private
   * @return {string} targetWindow
   */
		getTargetWindow: function getTargetWindow() {
			return Porthole.WindowProxy.getTargetWindow(this.targetWindowName);
		},

		post: function post(data, targetOrigin) {
			if (targetOrigin === undefined) {
				targetOrigin = '*';
			}
			this.dispatchMessage({
				'data': data,
				'sourceOrigin': this.getOrigin(),
				'targetOrigin': targetOrigin,
				'sourceWindowName': window.name,
				'targetWindowName': this.getTargetWindowName()
			});
		},

		addEventListener: function addEventListener(f) {
			this.eventListeners.push(f);
			return f;
		},

		removeEventListener: function removeEventListener(f) {
			var index;
			try {
				index = this.eventListeners.indexOf(f);
				this.eventListeners.splice(index, 1);
			} catch (e) {
				this.eventListeners = [];
			}
		},

		dispatchEvent: function dispatchEvent(event) {
			var i;
			for (i = 0; i < this.eventListeners.length; i++) {
				try {
					this.eventListeners[i](event);
				} catch (e) {
					Porthole.error(e);
				}
			}
		}
	});

	/**
  * Legacy browser implementation of proxy window object to post message to target window
  *
  * @private
  * @constructor
  * @param {string} proxyIFrameUrl - Fully qualified url to proxy iframe
  * @param {string} targetWindowName - Name of the proxy iframe window
  */
	Porthole.WindowProxyLegacy = Porthole.WindowProxyBase.extend({
		init: function init(proxyIFrameUrl, targetWindowName) {
			this._super(targetWindowName);

			if (proxyIFrameUrl !== null) {
				this.proxyIFrameName = this.targetWindowName + 'ProxyIFrame';
				this.proxyIFrameLocation = proxyIFrameUrl;

				// Create the proxy iFrame and add to dom
				this.proxyIFrameElement = this.createIFrameProxy();
			} else {
				// Won't be able to send messages
				this.proxyIFrameElement = null;
				Porthole.trace("proxyIFrameUrl is null, window will be a receiver only");
				this.post = function () {
					throw new Error("Receiver only window");
				};
			}
		},

		/**
   * Create an iframe and load the proxy
   *
   * @private
   * @returns iframe
   */
		createIFrameProxy: function createIFrameProxy() {
			var iframe = document.createElement('iframe');

			iframe.setAttribute('id', this.proxyIFrameName);
			iframe.setAttribute('name', this.proxyIFrameName);
			iframe.setAttribute('src', this.proxyIFrameLocation);
			// IE needs this otherwise resize event is not fired
			iframe.setAttribute('frameBorder', '1');
			iframe.setAttribute('scrolling', 'auto');
			// Need a certain size otherwise IE7 does not fire resize event
			iframe.setAttribute('width', 30);
			iframe.setAttribute('height', 30);
			iframe.setAttribute('style', 'position: absolute; left: -100px; top:0px;');
			// IE needs this because setting style attribute is broken. No really.
			if (iframe.style.setAttribute) {
				iframe.style.setAttribute('cssText', 'position: absolute; left: -100px; top:0px;');
			}
			document.body.appendChild(iframe);
			return iframe;
		},

		dispatchMessage: function dispatchMessage(message) {
			var encode = window.encodeURIComponent;

			if (this.proxyIFrameElement) {
				var src = this.proxyIFrameLocation + '#' + encode(Porthole.WindowProxy.serialize(message));
				this.proxyIFrameElement.setAttribute('src', src);
				this.proxyIFrameElement.height = this.proxyIFrameElement.height > 50 ? 50 : 100;
			}
		}
	});

	/**
  * Implementation for modern browsers that supports it
  */
	Porthole.WindowProxyHTML5 = Porthole.WindowProxyBase.extend({
		init: function init(proxyIFrameUrl, targetWindowName) {
			this._super(targetWindowName);
			this.eventListenerCallback = null;
		},

		dispatchMessage: function dispatchMessage(message) {
			this.getTargetWindow().postMessage(Porthole.WindowProxy.serialize(message), message.targetOrigin);
		},

		addEventListener: function addEventListener(f) {
			if (this.eventListeners.length === 0) {
				var self = this;
				if (window.addEventListener) {
					this.eventListenerCallback = function (event) {
						self.eventListener(self, event);
					};
					window.addEventListener('message', this.eventListenerCallback, false);
				} else if (window.attachEvent) {
					// Make IE8 happy, just not that 1. postMessage only works for IFRAMES/FRAMES http://blogs.msdn.com/b/ieinternals/archive/2009/09/16/bugs-in-ie8-support-for-html5-postmessage-sessionstorage-and-localstorage.aspx
					this.eventListenerCallback = function (event) {
						self.eventListener(self, window.event);
					};
					window.attachEvent("onmessage", this.eventListenerCallback);
				}
			}
			return this._super(f);
		},

		removeEventListener: function removeEventListener(f) {
			this._super(f);

			if (this.eventListeners.length === 0) {
				if (window.removeEventListener) {
					window.removeEventListener('message', this.eventListenerCallback);
				} else if (window.detachEvent) {
					// Make IE8, happy, see above
					// see jquery, detachEvent needed property on element, by name of that event, to properly expose it to GC
					if (typeof window.onmessage === 'undefined') window.onmessage = null;
					window.detachEvent('onmessage', this.eventListenerCallback);
				}
				this.eventListenerCallback = null;
			}
		},

		eventListener: function eventListener(self, nativeEvent) {
			var data = Porthole.WindowProxy.unserialize(nativeEvent.data);
			if (data && (self.targetWindowName === '' || data.sourceWindowName == self.targetWindowName)) {
				self.dispatchEvent(new Porthole.MessageEvent(data.data, nativeEvent.origin, self));
			}
		}
	});

	if (!window.postMessage) {
		Porthole.trace('Using legacy browser support');
		Porthole.WindowProxy = Porthole.WindowProxyLegacy.extend({});
	} else {
		Porthole.trace('Using built-in browser support');
		Porthole.WindowProxy = Porthole.WindowProxyHTML5.extend({});
	}

	/**
  * Serialize an object using JSON.stringify
  *
  * @param {Object} obj The object to be serialized
  * @return {String}
  */
	Porthole.WindowProxy.serialize = function (obj) {
		if (typeof JSON === 'undefined') {
			throw new Error('Porthole serialization depends on JSON!');
		}

		return JSON.stringify(obj);
	};

	/**
  * Unserialize using JSON.parse
  *
  * @param {String} text Serialization
  * @return {Object}
  */
	Porthole.WindowProxy.unserialize = function (text) {
		if (typeof JSON === 'undefined') {
			throw new Error('Porthole unserialization dependens on JSON!');
		}
		try {
			var json = JSON.parse(text);
		} catch (e) {
			return false;
		}
		return json;
	};

	Porthole.WindowProxy.getTargetWindow = function (targetWindowName) {
		if (targetWindowName === '') {
			return parent;
		} else if (targetWindowName === 'top' || targetWindowName === 'parent') {
			return window[targetWindowName];
		}
		return window.frames[targetWindowName];
	};

	/**
  * @classdesc Event object to be passed to registered event handlers
  * @class
  * @param {String} data
  * @param {String} origin - url of window sending the message
  * @param {Object} source - window object sending the message
  */
	Porthole.MessageEvent = function MessageEvent(data, origin, source) {
		this.data = data;
		this.origin = origin;
		this.source = source;
	};

	/**
  * @classdesc Dispatcher object to relay messages.
  * @public
  * @constructor
  */
	Porthole.WindowProxyDispatcher = {
		/**
   * Forward a message event to the target window
   * @private
   */
		forwardMessageEvent: function forwardMessageEvent(e) {
			var message,
			    decode = window.decodeURIComponent,
			    targetWindow,
			    windowProxy;

			if (document.location.hash.length > 0) {
				// Eat the hash character
				message = Porthole.WindowProxy.unserialize(decode(document.location.hash.substr(1)));

				targetWindow = Porthole.WindowProxy.getTargetWindow(message.targetWindowName);

				windowProxy = Porthole.WindowProxyDispatcher.findWindowProxyObjectInWindow(targetWindow, message.sourceWindowName);

				if (windowProxy) {
					if (windowProxy.origin === message.targetOrigin || message.targetOrigin === '*') {
						windowProxy.dispatchEvent(new Porthole.MessageEvent(message.data, message.sourceOrigin, windowProxy));
					} else {
						Porthole.error('Target origin ' + windowProxy.origin + ' does not match desired target of ' + message.targetOrigin);
					}
				} else {
					Porthole.error('Could not find window proxy object on the target window');
				}
			}
		},

		/**
   * Look for a window proxy object in the target window
   * @private
   */
		findWindowProxyObjectInWindow: function findWindowProxyObjectInWindow(w, sourceWindowName) {
			var i;

			if (w) {
				for (i in w) {
					if (Object.prototype.hasOwnProperty.call(w, i)) {
						try {
							// Ensure that we're finding the proxy object
							// that is declared to be targetting the window that is calling us
							if (w[i] !== null && _typeof(w[i]) === 'object' && w[i] instanceof w.Porthole.WindowProxy && w[i].getTargetWindowName() === sourceWindowName) {
								return w[i];
							}
						} catch (e) {
							// Swallow exception in case we access an object we shouldn't
						}
					}
				}
			}
			return null;
		},

		/**
   * Start a proxy to relay messages.
   * @public
   */
		start: function start() {
			if (window.addEventListener) {
				window.addEventListener('resize', Porthole.WindowProxyDispatcher.forwardMessageEvent, false);
			} else if (window.attachEvent && window.postMessage !== 'undefined') {
				window.attachEvent('onresize', Porthole.WindowProxyDispatcher.forwardMessageEvent);
			} else if (document.body.attachEvent) {
				window.attachEvent('onresize', Porthole.WindowProxyDispatcher.forwardMessageEvent);
			} else {
				// Should never happen
				Porthole.error('Cannot attach resize event');
			}
		}
	};

	window.Porthole = Porthole;

	return Porthole;
}(typeof window !== "undefined" ? window : undefined);

exports.Porthole = Porthole;

},{}],33:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PremiereReminder = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = require('../modules/cookie');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PremiereReminder = function () {
    function PremiereReminder(wrapper) {
        _classCallCheck(this, PremiereReminder);

        this._createElements(wrapper);
        this._addEvent();
    }

    _createClass(PremiereReminder, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.wrapper = wrapper;
            this.closeBtn = wrapper.querySelector('[data-PremiereReminder-close]');
            this.favBtn = wrapper.querySelector('[data-PremiereReminder-fav]');
            this.submitBtn = wrapper.querySelector('[data-PremiereReminder-submit]');
            this.rememberCheck = wrapper.querySelector('[data-PremiereReminder-remember]');
            this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
        }
    }, {
        key: '_show',
        value: function _show() {
            this.wrapper.classList.remove('hidden');
            this._sendStatShow();
        }
    }, {
        key: '_hide',
        value: function _hide() {
            var _this = this;

            this.wrapper.className += " hidden";
            setTimeout(function () {
                _this.wrapper.parentNode.removeChild(_this.wrapper);
            }, 500);
        }
    }, {
        key: '_setCookie',
        value: function _setCookie() {
            var self = this;

            if (self.rememberCheck && self.rememberCheck.checked) {
                _cookie.cookie.setCookie('FAV_POPUP_HIDE', 1, { expires: 604800, path: '/' });
            } else {
                var cookieName = 'COUNTER_' + self.data.type.toUpperCase() + '_' + self.data.uid + '_NO';
                _cookie.cookie.setCookie(cookieName, 1, { expires: 604800 });
            }
        }
    }, {
        key: '_gaStatErrorHandler',
        value: function _gaStatErrorHandler(event) {
            console.error('GA не сработал: ' + event + ' PremiereReminder');
        }
    }, {
        key: '_sendStatShow',
        value: function _sendStatShow() {

            var self = this;

            try {
                // ga('send', 'event', 'pop-up', 'show', 'pop-up_like-' + self.data.type.toLowerCase() + '_show', {nonInteraction: true});

                gtag('event', 'show', {
                    'event_category': 'pop-up',
                    'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_show',
                    'nonInteraction': true
                });
            } catch (e) {
                self._gaStatErrorHandler('появление попапа');
            }
        }
    }, {
        key: '_sendStatFavBtnPress',
        value: function _sendStatFavBtnPress() {

            var self = this;

            try {
                // ga('send', 'event', 'pop-up', 'button-press', 'pop-up_like-' + self.data.type.toLowerCase() + '_ok-button_press', {nonInteraction: false})

                gtag('event', 'button-press', {
                    'event_category': 'pop-up',
                    'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_ok-button_press'
                });
            } catch (e) {
                self._gaStatErrorHandler('нажатие на кнопку «в избранное»');
            }
        }
    }, {
        key: '_sendStatNoBtnPress',
        value: function _sendStatNoBtnPress() {

            var self = this;

            try {
                // ga('send', 'event', 'pop-up', 'button-press', 'pop-up_like-' + self.data.type.toLowerCase() + '_no-buttom_press', {nonInteraction: false});

                gtag('event', 'button-press', {
                    'event_category': 'pop-up',
                    'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_no-buttom_press'
                });
            } catch (e) {
                self._gaStatErrorHandler('нажатие на кнопку «нет, спасибо»');
            }
        }
    }, {
        key: '_sendStatCrossClick',
        value: function _sendStatCrossClick() {

            var self = this;

            try {
                // ga('send', 'event', 'pop-up', 'click', 'pop-up_like-' + self.data.type.toLowerCase() + '_close-icon_click', {nonInteraction: false});

                gtag('event', 'click', {
                    'event_category': 'pop-up',
                    'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_close-icon_click'
                });
            } catch (e) {
                self._gaStatErrorHandler('клик на крестик');
            }
        }
    }, {
        key: '_sendStatCheckTrue',
        value: function _sendStatCheckTrue() {

            var self = this;

            try {
                // ga('send', 'event', 'pop-up', 'click', 'pop-up_like-' + self.data.type.toLowerCase() + '_never-check_click', {nonInteraction: false});
                gtag('event', 'click', {
                    'event_category': 'pop-up',
                    'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_never-check_click'
                });
            } catch (e) {
                self._gaStatErrorHandler('поставлена галка «больше не предлагать»');
            }
        }
    }, {
        key: '_addEvent',
        value: function _addEvent() {
            var self = this;

            self._show();

            var close = function close(e) {
                e.preventDefault();

                self._sendStatCrossClick();

                self._hide();

                // set cookie
                self._setCookie();
            };
            this.closeBtn.addEventListener('click', close, false);

            var submit = function submit(e) {
                e.preventDefault();

                self._sendStatNoBtnPress();

                self._hide();

                // set cookie
                self._setCookie();
            };
            if (this.submitBtn) {
                this.submitBtn.addEventListener('click', submit, false);
            }

            this.favBtn.addEventListener('click', function () {
                self._sendStatFavBtnPress();
                setTimeout(function () {
                    self._hide();
                }, 500);
            }, false);

            if (this.rememberCheck) {
                this.rememberCheck.addEventListener('change', function () {
                    if (this.checked) {
                        self._sendStatCheckTrue();
                    }
                }, false);
            }
        }
    }, {
        key: '_del',
        value: function _del() {}
    }]);

    return PremiereReminder;
}();

exports.PremiereReminder = PremiereReminder;

},{"../modules/cookie":74}],34:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QuizForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuizForm = function () {
    function QuizForm(form) {
        _classCallCheck(this, QuizForm);

        this._createElements(form);
        this._addEvents();
    }

    _createClass(QuizForm, [{
        key: '_createElements',
        value: function _createElements(form) {
            this.form = form;
            this.form.noValidate = true;
            this.answerAll = this.form.querySelectorAll('[data-QuizForm-answer]');
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            this.form.addEventListener('submit', function (e) {
                if (!regAuthObj.isAuth) {
                    e.preventDefault();
                    regAuthObj.authForm.showPopup();
                } else if (!e.target.checkValidity()) {
                    e.preventDefault();
                    uPopup({
                        content: 'Пожалуйста, ответьте на все вопросы'
                    });
                }
            });

            for (var i = 0, j = this.answerAll.length; i < j; i++) {
                _event.event.add(this.answerAll[i], 'click', function (e) {
                    if (!regAuthObj.isAuth) {
                        e.preventDefault();
                        regAuthObj.authForm.showPopup();
                    }
                });
            }
        }
    }]);

    return QuizForm;
}();

exports.QuizForm = QuizForm;

},{"../modules/event":79}],35:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
    /*
    *
    * */
    function _class(wrapper) {
        _classCallCheck(this, _class);

        this.wrapper = wrapper;
        this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.rating = this.wrapper.getAttribute('data-js') == 'rating-box' ? this.wrapper : this.wrapper.querySelector('[data-js="rating-box"]');
        this.isAllowVote = this.rating.className.indexOf('js-allowVote') === -1 ? false : true;
        this.isSending = false;
        this.onchange = function () {};
        this._defineAjaxPath();
        this._findItems();
        this._addEvents();
        this._addToGlobal();
    }

    _createClass(_class, [{
        key: '_defineAjaxPath',
        value: function _defineAjaxPath() {
            var part = APP.vars.isDev ? '/_src/layouts' : '';
            this.ajaxPath = part + '/' + this.data.type + '/' + this.data.uid + '/vote/';
        }
    }, {
        key: '_findItems',
        value: function _findItems() {
            var self = this;
            this.star = []; //массив звезд
            this.numRating = this.rating.querySelector('[data-js="numRating"]');
            this.stars = this.rating.querySelector('[data-js="stars"]');
            this.starAll = this.rating.querySelectorAll('[data-star]');
            this.vote = this.rating.querySelector('[data-js="vote"]');
            this.votes = this.rating.querySelector('[data-js="votes"]');
            this.markEl = this.rating.querySelector('[data-js="mark"]');
            this.userMark = function () {
                if (!self.markEl) return false;
                var result = self.markEl.firstChild.nodeValue.match(/\d+/);
                if (!result) return false;
                return parseInt(result[0]);
            }();
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            _event.event.add(this.rating, 'click', function () {
                if (!self.isAllowVote) {
                    try {
                        console.log('Ваш рейтинг уже учтен');
                    } catch (e) {}
                    /*uPopup({
                        content:'Ваш рейтинг уже учтен'
                    });*/
                }
            });

            for (var i = 0, j = this.starAll.length; i < j; i++) {
                _event.event.add(this.starAll[i], 'click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (APP.vars.isMobile) {
                        if (!APP.auth.tryAuth()) return false;
                    } else if (!regAuthObj.isAuth) {
                        regAuthObj.authForm.showPopup();
                        return false;
                    }

                    if (self.isSending) return false;
                    self.isSending = true;

                    (0, _ajax.ajax)({
                        data: { "vote": this.getAttribute('data-star') },
                        url: self.ajaxPath,
                        callback: function callback(msg) {
                            self._checkAnswer.call(self, msg);
                        }
                    });
                });

                /*event.add(this.starAll[i], 'mouseover', function(e){
                    if(self.isSending) return false;
                    if(self.markEl) self.markEl.firstChild.nodeValue = 'Ваша оценка ' + this.getAttribute('data-star');
                });*/
            }

            if (this.markEl && this.isAllowVote && !('ontouchstart' in window)) {
                for (var i = 0, j = this.starAll.length; i < j; i++) {
                    _event.event.add(this.starAll[i], 'mouseover', function (e) {
                        if (self.isSending || !self.isAllowVote) return false;
                        self.markEl.firstChild.nodeValue = 'Ваша оценка ' + this.getAttribute('data-star');
                    });
                }

                _event.event.add(this.vote, 'mouseout', function (e) {
                    if (self.isSending || !self.isAllowVote) return false;
                    var text = self.userMark ? 'Ваша оценка ' + self.userMark : 'Оцените';
                    self.markEl.firstChild.nodeValue = text;
                });
            }
        }
    }, {
        key: '_checkAnswer',
        value: function _checkAnswer(msg) {
            var msg = JSON.parse(msg);

            if (msg.auth === false) {
                if (APP.vars.isMobile) {
                    alert('Вам нужно авторизоваться повторно.');
                } else {
                    uPopup({
                        content: 'Вам нужно авторизоваться повторно.',
                        oncloseBefore: function oncloseBefore() {
                            location.replace(location.protocol + '//' + location.host + location.pathname);
                        }
                    });
                }
            } else if (!msg.status) {
                if (APP.vars.isMobile) {
                    alert(msg.message);
                } else {
                    uPopup({
                        content: msg.message
                    });
                }
            } else {
                this._addVote(msg);
                //если задали функию успешного выполнения скрипта, запускаем
                if (this.successExec) this.successExec();
            }

            this.isSending = false;
        }
    }, {
        key: '_decline',
        value: function _decline(number, titles) {
            var cases = [2, 0, 1, 1, 1, 2];
            return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
        }
    }, {
        key: '_addVote',
        value: function _addVote(msg) {
            var key = 'uid-' + this.data.uid,
                type = this.data.type,
                all = window.GLOBALS[type + 'RatingAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                var width = all[i].data.stars === 'mark' ? msg.data.mark : msg.data.rating;
                all[i].stars.style.width = width * 10 + '%';

                if (all[i].numRating && msg.data.votes > 9) {
                    var treated = msg.data.rating + '';
                    //treated = treated.replace(/\./, ',');
                    //treated = treated.indexOf(',') !== -1 ? treated : treated + ',0';
                    treated = treated.indexOf('.') !== -1 ? treated : treated + '.0';
                    all[i].numRating.innerHTML = treated;
                }
                if (all[i].votes) {
                    /* стираем что внутри - ибо может быть дополнительный спан seo - в фильмах */
                    all[i].votes.innerHTML = msg.data.votes + ' ' + all[i]._decline(msg.data.votes, ['голос', 'голоса', 'голосов']);
                }
                if (all[i].markEl) {
                    all[i].userMark = msg.data.mark;
                    all[i].markEl.firstChild.nodeValue = 'Ваша оценка ' + msg.data.mark;
                }

                //all[i].rating.className = all[i].rating.className.replace('js-allowVote', '');
                //all[i].isAllowVote = false;
            }

            this._sendStat();

            this.onchange(msg.data.rating);
        }
    }, {
        key: '_sendStat',
        value: function _sendStat() {
            if (this.data.type) {
                try {
                    gtag('event', 'click', {
                        'event_category': 'engagement',
                        'event_label': 'rate_' + this.data.type
                    });
                    console.log('gtag success!');
                } catch (error) {
                    console.log('gtag error:', error);
                }
            } else {
                console.log('gtag unknow type');
            }
        }
    }, {
        key: '_addToGlobal',
        value: function _addToGlobal() {
            var key = 'uid-' + this.data.uid;
            var type = this.data.type;

            if (!window.GLOBALS) window.GLOBALS = {};
            if (!window.GLOBALS[type + 'RatingAll']) window.GLOBALS[type + 'RatingAll'] = {};
            if (!window.GLOBALS[type + 'RatingAll'][key]) window.GLOBALS[type + 'RatingAll'][key] = [];

            window.GLOBALS[type + 'RatingAll'][key].push(this);
        }
    }, {
        key: 'del',
        value: function del() {
            var key = 'uid-' + this.data.uid;
            var type = this.data.type;
            var all = window.GLOBALS[type + 'RatingAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                if (all[i] === this) {
                    all.splice(i, 1);
                    if (!all.length) delete window.GLOBALS[type + 'RatingAll'][key];
                    return false;
                }
            }
        }
    }]);

    return _class;
}();

exports.default = _class;
;
module.exports = exports.default;

},{"../modules/ajax":61,"../modules/event":79}],36:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegAuthBtn = function () {
    function RegAuthBtn(btn) {
        _classCallCheck(this, RegAuthBtn);

        this.btn = btn;
        this.formName = this.btn.getAttribute('data-param');
        regAuthObj[this.formName].addBtn(this.btn);
    }

    _createClass(RegAuthBtn, [{
        key: 'del',
        value: function del() {
            regAuthObj[this.formName].removeBtn(this.btn);
        }
    }]);

    return RegAuthBtn;
}();

;

exports.RegAuthBtn = RegAuthBtn;

},{}],37:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReloadForm = function ReloadForm(form) {
	_classCallCheck(this, ReloadForm);

	var elements = form.elements,
	    submitBtn = form.querySelector('[data-ReloadForm-submit]');

	//
	Array.prototype.forEach.call(elements, function (el) {
		el.onchange = function () {
			var selected = this.nodeName === 'SELECT' ? this.options[this.selectedIndex] : this,
			    url = selected.getAttribute('data-reloadform-field');

			//
			if (url) window.location = url;
		};
	});

	if (submitBtn) form.classList.add('js-active');
};

exports.ReloadForm = ReloadForm;

},{}],38:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ScrollSlider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _scriptonload = require('../modules/scriptonload');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollSlider = function () {
    function ScrollSlider(el) {
        _classCallCheck(this, ScrollSlider);

        var self = this;

        this.status; /* если вдруг решим удалить объект, а он еще не загрузился */
        this.oScrollbar;

        this.status = 'loading';
        (0, _scriptonload.scriptonload)(APP.vendors.scrolling, function () {
            self._init.call(self, el);
        });
    }

    _createClass(ScrollSlider, [{
        key: '_init',
        value: function _init(el) {
            if (this.status === 'notload') return;
            this.status = 'loaded';

            var self = this;

            this.offset = 220; /* TODO */

            this.btnLeft = el.querySelector('[data-scrollslider-btn="left"]');
            this.btnRight = el.querySelector('[data-scrollslider-btn="right"]');
            this.overview = el.querySelector('[data-scrolling-overview]');
            this.itemAll = el.querySelector('[data-scrollslider-item]');
            this.oScrollbar = tinyscrollbar(el, {
                axis: "x",
                trackSize: el.getBoundingClientRect().width,
                onStartPoint: function onStartPoint() {
                    var cls = self.btnLeft.className;
                    if (cls.indexOf('js-disabled') === -1) self.btnLeft.className = cls + ' js-disabled';
                },
                onEndPoint: function onEndPoint() {
                    var cls = self.btnRight.className;
                    if (cls.indexOf('js-disabled') === -1) self.btnRight.className = cls + ' js-disabled';
                },
                onWayPoint: function onWayPoint() {
                    if (self.btnLeft.className.indexOf('js-disabled') !== -1) self.btnLeft.className = self.btnLeft.className.replace(' js-disabled', '');
                    if (self.btnRight.className.indexOf('js-disabled') !== -1) self.btnRight.className = self.btnRight.className.replace(' js-disabled', '');
                }
            });

            this._addEvents();
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this,
                handler = function handler(e) {
                e.preventDefault();

                if (this.className.indexOf('js-disabled') !== -1) return;

                var name = this.getAttribute('data-scrollslider-btn');
                self._move.call(self, name);
            };

            this.btnLeft.addEventListener('click', handler, false);
            this.btnRight.addEventListener('click', handler, false);
        }
    }, {
        key: '_move',
        value: function _move(name) {
            var left = Math.abs(parseInt(this.overview.style.left)) || 0,
                offset = name === 'left' ? -this.offset : this.offset;

            left = Math.round((left + offset) / this.offset) * this.offset;

            this.oScrollbar.update(left);
        }
    }, {
        key: 'del',
        value: function del() {
            /*if(this.oScrollbar) this.oScrollbar.del();
            else this.status = 'notload';*/
            if (!this.oScrollbar) this.status = 'notload';else {
                this.btnLeft.removeEventListener('click', handler, false);
                this.btnRight.removeEventListener('click', handler, false);
            }
        }
    }]);

    return ScrollSlider;
}();

exports.ScrollSlider = ScrollSlider;

},{"../modules/scriptonload":106}],39:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollSmooth = function () {
    function ScrollSmooth(el) {
        _classCallCheck(this, ScrollSmooth);

        this._createElements(el);
        this._addEvents();
    }

    _createClass(ScrollSmooth, [{
        key: '_createElements',
        value: function _createElements(el) {
            this.btn = el;
            this.uid = this.btn.hash.replace('#', '');
            this.data = JSON.parse(this.btn.getAttribute('data-param')) || {};
            this.inArea = this.data.inArea || false;
            this.blockArea = document.getElementById(this.uid) || null;
            var header = document.querySelector('.navigation') || document.querySelector('.header');
            this.offset = -header.clientHeight;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            window.addEventListener('load', function () {
                self._checkHash();
            });

            this.btn.onclick = function (e) {
                if (!self._checkArea()) {
                    self._smoothScroll(self.uid);
                    window.location.hash = this.hash;
                }

                e.preventDefault();
            };
        }
    }, {
        key: '_checkArea',
        value: function _checkArea() {
            var self = this;

            if (self.blockArea && !self.inArea) {

                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                var blockRect = self.blockArea.getBoundingClientRect();
                var blockOffset = blockRect.top + scrollTop;
                var blockHeight = self.blockArea.clientHeight;

                var btnRect = self.btn.getBoundingClientRect();
                var btnOffset = btnRect.top + scrollTop;
                var btnHeight = self.btn.clientHeight;

                if (btnOffset > blockOffset && btnOffset + btnHeight < blockOffset + blockHeight) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }, {
        key: '_currentYPosition',
        value: function _currentYPosition() {
            // Firefox, Chrome, Opera, Safari
            if (self.pageYOffset) return self.pageYOffset;
            // Internet Explorer 6 - standards mode
            if (document.documentElement && document.documentElement.scrollTop) return document.documentElement.scrollTop;
            // Internet Explorer 6, 7 and 8
            if (document.body.scrollTop) return document.body.scrollTop;
            return 0;
        }
    }, {
        key: '_elmYPosition',
        value: function _elmYPosition(eID) {
            var elm = document.getElementById(eID);
            var y = elm.offsetTop;
            var node = elm;
            while (node.offsetParent && node.offsetParent != document.body) {
                node = node.offsetParent;
                y += node.offsetTop;
            }return y + this.offset;
        }
    }, {
        key: '_smoothScroll',
        value: function _smoothScroll(eID) {
            var startY = this._currentYPosition();
            var stopY = this._elmYPosition(eID);
            var distance = stopY > startY ? stopY - startY : startY - stopY;
            if (distance < 100) {
                scrollTo(0, stopY);return;
            }
            var speed = Math.round(distance / 100);
            if (speed >= 200) speed = 1000;
            var step = Math.round(distance / 25);
            var leapY = stopY > startY ? startY + step : startY - step;
            var timer = 0;
            if (stopY > startY) {
                for (var i = startY; i < stopY; i += step) {
                    setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                    leapY += step;if (leapY > stopY) leapY = stopY;timer++;
                }return;
            }
            for (var _i = startY; _i > stopY; _i -= step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY -= step;if (leapY < stopY) leapY = stopY;timer++;
            }
        }
    }, {
        key: '_checkHash',
        value: function _checkHash() {
            var self = this;
            //
            if (window.location.hash === self.btn.hash) {
                self._smoothScroll(self.uid);
            }
        }
    }, {
        key: '_del',
        value: function _del() {}
    }]);

    return ScrollSmooth;
}();

exports.ScrollSmooth = ScrollSmooth;

},{}],40:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* нигде не исп
* */

var ScrollTo = function () {
    function ScrollTo(el) {
        _classCallCheck(this, ScrollTo);

        this.btn = el;
        //this._addEvents();
        //this._checkHash();
    }

    _createClass(ScrollTo, [{
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            this.btn.onclick = function (e) {
                var hash = this.hash,
                    uid = hash.replace('#', ''),
                    target = document.querySelector('[data-ScrollTo-id="' + uid + '"]');

                //
                if (target) {
                    e.preventDefault();

                    var top = target.getBoundingClientRect().top - APP.vars.topPadding,
                        duration = 300,
                        offset = window.pageYOffset,
                        left = window.pageXOffset;

                    self.animate({
                        duration: duration,
                        timing: function timing(timeFraction) {
                            return timeFraction;
                        },
                        draw: function draw(progress) {
                            window.scrollTo(left, offset + progress * top);
                        }
                    });
                    location.hash = hash;
                }
            };
        }
    }, {
        key: '_checkHash',
        value: function _checkHash() {
            var uid, target;

            //
            if (location.hash === this.btn.hash) {
                uid = location.hash.replace('#', '');
                target = document.querySelector('[data-ScrollTo-id="' + uid + '"]');

                if (target) {
                    var top = target.getBoundingClientRect().top - APP.vars.topPadding;
                    scrollBy(0, top);
                }
            }
        }
    }, {
        key: 'animate',
        value: function animate(options) {

            var start = performance.now();

            requestAnimationFrame(function animate(time) {
                // timeFraction от 0 до 1
                var timeFraction = (time - start) / options.duration;
                if (timeFraction > 1) timeFraction = 1;

                // текущее состояние анимации
                var progress = options.timing(timeFraction);

                options.draw(progress);

                if (timeFraction < 1) {
                    requestAnimationFrame(animate);
                } else if (options.complete) options.complete();
            });
        }
    }]);

    return ScrollTo;
}();

exports.ScrollTo = ScrollTo;

},{}],41:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchCity = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchCity = function () {
    function SearchCity(wrapper) {
        _classCallCheck(this, SearchCity);

        this._createElements(wrapper);
        this._addEvents();
    }

    _createClass(SearchCity, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;

            this.wrapper = wrapper;
            //this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.field = document.querySelector('[data-SearchCity-field]');
            this.isSending = false;
            this.ajaxPath = this._defineAjaxPath();
            this.xmlhttp = false;
            this.resultBox = false;
            this.resultNav = false;
            this._returnCircuit = function (e) {
                self._return.call(self, e);
            };
        }
    }, {
        key: '_defineAjaxPath',
        value: function _defineAjaxPath() {
            var part = APP.vars.isDev ? '/_src/layouts' : '',
                ajaxPath = part + '/cities/search';

            return ajaxPath;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            _event.event.add(this.wrapper, 'submit', function (e) {
                e.preventDefault();
            });

            _event.event.add(this.field, 'click', function (e) {
                e.stopPropagation();
            });

            _event.event.add(this.field, 'keyup', function (e) {
                self._search.call(self);
            });
        }
    }, {
        key: '_search',
        value: function _search() {
            var self = this;
            if (this.xmlhttp) this.xmlhttp.abort();

            this.xmlhttp = (0, _ajax.ajax)({
                data: { "query": this.field.value },
                url: this.ajaxPath,
                callback: function callback(msg) {
                    self._addResult.call(self, msg);
                }
            });
        }
    }, {
        key: '_addResult',
        value: function _addResult(msg) {

            var self = this,
                msg = JSON.parse(msg),
                arr = msg.suggestions,
                length = arr.length,
                inner = '',
                cls;

            if (length) {
                if (!this.resultBox) this._createSearchBox();
                for (var i = 0; i < length; i++) {
                    inner += '<a class="searchForm_resultLink" href="' + arr[i].link + '">' + arr[i].name + '</a>';
                }
                this.resultNav.innerHTML = inner;

                setTimeout(function () {
                    cls = self.resultBox.className;
                    if (cls.indexOf('js-active') == -1) self.resultBox.className = cls + ' js-active';
                }, 10);
            } else this._return();
        }
    }, {
        key: '_createSearchBox',
        value: function _createSearchBox() {
            var self = this;

            this.resultBox = document.createElement('DIV');
            this.resultBox.className = 'searchForm_resultBox';
            this.resultNav = document.createElement('NAV');
            this.resultNav.className = 'searchForm_resultNav';
            this.resultBox.appendChild(this.resultNav);
            this.wrapper.appendChild(this.resultBox);
            _event.event.add(document.body, 'click', self._returnCircuit);
        }
    }, {
        key: '_return',
        value: function _return(e) {
            if (this.xmlhttp) {
                this.xmlhttp.abort();
                this.xmlhttp = false;
            }
            if (this.resultBox) {
                this.wrapper.removeChild(this.resultBox);
                this.resultBox = false;
                this.resultNav = false;
                _event.event.remove(document.body, 'click', this._returnCircuit);
            }
            //если кликнули на боди - очищаем поле
            if (e) {
                this.field.value = '';
            }
        }
    }]);

    return SearchCity;
}();

;

exports.SearchCity = SearchCity;

},{"../modules/ajax":61,"../modules/event":79}],42:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchMain = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

var _SearchPopup = require('../modules/SearchPopup');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchMain = function () {
    function SearchMain(btn) {
        _classCallCheck(this, SearchMain);

        this._createElements(btn);
        this._addEvents();
    }

    _createClass(SearchMain, [{
        key: '_createElements',
        value: function _createElements(btn) {
            this.btn = btn;
            this.popup = false;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            _event.event.add(this.btn, 'click', function (e) {
                e.preventDefault();
                self._showPopup.call(self);
            });
        }
    }, {
        key: '_showPopup',
        value: function _showPopup() {
            var src = '/static/',
                self = this,
                inner = '<div class=grid>' + '<div class=grid_row>' + '<div class="grid_cell10 grid_offset2">' + '<span class="title5 top20">Поиск</span>' + '</div>' + '</div>' + '</div>' + '<div class="layer bottom20 layer-reverse top10">' + '<div class=grid>' + '<div class=grid_row>' + '<div class="grid_cell10 grid_offset2">' + '<form autocomplete=off class="searchForm searchForm-large searchForm-popup" data-SearchPopup-form method="get" action="' + this.btn.href + '">' + '<input class=searchForm_field data-SearchPopup-field type="text" name="q"> ' + '<svg class=searchForm_icon role=img><use xlink:href=' + src + 'img/symbols/sprite.svg#loupe></use></svg>' + '<input class=searchForm_btn type=submit value=ok>' + '</form>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="layer layer-content">' + '<div class="grid grid-popupSearch"data-SearchPopup-box></div>' + '</div>';

            uPopup.closeAll();
            this.popup = uPopup({
                addClass: 'popup-search',
                name: 'search-main',
                content: inner,
                onopen: function onopen() {}
            });

            new _SearchPopup.SearchPopup(self.popup.table);
        }
    }]);

    return SearchMain;
}();

;

exports.SearchMain = SearchMain;

},{"../modules/SearchPopup":43,"../modules/ajax":61,"../modules/event":79}],43:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchPopup = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchPopup = function () {
    function SearchPopup(wrapper) {
        _classCallCheck(this, SearchPopup);

        this._createElements(wrapper);
        this._initField();
        this._addEvents();
    }

    _createClass(SearchPopup, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;

            this.wrapper = wrapper.querySelector('[data-SearchPopup-form]');
            this.field = this.wrapper.querySelector('[data-SearchPopup-field]');
            this.resultBox = wrapper.querySelector('[data-SearchPopup-box]');
            this.isSending = false;
            this.ajaxPath = this._defineAjaxPath();
            this.xmlhttp = false;
            this._returnCircuit = function (e) {
                self._return.call(self, e);
            };
        }
    }, {
        key: '_initField',
        value: function _initField() {
            this.field.focus();
        }
    }, {
        key: '_defineAjaxPath',
        value: function _defineAjaxPath() {
            var part = (window.location + '').indexOf('/build/') === -1 ? '' : 'layouts',
                ajaxPath = part + '/search/fasthtml';

            return ajaxPath;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            _event.event.add(this.field, 'click', function (e) {
                e.stopPropagation();
            });

            _event.event.add(this.field, 'keyup', function (e) {
                self._search.call(self);
            });
        }
    }, {
        key: '_search',
        value: function _search() {
            var self = this;
            if (this.xmlhttp) this.xmlhttp.abort();

            this.xmlhttp = (0, _ajax.ajax)({
                data: { "query": this.field.value },
                url: this.ajaxPath,
                callback: function callback(msg) {
                    self._addResult.call(self, msg);
                }
            });
        }
    }, {
        key: '_addResult',
        value: function _addResult(msg) {
            var self = this,
                msg = JSON.parse(msg);

            this.resultBox.innerHTML = msg.content ? msg.content : '';
        }
    }, {
        key: 'del',
        value: function del() {
            if (this.xmlhttp) {
                this.xmlhttp.abort();
                this.xmlhttp = false;
            }
        }
    }]);

    return SearchPopup;
}();

;

exports.SearchPopup = SearchPopup;

},{"../modules/ajax":61,"../modules/event":79}],44:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SeriesGallery = function () {
    _createClass(SeriesGallery, [{
        key: '_findActive',
        value: function _findActive() {
            var activeEl = this.element.querySelector(this.activeClass);
            var sid = parseInt(activeEl.dataset.sid);

            return sid;
        }
    }, {
        key: '_initSwiper',
        value: function _initSwiper() {
            var startPos = this._findActive();

            this.owl = $(".owl-carousel").owlCarousel({
                nav: true,
                items: 4,
                slideBy: 4,
                dots: true,
                navElement: 'span',
                navText: '',
                responsiveClass: true,
                startPosition: startPos,
                responsive: {
                    0: {
                        items: 1,
                        autoWidth: true,
                        margin: 20
                    },
                    768: {
                        items: 3
                    },
                    1000: {
                        items: 4
                    }
                }
            });
        }
    }]);

    function SeriesGallery(wrapper) {
        _classCallCheck(this, SeriesGallery);

        this.element = wrapper;
        this.activeClass = '.thumbGallery-series_slide-active';

        this._initSwiper();
    }

    return SeriesGallery;
}();

exports.default = SeriesGallery;
module.exports = exports.default;

},{}],45:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ajax = require('../modules/ajax');

var _scriptonload = require('../modules/scriptonload');

var _event = require('../modules/event');

var _Player2 = require('../modules/Player');

var _Vote2 = require('../modules/Vote');

var _Vote3 = _interopRequireDefault(_Vote2);

var _fullscreenGallery2 = require('../modules/fullscreenGallery');

var _Comments2 = require('../modules/Comments');

var _YaShare2 = require('../modules/YaShare2');

var _Time2 = require('../modules/Time');

var _Fav2 = require('../modules/Fav');

var _Fav3 = _interopRequireDefault(_Fav2);

var _Watch2 = require('../modules/Watch');

var _Watch3 = _interopRequireDefault(_Watch2);

var _More2 = require('../modules/More');

var _More3 = _interopRequireDefault(_More2);

var _TheaterMap2 = require('../modules/TheaterMap');

var _ToBuy2 = require('../modules/ToBuy');

var _RegAuthBtn2 = require('../modules/RegAuthBtn');

var _PageForm2 = require('../modules/PageForm');

var _Trailer2 = require('../modules/Trailer');

var _AllAjax2 = require('../modules/AllAjax');

var _showSubContent2 = require('../modules/showSubContent');

var _Rating2 = require('../modules/Rating');

var _Rating3 = _interopRequireDefault(_Rating2);

var _banners2 = require('../modules/banners');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _fullscreenGallery = (0, _fullscreenGallery2.fullscreenGalleryFunc)(window, document); /* TODO */

var SubContent = function () {
    function SubContent(wrapper) {
        _classCallCheck(this, SubContent);

        this._createElements(wrapper);
        this._addEvents();
        this._runModules();
    }

    _createClass(SubContent, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;
            this.wrapper = wrapper;
            this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.tabAll = this._getTabAll();
            this.frame = document.querySelector('[data-SubContent-frame]');
            this.scrollToElement = function () {
                try {
                    var el = document.getElementById(self.param.scrollTo);
                    if (el) return el;else return self.frame;
                } catch (e) {
                    return self.frame;
                }
            }(), this.ajaxPart = this._defineAjaxPart();
            this.xmlhttp = false;
            this.moduleAll = [];
            this.actions = {
                Player: function Player(el) {
                    return new _Player2.Player(el);
                },
                Vote: function Vote(el) {
                    return new _Vote3.default(el);
                },
                fullscreenGallery: function fullscreenGallery(el) {
                    return _fullscreenGallery(el);
                },
                Comments: function Comments(el) {
                    return new _Comments2.Comments(el);
                },
                YaShare2: function YaShare2(el) {
                    return new _YaShare2.YaShare2(el);
                },
                Time: function Time(el) {
                    return new _Time2.Time(el, self);
                },
                Fav: function Fav(el) {
                    return new _Fav3.default(el);
                },
                Watch: function Watch(el) {
                    return new _Watch3.default(el);
                },
                TheaterMap: function TheaterMap(el) {
                    var initMap = function initMap() {
                        ymaps.ready(createMap);
                    },
                        createMap = function createMap() {
                        new _TheaterMap2.TheaterMap(el);
                    };
                    (0, _scriptonload.scriptonload)(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], initMap);
                },
                ToBuy: function ToBuy(el) {
                    return new _ToBuy2.ToBuy(el);
                },
                RegAuthBtn: function RegAuthBtn(el) {
                    return new _RegAuthBtn2.RegAuthBtn(el);
                },
                PageForm: function PageForm(el) {
                    return new _PageForm2.PageForm(el);
                },
                uPlayer: function (_uPlayer) {
                    function uPlayer(_x) {
                        return _uPlayer.apply(this, arguments);
                    }

                    uPlayer.toString = function () {
                        return _uPlayer.toString();
                    };

                    return uPlayer;
                }(function (el) {
                    var init = function init() {
                        return uPlayer(el);
                    };

                    //
                    if (!window.uPlayer) (0, _scriptonload.scriptonload)(APP.vendors.uPlayer, init);else init();
                }),
                Trailer: function Trailer(el, data) {
                    return new _Trailer2.Trailer(el, data);
                },
                AllAjax: function AllAjax(el) {
                    return new _AllAjax2.AllAjax(el);
                },
                More: function More(el) {
                    return new _More3.default(el);
                },
                showSubContent: function showSubContent(el) {
                    return (0, _showSubContent2.showSubContent)(el);
                },
                Rating: function Rating(el) {
                    return new _Rating3.default(el);
                },
                banners: function banners(el) {
                    return (0, _banners2.banners)(el);
                }
            };
            this.curInd;
        }
    }, {
        key: '_getTabAll',
        value: function _getTabAll() {
            var arr = {},
                all = this.wrapper.querySelectorAll('[data-SubContent-btn]'),
                l = all.length,
                i = 0;

            //
            for (i; i < l; i++) {
                arr[all[i].getAttribute('data-SubContent-btn')] = all[i];
            }
            return arr;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            if (!window.history) return false;

            var self = this;

            self._checkHash();

            this._popstateOnCircuit = function (e) {
                self._popstateOn.call(self, e);
            };
            _event.event.add(window, 'popstate', self._popstateOnCircuit);

            for (var i in this.tabAll) {
                var tab = this.tabAll[i];
                if (tab.className.indexOf('js-active') !== -1) {
                    this.curInd = i;
                    //запомнить состояние текущей вкладки Запоминаем урл
                    window.history.replaceState({ ind: i, pathname: window.location.pathname, search: window.location.search }, '', window.location.href);
                }

                _event.event.add(tab, 'click', function (i) {
                    return function (e) {
                        self.show.call(self, this, e, i);
                    };
                }(i));
            }
        }

        /* check if we have hash like tab */

    }, {
        key: '_checkHash',
        value: function _checkHash() {
            var self = this;
            var winHash = window.location.hash;
            var tabName = winHash.replace('#', '');

            if (winHash && self._getTabAll().hasOwnProperty(tabName)) {

                window.onload = function () {
                    var h = wrapper.getBoundingClientRect().height;
                    var top = self.scrollToElement.getBoundingClientRect().top - APP.vars.topPadding,
                        duration = 300,
                        offset = window.pageYOffset,
                        left = window.pageXOffset;
                    self.animateObj = self.animate({
                        duration: duration,
                        timing: function timing(timeFraction) {
                            return timeFraction;
                        },
                        draw: function draw(progress) {
                            window.scrollTo(left, offset + progress * top);
                        }
                    });
                };
            }
        }
    }, {
        key: 'animate',
        value: function animate(options) {
            var Animate = function () {
                function Animate() {
                    _classCallCheck(this, Animate);

                    this._createElements();
                    this.run();
                }

                _createClass(Animate, [{
                    key: '_createElements',
                    value: function _createElements() {
                        this.req = undefined;
                        this.start = undefined;
                    }
                }, {
                    key: 'run',
                    value: function run() {
                        var self = this;
                        this.start = performance.now();
                        this.req = requestAnimationFrame(function animate(time) {
                            // timeFraction от 0 до 1
                            var timeFraction = (time - self.start) / options.duration;
                            if (timeFraction > 1) timeFraction = 1;

                            // текущее состояние анимации
                            var progress = options.timing(timeFraction);

                            options.draw(progress);

                            if (timeFraction < 1) {
                                self.req = requestAnimationFrame(animate);
                            }
                        });
                    }
                }, {
                    key: 'stop',
                    value: function stop() {
                        cancelAnimationFrame(this.req);
                    }
                }]);

                return Animate;
            }();

            //
            return new Animate();
        }
    }, {
        key: 'show',
        value: function show(btn, e, i, targetUid) {
            /* здесь btn либо внешняя кнопка, либо таб, без разницы */
            var h = this.wrapper.getBoundingClientRect().height;
            var top = this.scrollToElement.getBoundingClientRect().top - APP.vars.topPadding - h + 25,
                duration = 300,
                offset = window.pageYOffset,
                left = window.pageXOffset;

            this.animateObj = this.animate({
                duration: duration,
                timing: function timing(timeFraction) {
                    return timeFraction;
                },
                draw: function draw(progress) {
                    window.scrollTo(left, offset + progress * top);
                }
            });

            this._switchTab(btn, e, i, targetUid);
        }
    }, {
        key: '_switchTab',
        value: function _switchTab(btn, e, i, targetUid) {
            var param = {};

            e.preventDefault();
            //if(this.curInd === i) return false;
            window.history.pushState({ ind: i, pathname: btn.pathname, search: btn.search }, '', btn.pathname + btn.search);

            this._sendStat(btn.pathname + btn.search);

            param.data = this._getAjaxData(btn.search);
            param.url = this.ajaxPart + btn.pathname;

            this._prepare(i, param, targetUid);
        }
    }, {
        key: '_defineAjaxPart',
        value: function _defineAjaxPart() {
            var part = APP.vars.isDev ? '' : '';
            return part;
        }
    }, {
        key: '_getAjaxData',
        value: function _getAjaxData(search) {
            var data = {};
            if (!search) return data;

            search = search.replace('?', '').split('&');

            for (var i = 0, j = search.length; i < j; i++) {
                var item = search[i].split('=');
                data[item[0]] = item[1];
            }

            return data;
        }
    }, {
        key: '_popstateOn',
        value: function _popstateOn(e) {
            var param = {};
            param.data = this._getAjaxData(e.state.search);
            param.url = this.ajaxPart + e.state.pathname;

            this._sendStat(e.state.pathname + e.state.search); /* TODO непонятно работает или нет  */

            this._prepare(e.state.ind, param);
        }
    }, {
        key: '_prepare',
        value: function _prepare(i, param, targetUid) {

            var tab = this.tabAll[i];
            tab.className = tab.className + ' js-active';

            this.tabAll[this.curInd].className = this.tabAll[this.curInd].className.replace(' js-active', '');
            this.curInd = i;

            if (this.frame.className.indexOf('js-loading') === -1) this.frame.className = this.frame.className + ' js-loading';

            this.moduleAllRemove();

            this.getContent(param, 'POST', targetUid);
        }
    }, {
        key: 'getContent',
        value: function getContent(param, method, targetUid) {
            var self = this;

            if (this.xmlhttp) this.xmlhttp.abort();

            this.xmlhttp = (0, _ajax.ajax)({
                data: param.data,
                url: param.url,
                method: method || 'POST',
                callback: function callback(msg) {
                    self._addContent.call(self, msg, targetUid);
                }
            });
        }
    }, {
        key: '_addContent',
        value: function _addContent(msg, targetUid) {
            this.xmlhttp = false;
            this.frame.innerHTML = msg;
            this._runModules();
            if (targetUid) {
                var left = window.pageXOffset,
                    top = document.getElementById(targetUid).getBoundingClientRect().top - APP.vars.topPadding;
                this.animateObj.stop();
                window.scrollBy(0, top);
            }
            this.frame.className = this.frame.className.replace(' js-loading', '');
        }
    }, {
        key: '_sendStat',
        value: function _sendStat(page) {
            try {
                // ga('set', 'page', page);
                // ga('send', 'pageview');

                gtag('config', 'UA-21667993-5', {
                    'page_path': page
                });
                //if(console) console.log('GA при переключении таба обновлен - ' + page);
            } catch (e) {
                // if(console) console.error('GA при переключении таба не сработал');
            }

            try {
                window.yaCounter28763351.hit(page);
                //console.log('subContent yaCounter28763351', page);
            } catch (e) {}
        }
    }, {
        key: 'moduleAllRemove',
        value: function moduleAllRemove() {
            for (var i = 0, j = this.moduleAll.length; i < j; i++) {
                if (this.moduleAll[i] && this.moduleAll[i].del) this.moduleAll[i].del();else if (this.moduleAll[i] && this.moduleAll[i].destroy) this.moduleAll[i].destroy();
            }
            this.moduleAll = [];
        }
    }, {
        key: '_runModules',
        value: function _runModules() {
            var subModulesAll = void 0;

            if (this.frame) {
                subModulesAll = this.frame.querySelectorAll('[data-sub-modules]');

                for (var i = 0, j = subModulesAll.length; i < j; i++) {
                    var nameAll = subModulesAll[i].getAttribute('data-sub-modules').split(' ');
                    for (var m = 0, n = nameAll.length; m < n; m++) {
                        if (this.actions[nameAll[m]]) {
                            this.moduleAll.push(this.actions[nameAll[m]](subModulesAll[i]));
                        }
                    }
                }
            }
        }
    }, {
        key: 'del',
        value: function del() {
            _event.event.remove(window, 'popstate', this._popstateOnCircuit);
        }
    }]);

    return SubContent;
}();

;

exports.SubContent = SubContent;

},{"../modules/AllAjax":7,"../modules/Comments":12,"../modules/Fav":17,"../modules/More":22,"../modules/PageForm":28,"../modules/Player":29,"../modules/Rating":35,"../modules/RegAuthBtn":36,"../modules/TheaterMap":47,"../modules/Time":49,"../modules/ToBuy":51,"../modules/Trailer":52,"../modules/Vote":55,"../modules/Watch":57,"../modules/YaShare2":58,"../modules/ajax":61,"../modules/banners":62,"../modules/event":79,"../modules/fullscreenGallery":84,"../modules/scriptonload":106,"../modules/showSubContent":110}],46:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Tabs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tabs = function () {
    function Tabs(wrapper) {
        _classCallCheck(this, Tabs);

        this._createElements(wrapper);
        this._addEvents();
    }

    _createClass(Tabs, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;
            this.wrapper = wrapper;
            this.btnAll = this.wrapper.querySelectorAll('[data-Tabs-btn]');
            this.preview = this.wrapper.getAttribute('data-param') ? document.getElementById(this.wrapper.getAttribute('data-param')) : false;
            this.curBtn;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            for (var i = 0, j = this.btnAll.length; i < j; i++) {
                if (this.btnAll[i].className.indexOf('js-active') !== -1) {
                    this.curBtn = this.btnAll[i];
                    this.curBtn.tabContent = this._getContent(this.curBtn);
                }

                _event.event.add(this.btnAll[i], 'click', function (e) {
                    e.preventDefault();
                    self._showTab.call(self, this);
                });
            }
        }
    }, {
        key: '_getContent',
        value: function _getContent(btn) {
            var uid = btn.hash.substr(1, btn.hash.length);
            return document.getElementById(uid);
        }
    }, {
        key: '_showTab',
        value: function _showTab(btn) {
            if (btn.className.indexOf('js-active') !== -1) return;
            if (!btn.tabContent) btn.tabContent = this._getContent(btn);

            if (this.preview) {
                this.preview.parentNode.removeChild(this.preview);
                this.preview = false;
            }

            btn.className = btn.className + ' js-active';
            btn.tabContent.className = btn.tabContent.className + ' js-active';

            this.curBtn.className = this.curBtn.className.replace(' js-active', '');
            this.curBtn.tabContent.className = this.curBtn.tabContent.className.replace(' js-active', '');

            this.curBtn = btn;
        }
    }]);

    return Tabs;
}();

exports.Tabs = Tabs;

},{"../modules/event":79}],47:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TheaterMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Fav = require('../modules/Fav');

var _Fav2 = _interopRequireDefault(_Fav);

var _Rating = require('../modules/Rating');

var _Rating2 = _interopRequireDefault(_Rating);

var _event = require('../modules/event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TheaterMap = function () {
    function TheaterMap(wrapper) {
        _classCallCheck(this, TheaterMap);

        this._declare(wrapper);
        this._createMap();
        this._createPlacemarkAll();
    }

    _createClass(TheaterMap, [{
        key: '_declare',
        value: function _declare(wrapper) {
            this.wrapper = wrapper;
            this.data = JSON.parse(wrapper.getAttribute('data-param'));
            this.myMap;
            this.baseUrl = (window.location + '').indexOf('/build/') === -1 ? '/static/' : '';
        }
    }, {
        key: '_createMap',
        value: function _createMap() {
            this.myMap = new ymaps.Map(this.wrapper, {
                center: [this.data.lat, this.data.lon],
                zoom: this.data.zoom,
                controls: ["zoomControl"],
                behaviors: ['default', 'scrollZoom']
            }, {
                searchControlProvider: 'yandex#search'
            });
            this.myMap.behaviors.disable(['scrollZoom']);
        }
    }, {
        key: '_createPlacemarkAll',
        value: function _createPlacemarkAll() {
            var parent = this,
                placemarkAll = document.querySelectorAll('[data-placemark="' + parent.data.name + '"]'),
                Placemark = function () {
                function Placemark(theater) {
                    _classCallCheck(this, Placemark);

                    this.theater = theater;
                    this.data = JSON.parse(theater.getAttribute('data-param'));
                    this.isFav = this.theater.className.indexOf('js-fav') === -1 ? false : true;
                    this.iconPostfix = this.data.isClub ? '-blue' : '';
                    this._addFav(this.theater);
                    if (this.data.placemark === 'private') this._addRating(this.theater);
                    this.balloonLayout = this._createBalloonLayout();
                    this.balloonContentLayout = this._createBalloonContentLayout();
                    this.placemark = this._createPlacemark();
                    this._addEvents();
                }

                _createClass(Placemark, [{
                    key: '_getPlacemarkData',
                    value: function _getPlacemarkData() {
                        var placemarkData = {};
                        if (this.isFav) {
                            placemarkData.href = parent.baseUrl + 'img/symbols/map-icon-fav' + this.iconPostfix + '.png';
                            placemarkData.size = [40, 32];
                            placemarkData.imageOffset = [-17, -48];
                            placemarkData.balloonOffset = [-21, 19];
                        } else if (this.data.placemark === 'private') {
                            placemarkData.href = parent.baseUrl + 'img/symbols/map-icon-big' + this.iconPostfix + '.png';
                            placemarkData.size = [45, 48];
                            placemarkData.imageOffset = [-17, -48];
                            placemarkData.balloonOffset = [-21, 19];
                        } else {
                            placemarkData.href = parent.baseUrl + 'img/symbols/map-icon' + this.iconPostfix + '.png';
                            placemarkData.size = [16, 16];
                            placemarkData.imageOffset = [-8, -8];
                            placemarkData.balloonOffset = [-21, 19];
                        }
                        return placemarkData;
                    }
                }, {
                    key: '_createBalloonLayout',
                    value: function _createBalloonLayout() {
                        var self = this,
                            MyBalloonLayout = ymaps.templateLayoutFactory.createClass('<div class="layer layer-reverse  balloon">' + '<a data-js="close" class="balloon_close" href="#">' + '<svg class="symbol symbol-x symbol-balloon" role="img"><use xlink:href="/static/img/symbols/sprite.svg#x"></use></svg>' + '</a>' + '<div class="balloon_wrapper">' + '$[[options.contentLayout observeSize maxWidth=380]]' + '</div>' + '</div>', {
                            build: function build() {
                                var selfParam = this;

                                this.constructor.superclass.build.call(this);

                                this._$element = $('.balloon', this.getParentElement());

                                var closeBtn = this._$element[0].querySelector('[data-js="close"]');
                                _event.event.add(closeBtn, 'click', function (e) {
                                    selfParam.onCloseClick.call(selfParam, e);
                                });

                                self._buildBalloonContent.call(self, this._$element.find('.balloon_inner')[0]);

                                this.applyElementOffset();

                                //проверяем, что ссылка, ибо карта подключена еще к одному кинотеатру
                                if (self.data.placemark !== 'private' && self.theater.className.indexOf('js-active') === -1) {
                                    self.theater.className = self.theater.className + ' js-active';
                                }
                            },
                            clear: function clear() {
                                this.constructor.superclass.clear.call(this);
                                self.favBalloon.del();
                                self.ratingBalloon.del();

                                //проверяем, что ссылка, ибо карта подключена еще к одному кинотеатру
                                if (self.data.placemark !== 'private') {
                                    self.theater.className = self.theater.className.replace(/\s*js-active/g, '');
                                }
                            },
                            onSublayoutSizeChange: function onSublayoutSizeChange() {
                                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                                if (!this._isElement(this._$element)) {
                                    return;
                                }

                                this.applyElementOffset();

                                this.events.fire('shapechange');
                            },
                            applyElementOffset: function applyElementOffset() {
                                this._$element.css({
                                    left: 0,
                                    top: -this._$element[0].offsetHeight - 40
                                });
                            },
                            onCloseClick: function onCloseClick(e) {
                                e.preventDefault();
                                this.events.fire('userclose');
                            },
                            getShape: function getShape() {
                                if (!this._isElement(this._$element)) {
                                    return MyBalloonLayout.superclass.getShape.call(this);
                                }

                                var position = this._$element.position();

                                return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([[position.left, position.top], [position.left + this._$element[0].offsetWidth, position.top + this._$element[0].offsetHeight]]));
                            },
                            _isElement: function _isElement(element) {
                                return element && element[0];
                            }
                        });
                        return MyBalloonLayout;
                    }
                }, {
                    key: '_buildBalloonContent',
                    value: function _buildBalloonContent(wrapper) {
                        wrapper.innerHTML = this._createBalloonHtml();

                        var box = wrapper.firstChild;

                        this.favBalloon = this._addFav(box);
                        this.ratingBalloon = this._addRating(box);
                    }
                }, {
                    key: '_createBalloonContentLayout',
                    value: function _createBalloonContentLayout() {
                        var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass('<div class="balloon_inner">' + '$[properties.content]' + '</div>');
                        return MyBalloonContentLayout;
                    }
                }, {
                    key: '_createPlacemark',
                    value: function _createPlacemark() {
                        var data = this._getPlacemarkData(),
                            myPlacemark = new ymaps.Placemark([this.data.lat, this.data.lon], {}, {
                            iconLayout: 'default#image',
                            iconImageHref: data.href,
                            iconImageSize: data.size,
                            iconImageOffset: data.imageOffset,
                            balloonShadow: false,
                            balloonLayout: this.balloonLayout,
                            balloonContentLayout: this.balloonContentLayout,
                            balloonPanelMaxMapArea: 0,
                            hideIconOnBalloonOpen: true,
                            balloonOffset: data.balloonOffset
                        });

                        parent.myMap.geoObjects.add(myPlacemark);
                        return myPlacemark;
                    }
                }, {
                    key: '_createBalloonHtml',
                    value: function _createBalloonHtml() {
                        var favClass = this.isFav ? 'js-fav' : '',
                            ratingClass = this.data.ratingAllow ? 'js-allowVote' : '',
                            ratingWidth = this.data.rating * 10,
                            balloonContent = '<div data-param=\'{"uid":"' + this.data.uid + '", "type":"' + this.data.type + '"}\' class="theater theater-balloon fav fav-default ' + favClass + '">' + '<div class="theater_right align-bottom">' + '<a class="theater_name link link-default" href="' + this.data.link + '"><span class="link_border">' + this.data.name + '</span></a>' + '<span class="theater_entry">' + this.data.addr + '</span>' + '<span class="theater_entry">' + this.data.phone + '</span>' + '<div data-js="rating-box" class="rating ' + ratingClass + ' rating-mini">' + '<span class="rating_vote">' + '<span data-js="stars" class="rating_stars" style="width:' + ratingWidth + '%;"></span >' + '<a data-star="1" class="rating_star rating_star-1" href="#"></a>' + '<a data-star="2" class="rating_star rating_star-2" href="#"></a>' + '<a data-star="3" class="rating_star rating_star-3" href="#"></a>' + '<a data-star="4" class="rating_star rating_star-4" href="#"></a>' + '<a data-star="5" class="rating_star rating_star-5" href="#"></a>' + '<a data-star="6" class="rating_star rating_star-6" href="#"></a>' + '<a data-star="7" class="rating_star rating_star-7" href="#"></a>' + '<a data-star="8" class="rating_star rating_star-8" href="#"></a>' + '<a data-star="9" class="rating_star rating_star-9" href="#"></a>' + '<a data-star="10" class="rating_star rating_star-10" href="#"></a>' + '</span>' + '</div>' + '</div>' + '<div class="theater_rightMore align-bottom">' + '<a data-js="fav-btn" class="fav_btn" href="#">' + '<svg class="fav_symbol symbol symbol-health" role="img"><use xlink:href="' + parent.baseUrl + 'img/symbols/sprite.svg#health"></use></svg>' + '</a>' + '</div>' + '</div>';
                        return balloonContent;
                    }
                }, {
                    key: '_addFav',
                    value: function _addFav(wrapper) {
                        var self = this,
                            obj = new _Fav2.default(wrapper),
                            data;

                        obj.onchange = function (isFav) {
                            if (self.isFav === isFav) return;

                            self.isFav = isFav;
                            data = self._getPlacemarkData.call(self);
                            self.placemark.options.set('iconImageHref', data.href);
                            self.placemark.options.set('iconImageSize', data.size);
                            self.placemark.options.set('iconImageOffset', data.imageOffset);
                            self.placemark.options.set('balloonOffset', data.balloonOffset);
                        };
                        return obj;
                    }
                }, {
                    key: '_addRating',
                    value: function _addRating(wrapper) {
                        var self = this,
                            obj = new _Rating2.default(wrapper),
                            data;

                        obj.onchange = function (rating) {
                            if (!self.data.ratingAllow) return;

                            self.data.ratingAllow = false;
                            self.data.rating = rating;
                            self.theater.setAttribute('data-param', JSON.stringify(self.data));
                        };
                        return obj;
                    }
                }, {
                    key: '_addEvents',
                    value: function _addEvents() {
                        var self = this;

                        if (this.data.placemark !== 'private') {
                            _event.event.add(this.theater, 'click', function (e) {
                                e.preventDefault();

                                if (this.className.indexOf('js-active') !== -1) return;

                                parent.myMap.panTo([self.data.lat, self.data.lon]).then(function () {
                                    self.placemark.balloon.open();
                                });
                            });
                        }
                    }
                }]);

                return Placemark;
            }();

            for (var i = 0, j = placemarkAll.length; i < j; i++) {
                new Placemark(placemarkAll[i]);
            }
        }
    }]);

    return TheaterMap;
}();

exports.TheaterMap = TheaterMap;

},{"../modules/Fav":17,"../modules/Rating":35,"../modules/event":79}],48:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Thetop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Thetop = function () {
    function Thetop(box) {
        _classCallCheck(this, Thetop);

        this._createElements(box);

        if (document.readyState === "complete") {
            this._addEvents();
        } else {
            var self = this;
            _event.event.add(window, 'load', function () {
                self._addEvents.call(self);
            });
        }
    }

    _createClass(Thetop, [{
        key: '_createElements',
        value: function _createElements(box) {
            this.box = box;
            this.boxH = 167;
            this.top = this.box.getBoundingClientRect().top;
            this.offset = this.top + this.boxH;
            this.minWidth = 990;
            this.clear;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;
            var f = function f(e) {
                try {
                    clearTimeout(self.clear);
                } catch (e) {};

                self.clear = setTimeout(function () {
                    if (window.pageYOffset > self.offset) {
                        _event.event.remove(window, 'scroll', f);
                        self._show.call(self);
                    }
                }, 300);
            };

            //
            _event.event.add(window, 'scroll', f);
            //f();
        }
    }, {
        key: '_show',
        value: function _show() {
            var top = window.pageYOffset;
            this.box.className = this.box.className + ' js-active';

            /* ФФ не прокручивает страницу, а хром сам автоматом крутит, оставляя содержимое на этом же месте */
            if (top == window.pageYOffset) window.scrollBy(0, this.boxH);
        }
    }]);

    return Thetop;
}();

exports.Thetop = Thetop;

},{"../modules/event":79}],49:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Time = function () {
    function Time(wrapper, subContent) {
        _classCallCheck(this, Time);

        if (!window.history) return false;
        this._createElements(wrapper, subContent);
        this._addEvents();
    }

    _createClass(Time, [{
        key: '_createElements',
        value: function _createElements(wrapper, subContent) {
            this.wrapper = wrapper;
            this.subContent = subContent;
            this.btnAll = this.wrapper.querySelectorAll('[data-Time-btn]');
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            for (var i = 0, j = this.btnAll.length; i < j; i++) {
                this.btnAll[i].onclick = function () {
                    self._prepareToShow.call(self, this); /* напрмиер, в сортировке по расположению предварительно пытаемся проставлять координаты */
                    return false;
                };
            }
        }
    }, {
        key: '_prepareToShow',
        value: function _prepareToShow(btn) {
            var param = btn.getAttribute('data-Time-btn');

            //
            if (this.subContent.frame.className.indexOf('js-loading') === -1) this.subContent.frame.className = this.subContent.frame.className + ' js-loading';

            if (!param) {
                this._showTime(btn);
            } else {
                param = JSON.parse(param);
                switch (param.type) {
                    case 'geo':
                        {
                            this._getLocation(btn);
                            break;
                        }
                    default:
                        this._showTime(btn);
                }
            }
        }
    }, {
        key: '_getLocation',
        value: function _getLocation(btn) {
            var _this = this;

            if (!navigator.geolocation) {
                this._showTime(btn);
            } else {
                console.log('geolocation', 'navigator.geolocation ');
                navigator.geolocation.getCurrentPosition(function (position) {
                    console.log('geolocation', 'navigator.geolocation success');
                    var search = btn.search;
                    var coords = 'long=' + position.coords.longitude + '&lat=' + position.coords.latitude;
                    btn.search = search ? search + '&' + coords : '?' + coords;
                    _this._showTime(btn);
                }, function () {
                    console.log('geolocation', 'navigator.geolocation error');
                    _this._showTime(btn);
                }, {
                    timeout: 5000
                });
            }
        }
    }, {
        key: '_showTime',
        value: function _showTime(btn) {
            window.history.pushState({ ind: this.subContent.curInd, pathname: btn.pathname, search: btn.search }, '', btn.pathname + btn.search);

            this._sendStat(btn.pathname + btn.search);

            this.subContent.moduleAllRemove();

            var param = {};
            param.data = this.subContent._getAjaxData(btn.search);
            param.url = this.subContent.ajaxPart + btn.pathname + btn.search;

            this.subContent.getContent(param);
        }
    }, {
        key: '_sendStat',
        value: function _sendStat(page) {
            try {
                // ga('set', 'page', page);
                // ga('send', 'pageview');

                gtag('config', 'UA-21667993-5', {
                    'page_path': page
                });
                if (console) console.log('GA при переключении сортировки обновлен - ' + page);
            } catch (e) {
                if (console) console.error('GA при переключении сортировки не сработал');
            }
        }
    }]);

    return Time;
}();

exports.Time = Time;

},{}],50:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Title = function () {
    function Title(btn) {
        _classCallCheck(this, Title);

        this._createElements(btn);
        this._addEvents();
    }

    _createClass(Title, [{
        key: '_createElements',
        value: function _createElements(btn) {
            this.btn = btn;
            this.inner = this.btn.getAttribute('title');
            this.btn.removeAttribute('title');
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;
            _event.event.add(this.btn, 'mouseenter', function () {
                self._show.call(self);
            });
        }
    }, {
        key: '_show',
        value: function _show() {
            var self = this,
                box = document.createElement('DIV');

            _event.event.add(this.btn, 'mouseleave', function onOut() {
                self._hide.call(self, box, onOut);
            });

            box.className = 'title_popup';
            box.innerHTML = this.inner;
            this.btn.appendChild(box);
        }
    }, {
        key: '_hide',
        value: function _hide(box, onOut) {
            _event.event.remove(this.btn, 'mouseleave', onOut);
            this.btn.removeChild(box);
        }
    }]);

    return Title;
}();

exports.Title = Title;

},{"../modules/event":79}],51:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ToBuy = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _CrossDomainTransport = require('../modules/CrossDomainTransport');

var _scriptonload = require('../modules/scriptonload');

var _page = require('../modules/page');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ToBuy = function () {
    function ToBuy(btn) {
        _classCallCheck(this, ToBuy);

        if (!APP.vars.isMobile) {
            this._createElements(btn);
            this._addEvents();
        } else {
            var self = this;

            if (!window.jQuery) (0, _scriptonload.scriptonload)('/static/js/vendors/jquery-1.12.0.min.js', function () {
                self._runMobile.call(self, btn);
            });else this._runMobile(btn);
        }
    }

    _createClass(ToBuy, [{
        key: '_createElements',
        value: function _createElements(btn) {
            this.btn = btn;
            this.dataParam = false;

            if (!APP.vars.rbKey) {
                /*
                 * TODO
                 * DEPRECATED
                 * */
                var el = document.getElementsByTagNameNS('*', 'rb:rich')[0];
                APP.vars.rbKey = el.getAttribute('key');
            }
        }
    }, {
        key: '_addUtmToUrl',
        value: function _addUtmToUrl(src) {
            if (APP && APP.vars && APP.vars.ticketsUtm) {
                var sign = src.indexOf('?') == -1 ? '?' : '&';
                if (src.indexOf('?')) src = src + sign + APP.vars.ticketsUtm.utm + '=' + APP.vars.ticketsUtm.value;
            }
            return src;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;
            this._showPopupLocking = function (event) {
                event.preventDefault();
                if (self.dataParam === false) self.dataParam = JSON.parse(this.getAttribute('data-param'));
                //
                if (self.dataParam.type === 'kinohod') {
                    /* TODO заплатка от Антошки. У кинохода2 в id присутствует _ избавляемся от него */
                    self.dataParam.uid = self.dataParam.uid.replace(/^_/, '');
                    self._showKinohod.call(self);
                } else self._showRambler.call(self); /* TODO premieralight */

                self._sendStat(self.dataParam, 'open');
            };

            _event.event.add(this.btn, 'click', this._showPopupLocking);
        }
    }, {
        key: '_showKinohod',
        value: function _showKinohod() {
            var _this = this;

            var self = this;
            var param = this.dataParam;
            var apikey = param.apikey || 'ba22a607-2480-3c14-80a1-c92613e30bbf',
                src = this._addUtmToUrl('https://kinohod.ru/widget/seances/' + param.uid + '?apikey=' + apikey + '&utm_source=' + apikey + '&utm_content=' + param.userid + '&type=seance&__referrer=boxoffice&_referrer=' + location.origin),
                popup = uPopup({
                addClass: 'popup-tobuy popup-tobuy-kinohod tobuy tobuy-kinohod',
                name: 'tobuy',
                content: '<header class="tobuy_header">' + '<div class="tobuy_header_left">' + '<a class="mainLogo mainLogo-tobuy" href="/">' + '<span class="mainLogo_title g-active">' + '<span class="mainLogo_letter">К</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">н</span><span class="mainLogo_letter">о</span><span class="mainLogo_letter">а</span><span class="mainLogo_letter">ф</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">ш</span><span class="mainLogo_letter">а</span>' + '</span>' + '</a>' + '</div>' + '<div class="tobuy_header_right">' + '<span class="tobuy_header_text">' + 'Проблемы с билетами?<br />' + 'Телефон поддержки' + '</span>' + '<span class="tobuy_header_handset">' + '<svg class="symbol symbol-handset symbol-handset-tobuy" role="img"><use xlink:href="/static/img/symbols/sprite.svg#handset"></use></svg>' + '</span>' + '<span class="tobuy_header_phone">8 (800) 333 80 97</span>' + '</div>' + '</header>' + '<iframe id="widgetFrame"  name="widgetFrame" data-ToBuy="partner" class="tobuy_partner" src="' + src + '"></iframe>',
                oncloseBefore: function oncloseBefore() {
                    _this._onClosePopup();
                    return true;
                }
            }),
                iframe = popup.content.querySelector('[data-ToBuy="partner"]'),
                portal = new _CrossDomainTransport.CrossDomainTransport(window.location.href, 'widgetFrame', {
                'check.kh.frame': function onWidgetFrame(data) {
                    portal.post('embedded.kh.frame'); //Это дает понять виджету что он во фрейме
                    portal.post('boxoffice.kh.ready'); //Это как раз запуск событий из виджета в главное окно
                },
                'resize.kh.widget': function onWidgetResize(data) {
                    //iframe.style.height = data.height + 'px';
                    //console.log(data.height);
                },
                'scroll.kh.widget': function onWidgetScroll() {
                    console.log('scroll.kh.widget');
                },
                'info.kh.order': function onWidgetSuccess(data) {
                    self._onSuccess.call(self, data, self.dataParam);
                }
            });

            //

            iframe.onload = function () {
                portal.post('loaded', { _isEmbeddedWithBoxoffice: true, type: 'movie|movies|seance|seances|cinema|cinemas' });
            };
        }
    }, {
        key: '_showRambler',
        value: function _showRambler() {
            var _this2 = this;

            var param = this.dataParam;
            var self = this;
            var src = this._addUtmToUrl('https://w.kassa.rambler.ru/event/' + param.uid + '/' + APP.vars.rbKey + '/' + encodeURIComponent(window.location.toString()) + '/'),
                popup = uPopup({
                addClass: 'popup-tobuy popup-tobuy-rambler tobuy tobuy-rambler',
                name: 'tobuy',
                content: '<header class="tobuy_header">' + '<div class="tobuy_header_left">' + '<a class="mainLogo mainLogo-tobuy" href="/">' + '<span class="mainLogo_title g-active">' + '<span class="mainLogo_letter">К</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">н</span><span class="mainLogo_letter">о</span><span class="mainLogo_letter">а</span><span class="mainLogo_letter">ф</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">ш</span><span class="mainLogo_letter">а</span>' + '</span>' + '</a>' + '</div>' + '<div class="tobuy_header_right">' + '<span class="tobuy_header_text">' + 'Проблемы с билетами?<br />' + 'Телефон поддержки' + '</span>' + '<span class="tobuy_header_handset">' + '<svg class="symbol symbol-handset symbol-handset-tobuy" role="img"><use xlink:href="/static/img/symbols/sprite.svg#handset"></use></svg>' + '</span>' + '<span class="tobuy_header_phone">8 (800) 505-67-91</span>' + '</div>' + '</header>' + '<iframe data-ToBuy="partner" scrolling="no" class = "tobuy_partner" src="' + src + '"></iframe>',
                oncloseBefore: function oncloseBefore() {
                    _this2._onClosePopup();
                    return true;
                }
            }),
                onMessage = function onMessage(event) {
                if (event.origin === 'https://w.kassa.rambler.ru') {
                    //есть косяки, что-то передается в виде объекта, что-то в виде строки
                    if (_typeof(event.data) === 'object' && event.data.id === 'kassa-widget-successful-payment' && event.data.orderId) {
                        //{id: "kassa-widget-successful-payment", orderId: "b2c5ab40-9482-482e-9210-dd0d03ffe5e7"}
                        self._onSuccess.call(self, event.data, self.dataParam);

                        //console.log('Билет куплен, отправляем запрос');
                        var data = 'orderkey=' + event.data.orderId;
                        var xhr = new XMLHttpRequest();
                        xhr.open("POST", 'https://api.kinoafisha.info/sales/rk/', true);
                        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                        xhr.withCredentials = true;
                        xhr.onload = function () {
                            // console.log('orderKey передался')};
                            xhr.send(data);
                        };
                    }
                }
            };
            //
            window.addEventListener('message', onMessage, false);
        }
    }, {
        key: '_onSuccess',
        value: function _onSuccess(widgetData, dataParam) {
            /* TODO - когда переедет все в одно место  - будет и так доступно this.dataParam */
            console.log('Успешная покупка билета _onSuccess');
            var messageParam = { status: 'success', initialData: dataParam, widgetData: widgetData };
            if (window.top.ReactNativeWebView) window.top.ReactNativeWebView.postMessage(messageParam, "*"); //для приложения
            else window.top.postMessage(messageParam, "*");
            this._sendStat(dataParam, 'success');
        }
    }, {
        key: '_onClosePopup',
        value: function _onClosePopup() {
            uPopup.closeAll();

            var count = regAuthObj.isAuth ? 1 : 2;
            var random = APP.helpers.randomInteger(1, count);

            switch (random) {
                case 1:
                    this._showAllcafePopup();
                    break;
                case 2:
                    regAuthObj.authForm.showPopup({ "cls": "popup-middle-saveTicket" });
                    break;
            }
        }
    }, {
        key: '_showAllcafePopup',
        value: function _showAllcafePopup() {
            if (APP.vars.showAllcafe) {
                var path = APP.pagesParam['allcafe']['ajax'].replace('[CINEMAID]', this.dataParam.cinemaid);
                (0, _page.page)({ "name": "allcafe", ajax: path });
            } else return false;
        }
    }, {
        key: '_sendStat',
        value: function _sendStat(param, type) {
            switch (type) {
                case 'open':
                    {
                        //Открытие виджета
                        var page = window.location.pathname + 'tickets/';
                        try {
                            gtag('config', 'UA-21667993-5', {
                                'page_path': page
                            });
                        } catch (e) {
                            if (console) console.error('GA при покупке билета не сработал');
                        }

                        if (param.movieid == '8356092') {
                            try {
                                fbq('track', 'InitiateCheckout');
                            } catch (e) {
                                console.log(e);
                            }
                        }
                        break;
                    }

                case 'success':
                    {
                        //успешная покупка билета
                        console.log('Отправляем стату успешной покупки билета');
                        ['tickets_buy', 'tickets_buy_' + param.type].forEach(function (event) {
                            try {
                                gtag('event', event, {
                                    'event_category': 'engagement',
                                    'event_action': 'tickets',
                                    'event_label': 'buy'
                                });
                            } catch (e) {
                                if (console) console.log('gtag не существует');
                            };

                            try {
                                yaCounter28763351.reachGoal(event);
                            } catch (e) {
                                if (console) console.log('ym не существует');
                            };
                        });
                        break;
                    }
            }
        }
    }, {
        key: 'del',
        value: function del() {
            _event.event.remove(this.btn, 'click', this._showPopupLocking);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.del();
        }

        /* TODO */

    }, {
        key: '_runMobile',
        value: function _runMobile(newBtn) {
            var self = this;

            $(function () {
                var $tobuy,
                    $closeBtn,
                    $body = $(document.body),
                    top,
                    bodyClass = 'tobuy',
                    /* на отельной странице доавляется tobuy-widget Пример - tobuy-widget.php */
                isWidget = false; /* Покупка билета может подключаться на отдельной странице */

                function buy(e, widget) {
                    if (widget) {
                        /* если передается нужные параметры гетом - значит это виджет */
                        bodyClass = 'tobuy tobuy-widget';
                        isWidget = true;
                    } else dataParam = JSON.parse(this.getAttribute('data-param'));

                    /* TODO заплатка от Антошки. У кинохода2 в id присутствует _ избавляемся от него */
                    if (dataParam.type === 'kinohod') dataParam.uid = dataParam.uid.replace(/^_/, '');

                    createElements();
                    show();
                    addClose();
                    self._sendStat(dataParam, 'open');

                    if (dataParam.type === 'rambler') {
                        addNewWidgetRamblerIframe();
                    } else addWidgetKinohodIframe();
                }

                function createElements() {
                    var type = dataParam.type;

                    if (type === 'rambler') {
                        var phone = '8 800 505-67-91';
                        var patch = '';
                        var cls = 'tobuy-box-rambler';
                    } else {
                        var phone = '8 800 333 80 97';
                        var patch = '<div class="tobuy-header-patch">Не влезает форма оплаты? Переверни телефон!</div>';
                        var cls = 'tobuy-box-kinohod';
                    }

                    $tobuy = $('<div class="tobuy-box ' + cls + '">' + '<div class="tobuy-header">' + '<div class="tobuy-header-content">' + '<div class="tobuy-header-left">' + '<a class="tobuy-header-logo" href="/main.php"></a>' + '</div>' + '<div class="tobuy-header-right">' + '<img class="tobuy-header-handset" src="/static/mobile/img/phone.png" alt=""/>' + '<a class="tobuy-header-phone" href="tel:' + phone.replace(/ /g, '') + '">' + phone + '</a>' + '</div>' + '</div>' + patch + '<div class="tobuy-header-close">×</div>' + '</div>' + '</div>');

                    $closeBtn = $('.tobuy-header-close', $tobuy);
                }

                function show() {
                    /* TODO
                     * по-хорошему нужно предусмотреть измененние высоты при повороте и масштабе (если есть)
                     */
                    top = window.pageYOffset;

                    $(document.body).append($tobuy);
                    $body.addClass(bodyClass);
                }

                function addClose() {
                    $closeBtn.click(function () {
                        $body.removeClass(bodyClass);
                        window.scrollTo(0, top);
                        $closeBtn.unbind('click');
                        $tobuy.remove();
                        $tobuy = null;
                        $closeBtn = null;
                        top = null;

                        if (!isWidget) {
                            /*
                            * Для виджета авторизация не нужна
                            * */
                            var count = isUserAuth ? 1 : 2;
                            var random = APP.helpers.randomInteger(1, count);

                            /* TODO */
                            /*switch(random){
                                case 1:
                                    showAllcafePopup();
                                    break;
                                case 2:
                                    APP.auth.tryAuth(false, {"cls":"authPopup-saveTicket"});
                                    break;
                            }*/
                        } else {
                                /* для виджета не показываем */
                            }
                    });
                }

                function addWidgetKinohodIframe() {
                    var apikey = dataParam.apikey || APP.vars.khKey,
                        /* чтобы были одинаковые  урлы с десктопом */
                    src = self._addUtmToUrl('https://kinohod.ru/widget/seances/' + dataParam.uid + '?apikey=' + apikey + '&utm_source=' + apikey + '&utm_content=' + dataParam.userid + '&type=seance&__referrer=boxoffice&_referrer=' + location.origin),


                    /* TODO */
                    onMessage = function onMessage(event) {
                        console.log('onMessage origin', event.origin);
                        console.log('onMessage data', event.data);
                    };

                    //Прокидываем метку в урл из разметки, если есть


                    // В приложении в айфоне на киноходе не работает форма оплаты сбера.
                    // Поэтому просто пока редиректим
                    if (dataParam.app == 'ios') document.location = src;else $tobuy.append('<iframe id="widgetFrame" name="widgetFrame" class="tobuy-iframe" scrolling="no" src="' + src + '"></iframe>');

                    window.addEventListener('message', onMessage, false);

                    var iframe = $tobuy.find('iframe.tobuy-iframe')[0],
                        portal = new _CrossDomainTransport.CrossDomainTransport(window.location.href, 'widgetFrame', {
                        'check.kh.frame': function onWidgetFrame(data) {
                            portal.post('embedded.kh.frame'); //Это дает понять виджету что он во фрейме
                            portal.post('boxoffice.kh.ready'); //Это как раз запуск событий из виджета в главное окно
                        },
                        'resize.kh.widget': function onWidgetResize(data) {
                            console.log('WidgetResize', data);
                        },
                        'scroll.kh.widget': function onWidgetScroll(data) {
                            console.log('scroll.kh.widget', data);
                        },
                        'info.kh.order': function onWidgetSuccess(data) {
                            console.log('info.kh.order', data);
                            self._onSuccess.call(self, data, dataParam);
                        }
                    });
                    iframe.onload = function () {
                        portal.post('loaded', { _isEmbeddedWithBoxoffice: true, type: 'movie|movies|seance|seances|cinema|cinemas' });
                    };
                }

                function addNewWidgetRamblerIframe() {
                    var src = self._addUtmToUrl('https://w.kassa.rambler.ru/event/' + dataParam.uid + '/' + APP.vars.rbKey + '/' + encodeURIComponent(window.location.toString()) + '/'),
                        onMessage = function onMessage(event) {
                        if (event.origin === 'https://w.kassa.rambler.ru') {
                            //есть косяки, что-то передается в виде объекта, что-то в виде строки
                            if (_typeof(event.data) === 'object' && event.data.id === 'kassa-widget-successful-payment' && event.data.orderId) {
                                //{id: "kassa-widget-successful-payment", orderId: "b2c5ab40-9482-482e-9210-dd0d03ffe5e7"}
                                self._onSuccess.call(self, event.data, dataParam);
                                //console.log('Билет куплен, отправляем запрос');
                                $.ajax({
                                    url: 'https://api.kinoafisha.info/sales/rk/',
                                    type: 'POST',
                                    data: {
                                        orderkey: event.data.orderId
                                    },
                                    xhrFields: {
                                        withCredentials: true
                                    }
                                });
                            }
                        }
                    };

                    //
                    $tobuy.append('<iframe class="tobuy-iframe" src="' + src + '"></iframe>');
                    window.addEventListener('message', onMessage, false);
                }

                function showAllcafePopup() {
                    if (APP.vars.showAllcafe) {
                        var path = APP.pagesParam['allcafe']['ajax'].replace('[CINEMAID]', dataParam.cinemaid);
                        (0, _page.page)({ "name": "allcafe", ajax: path });
                    } else return false;
                }

                //
                var search = location.search.substring(1);
                var dataParam = void 0;
                if (search) {
                    dataParam = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
                    if (dataParam.type == 'kinohod' || dataParam.type == 'rambler') {
                        buy(false, true);
                        return;
                    }
                }

                $(newBtn).click(buy);
            });
        }
    }]);

    return ToBuy;
}();

exports.ToBuy = ToBuy;

},{"../modules/CrossDomainTransport":15,"../modules/event":79,"../modules/page":95,"../modules/scriptonload":106}],52:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Trailer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ajax = require('../modules/ajax');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
    @param string foreignIframe - src внешнего ифрейма.
    @param string filmName - если используется внешний ифрейм, то сами подставляем название.
    TODO - дописать все параметры
 */

var Trailer = function () {
    function Trailer(wrapper) {
        _classCallCheck(this, Trailer);

        this._createElements(wrapper);
        this._addPreviews();
    }

    _createClass(Trailer, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            var self = this;
            this.wrapper = wrapper;
            this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.extended = function () {
                try {
                    return self.param.extended + '/';
                } catch (e) {
                    return '';
                }
            }();
            this.frame = this.wrapper.querySelector('[data-Trailer-frame]');
            this.previews = this.wrapper.querySelector('[data-Trailer-previews]');
            this.thumbAll;
            this.moduleFrameAll = APP.modules.run(this.frame, 'data-trailer-modules');
            /* плеера может и не быть, может всталяться ифрейм */
            if (this.moduleFrameAll.uPlayer) {
                this.moduleFrameAll.uPlayer[0].onActive = function () {
                    self.wrapper.classList.add('js-active');
                    self.wrapper.classList.remove('js-closed');
                };

                this.moduleFrameAll.uPlayer[0].onDisableActive = function () {
                    self.wrapper.classList.remove('js-active');
                    self.wrapper.classList.add('js-closed');
                };
            } else if (this.moduleFrameAll.onlinePlayer) {
                this.moduleFrameAll.onlinePlayer[0].onActive = function () {
                    self.wrapper.classList.add('js-active');
                    self.wrapper.classList.remove('js-closed');
                };
            }
            this.modulePreviewsAll;
            this.isSending = false;
            this.curInd = false;
            this.ajaxPath = this._defineAjaxPath();
            this.xhr = false;
            /* если у нас простой ифрейм, то без всяких запросов - просто меняем название и урл */
            this.filmName;
            this.foreignIframe;
        }
    }, {
        key: '_defineAjaxPath',
        value: function _defineAjaxPath() {
            var part = (window.location + '').indexOf('/_src/') === -1 ? '' : '/_src/layouts/trailerModule';
            return part;
        }
    }, {
        key: '_addPreviews',
        value: function _addPreviews() {
            if (!this.previews) return false;

            var self = this;

            this.modulePreviewsAll = APP.modules.run(this.previews, 'data-trailer-modules');
            this.thumbAll = this.previews.querySelectorAll('[data-Trailer-thumb]');

            for (var i = 0, j = this.thumbAll.length; i < j; i++) {
                var thumb = this.thumbAll[i];

                if (thumb.className.indexOf('js-active') !== -1) this.curInd = i;

                thumb.addEventListener('click', function (i) {
                    return function (e) {
                        self._switchTab.call(self, e, i);
                    };
                }(i), false);
            }
        }
    }, {
        key: '_switchTab',
        value: function _switchTab(e, i) {
            var newThumb = this.thumbAll[i],
                param;

            e.preventDefault();
            if (this.curInd === i) return false;

            newThumb.className = newThumb.className + ' js-active';
            if (this.curInd !== false) {
                var oldThumb = this.thumbAll[this.curInd];
                oldThumb.className = oldThumb.className.replace(' js-active', '');
            }

            this.curInd = i;
            param = JSON.parse(newThumb.getAttribute('data-Trailer-thumb'));

            /* если внешний ифрейм - просто меняем урл и название, без всяких запросов и прелоадеров */
            if (param.foreignIframe) {
                if (!this.foreignIframe) {
                    this.filmName = this.frame.querySelector('[data-trailer-filmName]');
                    this.foreignIframe = this.frame.querySelector('[data-trailer-foreignIframe]');
                }

                this.filmName.innerHTML = param.filmName;
                this.foreignIframe.setAttribute('src', param.foreignIframe);
            } else {
                if (this.frame.className.indexOf('js-loading') === -1) this.frame.className = this.frame.className + ' js-loading';

                APP.modules.destroy(this.moduleFrameAll);
                delete this.moduleFrameAll;

                this._getContent(param);
            }
        }
    }, {
        key: '_getContent',
        value: function _getContent(param) {
            var self = this,
                path = this.ajaxPath + '/movies/' + param.movieid + '/video/' + param.videoid + '/' + this.extended;

            if (this.xhr) this.xhr.abort();

            this.xhr = new XMLHttpRequest();
            this.xhr.open("POST", path, true);
            this.xhr.setRequestHeader("X-Request-Ajax", "1");
            this.xhr.onload = function () {
                self._addContent.call(self, self.xhr.responseText);
            };
            this.xhr.send(this._jsonToQueryString(param));
        }
    }, {
        key: '_addContent',
        value: function _addContent(msg) {
            this.xhr = false;
            this.frame.innerHTML = msg;
            this.moduleFrameAll = APP.modules.run(this.frame, 'data-trailer-modules');
            this.frame.className = this.frame.className.replace(' js-loading', '');
        }
    }, {
        key: '_jsonToQueryString',
        value: function _jsonToQueryString(json) {
            return '?' + Object.keys(json).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
            }).join('&');
        }
    }, {
        key: 'del',
        value: function del() {
            APP.modules.destroy(this.moduleFrameAll);
            if (this.modulePreviewsAll) APP.modules.destroy(this.modulePreviewsAll);

            for (var key in this) {
                delete this[key];
            }
        }
    }]);

    return Trailer;
}();

exports.Trailer = Trailer;

},{"../modules/ajax":61}],53:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Transform = function () {
    function Transform(wrapper) {
        _classCallCheck(this, Transform);

        this._createElements(wrapper);
        this.getArea();
        this._addEvents();
    }

    _createClass(Transform, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.box = wrapper;
            this.parentBox = this.box.parentNode;
            this.parent = {};
            this.parent.width = this.parentBox.clientWidth;
            this.parent.height = this.parentBox.clientHeight;
            this.isResize = false;
            this.names = {}; //имена функций для запуска, курсоров
            this.names.cursor = 'default';
            this.names.funcBefore;
            this.names.funcTransform;
            this.boxComputedStyle = window.getComputedStyle ? getComputedStyle(this.box, '') : this.box.currentStyle;
            this.area = {};
            this.area.marginLeft = parseFloat(this.boxComputedStyle.marginLeft); //справа, снизу нужно предусмотреть
            this.area.marginTop = parseFloat(this.boxComputedStyle.marginTop);
            this.area.border = parseFloat(this.boxComputedStyle.borderLeftWidth); // границы одинаковые со всех сторон, другое нужно предусматривать
            this.area.minSize = 5;
            this.area.maxSize; //вычисляем для каждого направления отдельно
            this.area.getOffsetSize; //ф-я задается для каждого направления отдельно
            this.area.minLeft = -this.area.marginLeft;
            this.area.maxLeft;
            this.area.minTop = -this.area.marginTop;
            this.area.maxTop;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.box.style.cssText = '';
        }
    }, {
        key: 'getArea',
        value: function getArea() {
            this.area.parentWidth = this.parentBox.clientWidth;
            this.area.parentHeight = this.parentBox.clientHeight;
            this.area.width = this.box.clientWidth;
            this.area.height = this.box.clientHeight;
            this.area.offsetLeft = this.box.offsetLeft;
            this.area.offsetRight = this.area.parentWidth - this.area.offsetLeft - this.area.width - this.area.border * 2;
            this.area.offsetTop = this.box.offsetTop;
            this.area.offsetBottom = this.area.parentHeight - this.area.offsetTop - this.area.height - this.area.border * 2;
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var self = this;

            this.eNames = {};
            if (window.navigator.pointerEnabled) this.eNames = { 'down': 'pointerdown', 'move': 'pointermove', 'enter': 'pointerenter', 'leave': 'pointerleave', 'up': 'pointerup' };else if (window.navigator.msPointerEnabled) this.eNames = { 'down': 'MSPointerDown', 'move': 'MSPointerMove', 'enter': 'MSPointerEnter', 'leave': 'MSPointerLeave', 'up': 'MSPointerUp' };else if ('ontouchstart' in document.documentElement) {
                this.eNames = { 'down': 'touchstart', 'move': 'touchmove', 'enter': 'touchstart', 'leave': 'touchend', 'up': 'touchend' };
            } else this.eNames = { 'down': 'mousedown', 'move': 'mousemove', 'enter': 'mouseenter', 'leave': 'mouseleave', 'up': 'mouseup' };

            if (document.body.addEventListener) {
                var addEvent = 'addEventListener',
                    on = '';
            } else {
                var addEvent = 'attachEvent',
                    on = 'on';
            }

            this.box['on' + this.eNames.move] = function (e) {
                e = e || window.event;
                e = e.touches ? e.touches[0] : e;

                if (!self.isResize) self._defineCursor.call(self, e);
            };

            document.body[addEvent](on + this.eNames.down, function (e) {
                e = e || window.event;
                e = e.touches ? e.touches[0] : e;

                var target = e.target || e.srcElement;
                if (target == self.box) {
                    self.getArea();
                    self.area.x = e.clientX;
                    self.area.y = e.clientY;
                    self.isResize = true;
                    document.body.style.cursor = self.names.cursor;
                    self[self.names.funcBefore].call(self, e);
                }
            }, false);

            document.body[addEvent](on + this.eNames.move, function (e) {
                e = e || window.event;
                e = e.touches ? e.touches[0] : e;

                if (self.isResize) self[self.names.funcTransform].call(self, e);
            }, false);

            document.body[addEvent](on + this.eNames.up, function (e) {
                if (self.isResize) {
                    document.body.style.cursor = 'default';
                    self.isResize = false;
                }
            }, false);
        }
    }, {
        key: '_resize',
        value: function _resize(e) {
            var offset = this.area.getOffsetSize(e.clientX, e.clientY);
            this.box.style.width = Math.max(Math.min(this.area.width + offset, this.area.maxSize), this.area.minSize) + 'px';
            this.box.style.height = this.box.style.width;
        }
    }, {
        key: '_move',
        value: function _move(e) {
            //Объединить с ресайз?
            this.box.style.left = Math.max(Math.min(this.area.offsetLeft - this.area.marginLeft + e.clientX - this.area.x, this.area.maxLeft), this.area.minLeft) + 'px';
            this.box.style.top = Math.max(Math.min(this.area.offsetTop - this.area.marginTop + e.clientY - this.area.y, this.area.maxTop), this.area.minTop) + 'px';
        }
    }, {
        key: '_nwBeforeResize',
        value: function _nwBeforeResize(e) {
            this.area.getOffsetSize = function (x, y) {
                return (this.x - x - y + this.y) / 2;
            };
            this.box.style.left = 'auto';
            this.box.style.right = this.area.offsetRight + 'px';
            this.box.style.top = 'auto';
            this.box.style.bottom = this.area.offsetBottom + 'px';
            this.area.maxSize = Math.min(this.area.parentWidth - this.area.offsetRight, this.area.parentHeight - this.area.offsetBottom) - this.area.border * 2; //выбираем меньшее из макс высоты и ширины
        }
    }, {
        key: '_swBeforeResize',
        value: function _swBeforeResize(e) {
            this.area.getOffsetSize = function (x, y) {
                return (this.x - x + y - this.y) / 2;
            };
            this.box.style.left = 'auto';
            this.box.style.right = this.area.offsetRight + 'px';
            this.box.style.top = this.area.offsetTop - this.area.marginTop + 'px';
            this.box.style.bottom = 'auto';
            this.area.maxSize = Math.min(this.area.parentWidth - this.area.offsetRight, this.area.parentHeight - this.area.offsetTop) - this.area.border * 2; //выбираем меньшее из макс высоты и ширины
        }
    }, {
        key: '_neBeforeResize',
        value: function _neBeforeResize(e) {
            this.area.getOffsetSize = function (x, y) {
                return (x - this.x - y + this.y) / 2;
            };
            this.box.style.left = this.area.offsetLeft - this.area.marginLeft + 'px';
            this.box.style.right = 'auto';
            this.box.style.top = 'auto';
            this.box.style.bottom = this.area.offsetBottom + 'px';
            this.area.maxSize = Math.min(this.area.parentWidth - this.area.offsetLeft, this.area.parentHeight - this.area.offsetBottom) - this.area.border * 2; //выбираем меньшее из макс высоты и ширины
        }
    }, {
        key: '_seBeforeResize',
        value: function _seBeforeResize(e) {
            this.area.getOffsetSize = function (x, y) {
                return (x - this.x + y - this.y) / 2;
            };
            this.box.style.left = this.area.offsetLeft - this.area.marginLeft + 'px';
            this.box.style.right = 'auto';
            this.box.style.top = this.area.offsetTop - this.area.marginTop + 'px';
            this.box.style.bottom = 'auto';
            this.area.maxSize = Math.min(this.area.parentWidth - this.area.offsetLeft, this.area.parentHeight - this.area.offsetTop) - this.area.border * 2; //выбираем меньшее из макс высоты и ширины
        }
    }, {
        key: '_beforeMove',
        value: function _beforeMove(e) {
            this.box.style.left = this.area.offsetLeft - this.area.marginLeft + 'px';
            this.box.style.right = 'auto';
            this.box.style.top = this.area.offsetTop - this.area.marginTop + 'px';
            this.box.style.bottom = 'auto';
            this.area.maxLeft = this.area.parentWidth - this.area.width - this.area.marginLeft - this.area.border * 2;
            this.area.maxTop = this.area.parentHeight - this.area.height - this.area.marginTop - this.area.border * 2;
        }
    }, {
        key: '_defineCursor',
        value: function _defineCursor(e) {

            var x = e.offsetX == undefined ? e.layerX : e.offsetX;
            var y = e.offsetY == undefined ? e.layerY : e.offsetY;
            var offsetX = x / (this.box.clientWidth + this.area.border * 2);
            var offsetY = y / (this.box.clientWidth + this.area.border * 2);

            if (offsetX < .3) {
                if (offsetY < .5) {
                    this.names.cursor = 'nw-resize';
                    this.names.funcBefore = '_nwBeforeResize';
                    this.names.funcTransform = '_resize';
                } else {
                    this.names.cursor = 'sw-resize';
                    this.names.funcBefore = '_swBeforeResize';
                    this.names.funcTransform = '_resize';
                }
            } else if (offsetX > .7) {
                if (offsetY < .5) {
                    this.names.cursor = 'ne-resize';
                    this.names.funcBefore = '_neBeforeResize';
                    this.names.funcTransform = '_resize';
                } else {
                    this.names.cursor = 'se-resize';
                    this.names.funcBefore = '_seBeforeResize';
                    this.names.funcTransform = '_resize';
                }
            } else {
                this.names.cursor = 'move';
                this.names.funcBefore = '_beforeMove';
                this.names.funcTransform = '_move';
            }
            this.box.style.cursor = this.names.cursor;
        }
    }]);

    return Transform;
}();

exports.Transform = Transform;

},{}],54:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPlayerWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _scriptonload = require('../modules/scriptonload');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UPlayerWrapper = function () {
    function UPlayerWrapper(el) {
        _classCallCheck(this, UPlayerWrapper);

        var self = this;

        this.status; /* если вдруг решим удалить объект, а он еще не загрузился */
        this.oUPlayer;

        if (!window.uPlayer) {
            this.status = 'loading';
            (0, _scriptonload.scriptonload)(APP.vendors.uPlayer, function () {
                self._init.call(self, el);
            });
        } else this._init(el);
    }

    _createClass(UPlayerWrapper, [{
        key: '_init',
        value: function _init(el) {
            if (this.status === 'notload') return;
            this.oUPlayer = uPlayer(el);

            var self = this;

            this.oUPlayer.onActive = function () {
                if (self.onActive) self.onActive.call(self.oUPlayer);
            };
            this.oUPlayer.onDisableActive = function () {
                if (self.onDisableActive) self.onDisableActive.call(self.oUPlayer);
            };

            this.status = 'loaded';
        }
    }, {
        key: 'del',
        value: function del() {
            if (this.oUPlayer) this.oUPlayer.del();else this.status = 'notload';
        }
    }]);

    return UPlayerWrapper;
}();

exports.UPlayerWrapper = UPlayerWrapper;

},{"../modules/scriptonload":106}],55:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

var _comeToFavPopup = require('../modules/comeToFavPopup');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* Голосовалка в:
* - фильмах;	 type === 'movies'
* - рецензиях;   type = 'review'
* - трейлкрах;   type = 'video'
*
* если тип "video", то пишем по id трейлера - videoid
 * если тип "video", то пишем по id трейлера - videoid
 * если тип "review" - пишем по id рецензии - reviewid
 *
*
* TODO cделать универсально
*
* */

var _class = function () {
	function _class(wrapper) {
		_classCallCheck(this, _class);

		this._createElements(wrapper);
		this._addEvents();
		this._addToGlobal();
	}

	_createClass(_class, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			this.wrapper = wrapper;
			this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
			this.box = this._getBox();
			this.btnAll = this.box.querySelectorAll('[data-vote-btn]');
			this.countYes = this.box.querySelector('[data-vote-count="yes"]');
			this.countNo = this.box.querySelector('[data-vote-count="no"]');
			this.telegramLink = document.querySelector('[data-telegramLink]');
			this.isSending = false;
			this.ajaxPath = this._defineAjaxPath();
			this.key = this._defineKey();
		}
	}, {
		key: '_getBox',
		value: function _getBox() {
			if (this.wrapper.hasAttribute('data-vote-box')) return this.wrapper;else return this.wrapper.querySelector('[data-vote-box]');
		}
	}, {
		key: '_defineAjaxPath',
		value: function _defineAjaxPath() {
			var self = this,
			    part = APP.vars.isDev ? '/_src/layouts' : '',
			    part2 = function () {
				if (self.data.type === 'movies') return '/movies/' + self.data.uid + '/come/';else if (self.data.type === 'video') return '/movies/' + self.data.movieid + '/video/' + self.data.videoid + '/vote';else if (self.data.type === 'review') return '/movies/' + self.data.movieid + '/reviews/' + self.data.reviewid + '/vote';
			}();

			return part + part2;
		}
	}, {
		key: '_defineKey',
		value: function _defineKey() {
			if (this.data.type === 'movies') return this.data.uid;else if (this.data.type === 'video') return this.data.videoid;else if (this.data.type === 'review') return this.data.reviewid;
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {

			var self = this;
			for (var i = 0, j = this.btnAll.length; i < j; i++) {
				_event.event.add(this.btnAll[i], 'click', function (e) {

					if (APP.vars.isMobile) {
						if (!APP.auth.tryAuth()) return false;
					} else if (!regAuthObj.isAuth) {
						regAuthObj.authForm.showPopup();
						return false;
					}

					self._sendAjax.call(self, e, this.getAttribute('data-vote-btn'));
				});
			}
		}
	}, {
		key: '_sendAjax',
		value: function _sendAjax(e, val) {
			e.preventDefault();
			e.stopPropagation();

			if (this.isSending) return false;
			this.isSending = true;

			var self = this;

			(0, _ajax.ajax)({
				data: { "vote": val },
				url: this.ajaxPath,
				callback: function callback(msg) {
					self._checkMsg.call(self, msg);

					if (val && self.telegramLink) {
						self.wrapper.parentNode.insertBefore(self.telegramLink, self.wrapper.nextSibling);
						//self.wrapper.appendChild(self.telegramLink);
					}
				}
			});
		}
	}, {
		key: '_checkMsg',
		value: function _checkMsg(msg) {
			var msg = JSON.parse(msg);

			if (msg.auth === false) {
				if (APP.vars.isMobile) {
					alert('Вам нужно авторизоваться повторно.');
				} else {
					uPopup({
						content: 'Вам нужно авторизоваться повторно.',
						oncloseBefore: function oncloseBefore() {
							location.replace(location.protocol + '//' + location.host + location.pathname);
						}
					});
				}
			} else if (!msg.status) {
				if (APP.vars.isMobile) {
					alert(msg.message);
				} else {
					uPopup({
						content: msg.message
					});
				}
			} else this._addVote(msg);

			this.isSending = false;
		}
	}, {
		key: '_addVote',
		value: function _addVote(msg) {
			/*
   * Применяем ответ сразу ко всем одинаковым id
   * Смотрим, есть ли в ответе fav: true
   * Если есть - это значит, что пользователь нажал "Пойду"
   * В таком случаем фильм автоматом добавляется на сервере в избранное
   * На клиенте остается закрасить сердечко
   * Если есть в ответе hint:true - показываем подсказку о добавлении в избранное
   *
   * */

			var key = this.key,
			    type = this.data.type,
			    all = window.GLOBALS[type + 'VoteAll'][key];

			for (var i = 0, j = all.length; i < j; i++) {
				var obj = all[i];

				if (obj.countYes) {
					obj.countYes.innerHTML = msg.data.yes;
					obj.countNo.innerHTML = msg.data.no;
				}

				var className = obj.box.className.replace(/js-vote-(yes|no)/g, '');
				if (msg.data.mark) className += ' js-vote-' + msg.data.mark;

				obj.box.className = className;
				//если задали функию успешного выполнения скрипта, запускаем
				//НО!!! запускаем только у текущего объекта
				if (obj.successExec && obj === this) obj.successExec();
			}

			if (msg.data.fav) this._addFav();
			if (msg.data.hint) this._addHint(msg.data);

			// analytics
			this._sendStat();
		}
	}, {
		key: '_addFav',
		value: function _addFav() {
			/*
    * Добавляем в избранное
    * На данный момент добавляем только фильм, если пользователь нажал пойду
    * поэтому проверяем на всякий случай тип голосовалки
    * */
			var type = this.data.type;
			if (type !== 'movies') return;

			try {
				window.GLOBALS[type + 'FavAll']['uid-' + this.key][0].addToFav();
			} catch (e) {
				console.log(e);
			}
		}
	}, {
		key: '_addHint',
		value: function _addHint(data) {
			if (!APP.objects.comeToFavPopup) {
				APP.objects.comeToFavPopup = (0, _comeToFavPopup.comeToFavPopup)();
			}
			APP.objects.comeToFavPopup.show(this.box, data);
		}
	}, {
		key: '_sendStat',
		value: function _sendStat() {
			if (this.data.type === 'movies') {
				try {
					gtag('event', 'click', {
						'event_category': 'engagement',
						'event_label': 'movie_go_or_not'
					});
					console.log('gtag success!');
				} catch (error) {
					console.error('gtag error:', error);
				}
			} else if (this.data.type === 'review') {
				try {
					gtag('event', 'click', {
						'event_category': 'engagement',
						'event_label': 'user_review_like_or_dislike'
					});
					console.log('gtag success!');
				} catch (error) {
					console.error('gtag error:', error);
				}
			} else if (this.data.type === 'video') {
				try {
					gtag('event', 'click', {
						'event_category': 'engagement',
						'event_label': 'trailer_like_or_dislike'
					});
					console.log('gtag success!');
				} catch (error) {
					console.error('gtag error:', error);
				}
			} else {
				console.error('gtag unknow type');
			}
		}
	}, {
		key: '_addToGlobal',
		value: function _addToGlobal() {
			var key = this.key;
			var type = this.data.type;

			if (!window.GLOBALS) window.GLOBALS = {};
			if (!window.GLOBALS[type + 'VoteAll']) window.GLOBALS[type + 'VoteAll'] = {};
			if (!window.GLOBALS[type + 'VoteAll'][key]) window.GLOBALS[type + 'VoteAll'][key] = [];

			window.GLOBALS[type + 'VoteAll'][key].push(this);
		}
	}, {
		key: 'del',
		value: function del() {
			var key = this.key,
			    type = this.data.type,
			    all = window.GLOBALS[type + 'VoteAll'][key];

			for (var i = 0, j = all.length; i < j; i++) {
				if (all[i] === this) {
					all.splice(i, 1);
					if (!all.length) delete window.GLOBALS[type + 'VoteAll'][key];
					return false;
				}
			}
		}
	}]);

	return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{"../modules/ajax":61,"../modules/comeToFavPopup":73,"../modules/event":79}],56:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('../modules/event');

var _ajax = require('../modules/ajax');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* Голосовалка в:
* - фильмах;	 type === 'movies'
* - рецензиях;   type = 'review'
* - трейлкрах;   type = 'video'
*
* если тип "video", то пишем по id трейлера - videoid
 * если тип "video", то пишем по id трейлера - videoid
 * если тип "review" - пишем по id рецензии - reviewid
 *
*
* TODO cделать универсально
*
* */

var _class = function () {
	function _class(wrapper) {
		_classCallCheck(this, _class);

		this._createElements(wrapper);
		this._addEvents();
	}

	_createClass(_class, [{
		key: '_createElements',
		value: function _createElements(wrapper) {
			this.wrapper = wrapper;
			this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
			this.catId = this.data.catid;
			this.btnAll = this.wrapper.querySelectorAll('[data-VoteResults-btn]');
			this.isSending = false;
			this.ajaxPath = this._defineAjaxPath();
			this.btnBaseModifierClass = APP.vars.isMobile ? 'btn-primary' : 'btn-warning';
		}
	}, {
		key: '_defineAjaxPath',
		value: function _defineAjaxPath() {
			var self = this,
			    part = APP.vars.isDev ? '/_src/layouts/results/vote' : '/itogi/vote';

			return part;
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {

			var self = this;
			for (var i = 0, j = this.btnAll.length; i < j; i++) {
				_event.event.add(this.btnAll[i], 'click', function (e) {

					if (APP.vars.isMobile) {
						if (!APP.auth.tryAuth()) return false;
					} else if (!regAuthObj.isAuth) {
						regAuthObj.authForm.showPopup();
						return false;
					}

					var item_id = this.getAttribute('data-VoteResults-btn');

					self._sendAjax.call(self, e, item_id);
				});
			}
		}
	}, {
		key: '_sendAjax',
		value: function _sendAjax(e, val) {
			e.preventDefault();
			e.stopPropagation();

			var self = this;

			if (self.isSending) {
				return false;
			}

			self.isSending = true;

			(0, _ajax.ajax)({
				data: {
					"item_id": val,
					"nomination_id": self.catId
				},
				method: 'POST',
				url: self.ajaxPath,
				callback: function callback(result) {

					self.isSending = false;

					var resultParse = JSON.parse(result);
					if (resultParse && resultParse.status) {

						for (var i = 0, j = self.btnAll.length; i < j; i++) {
							if (self.btnAll[i].classList.contains('btn-success')) {
								self.btnAll[i].classList.remove('btn-success');
								self.btnAll[i].classList.add(self.btnBaseModifierClass);
							}
							self.btnAll[i].innerHTML = 'Голосовать';
						}
						e.target.classList.add('btn-success');
						e.target.classList.remove(self.btnBaseModifierClass);
						e.target.innerHTML = 'Ваш выбор';
					} else {
						alert('При отправке запроса произошла ошибка!');
					}
				}
			});
		}
	}, {
		key: 'del',
		value: function del() {}
	}]);

	return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{"../modules/ajax":61,"../modules/event":79}],57:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _event = require('./event');

var _ajax = require('./ajax');

var _page = require('./page');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
    function _class(wrapper) {
        _classCallCheck(this, _class);

        this._createElements(wrapper);
        this._getBtn();
        this._defineAjaxPath();
        this._addEvent();
        this._addToGlobal();
    }

    _createClass(_class, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.wrapper = wrapper;
            this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.btn;
            this.isWatch = this.wrapper.className.indexOf('js-watch') === -1 ? false : true;
            this.isSending = false;
            this.onchange = function () {};
        }
    }, {
        key: '_getBtn',
        value: function _getBtn() {
            if (this.wrapper.getAttribute('data-js') === 'watch-btn') this.btn = this.wrapper;else this.btn = this.wrapper.querySelector('[data-js="watch-btn"]');
        }
    }, {
        key: '_defineAjaxPath',
        value: function _defineAjaxPath() {
            var self = this;
            self.data = JSON.parse(self.wrapper.getAttribute('data-param'));
            var part = APP.vars.isDev ? '/_src/layouts' : '',
                part2 = '/' + self.data.type + '/' + self.data.uid + '/watch/';
            self.ajaxPath = part + part2;
        }
    }, {
        key: '_addEvent',
        value: function _addEvent() {
            var self = this;

            _event.event.add(this.btn, 'click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                self._defineAjaxPath();
                self._addToGlobal();

                if (!self._checkAuth.call(self)) return false;

                if (self.isSending) return false;
                self.isSending = true;

                (0, _ajax.ajax)({
                    data: { "watch": !self.isWatch },
                    url: self.ajaxPath,
                    callback: function callback(msg) {
                        self._checkMsg.call(self, msg);
                    }
                });
            });
        }
    }, {
        key: '_checkAuth',
        value: function _checkAuth() {

            if (APP.vars.isMobile) {
                if (!APP.auth.tryAuth()) return false;
            } else if (!regAuthObj.isAuth) {
                regAuthObj.authForm.showPopup();
                return false;
            }

            return true;
        }
    }, {
        key: '_checkMsg',
        value: function _checkMsg(msg) {
            var msg = JSON.parse(msg);

            if (msg.auth === false) {
                uPopup({
                    content: 'Вам нужно авторизоваться повторно.',
                    oncloseBefore: function oncloseBefore() {
                        location.replace(location.protocol + '//' + location.host + location.pathname);
                    }
                });
            } else if (!msg.status) {
                uPopup({
                    content: msg.message
                });
            } else {
                if (msg.data) {
                    this.addToWatched();
                    this._sendStat();
                } else {
                    this.removeFromWatched();
                }
            }

            this.isSending = false;
        }
    }, {
        key: '_sendStat',
        value: function _sendStat() {
            if (this.data.type) {
                try {
                    gtag('event', 'click', {
                        'event_category': 'watched',
                        'event_label': 'add_' + this.data.type + '_to_favourite'
                    });
                } catch (e) {}
            } else {
                console.error('gtag unknown type');
            }
        }
    }, {
        key: 'addToWatched',
        value: function addToWatched() {
            /*
            Добавляем в избранное (фильм, кинотеатр итд) сразу ко всем одинаковым id
            Ф-я может вызываться из глобального объекта - если мы щелкнули на пойду у фильма - то автоматом добаляется избранное
            */
            var key = 'uid-' + this.data.uid,
                type = this.data.type,
                all = window.GLOBALS[type + 'WatchAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                all[i].wrapper.className = all[i].wrapper.className.replace(/\s*js-watch/, '') + ' js-watch';
                all[i].isWatch = true;
            }
            this.onchange(true);

            this._addCustomEvent({ isWatch: true, typeWatch: type, uid: this.data.uid });
        }
    }, {
        key: 'removeFromWatched',
        value: function removeFromWatched() {
            var key = 'uid-' + this.data.uid,
                type = this.data.type,
                all = window.GLOBALS[type + 'WatchAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                all[i].wrapper.className = all[i].wrapper.className.replace(/\s*js-watch/, '');
                all[i].isWatch = false;
            }
            this.onchange(false);

            this._addCustomEvent({ isWatch: false, typeFav: type, uid: this.data.uid });
        }
    }, {
        key: '_addCustomEvent',
        value: function _addCustomEvent(data) {
            if (window.CustomEvent) {
                var event = new Event(data.typeFav + 'ChangeWatch');
                event.isWatch = data.isWatch;
                event.uid = data.uid;
                document.dispatchEvent(event);
            }
        }
    }, {
        key: '_addToGlobal',
        value: function _addToGlobal() {
            var key = 'uid-' + this.data.uid;
            var type = this.data.type;

            if (!window.GLOBALS) window.GLOBALS = {};
            if (!window.GLOBALS[type + 'WatchAll']) window.GLOBALS[type + 'WatchAll'] = {};
            if (!window.GLOBALS[type + 'WatchAll'][key]) window.GLOBALS[type + 'WatchAll'][key] = [];

            window.GLOBALS[type + 'WatchAll'][key].push(this);
        }
    }, {
        key: 'isDOM',
        value: function isDOM() {
            if (this.wrapper.getClientRects().length) return true;else return false;
        }
    }, {
        key: 'del',
        value: function del() {
            var key = 'uid-' + this.data.uid;
            var type = this.data.type;
            var all = window.GLOBALS[type + 'WatchAll'][key];

            for (var i = 0, j = all.length; i < j; i++) {
                if (all[i] === this) {
                    all.splice(i, 1);
                    if (!all.length) delete window.GLOBALS[type + 'WatchAll'][key];
                    return false;
                }
            }
        }
    }]);

    return _class;
}();

exports.default = _class;
module.exports = exports.default;

},{"./ajax":61,"./event":79,"./page":95}],58:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.YaShare2 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _scriptonload = require('../modules/scriptonload');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var YaShare2 = function () {
    function YaShare2(wrapper) {
        _classCallCheck(this, YaShare2);

        this.param = JSON.parse(wrapper.getAttribute('data-param'));
        this.embedId = wrapper.getAttribute('data-embed-id');

        if (!this.param.services) {
            if (APP.vars.isMobile) {
                this.param.services = 'vkontakte,facebook,odnoklassniki,twitter,viber,whatsapp,skype,telegram';
            } else {
                this.param.services = 'vkontakte,facebook,odnoklassniki,twitter,telegram';
            }
        }
        this.wrapper = wrapper;
        this.frame = wrapper.querySelector('[data-YaShare2-wrapper]');
        this.frame = this.frame ? this.frame : wrapper;
        this._add();
    }

    _createClass(YaShare2, [{
        key: '_add',
        value: function _add() {
            var self = this;
            (0, _scriptonload.scriptonload)(['//yastatic.net/es5-shims/0.0.2/es5-shims.min.js', '//yastatic.net/share2/share.js'], function () {
                self._create.call(self);
            });
        }
    }, {
        key: '_create',
        value: function _create() {
            var self = this,
                param = this.param,
                content = function () {
                var data = {};
                if (param.url) data.url = param.url;
                if (param.image) data.image = param.image;
                if (param.title) data.title = param.title;
                return data;
            }();

            Ya.share2(this.frame, {
                content: content,
                theme: {
                    services: this.param.services,
                    bare: true,
                    counter: true
                },
                hooks: {
                    onready: function onready() {
                        if (self.param.type === 'counter') self._showCounter.call(self);
                    },
                    onshare: function onshare(name) {
                        YaShare2._sendStat(name);
                    }
                }
            });
        }
    }, {
        key: '_showCounter',
        value: function _showCounter() {
            var num = this.wrapper.querySelector('[data-YaShare2-num]'),
                all = this.frame.querySelectorAll('.ya-share2__counter'),
                all2 = this.wrapper.querySelectorAll('.ya-share2__counter'),
                countAll = 0,
                check = function check() {
                for (var i = 0, j = all.length; i < j; i++) {
                    var inner = all[i].innerHTML;
                    if (!inner.length) {
                        requestAnimationFrame(check);
                        countAll = 0;
                        return false;
                    }

                    var count = parseFloat(inner);
                    countAll += count;
                }

                // 0 не выводим
                if (countAll && num) num.innerHTML = countAll;
            };

            //количество голосов загружается асинхронно, специального события нет, поэтому отслеживаем сами, когда выставятся все счетчики
            check();
        }
    }], [{
        key: '_sendStat',
        value: function _sendStat(name) {
            try {
                gtag('event', 'click', {
                    'event_category': 'engagement',
                    'event_label': 'share_via_' + name
                });
                console.log('gtag success!');
            } catch (error) {
                console.error('gtag error:', error);
            }
        }
    }]);

    return YaShare2;
}();

exports.YaShare2 = YaShare2;

},{"../modules/scriptonload":106}],59:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var addGlobals = function () {

	if (!window.GLOBALS) window.GLOBALS = {};

	if (!window.GLOBALS.callbackAll) window.GLOBALS.callbackAll = {};

	if (window.GLOBALS.scriptRequest) return false;

	// при успехе вызовет onSuccess, при ошибке onError
	window.GLOBALS.scriptRequest = function (url, onSuccess, onError) {

		var scriptOk = false; // флаг, что вызов прошел успешно

		// сгенерировать имя JSONP-функции для запроса
		var callbackName = 'callbackFunction' + String(Math.random()).slice(-6);

		// укажем это имя в URL запроса
		url += ~url.indexOf('?') ? '&' : '?';
		url += 'callback=GLOBALS.callbackAll.' + callbackName;

		// ..и создадим саму функцию в реестре
		GLOBALS.callbackAll[callbackName] = function (data) {
			scriptOk = true; // обработчик вызвался, указать что всё ок
			delete GLOBALS.callbackAll[callbackName]; // можно очистить реестр
			onSuccess(data); // и вызвать onSuccess
		};

		// эта функция сработает при любом результате запроса
		// важно: при успешном результате - всегда после JSONP-обработчика
		function checkCallback() {
			if (scriptOk) return; // сработал обработчик?
			delete GLOBALS.callbackAll[callbackName];
			onError(url); // нет - вызвать onError
		}

		var script = document.createElement('script');

		// в старых IE поддерживается только событие, а не onload/onerror
		// в теории 'readyState=loaded' означает "скрипт загрузился",
		// а 'readyState=complete' -- "скрипт выполнился", но иногда
		// почему-то случается только одно из них, поэтому проверяем оба
		script.onreadystatechange = function () {
			if (this.readyState == 'complete' || this.readyState == 'loaded') {
				this.onreadystatechange = null;
				setTimeout(checkCallback, 0); // Вызвать checkCallback - после скрипта
			}
		};

		// события script.onload/onerror срабатывают всегда после выполнения скрипта
		script.onload = script.onerror = checkCallback;
		script.src = url;

		document.body.appendChild(script);
	};
}();

exports.addGlobals = addGlobals;

},{}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ads = undefined;

var _scriptonload = require("./scriptonload");

var _checkVisibility = require("./checkVisibility");

var ads = function ads(el) {
    var param = JSON.parse(el.getAttribute('data-param')),
        uid = param.uid,
        adsObj = {},
        //возвращаемый объект
    insertYandexRTB = function insertYandexRTB() {
        var func = function func(w, d, n, s, t) {
            w[n] = w[n] || [];
            w[n].push(function () {
                Ya.Context.AdvManager.render({
                    blockId: blockId,
                    renderTo: renderTo,
                    async: true
                });
            });
            t = d.getElementsByTagName("script")[0];
            s = d.createElement("script");
            s.type = "text/javascript";
            s.src = "//an.yandex.ru/system/context.js";
            s.async = true;
            t.parentNode.insertBefore(s, t);
        },
            renderTo = el.getAttribute('id'),
            blockId = renderTo.replace('yandex_rtb_', '');

        //
        func(window, window.document, "yandexContextAsyncCallbacks");
    },
        insertGoogle = function insertGoogle() {
        (0, _scriptonload.scriptonload)('//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', function () {
            (adsbygoogle = window.adsbygoogle || []).push({});
        });
    },
        insertGoogleTag = function insertGoogleTag() {
        try {
            var slot;
            var frame = el.querySelector('[data-ads-frame]'); /* TODO нужно не нужно */
            var progressEl = el.querySelector('[data-ads-progress]');
            var callback = function callback() {
                googletag.cmd.push(function () {
                    googletag.pubads().refresh([slot]);
                });
                //console.log('googletag refresh');
            };
            var param = {
                box: el,
                progressEl: progressEl,
                callback: callback

                //
            };googletag.cmd.push(function () {
                slot = googletag.defineSlot('/21624868510/ka_side/ka_side_3', [[300, 300], [160, 600], [300, 500], [240, 600], [300, 600], [240, 400]], 'div-gpt-ad-1549951781921-0').addService(googletag.pubads());
                googletag.display('div-gpt-ad-1549951781921-0');
            });

            (0, _checkVisibility.checkVisibility)(param);
        } catch (e) {
            //console.log('GoogleTag не отработал', e)
        }
    },
        insertAdfox = function insertAdfox() {
        var blockData = APP.ads.adFox.blocks[uid];

        try {
            if (blockData.obj === undefined) {
                window.Ya.headerBidding.pushAdUnits(blockData.adUnits);
                blockData.obj = window.Ya.adfoxCode.create({
                    ownerId: 275464,
                    containerId: uid,
                    params: blockData.params,
                    onLoad: function onLoad(data) {
                        console.log('Adfox Load', 'Банер загрузился');
                    },
                    onRender: function onRender() {
                        console.log('Adfox Render', 'Код вставлен в контейнер');
                    },
                    onError: function onError(err) {
                        _onError('Adfox', err);console.log('Adfox error', err);
                    },
                    onStub: function onStub() {
                        _onError('Adfox');console.log('Adfox Stub', 'cервер вернул пустоту');
                    }
                });
            } else {
                blockData.obj.initialize();
            }

            if (param.reload) {
                var progressEl = el.querySelector('[data-ads-progress]');
                var callback = function callback() {
                    window.Ya.adfoxCode.reload(uid);
                };
                var visibilityParam = {
                    box: el,
                    time: param.reload.time * 1000 || 30000,
                    progressEl: progressEl || false,
                    callback: callback
                };

                //
                (0, _checkVisibility.checkVisibility)(visibilityParam);
            }

            adsObj = {
                destroy: function destroy() {
                    console.log('Удаляем банер');
                    blockData.obj.destroy();
                }
            };
        } catch (e) {
            _onError('Adfox', e);
        }
    },
        _onError = function _onError(system, err) {
        console.log(4444444444444444444);
        el.parentElement.removeChild(el);
        console.log('система ' + system + 'не отработала. uid - ' + uid, err);
    },
        init = function init() {
        eval('insert' + param.name + '()');
    };

    //
    init();
    return adsObj;
};

exports.ads = ads;

},{"./checkVisibility":67,"./scriptonload":106}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var ajax = function () {
	function createRequest() {
		var request = null;
		try {
			request = new XMLHttpRequest();
		} catch (trymicrosoft) {
			try {
				request = new ActiveXObject("Msxml2.XMLHTTP");
			} catch (othermicrosoft) {
				try {
					request = new ActiveXObject("Microsoft.XMLHTTP");
				} catch (failed) {
					request = null;
				}
			}
		}
		if (request == null) {
			alert('Внимание! Объект запроса не создан. Обратитесь к разработчику');
		} else {
			return request;
		}
	}

	return function sendRequest(userData) {
		var str = null,
		    method = userData.method || 'POST';

		if (method === 'POST') {
			str = '';
			for (var key in userData.data) {
				str += key + '=' + userData.data[key] + '&';
			}
			str = str.slice(0, -1);
		};

		var request = createRequest();
		request.open(method, userData.url, true);
		request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
		request.setRequestHeader("X-Request-Ajax", "1");
		request.onreadystatechange = function () {
			getRequest(request, userData);
		};
		request.send(str);
		return request;
	};

	function getRequest(request, userData) {
		if (request.readyState == 4) {
			if (request.status == 200) {
				var message = request.responseText; //передаем полученные данные переменной
				userData.callback(message);
			}
		}
	}
}();

exports.ajax = ajax;

},{}],62:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.banners = undefined;

var _scriptonload = require('./scriptonload');

var banners = function banners(el) {
    var param = JSON.parse(el.getAttribute('data-param')),
        adsObj,
        /* объект, возвращаемый рекламой. Должен в идеале содержать  метод destroy */
    uid = el.getAttribute('id'),
        insertAdFox = function insertAdFox() {
        var blockData = APP.ads.adFox.blocks[uid];

        try {
            if (blockData.obj === undefined) {
                window.Ya.headerBidding.pushAdUnits(blockData.adUnits);
                blockData.obj = window.Ya.adfoxCode.create({
                    ownerId: 275464,
                    containerId: uid,
                    params: blockData.params,
                    onLoad: function onLoad(data) {
                        console.log('Adfox Load', 'Банер загрузился');
                    },
                    onRender: function onRender() {
                        console.log('Adfox Render', 'Код вставлен в контейнер');
                    },
                    onError: function onError(err) {
                        _onError(err);console.log('Adfox error', error);
                    },
                    onStub: function onStub() {
                        _onError();console.log('Adfox Stub', 'cервер вернул пустоту');
                    }
                });
            } else {
                blockData.obj.initialize();
            }

            adsObj = {
                destroy: function destroy() {
                    console.log('Удаляем банер');
                    blockData.obj.destroy();
                }
            };
        } catch (e) {
            _onError();console.log('AdFox не отработал ' + uid, e);
        }
    },
        insertYandexRTB = function insertYandexRTB() {
        var func = function func(w, d, n, s, t) {
            w[n] = w[n] || [];
            w[n].push(function () {
                Ya.Context.AdvManager.render({
                    blockId: blockId,
                    renderTo: renderTo,
                    async: true
                });
            });
            t = d.getElementsByTagName("script")[0];
            s = d.createElement("script");
            s.type = "text/javascript";
            s.src = "//an.yandex.ru/system/context.js";
            s.async = true;
            t.parentNode.insertBefore(s, t);
        },
            renderTo = el.getAttribute('id'),
            blockId = renderTo.replace('yandex_rtb_', '');

        //
        func(window, window.document, "yandexContextAsyncCallbacks");
    },
        insertGoogle = function insertGoogle() {
        (0, _scriptonload.scriptonload)('//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', function () {
            (adsbygoogle = window.adsbygoogle || []).push({});
        });
    },
        insertGoogleTag = function insertGoogleTag() {
        try {
            var slot;
            var frame = el.querySelector('[data-banners-frame]');
            var progressEl = el.querySelector('[data-banners-frame]');
            googletag.cmd.push(function () {
                slot = googletag.defineSlot('/21624868510/ka_side/ka_side_2', [[300, 500], [300, 300], [300, 600], [240, 400], [160, 600], [240, 600]], 'div-gpt-ad-1549951749514-0').addService(googletag.pubads());
                googletag.display('div-gpt-ad-1549951749514-0');
            });

            setInterval(function () {
                googletag.cmd.push(function () {
                    googletag.pubads().refresh([slot]);
                });
                console.log('googletag refresh');
            }, 20000);
        } catch (e) {
            console.log('GoogleTag не отработал', e);
        }
    },
        _onError = function _onError(err) {
        el.parentElement.removeChild(el);
    },
        init = function init() {
        eval('insert' + param.name + '()');
    };
    //
    init();
    return adsObj;
};

exports.banners = banners;

},{"./scriptonload":106}],63:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bbutton = undefined;

require('../modules/uPopup');

var _cookie = require('../modules/cookie');

var _raskhlop = require('../modules/raskhlop');

var bbutton = function bbutton(el) {
    var param = JSON.parse(el.getAttribute('data-param')),
        closeBtn = el.querySelector('[data-bbutton-close]'),
        lookBtn = el.querySelector('[data-bbutton-look]'),
        goBtnAll = el.querySelectorAll('[data-bbutton-go]'),
        raskhlopObj,
        setCookie = function setCookie(expires) {
        var options = {},
            domains = ['.kinoafisha.spb.ru', '.kinoafisha.msk.ru', '.kinoafisha.info'],
            i = 0,
            l = domains.length;

        options.expires = expires;
        options.path = '/';

        for (i; i < l; i++) {
            options.domain = domains[i];
            _cookie.cookie.setCookie('branding_bbutton', '1', options);
        }
    },
        addPixel = function addPixel() {
        for (var i = 0, j = param.px.length; i < j; i++) {
            var img = document.createElement('IMG'),
                src = param.px[i];

            img.setAttribute('class', 'px');
            img.setAttribute('src', src + '&rnd=' + new Date().getTime());
            document.body.appendChild(img);
        }
    },

    /* Просто перенес функцию с мобильной версии */
    mobileRaskhlop = function mobileRaskhlop() {
        var box = document.getElementById('branding'),
            param = JSON.parse(box.getAttribute('data-param')),
            close = box.querySelector('[data-close]'),
            addPixel = function addPixel() {
            for (var i = 0, j = param.px.length; i < j; i++) {
                var img = document.createElement('IMG'),
                    src = param.px[i];

                img.setAttribute('class', 'px');
                img.setAttribute('src', src + '&rnd=' + new Date().getTime());
                document.body.appendChild(img);
            }
        };

        //
        param.px = typeof param.px === 'string' ? [param.px] : param.px;

        document.body.className = document.body.className + ' tobuy';
        close.onclick = function () {
            //document.body.removeChild(box);
            document.body.className = document.body.className.replace(' tobuy', '');
        };

        addPixel();
    },
        onLookClick = function onLookClick(e) {
        e.preventDefault();

        onCloseClick();

        if (APP.vars.isMobile) {
            mobileRaskhlop();
        } else {
            var el = document.querySelector('[data-bbutton-raskhlop]'),
                obj = (0, _raskhlop.raskhlop)(el);

            //
            obj.start();
        }
    },
        onGoClick = function onGoClick() {
        onCloseClick();
    },
        onCloseClick = function onCloseClick(e) {
        if (e) e.preventDefault();

        el.classList.remove('js-active');
        setCookie(3600 * 24);
    },
        start = function start() {
        if (lookBtn) lookBtn.addEventListener('click', onLookClick);
        Array.prototype.forEach.call(goBtnAll, function (goBtn) {
            goBtn.addEventListener('click', onGoClick);
        });
        closeBtn.addEventListener('click', onCloseClick);
        el.classList.add('js-active');
        addPixel();
    };

    //
    if (!navigator.cookieEnabled) return false;
    if (window.location.hostname.indexOf('kinoafishaspb.ru') !== -1) return false; /* на деве не показываем кнопку */

    param.px = typeof param.px === 'string' ? [param.px] : param.px;

    if (!_cookie.cookie.getCookie('branding_bbutton') || window.location.pathname.indexOf('/_src/') !== -1) {
        if (document.readyState === "complete") {
            start();
        } else {
            window.addEventListener('load', start);
        }
    }
};

exports.bbutton = bbutton;

},{"../modules/cookie":74,"../modules/raskhlop":99,"../modules/uPopup":117}],64:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bcontentForm = undefined;

var _scriptonload = require('../modules/scriptonload');

var bcontentForm = function bcontentForm(form) {
	var area = form.querySelector('[data-bcontentForm-area]'),
	    box,
	    bcontentObj,
	    replaceArea = function replaceArea() {
		var snippetFile = area.getAttribute('data-bcontentForm-area');
		//
		box = document.createElement('DIV');
		box.classList.add('columnForm_bcontent');
		box.classList.add('visualEditorInsertion');
		box.setAttribute('data-param', '{"snippetFile":"' + snippetFile + '"}');
		box.innerHTML = area.value;
		area.parentNode.insertBefore(box, area);
	},
	    addBcontent = function addBcontent() {
		console.log(bcontent);
		bcontentObj = bcontent(box);
	},
	    beforeSubmit = function beforeSubmit(e) {
		var html = bcontentObj.getHTML();
		area.value = html;
	},
	    addEvents = function addEvents() {
		form.addEventListener('submit', beforeSubmit, false);
	},
	    init = function init() {
		replaceArea();
		addBcontent();
		addEvents();
	};

	(0, _scriptonload.scriptonload)(APP.vendors.bcontent, function () {
		init();
	});
};

exports.bcontentForm = bcontentForm;

},{"../modules/scriptonload":106}],65:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buyTicketsPopup = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = require('../modules/cookie');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var buyTicketsPopup = function () {
    function buyTicketsPopup(wrapper) {
        _classCallCheck(this, buyTicketsPopup);

        this._createElements(wrapper);
        this._addEvent();
    }

    _createClass(buyTicketsPopup, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.wrapper = wrapper;
            this.closeBtn = wrapper.querySelector('[data-close]');
            this.calendar = document.querySelector('.js-calendar');
            this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
        }
    }, {
        key: '_gaStatErrorHandler',
        value: function _gaStatErrorHandler(event) {
            console.error('GA не сработал: ' + event + ' buyTicketsPopup');
        }
    }, {
        key: '_sendStatShow',
        value: function _sendStatShow() {
            var self = this;
            try {
                // ga('send', 'event', 'pop-up', 'show', 'pop-up_buy-tickets-online_show', {nonInteraction: true});
                gtag('event', 'show', {
                    'event_category': 'pop-up',
                    'event_label': 'pop-up_buy-tickets-online_show',
                    'non_interaction': true
                });
            } catch (e) {
                self._gaStatErrorHandler('появление попапа');
            }
        }
    }, {
        key: '_sendStatBtnPress',
        value: function _sendStatBtnPress() {
            var self = this;
            try {
                // ga('send', 'event', 'pop-up', 'button-press', 'pop-up_buy-tickets-online_ok-button_press', {nonInteraction: false});

                gtag('event', 'button_press', {
                    'event_category': 'pop-up',
                    'event_label': 'pop-up_buy-tickets-online_ok-button_press'
                });
            } catch (e) {
                self._gaStatErrorHandler('нажатие на кнопку «понятно»');
            }
        }
    }, {
        key: '_hide',
        value: function _hide() {
            var _this = this;

            this.wrapper.classList.add("hidden");
            setTimeout(function () {
                _this._del();
            }, 500);
        }
    }, {
        key: '_show',
        value: function _show() {
            var self = this;
            this.wrapper.classList.remove("hidden");
            self._sendStatShow();
        }
    }, {
        key: '_close',
        value: function _close() {}
    }, {
        key: '_addEvent',
        value: function _addEvent() {
            var self = this;

            var isShowed = false;

            this._close = function (e) {
                e.preventDefault();
                var cookieName = self.data.type.toLowerCase() + '_popup_buy_no';
                _cookie.cookie.setCookie(cookieName, 1, { expires: 5.256e+6, path: '/' });
                self._sendStatBtnPress();
                self._hide();
            };

            this.closeBtn.addEventListener('click', this._close, false);

            if (self.calendar) {
                window.addEventListener('scroll', function () {
                    var rect = self.calendar.getBoundingClientRect();
                    var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;

                    if (scrollTop >= rect.top + 300 && !isShowed) {
                        self._show();
                        isShowed = true;
                    }
                }, false);
            } else {
                console.error('calendar element wasn`t find');
            }
        }
    }, {
        key: '_del',
        value: function _del() {
            this.closeBtn.removeEventListener('click', this._close, false);
            this.wrapper.parentNode.removeChild(this.wrapper);
        }
    }]);

    return buyTicketsPopup;
}();

exports.buyTicketsPopup = buyTicketsPopup;

},{"../modules/cookie":74}],66:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/* Сперва это, потом thetop, чтобы правильно считалась высота */
var cat = function cat(el) {
	var box = document.getElementById('illumination');

	if (box && !box.getBoundingClientRect().width) {
		var mainLeft = document.getElementById('main-left');
		var box = document.createElement('DIV');

		box.className = 'cat layer layer-light';
		box.innerHTML = '<div class="grid">' + '<img class="cat_image" src="/static/img/bg/cat.png" alt="Грустный котик" />' + '<div class="cat_content">' + '<span class="cat_title title2">Редакционный котик грустит</span>' + '<p class="cat_desc">' + '<span class="cat_desc_att">Включенный блокировщик рекламы</span> Включенный блокировщик рекламы делает его работу менее прибыльной, а значит и сам сайт становится менее интересным. Мы не используем огромные попапы и всякие мешающие посетителям форматы рекламы. Пожалуйста, добавьте нас в белый список блокировщика.' + '</p>' + '</div>' + '</div>';

		mainLeft.insertBefore(box, mainLeft.firstChild);
	}
};

exports.cat = cat;

},{}],67:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkVisibility = undefined;

var _throttle = require('../modules/throttle');

/* вспомогательный модуль
 * Определяет видимость элемента в течение определенного времени
  * По истечении указанного времени вызывает callback
  *
  * param.box - блок, ивдимость которого отслеживаем
  * param.progressEl - блок  прогресса
  * param.callback - ф-я, которая вызывается если блок видим указанное время
  * param.time - время  в мс  в тчение которого будет виден блок
  * */

var checkVisibility = function checkVisibility(param) {
    var box = param.box,
        progressEl = param.progressEl || false,
        callback = param.callback || false,
        stopTime = false,
        durTimeMs = param.time || 30000,
        pastTimeMs = 0,
        startTimeMs = 0,
        checkVisibility = function checkVisibility() {
        var rect = box.getBoundingClientRect(),
            midY = rect.top + rect.height / 2,
            midX = rect.left + rect.width / 2;

        return midY > 0 && midX > 0 && midY < (window.innerHeight || document.documentElement.clientHeight) && midX < (window.innerWidth || document.documentElement.clientWidth);
    },
        handleVisibilityChange = function handleVisibilityChange() {
        if (document.hidden) {
            pause();
        } else {
            checkReload();
        }
    },
        checkReload = function checkReload() {
        if (checkVisibility()) {
            if (!stopTime) {
                startTimeMs = Date.now();
                var leftTimeMs = durTimeMs - pastTimeMs;
                try {
                    progressEl.style.cssText = 'width:100%;transition-duration:' + leftTimeMs + 'ms';
                } catch (e) {}

                //console.log('Старт интервала, оставшееся время показа', leftTimeMs);

                stopTime = setTimeout(function () {
                    callback();
                    pastTimeMs = 0;
                    try {
                        progressEl.style.cssText = 'width:0%;transition-duration:0ms';
                    } catch (e) {}
                    stopTime = false;
                    checkReload();
                    //console.log('Reload box', leftTimeMs);
                }, leftTimeMs);
            }
        } else pause();
    },
        pause = function pause() {
        if (stopTime) {
            clearTimeout(stopTime);
            stopTime = false;
            pastTimeMs += Date.now() - startTimeMs;
            try {
                progressEl.style.cssText = 'width:' + pastTimeMs / durTimeMs * 100 + '%;transition-duration:0ms';
            } catch (e) {}
            //console.log('Приостановка pastTimeMs',  pastTimeMs);
        }
    },
        init = function init() {
        (0, _throttle.throttle)('scroll', checkReload);
        (0, _throttle.throttle)('resize', checkReload);
        document.addEventListener('visibilityChange', handleVisibilityChange, false);
        if (!document.hidden) checkReload();
    };

    //
    if (document.readyState === "complete") {
        init();
    } else {
        window.addEventListener('load', init);
    }
};

exports.checkVisibility = checkVisibility;

},{"../modules/throttle":115}],68:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});


var chooseCity = function chooseCity(el) {
	var frame = el.querySelector('[data-js="frame"]'),
	    close = frame.querySelector('[data-js="close"]'),
	    btn = document.getElementById('chooseCity-btn'),
	    city = btn.querySelector('[data-js="chooseCity-name"]').firstChild,
	    cityName = city.nodeValue,
	    isOpen = false,
	    shangeShow = function shangeShow() {
		if (isOpen) {
			isOpen = false;
			el.style.height = '0px';
			city.nodeValue = cityName;
			btn.className = btn.className.replace(/\s*js-active/, '');
		} else {
			isOpen = true;
			var h = frame.getBoundingClientRect().bottom - frame.getBoundingClientRect().top;
			el.style.height = h + 'px';
			city.nodeValue = 'Закрыть';
			btn.className = btn.className + ' js-active';
		}
		return false;
	};

	//
	btn.onclick = shangeShow;
	close.onclick = function () {
		if (isOpen) shangeShow();
	};
};

exports.chooseCity = chooseCity;

},{}],69:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.cityMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _scriptonload = require('../modules/scriptonload');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cityMap = function cityMap(wrapper, param, callback) {
	var param = param ? param : JSON.parse(wrapper.getAttribute('data-param')),
	    MyMap = function () {
		function MyMap(wrapper) {
			_classCallCheck(this, MyMap);

			this.wrapper = wrapper;
			this._createElements();
		}

		_createClass(MyMap, [{
			key: '_createElements',
			value: function _createElements() {
				this.MyMap = this._createMyMap();
			}
		}, {
			key: '_createMyMap',
			value: function _createMyMap() {
				var MyMap = new ymaps.Map(this.wrapper, {
					center: param.map.center,
					zoom: param.map.zoom,
					controls: ["zoomControl"],
					behaviors: ['default', 'scrollZoom']
				}, {
					searchControlProvider: 'yandex#search'
				}),
				    myCollection = new ymaps.GeoObjectCollection();

				//
				MyMap.behaviors.disable(['scrollZoom']);

				for (var name in param.cities) {
					var city = param.cities[name],
					    myPlacemark = new ymaps.Placemark([city.lat, city.lon], {
						hintContent: city.name
					}, {
						iconLayout: 'default#image',
						iconImageHref: '/static/img/symbols/map-icon.png',
						iconImageSize: [16, 16],
						iconImageOffset: [-8, -8]
					});

					//
					myPlacemark.events.add(['click'], function (city) {
						return function () {
							window.location.assign(city.link);
						};
					}(city));
					myCollection.add(myPlacemark);
				}

				MyMap.geoObjects.add(myCollection);
				return MyMap;
			}
		}]);

		return MyMap;
	}();

	//
	(0, _scriptonload.scriptonload)(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], function () {
		ymaps.load([], function () {
			var map = new MyMap(wrapper);
			if (callback) callback(map);
		});
	});
};

exports.cityMap = cityMap;

},{"../modules/scriptonload":106}],70:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var clamp = function clamp(el) {
    var show = function show(e) {
        console.log(e.target);
        el.classList.remove('js-clamp');
        el.removeEventListener('click', show);
    };
    el.addEventListener('click', show);
};

exports.clamp = clamp;

},{}],71:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clipboardData = undefined;

var _event = require('../modules/event');

var clipboardData = function clipboardData(body) {
    body.addEventListener('copy', function (e) {
        var exception = ['/write/', '/about/'],
            isException = false,
            locationPath = location.pathname;

        /* К инпутам, textarea и на страницах с блочным редактором и о нас ничего не добавляем */
        if (e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA') return;
        exception.forEach(function (item) {
            if (locationPath.indexOf(item) !== -1) {
                isException = true;
                return;
            }
        });
        if (isException) return;

        e.preventDefault();
        if (window.getSelection) {
            var selText = window.getSelection().toString();
            //var text = window.getSelection().toString() + ' Подробнее на ' + location.href;
            var text = window.getSelection().toString();
            if (e.clipboardData) e.clipboardData.setData('text/plain', text);
        }
    });
};

exports.clipboardData = clipboardData;

},{"../modules/event":79}],72:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.codeInsert = undefined;

var _scriptonload = require('../modules/scriptonload');

var codeInsert = function codeInsert(el) {
    var btn = el.querySelector('[data-codeInsert-btn]'),
        clipboard,
        init = function init() {
        clipboard = new ClipboardJS(btn);
        clipboard.on('success', function (e) {
            el.classList.toggle('js-active');
            if (el.classList.contains('js-active')) {
                alert('Код скопирован в буфер обмена');
            }

            e.clearSelection();
        });
        el.classList.add('js-loaded');
    };

    //
    (0, _scriptonload.scriptonload)(APP.vendors.clipboard, function () {
        init();
    });
};

exports.codeInsert = codeInsert;

},{"../modules/scriptonload":106}],73:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.comeToFavPopup = undefined;

var _cookie = require('../modules/cookie');

/*
* Используется в составе голосовалки
* Это подсказка о том, что при голосовании "Пойду" попап автоматом добавляется в избранное
*
* */
var comeToFavPopup = function comeToFavPopup() {
    var template = document.getElementById('comeToFavTemplate').innerHTML,
        popupEl = undefined,
        closeBtn = undefined,
        remember = function remember() {
        var options = {};

        options.expires = 60 * 60 * 24 * 365 * 10;
        options.path = '/';
        options.domain = '.v4.kinoafisha';

        _cookie.cookie.setCookie('ka_come_to_fav_popup', '1', options);
    },
        remove = function remove() {
        closeBtn.removeEventListener('click', hidePopup);
        document.body.removeChild(popupEl);
        popupEl = undefined;
        closeBtn = undefined;
    },
        hidePopup = function hidePopup() {
        remember();
        remove();
    },
        createPopup = function createPopup(data) {
        var div = document.createElement('DIV');
        div.innerHTML = APP.helpers.templateEngine(template, data);
        popupEl = div.firstElementChild;
        closeBtn = popupEl.querySelector('[data-comeToFavPopup-close]');
        closeBtn.addEventListener('click', hidePopup);
    },
        show = function show(box, data) {
        /*
        * Показываем попап
        * Мы не вызыаем эту функцию, если при ответе на голосовалку нет hint:true
        * Поэтому здесь кука проверяется на всякий пожарный
        *
        * Аналогично, шаблон попапа вставляется в разметку только когда нужно
        * Проверяем его наличие на всякий пожарный
        *
        * Если пользователь закрывает попап - ставим бессрочную куку, которая отслеживается на стороне сервера
        * */

        //if(cookie.getCookie('ka_come_to_fav_popup')) return;
        if (!template) return;

        var rect = box.getBoundingClientRect(),
            left = rect.left + window.pageXOffset,
            bottom = rect.bottom + window.pageYOffset;

        if (popupEl) remove();
        createPopup(data);

        popupEl.style.cssText = 'left:' + left + 'px; top:' + bottom + 'px';
        document.body.appendChild(popupEl);
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                popupEl.classList.add('js-active');
            });
        });
    },
        returnObj = {
        show: show
    };

    //
    return returnObj;
};

exports.comeToFavPopup = comeToFavPopup;

},{"../modules/cookie":74}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// возвращает cookie с именем name, если есть, если нет, то undefined

var cookie = {};

cookie.getCookie = function (name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
};

/*
 * устанавливает cookie с именем name и значением value options - объект с свойствами cookie (expires, path, domain, secure)
 * options содержит следующие свойства:
 * expires

 Время истечения cookie. Интерпретируется по-разному, в зависимости от типа:

 Число – количество секунд до истечения. Например, expires: 3600 – кука на час.
 Объект типа Date – дата истечения.
 Если expires в прошлом, то cookie будет удалено.
 Если expires отсутствует или 0, то cookie будет установлено как сессионное и исчезнет при закрытии браузера.

 *path - путь для cookie.
 *domain - домен для cookie.
 *secure - если true, то пересылать cookie только по защищенному соединению.
 */
cookie.setCookie = function (name, value, options) {
    options = options || {};

    var expires = options.expires;

    if (typeof expires == "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }

    document.cookie = updatedCookie;
};

// удаляет cookie с именем name
cookie.deleteCookie = function (name) {
    setCookie(name, "", {
        expires: -1
    });
};

exports.cookie = cookie;

},{}],75:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var detectElementResizeFunc = function detectElementResizeFunc() {
	/**
  * Detect Element Resize
  *
  * https://github.com/sdecima/javascript-detect-element-resize
  * Sebastian Decima
  *
  * version: 0.5.3
  **/

	var attachEvent = document.attachEvent,
	    stylesCreated = false;

	if (!attachEvent) {
		var requestFrame = function () {
			var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
				return window.setTimeout(fn, 20);
			};
			return function (fn) {
				return raf(fn);
			};
		}();

		var cancelFrame = function () {
			var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
			return function (id) {
				return cancel(id);
			};
		}();

		var resetTriggers = function resetTriggers(element) {
			var triggers = element.__resizeTriggers__,
			    expand = triggers.firstElementChild,
			    contract = triggers.lastElementChild,
			    expandChild = expand.firstElementChild;
			contract.scrollLeft = contract.scrollWidth;
			contract.scrollTop = contract.scrollHeight;
			expandChild.style.width = expand.offsetWidth + 1 + 'px';
			expandChild.style.height = expand.offsetHeight + 1 + 'px';
			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
		};

		var checkTriggers = function checkTriggers(element) {
			return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
		};

		var scrollListener = function scrollListener(e) {
			var element = this;
			resetTriggers(this);
			if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
			this.__resizeRAF__ = requestFrame(function () {
				if (checkTriggers(element)) {
					element.__resizeLast__.width = element.offsetWidth;
					element.__resizeLast__.height = element.offsetHeight;
					element.__resizeListeners__.forEach(function (fn) {
						fn.call(element, e);
					});
				}
			});
		};

		/* Detect CSS Animations support to detect element display/re-attach */
		var animation = false,
		    animationstring = 'animation',
		    keyframeprefix = '',
		    animationstartevent = 'animationstart',
		    domPrefixes = 'Webkit Moz O ms'.split(' '),
		    startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
		    pfx = '';
		{
			var elm = document.createElement('fakeelement');
			if (elm.style.animationName !== undefined) {
				animation = true;
			}

			if (animation === false) {
				for (var i = 0; i < domPrefixes.length; i++) {
					if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
						pfx = domPrefixes[i];
						animationstring = pfx + 'Animation';
						keyframeprefix = '-' + pfx.toLowerCase() + '-';
						animationstartevent = startEvents[i];
						animation = true;
						break;
					}
				}
			}
		}

		var animationName = 'resizeanim';
		var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
		var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}

	function createStyles() {
		if (!stylesCreated) {
			//opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
			var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
			    head = document.head || document.getElementsByTagName('head')[0],
			    style = document.createElement('style');

			style.type = 'text/css';
			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
			stylesCreated = true;
		}
	}

	window.addResizeListener = function (element, fn) {
		if (attachEvent) element.attachEvent('onresize', fn);else {
			if (!element.__resizeTriggers__) {
				//if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
				createStyles();
				element.__resizeLast__ = {};
				element.__resizeListeners__ = [];
				(element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
				element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
				element.appendChild(element.__resizeTriggers__);
				resetTriggers(element);
				element.addEventListener('scroll', scrollListener, true);

				/* Listen for a css animation to detect element display/re-attach */
				animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
					if (e.animationName == animationName) resetTriggers(element);
				});
			}
			element.__resizeListeners__.push(fn);
		}
	};

	window.removeResizeListener = function (element, fn) {
		if (attachEvent) element.detachEvent('onresize', fn);else {
			element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
			if (!element.__resizeListeners__.length) {
				element.removeEventListener('scroll', scrollListener);
				element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
			}
		}
	};
};

exports.detectElementResizeFunc = detectElementResizeFunc;

},{}],76:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.disableHover = undefined;

var _event = require('../modules/event');

var disableHover = function disableHover(body) {
    var timer;

    _event.event.add(window, 'scroll', function () {
        clearTimeout(timer);
        if (body.className.indexOf(' main-disableHover') === -1) body.className = body.className + ' main-disableHover';

        timer = setTimeout(function () {
            body.className = body.className.replace(' main-disableHover', '');
        }, 500);
    });
};

exports.disableHover = disableHover;

},{"../modules/event":79}],77:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dynamicIframe = undefined;

var _throttle = require('../modules/throttle');

var dynamicIframe = function dynamicIframe(wrapper) {
    var param = JSON.parse(wrapper.getAttribute('data-param')),
        iframe = wrapper.querySelector('[data-dynamicIframe-element]'),
        uid = new Date().getTime() + Math.random(),
        data = JSON.stringify({ "uid": uid, "module": "dynamicIframe" }),
        checkData = function checkData(data) {
        try {
            var data = JSON.parse(data);
        } catch (e) {
            return false;
        }
        if (data.module !== 'dynamicIframe' || data.uid !== uid) return false;
        return data;
    },
        onMessage = function onMessage(data) {
        var data = checkData(data.data);
        if (!data) return;
        wrapper.style.height = data.h + 'px';
        wrapper.classList.add('js-active');
    },
        onLoad = function onLoad() {
        iframe.contentWindow.postMessage(data, '*');
    },
        init = function init() {
        iframe.src = param.src;
        iframe.addEventListener('load', onLoad);
        window.addEventListener('message', onMessage);
    };

    //
    if (!iframe) return;
    init();
};

exports.dynamicIframe = dynamicIframe;

},{"../modules/throttle":115}],78:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dynamicPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = require('./throttle');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dynamicPage = function dynamicPage(wrapper) {
    var maxDelta = 500,
        /*  */
    endScrollTime = 200,
        clearWaitEndScroll,
        itemAllObj = [],
        itemCurInd = 0,
        /* индекс */
    xhr = false,
        metaEls = function () {
        var data = {};
        var head = document.querySelector('head');

        data.ogTitle = head.querySelector('meta[property="og:title"]');
        data.ogUrl = head.querySelector('meta[property="og:url"]');
        return data;
    }(),
        changeMeta = function changeMeta(data) {
        document.title = data.title || '';
        if (metaEls.ogTitle) metaEls.ogTitle.setAttribute('content', data.title || '');
        if (metaEls.ogUrl) metaEls.ogUrl.setAttribute('content', data.url || '');
    },
        Item = function () {
        function Item(prevItemObj) {
            var _this = this;

            _classCallCheck(this, Item);

            if (!prevItemObj) {
                //первый пункт, который уже есть на странице
                this.itemEl = wrapper.querySelector('[data-dynamicPage-item]');
                this.url = window.location.pathname + window.location.search;
                this.hideBlocks();
                this.addModules();
            } else {
                this.url = prevItemObj.param.next;
                xhr = new XMLHttpRequest();
                xhr.open("POST", this.url, true);
                xhr.setRequestHeader("X-Request-Ajax", "1");
                xhr.onload = function () {
                    _this.onloadData();
                };
                xhr.send('');
            }
        }

        _createClass(Item, [{
            key: 'onloadData',
            value: function onloadData() {
                if (!xhr.responseText) return; //закончилось
                var tempBlock = document.createElement('DIV');
                var sticking = false; //возможно прилипание страницы к низу
                tempBlock.innerHTML = xhr.responseText;
                this.itemEl = tempBlock.firstElementChild;
                if (wrapper.getBoundingClientRect().bottom < 0) sticking = true;
                this.hideBlocks();
                wrapper.appendChild(this.itemEl);
                if (sticking) window.scrollBy(0, this.itemEl.getBoundingClientRect().top - 46);
                this.reloadScripts();
                this.addModules();
                xhr = false;
            }
        }, {
            key: 'hideBlocks',
            value: function hideBlocks() {
                //некотрые элементы навигации остались от статичных страниц для роботов. Скрываем их.
                var blocks = this.itemEl.querySelectorAll('[data-dynamicPage-hide]');
                blocks.forEach(function (el) {
                    el.style.display = 'none';
                });
            }
        }, {
            key: 'reloadScripts',
            value: function reloadScripts() {
                //перегружаем тег скрипт, сущ на новой странице
                console.log('reloadScripts');
                var scripts = this.itemEl.querySelectorAll('[data-dynamicPage-script]');
                scripts.forEach(function (el) {
                    var src = el.getAttribute('src');

                    if (src) {
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = src;
                        document.body.appendChild(script);
                    } else {
                        console.log('eval', el.innerHTML);
                        eval(el.innerHTML);
                    }
                });
            }
        }, {
            key: 'addModules',
            value: function addModules() {
                this.param = JSON.parse(this.itemEl.getAttribute('data-dynamicPage-item'));
                this.modules = APP.modules.run(this.itemEl, 'data-dynamicPage-modules');
            }
        }]);

        return Item;
    }(),
        checkLoad = function checkLoad() {
        if (xhr) return;
        var docHeight = document.documentElement.clientHeight;
        var delta = wrapper.getBoundingClientRect().bottom - docHeight;
        if (delta < maxDelta) {
            var prevItemObj = itemAllObj[itemAllObj.length - 1];
            itemAllObj.push(new Item(prevItemObj)); /* TODO */
        }
        waitEndScroll();
    },
        waitEndScroll = function waitEndScroll() {
        if (clearWaitEndScroll) clearTimeout(clearWaitEndScroll);
        clearWaitEndScroll = setTimeout(onEndScroll, endScrollTime);
    },
        onEndScroll = function onEndScroll() {
        checkPage();
        clearWaitEndScroll = false;
    },
        checkPage = function checkPage() {
        var middlePage = document.documentElement.clientHeight / 2;
        var curInd = false;
        var itemObj;

        //
        itemAllObj.some(function (item, ind) {
            var rect = item.itemEl.getBoundingClientRect();
            if (rect.top <= middlePage && rect.bottom >= middlePage) {
                curInd = ind;
                return true;
            }
        });
        curInd = curInd ? curInd : 0; /* для первой страницы */
        if (itemCurInd != curInd) {
            //console.log('новая страница', curInd);
            itemCurInd = curInd;
            var itemObj = itemAllObj[itemCurInd];
            window.history.pushState({ module: 'DynamicPage', ind: curInd }, '', itemObj.url);
            changeMeta({
                title: itemObj.param.title,
                url: itemObj.url
            });
            sendStat(itemObj.url);
        }
    },
        sendStat = function sendStat(url) {
        try {
            gtag('config', 'UA-21667993-5', {
                'page_path': url
            });
        } catch (e) {}
    },
        onPopstate = function onPopstate(e) {
        /*
        * урл может меняться в двух случаях:
        * при щелчке  на стрелочки вперед-назад и, напрмиер, при сизмеении хэша
        * если поменяли хэш, данные будут отсутствовать. При изменении хеша ничего не делаем
        * если нажали в браузере вперед-назад - перегружаем страницу
        */

        if (!e.state) return;

        window.removeEventListener('scroll', checkLoad);
        window.scrollTo(0, 0);
        window.location.reload(true);
    },
        init = function init() {
        itemAllObj.push(new Item()); /* TODO */
        (0, _throttle.throttle)('scroll', checkLoad);
        (0, _throttle.throttle)('resize', checkLoad);
        (0, _throttle.throttle)('orientationChange', checkLoad);
        window.history.replaceState({ module: 'DinamicPage', ind: 0 }, location.href);
        window.addEventListener('popstate', onPopstate);
        checkLoad();
    };

    //
    init();
};

exports.dynamicPage = dynamicPage;

},{"./throttle":115}],79:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var event = function () {

	var guid = 0;

	function fixEvent(event) {
		event = event || window.event;

		if (event.isFixed) {
			return event;
		}
		event.isFixed = true;

		event.preventDefault = event.preventDefault || function () {
			this.returnValue = false;
		};
		event.stopPropagation = event.stopPropagaton || function () {
			this.cancelBubble = true;
		};

		if (!event.target) {
			event.target = event.srcElement;
		}

		if (!event.relatedTarget && event.fromElement) {
			event.relatedTarget = event.fromElement == event.target ? event.toElement : event.fromElement;
		}

		if (event.pageX == null && event.clientX != null) {
			var html = document.documentElement,
			    body = document.body;
			event.pageX = event.clientX + (html && html.scrollLeft || body && body.scrollLeft || 0) - (html.clientLeft || 0);
			event.pageY = event.clientY + (html && html.scrollTop || body && body.scrollTop || 0) - (html.clientTop || 0);
		}

		if (!event.which && event.button) {
			event.which = event.button & 1 ? 1 : event.button & 2 ? 3 : event.button & 4 ? 2 : 0;
		}

		return event;
	}

	/* ���������� � ��������� �������� ������ this = element */
	function commonHandle(event) {
		event = fixEvent(event);

		var handlers = this.events[event.type];

		for (var g in handlers) {
			var handler = handlers[g];

			var ret = handler.call(this, event);
			if (ret === false) {
				event.preventDefault();
				event.stopPropagation();
			}
		}
	}

	return {
		add: function add(elem, type, handler) {
			if (!elem) {
				return;
			}
			if (elem.setInterval && elem != window && !elem.frameElement) {
				elem = window;
			}

			if (!handler.guid) {
				handler.guid = ++guid;
			}

			if (!elem.events) {
				elem.events = {};
				elem.handle = function (event) {
					if (typeof Event !== "undefined") {
						return commonHandle.call(elem, event);
					}
				};
			}

			if (!elem.events[type]) {
				elem.events[type] = {};

				if (elem.addEventListener) elem.addEventListener(type, elem.handle, false);else if (elem.attachEvent) elem.attachEvent("on" + type, elem.handle);
			}

			elem.events[type][handler.guid] = handler;
		},

		remove: function remove(elem, type, handler) {
			var handlers = elem.events && elem.events[type];

			if (!handlers) return;

			delete handlers[handler.guid];

			for (var any in handlers) {
				return;
			}if (elem.removeEventListener) elem.removeEventListener(type, elem.handle, false);else if (elem.detachEvent) elem.detachEvent("on" + type, elem.handle);

			delete elem.events[type];

			for (var any in elem.events) {
				return;
			}try {
				delete elem.handle;
				delete elem.events;
			} catch (e) {
				// IE
				elem.removeAttribute("handle");
				elem.removeAttribute("events");
			}
		}
	};
}();

exports.event = event;

},{}],80:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fb = undefined;

var _scriptonload = require('../modules/scriptonload');

var fb = function fb() {
  var init = function () {}
  //VK.Widgets.Group("vk_groups", {mode: 0, width: "240", height: "300", color1: '141414', color2: 'ffffff', color3: '5B7FA6'}, 52241390);


  //scriptonload('http://connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v2.5', init);


  (function (d, s, id) {
    var js,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);js.id = id;
    js.src = "//connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v2.5";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
};

exports.fb = fb;

},{"../modules/scriptonload":106}],81:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var filterRange = function () {
    function filterRange(wrapper) {
        _classCallCheck(this, filterRange);

        this._createElements(wrapper);
        this._addEvents();
    }

    _createClass(filterRange, [{
        key: '_createElements',
        value: function _createElements(wrapper) {
            this.wrapper = wrapper;
            this.minVal = wrapper.querySelector('[data-filterRange-min]');
            this.maxVal = wrapper.querySelector('[data-filterRange-max]');

            this.allBtn = wrapper.querySelector('[data-filterRange-allBtn]');
            this.cheapBtn = wrapper.querySelector('[data-filterRange-cheapBtn]');
            this.expensiveBtn = wrapper.querySelector('[data-filterRange-expensiveBtn]');

            this.cross = wrapper.querySelectorAll('[data-filterRange-cross]');

            this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
            this.min = this.data.min;
            this.max = this.data.max;
        }
    }, {
        key: '_checkEmpty',
        value: function _checkEmpty(el) {

            if (!el) {
                return;
            }

            var check = function check(element) {
                if (element.value != '') {
                    element.parentNode.querySelector('[data-filterRange-cross]').style.display = 'block';
                } else {
                    element.parentNode.querySelector('[data-filterRange-cross]').style.display = 'none';
                }
            };

            if (Array.isArray(el)) {
                el.forEach(function (item, i, arr) {
                    check(item);
                });
            } else if ((typeof el === 'undefined' ? 'undefined' : _typeof(el)) == 'object') {
                check(el);
            } else {
                console.error('ERROR:', 'param most be an array or object! get ' + (typeof el === 'undefined' ? 'undefined' : _typeof(el)));
            }
        }
    }, {
        key: '_compareMinMax',
        value: function _compareMinMax(min, max) {
            var tempMin = parseInt(min.value);
            var tempMax = parseInt(max.value);
            if (parseInt(min.value) > 0 && parseInt(max.value) > 0) {
                if (parseInt(min.value) > parseInt(max.value)) {
                    this.minVal.value = tempMax;
                    this.maxVal.value = tempMin;
                }
            }
        }
    }, {
        key: '_checkMinMax',
        value: function _checkMinMax(el) {
            if (el.value < this.min) {
                el.value = this.min;
            } else if (el.value > this.max) {
                el.value = this.max;
            }
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var _this = this;

            var self = this;

            this.minVal.addEventListener('keydown', function (e) {
                var arrCodes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 8, 46, 37, 39];
                if (arrCodes.indexOf(e.keyCode) === -1) {
                    e.preventDefault();
                }
                if (_this.minVal.value.length > 4 && e.keyCode !== 8 && e.keyCode !== 46 && e.keyCode !== 37 && e.keyCode !== 39) {
                    e.preventDefault();
                }
            }, false);

            this.maxVal.addEventListener('keydown', function (e) {
                var arrCodes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 8, 46, 37, 39];
                if (arrCodes.indexOf(e.keyCode) === -1) {
                    e.preventDefault();
                }
                if (_this.maxVal.value.length > 4 && e.keyCode !== 8 && e.keyCode !== 46 && e.keyCode !== 37 && e.keyCode !== 39) {
                    e.preventDefault();
                }
            }, false);

            this.minVal.addEventListener('change', function () {
                _this._checkMinMax(_this.minVal);
                _this._checkEmpty(_this.minVal);
                _this._compareMinMax(_this.minVal, _this.maxVal);
            }, false);

            this.maxVal.addEventListener('change', function () {
                _this._checkMinMax(_this.maxVal);
                _this._checkEmpty(_this.maxVal);
                _this._compareMinMax(_this.minVal, _this.maxVal);
            }, false);

            this.allBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.minVal.value = _this.min;
                _this.maxVal.value = _this.max;
                _this._checkEmpty([_this.minVal, _this.maxVal]);
            }, false);

            this.cheapBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.minVal.value = _this.min;
                _this.maxVal.value = _this.data.cheapTo;
                _this._checkEmpty([_this.minVal, _this.maxVal]);
            }, false);

            this.expensiveBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.minVal.value = _this.data.expensiveFrom;
                _this.maxVal.value = _this.max;
                _this._checkEmpty([_this.minVal, _this.maxVal]);
            }, false);

            this.cross.forEach(function (item, i, arr) {
                item.addEventListener('click', function (e) {
                    e.preventDefault();
                    var input = item.parentNode.querySelector('input');
                    input.value = '';
                    _this._checkEmpty(input);
                }, false);
            });
        }
    }, {
        key: 'del',
        value: function del() {}
    }]);

    return filterRange;
}();

exports.filterRange = filterRange;

},{}],82:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var filterSchedule = function () {
    function filterSchedule(wrapper) {
        _classCallCheck(this, filterSchedule);

        this.element = wrapper;

        this.declare(this.element);
        this.setListeners();
    }

    _createClass(filterSchedule, [{
        key: 'declare',
        value: function declare(el) {
            this.class = 'showtimesFilter_sort_filter-open';
            this.list = document.querySelector('[data-filterschedule-list]');
            this.items = this.list.querySelectorAll('[data-filterSchedule-list-item]');
            this.input = el.querySelector('[data-filterSchedule-input]');
            this.btn = el.querySelector('[data-filterSchedule-btn]');
        }
    }, {
        key: 'setListeners',
        value: function setListeners() {
            var that = this;
            var opened = false;

            this.btn.addEventListener('click', function () {
                that.element.classList.toggle(that.class);
                that.input.classList.toggle('as-none');
                that.input.focus();
                that.input.value = '';

                that.filterByQuery('');

                var opened = true;
            });

            this.input.addEventListener('keyup', function (e) {
                var val = e.currentTarget.value;

                that.filterByQuery(val);
            });
        }
    }, {
        key: 'filterByQuery',
        value: function filterByQuery(query) {
            var _this = this;

            var matchCount = 0;
            var matchedIndexes = [];

            this.items.forEach(function (item, index) {
                var name = item.querySelector('[data-filterschedule-name]').innerText.toLowerCase();
                var itemIndex = item.dataset.filterscheduleListItem;

                if (name.indexOf(query.toLowerCase()) >= 0) {
                    matchCount++;
                    matchedIndexes.push(itemIndex);
                }

                item.classList.add('as-none');
            });

            matchedIndexes.forEach(function (ind) {
                console.warn(matchedIndexes, ind);
                _this.items[ind].classList.remove('as-none');
            });

            if (matchedIndexes.length === 0) {
                this.items.forEach(function (item) {
                    return item.classList.remove('as-none');
                });
            }
        }
    }]);

    return filterSchedule;
}();

exports.filterSchedule = filterSchedule;

},{}],83:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
* Фиксирует высоту селекта при выпадении
* Это нужно, например, в меню онлайна
*
* */

var fixSelect = function fixSelect(el) {
	var select = el.querySelector('[data-fixSelect-select]'),
	    hide = function hide() {
		el.classList.remove('js-focus');
		select.removeAttribute('size');
	},
	    show = function show() {
		el.classList.add('js-focus');
		select.setAttribute('size', 5);
	};

	//
	if (navigator.userAgent.indexOf('Edge') !== -1) return false; /* В ие при выборе селекта и так ничего не пряяется */

	select.onmousedown = function (e) {
		if (!el.classList.contains('js-focus')) e.preventDefault();
	};

	select.onclick = function () {
		if (el.classList.contains('js-focus')) hide();else show();
	};
};

exports.fixSelect = fixSelect;

},{}],84:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* Галерея - используется по всему сайту
* изначально была fullscreen
* #1 - переделал на обычную
* */

var fullscreenGalleryFunc = function fullscreenGalleryFunc(root, doc) {
    var identify = function () {
        if ('fullscreenEnabled' in doc) return 'fullscreenEnabled';
        if ('mozFullScreenEnabled' in doc) return 'mozFullScreenEnabled';
        if ('webkitFullscreenEnabled' in doc) return 'webkitFullscreenEnabled';
        if ('msFullscreenEnabled' in doc) return 'msFullscreenEnabled';
        return false;
    }(),
        requestName = function () {
        if (doc.documentElement.requestFullscreen) return 'requestFullscreen';else if (doc.documentElement.mozRequestFullScreen) return 'mozRequestFullScreen';else if (doc.documentElement.webkitRequestFullscreen) return 'webkitRequestFullscreen';else if (doc.documentElement.msRequestFullscreen) return 'msRequestFullscreen';
    }(),
        exitName = function () {
        if (doc.exitFullscreen) return 'exitFullscreen';else if (doc.mozCancelFullScreen) return 'mozCancelFullScreen';else if (doc.webkitCancelFullScreen) return 'webkitCancelFullScreen';else if (doc.msExitFullscreen) return 'msExitFullscreen';
    }(),
        eventName = function () {
        if ('onfullscreenchange' in doc) return 'fullscreenchange';
        if ('onmozfullscreenchange' in doc) return 'mozfullscreenchange';
        if ('onwebkitfullscreenchange' in doc) return 'webkitfullscreenchange';
        if ('onmsfullscreenchange' in doc) return 'MSFullscreenChange';
        return false;
    }(),
        elementName = function () {
        if ('fullscreenElement' in doc) return 'fullscreenElement';
        if ('mozFullScreenElement' in doc) return 'mozFullScreenElement';
        if ('webkitFullscreenElement' in doc) return 'webkitFullscreenElement';
        if ('msFullscreenElement' in doc) return 'msFullscreenElement';
        return false;
    }(),
        FullscreenGallery = function () {
        function FullscreenGallery(wrapper) {
            _classCallCheck(this, FullscreenGallery);

            this._createElements(wrapper);
            this._addEvents();
        }

        _createClass(FullscreenGallery, [{
            key: '_createElements',
            value: function _createElements(wrapper) {
                this.wrapper = wrapper;
                this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
                this.itemAll = this.wrapper.querySelectorAll('[data-fullscreenGallery-item]');
                this.curInd = 0;
                this.count = this.itemAll.length;
                this.frame = false;
                this.top = false;
                this.frameImageFrame = false;
                this.frameTitle = false;
            }
        }, {
            key: '_addEvents',
            value: function _addEvents() {
                var self = this;

                for (var i = 0, j = this.itemAll.length; i < j; i++) {
                    this.itemAll[i].onclick = function (i) {
                        return function () {
                            self._open.call(self, JSON.parse(this.getAttribute('data-fullscreenGallery-item')), i);
                            return false;
                        };
                    }(i);
                }
            }
        }, {
            key: '_open',
            value: function _open(data, curInd) {
                this.curInd = curInd;
                this._createFrame();
                this._addData(data);
                if (document.body.className.indexOf('js-fullscreen') === -1) document.body.className = document.body.className + ' js-fullscreen';
            }
        }, {
            key: '_next',
            value: function _next(e) {
                var newInd;

                newInd = this.curInd + 1;
                if (this.count === newInd) newInd = 0;

                this._move(newInd);
            }
        }, {
            key: '_prev',
            value: function _prev(e) {
                var newInd;

                newInd = this.curInd - 1;
                if (newInd < 0) newInd = this.count - 1;

                this._move(newInd);
            }
        }, {
            key: '_move',
            value: function _move(newInd) {
                this.curInd = newInd;
                this._addData(JSON.parse(this.itemAll[this.curInd].getAttribute('data-fullscreenGallery-item')));
            }
        }, {
            key: '_createFrame',
            value: function _createFrame() {
                var _this = this;

                var self = this,
                    box,
                    close,
                    changeCallback = function changeCallback(e) {
                    self._changeCallback.call(self, e, changeCallback);
                };

                this._changeHeightLocking = function () {
                    self._changeHeight.call(self);
                };

                box = doc.createElement('DIV');
                box.className = 'fullscreen';
                box.innerHTML = '<svg data-js="close" class="fullscreen_close symbol symbol-x" role="img"><use xlink:href="/static/img/symbols/sprite.svg#x"></use></svg>' + '<div class="fullImage">' + '<div class="fullImage_line">' + '<div data-fullscreenGallery-top class="fullImage_item fullImage_item-top">' + '<div data-fullscreenGallery-imageFrame class="fullImage_imageFrame"></div>' + '<div class="fullImage_btn fullImage_btn-left" data-fullscreenGallery-btn="left">' + '<svg class="fullImage_btnIcon symbol symbol-cornerArrow" role="img"><use xlink:href="/static/img/symbols/sprite.svg#cornerArrow"></use></svg>' + '</div>' + '<div class="fullImage_btn fullImage_btn-right" data-fullscreenGallery-btn="right">' + '<svg class="fullImage_btnIcon symbol symbol-cornerArrow" role="img"><use xlink:href="/static/img/symbols/sprite.svg#cornerArrow"></use></svg>' + '</div>' + '</div>' + '</div>' + '<div class="fullImage_line">' + '<div class="fullImage_item fullImage_item-bottom">' + '<div class="fullImage_content">' + '<div class="fullImage_contentItem">' + '<span data-fullscreenGallery-title class="fullImage_title">&nbsp;</span>' + '</div>' + '<div class="fullImage_contentItem">' + '<!-- <nav class="fullImage_wallpapers menuBtn menuBtn-withTitle">' + '<span class="menuBtn_title">Обои:</span>' + '<div class="menuBtn_content">' + '<a class="menuBtn_item btn btn-default btn-view3" href="#">компьютер</a>' + '<a class="menuBtn_item btn btn-default btn-view3" href="#">аланшет</a>' + '<a class="menuBtn_item btn btn-default btn-view3" href="#">смартфон</a>' + '</div>' + '</nav> -->' + '</div>' + '<div class="fullImage_contentItem align-right">' + '<!--<div class="fullImage_social symbols">' + '<a href="#"><svg class="symbols_item symbol symbol-vk" role="img"><use xlink:href="img/symbols/sprite.svg#vk"></use></svg></a>' + '<a href="#"><svg class="symbols_item symbol symbol-fb" role="img"><use xlink:href="img/symbols/sprite.svg#fb"></use></svg></a>' + '<a href="#"><svg class="symbols_item symbol symbol-tw" role="img"><use xlink:href="img/symbols/sprite.svg#tw"></use></svg></a>' + '<a href="#"><svg class="symbols_item symbol symbol-ok" role="img"><use xlink:href="img/symbols/sprite.svg#ok"></use></svg></a>' + '</div>-->' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';

                doc.body.appendChild(box);

                var closeBtn = box.querySelector('[data-js="close"]');

                closeBtn.onclick = function () {
                    self._removeFrame.call(self);
                };

                this.frame = box;
                this.top = this.frame.querySelector('[data-fullscreenGallery-top]');
                this.frameImageFrame = this.frame.querySelector('[data-fullscreenGallery-imageFrame]');
                this.frameTitle = this.frame.querySelector('[data-fullscreenGallery-title]');
                this.btnLeft = this.frame.querySelector('[data-fullscreenGallery-btn="left"]');
                this.btnRight = this.frame.querySelector('[data-fullscreenGallery-btn="right"]');

                if (this.count !== 1) {
                    this.btnRight.addEventListener('click', function () {
                        _this._next();
                    });
                    this.btnLeft.addEventListener('click', function () {
                        _this._prev();
                    });
                } else {
                    this.top.removeChild(this.btnRight);
                    this.top.removeChild(this.btnLeft);
                }

                window.addEventListener('resize', this._changeHeightLocking, false);
                this._changeHeightLocking();
            }
        }, {
            key: '_changeHeight',
            value: function _changeHeight() {
                var self = this,
                    change = function change() {
                    var box = self.top.getBoundingClientRect(),
                        h = box.bottom - box.top;

                    if (h > 0) self.frameImageFrame.style.height = h + 'px';else {
                        requestAnimationFrame(change);
                    }
                };
                change();
            }
        }, {
            key: '_addData',
            value: function _addData(data) {
                var title = data.title ? data.title : this.param.title;

                this.frameImageFrame.innerHTML = '<img data-fullscreenGallery-image class="fullImage_image" src="' + data.image + '" alt="" title="' + title + '" />';
                this.frameTitle.innerHTML = title;
            }
        }, {
            key: '_removeFrame',
            value: function _removeFrame() {
                doc.body.removeChild(this.frame);
                if (document.body.className.indexOf('js-fullscreen') !== -1) document.body.className = document.body.className.replace(' js-fullscreen', '');
                window.removeEventListener('resize', this._changeHeightLocking);

                delete this.frame;
                delete this.frameTitle;
            }
        }]);

        return FullscreenGallery;
    }(),
        fullscreenGallery = function fullscreenGallery(wrapper) {
        if (!window.requestAnimationFrame) return false;
        return new FullscreenGallery(wrapper);
    };

    return fullscreenGallery;
};

exports.fullscreenGalleryFunc = fullscreenGalleryFunc;

},{}],85:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var geography = function geography(btn) {
	var frame = document.querySelector('[data-geography-frame]'),
	    contriesFrame = null,
	    contriesToggleBtn = null,
	    frameInner = undefined,
	    chooseCity = undefined,
	    closeBtn = undefined,
	    xhr = undefined,
	    modules = undefined,
	    isLoaded = false,
	    path = APP.vars.isDev ? "/_src/layouts/desktop/_pieces/geography.php" : '/service/header/',
	    showHat = function showHat() {
		if (isLoaded) openHat();else getData();
	},
	    getData = function getData() {
		btn.classList.add('js-loading');
		xhr = new XMLHttpRequest();
		xhr.open("POST", path, true);
		xhr.setRequestHeader("X-Request-Ajax", "1");
		xhr.onload = addData;
		xhr.send('');
	},
	    addData = function addData() {
		frame.innerHTML = xhr.responseText;
		frameInner = frame.querySelector('[data-js="frame"]');
		chooseCity = frame.querySelector('.chooseCity');
		closeBtn = frame.querySelector('[data-js="close"]');
		modules = APP.modules.run(frame, 'data-geography-modules');
		closeBtn.addEventListener('click', closeHat);
		btn.classList.remove('js-loading');
		isLoaded = true;
		openHat();
	},
	    toggleBtnHandler = function toggleBtnHandler(e) {
		e.preventDefault();
		contriesFrame.classList.toggle('as-none');
		chooseCity.style.height = frameInner.getBoundingClientRect().height + 'px';
	},
	    openHat = function openHat() {
		frame.classList.add('js-active');
		chooseCity.style.height = frameInner.getBoundingClientRect().height + 'px';
		btn.classList.add('js-active');
		contriesFrame = document.querySelector('[data-geography-contriesFrame]');
		contriesToggleBtn = document.querySelector('[data-geography-contriesToggleBtn]');
		if (contriesToggleBtn && contriesFrame) {
			contriesToggleBtn.addEventListener('click', toggleBtnHandler);
		}
	},
	    closeHat = function closeHat() {
		frame.classList.remove('js-active');
		btn.classList.remove('js-active');
		if (contriesToggleBtn && contriesFrame) {
			contriesToggleBtn.removeEventListener('click', toggleBtnHandler);
		}
	},
	    toggleHat = function toggleHat(e) {
		e.preventDefault();
		if (this.classList.contains('js-loading')) return;else if (this.classList.contains('js-active')) closeHat();else showHat();
	};
	//
	btn.addEventListener('click', toggleHat);
};

exports.geography = geography;

},{}],86:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.header = undefined;

var _scriptonload = require('../modules/scriptonload');

var header = function header(el) {
    (0, _scriptonload.scriptonload)('/static/js/vendors/stickyfill.min.js', function () {
        Stickyfill.add(el);
    });
};

exports.header = header;

},{"../modules/scriptonload":106}],87:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.helpers = undefined;

var _templateEngine = require('./templateEngine');

var _throttle = require('../modules/throttle');

var helpers = function helpers() {
	return {
		'randomInteger': function randomInteger(min, max) {
			var rand = min - 0.5 + Math.random() * (max - min + 1);
			rand = Math.round(rand);
			return rand;
		},
		'templateEngine': _templateEngine.templateEngine,
		'decline': function decline(number, titles) {
			var cases = [2, 0, 1, 1, 1, 2];
			return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
		},
		'throttle': _throttle.throttle
	};
};

exports.helpers = helpers;

},{"../modules/throttle":115,"./templateEngine":114}],88:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.kinoafisha2 = undefined;

var _cookie = require("../modules/cookie");

var kinoafisha2 = function kinoafisha2() {
	var _0xbec9 = ["\x6B\x69\x6E\x6F\x61\x66\x69\x73\x68\x61\x32", "\x67\x65\x74\x43\x6F\x6F\x6B\x69\x65", "\x69\x73\x4D\x6F\x62\x69\x6C\x65", "\x76\x61\x72\x73", "\x69\x73\x55\x73\x65\x72\x41\x75\x74\x68", "\x49\x46\x52\x41\x4D\x45", "\x63\x72\x65\x61\x74\x65\x45\x6C\x65\x6D\x65\x6E\x74", "\x73\x72\x63", "\x68\x74\x74\x70\x73\x3A\x2F\x2F\x77\x77\x77\x2E\x6B\x69\x6E\x6F\x61\x66\x69\x73\x68\x61\x2E\x69\x6E\x66\x6F", "\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75\x74\x65", "\x63\x73\x73\x54\x65\x78\x74", "\x73\x74\x79\x6C\x65", "\x76\x69\x73\x69\x62\x69\x6C\x69\x74\x79\x3A\x20\x68\x69\x64\x64\x65\x6E\x3B\x70\x6F\x73\x69\x74\x69\x6F\x6E\x3A\x20\x61\x62\x73\x6F\x6C\x75\x74\x65\x3B\x6C\x65\x66\x74\x3A\x20\x2D\x39\x39\x39\x39\x70\x78\x3B\x74\x6F\x70\x3A\x20\x2D\x39\x39\x39\x39\x70\x78\x3B\x64\x69\x73\x70\x6C\x61\x79\x3A\x20\x62\x6C\x6F\x63\x6B\x3B\x6F\x76\x65\x72\x66\x6C\x6F\x77\x3A\x20\x68\x69\x64\x64\x65\x6E\x3B", "\x61\x70\x70\x65\x6E\x64\x43\x68\x69\x6C\x64", "\x62\x6F\x64\x79", "\x2E\x6B\x69\x6E\x6F\x61\x66\x69\x73\x68\x61\x2E\x73\x70\x62\x2E\x72\x75", "\x2E\x6B\x69\x6E\x6F\x61\x66\x69\x73\x68\x61\x2E\x6D\x73\x6B\x2E\x72\x75", "\x2E\x6B\x69\x6E\x6F\x61\x66\x69\x73\x68\x61\x2E\x69\x6E\x66\x6F", "\x6C\x65\x6E\x67\x74\x68", "\x65\x78\x70\x69\x72\x65\x73", "\x70\x61\x74\x68", "\x2F", "\x64\x6F\x6D\x61\x69\x6E", "\x31", "\x73\x65\x74\x43\x6F\x6F\x6B\x69\x65", "\x72\x65\x61\x64\x79\x53\x74\x61\x74\x65", "\x63\x6F\x6D\x70\x6C\x65\x74\x65", "\x6C\x6F\x61\x64", "\x61\x64\x64\x45\x76\x65\x6E\x74\x4C\x69\x73\x74\x65\x6E\x65\x72"];if (self != top || _cookie.cookie[_0xbec9[1]](_0xbec9[0]) || APP[_0xbec9[3]][_0xbec9[2]] || !APP[_0xbec9[3]][_0xbec9[4]]) {
		return;
	};var start = function start() {
		var _0xc3d6x3 = document[_0xbec9[6]](_0xbec9[5]);_0xc3d6x3[_0xbec9[9]](_0xbec9[7], _0xbec9[8]);_0xc3d6x3[_0xbec9[11]][_0xbec9[10]] = _0xbec9[12];document[_0xbec9[14]][_0xbec9[13]](_0xc3d6x3);setCookie(3600 * 24);
	},
	    setCookie = function setCookie(_0xc3d6x4) {
		var _0xc3d6x5 = {},
		    _0xc3d6x6 = [_0xbec9[15], _0xbec9[16], _0xbec9[17]],
		    _0xc3d6x7 = 0,
		    _0xc3d6x8 = _0xc3d6x6[_0xbec9[18]];_0xc3d6x5[_0xbec9[19]] = _0xc3d6x4;_0xc3d6x5[_0xbec9[20]] = _0xbec9[21];for (_0xc3d6x7; _0xc3d6x7 < _0xc3d6x8; _0xc3d6x7++) {
			_0xc3d6x5[_0xbec9[22]] = _0xc3d6x6[_0xc3d6x7];_cookie.cookie[_0xbec9[24]](_0xbec9[0], _0xbec9[23], _0xc3d6x5);
		}
	};if (document[_0xbec9[25]] === _0xbec9[26]) {
		start();
	} else {
		window[_0xbec9[28]](_0xbec9[27], start);
	}
};

exports.kinoafisha2 = kinoafisha2;

},{"../modules/cookie":74}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mainLogo = undefined;

var _event = require("../modules/event");

var mainLogo = function mainLogo(wrapper) {
    var logo = wrapper.firstChild.nodeType == 1 ? wrapper.firstChild : wrapper.firstChild.nextSibling;
    logo.innerHTML = logo.firstChild.nodeValue.replace(/./g, "<span class=\"mainLogo_letter\">$&</span>");

    if (document.readyState === "complete") {
        logo.className = logo.className + ' g-active';
    } else {
        _event.event.add(window, 'load', function () {
            logo.className = logo.className + ' g-active';
        });
    }
};

exports.mainLogo = mainLogo;

},{"../modules/event":79}],90:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* TODO step and minus */
var multiRange = function multiRange(el) {
    var rangeTags = el.querySelectorAll('input');
    var min = parseFloat(rangeTags[0].getAttribute('min'));
    var max = parseFloat(rangeTags[0].getAttribute('max'));
    var rangeWidth = max - min;
    var clickEventName = window.PointerEvent ? 'pointerup' : 'click';
    var addHints = function addHints() {
        var template = el.querySelector('[data-multiRange-hint]');
        if (!template) return false;
        var hintTag = template.content.firstElementChild;
        rangeTags.forEach(function (tag) {
            tag.hintTag = tag.insertAdjacentElement('afterEnd', document.importNode(hintTag, true));
            updateHint(tag);
        });
    };
    var moveNearestThumb = function moveNearestThumb(e) {
        /* событие клика по треку может срабатывать  после того, как подвигал ползунок, нам это не нужно */
        if (e.target !== el) return;
        console.log('pointer events');

        var clickValue = Math.round(e.offsetX / el.getBoundingClientRect().width * rangeWidth) + min; /* TODO */
        var nearest = rangeWidth;
        var nearestTag;
        rangeTags.forEach(function (tag) {
            var offset = Math.abs(tag.value - clickValue);
            if (offset < nearest) {
                nearest = offset;
                nearestTag = tag;
            }
        });
        nearestTag.value = clickValue;
        updateHint(nearestTag);
        updateSelected();
    };

    var updateHint = function updateHint(tag) {
        if (!tag.hintTag) return;
        var ratio = (tag.value - min) / rangeWidth;
        tag.hintTag.innerHTML = tag.value;
        var hintOffset = tag.hintTag.getBoundingClientRect().width * ratio;
        tag.hintTag.style.cssText = 'left:' + ratio * 100 + '%; margin-left:-' + hintOffset + 'px';
    };

    var updateSelected = function updateSelected() {
        var minVal = parseFloat(rangeTags[0].value);
        var maxVal = parseFloat(rangeTags[1].value);
        if (minVal > maxVal) minVal = [maxVal, maxVal = minVal][0];

        el.style.cssText = '--multiRange-low:' + (minVal - min) / rangeWidth * 100 + '%; --multiRange-high:' + (maxVal - min) / rangeWidth * 100 + '%';
    };

    var onChange = function onChange(e) {
        updateHint(e.target);
        updateSelected();
    };

    //
    addHints();
    updateSelected();
    rangeTags.forEach(function (tag) {
        tag.addEventListener('input', onChange);
        tag.addEventListener('change', onChange);
    });

    el.addEventListener(clickEventName, moveNearestThumb);
};

exports.multiRange = multiRange;

},{}],91:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function nearFilter(btn) {
    if (!navigator.geolocation) return;

    var getLocation = function getLocation() {
        navigator.geolocation.getCurrentPosition(function (position) {
            var search = btn.search;
            var coords = 'long=' + position.coords.longitude + '&lat=' + position.coords.latitude;
            btn.search = search ? search + '&' + coords : '?' + coords;
            document.location = btn.href;
        }, function () {
            alert('Геолокацию не удалось получить. Список ближайших кинотеатров может быть неточным. Разрешите браузеру определять местоположение для нашего сайта.');
            document.location = btn.href;
        }, {
            timeout: 5000
        });
    };

    btn.addEventListener('click', function (e) {
        e.preventDefault();
        getLocation();
    }, false);
}

exports.nearFilter = nearFilter;

},{}],92:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notificationPopup = undefined;

var _event = require('../modules/event');

var _cookie = require('../modules/cookie');

var notificationPopup = function notificationPopup(wrapper) {

    var cancelBtn = wrapper.querySelector('[data-notificationPopup-cancel]'),
        showBtn = wrapper.querySelector('[data-notificationPopup-show]'),
        popup,
        show = function show() {
        if (APP.vars.isMobile) {
            popup = uPopup({
                addClass: 'popup-notification',
                content: wrapper
            });
        } else {
            wrapper.className = wrapper.className + ' js-active';
        }
    },
        hide = function hide() {
        if (APP.vars.isMobile) {
            uPopup.closeAll();
        } else {
            wrapper.className = wrapper.className.replace(' js-active', '');
        }
    },
        setCookie = function setCookie(expires) {
        var options = {};

        options.expires = expires;
        options.path = '/';
        options.domain = '.kinoafisha.info'; //.kinoafishaspb.ru

        _cookie.cookie.setCookie('ka_push_showed', 'ok', options);
    },
        add = function add() {
        cancelBtn.onclick = function (e) {
            if (e) e.preventDefault();
            setCookie(3600 * 24 * 30);
            hide();
            return false;
        };
        showBtn.onclick = function () {
            setCookie(3600 * 24);
            hide();
        };
        show();
    };

    //
    if (!('serviceWorker' in navigator)) return false; /* не работает с http */
    if (!navigator.cookieEnabled) return false;

    if (document.readyState === "complete") {
        add();
    } else {
        _event.event.add(window, 'load', add);
    }
};

exports.notificationPopup = notificationPopup;

},{"../modules/cookie":74,"../modules/event":79}],93:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.novelties = undefined;

var _cookie = require('../modules/cookie');

/*  */
var novelties = function novelties(el) {
    var closeBtn = el.querySelector('[data-novelties-close]'),
        setCookie = function setCookie(expires) {
        var options = {},
            domains = ['.kinoafisha.spb.ru', '.kinoafisha.msk.ru', '.kinoafisha.info'],
            i = 0,
            l = domains.length;

        options.expires = expires;
        options.path = '/';

        for (i; i < l; i++) {
            options.domain = domains[i];
            _cookie.cookie.setCookie('ka_rating', '1', options);
        }
    };
    //
    closeBtn.onclick = function () {
        delete this.onclick;
        el.parentNode.removeChild(el);
        setCookie(3600 * 24 * 365);
    };
};

exports.novelties = novelties;

},{"../modules/cookie":74}],94:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var onlinePlayer = function onlinePlayer(el) {
	var _this = this;

	var btn = el.querySelector('[data-onlinePlayer-cover]'),
	    iframe = el.querySelector('[data-onlinePlayer-iframe]'),
	    select = el.querySelector('[data-onlinePlayer-change]'),
	    frame = document.querySelector('[data-modules="Trailer"]'),
	    age = el.querySelector('[data-onlinePlayer-age]'),
	    watchBtns = frame ? frame.querySelector('[data-onlinePlayer-buttons]') : null,
	    param = JSON.parse(el.getAttribute('data-param')),
	    sendStat = function sendStat() {
		try {
			gtag('event', 'click', {
				'event_category': 'engagement',
				'event_action': 'online',
				'event_label': param.source
			});
		} catch (e) {
			console.log('gtag onlinePlayer error', e);
		}

		try {
			yaCounter28763351.reachGoal('online_activate');
		} catch (e) {
			console.log('ym onlinePlayer error', e);
		}
	};

	//
	btn.onclick = function () {
		el.classList.add('js-open');
		iframe && iframe.setAttribute('src', param.src);
		sendStat();
		try {
			_this.onActive();
		} catch (e) {}

		if (param.series) {
			if (watchBtns) watchBtns.style.opacity = 0;

			age && age.classList.add('as-none');
		}
	};

	if (select) {
		select.onchange = function () {
			var selected = this.options[this.selectedIndex],
			    url = selected.getAttribute('data-onlinePlayer-field');

			if (url) iframe.setAttribute('src', url);
		};
	}

	return this;
};

exports.onlinePlayer = onlinePlayer;

},{}],95:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.page = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Form = require('./Form');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function page(param) {
    param = typeof param === 'string' ? { 'name': param } : param;
    var name = param.name;
    var defParam = APP.pagesParam[name];

    for (var key in defParam) {
        if (param.hasOwnProperty(key)) continue;else param[key] = defParam[key];
    }

    console.log('page param', param);

    var Page = function () {
        function Page() {
            _classCallCheck(this, Page);

            this.show();
        }

        _createClass(Page, [{
            key: 'handleEvent',
            value: function handleEvent(event) {
                event.preventDefault();
                this.show();
            }
        }, {
            key: '_getContent',
            value: function _getContent() {
                return new Promise(function (resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", param.ajax, true);
                    xhr.setRequestHeader("X-Request-Ajax", "1");
                    xhr.setRequestHeader("X-Request-Referer", window.location.toString());
                    xhr.onload = function () {
                        if (xhr.status != 200) reject(xhr);else resolve(xhr.responseText);
                    };
                    xhr.send('');
                });
            }
        }, {
            key: 'show',
            value: function show() {
                var _this = this;

                var cls = param.cls ? param.cls : 'popup-middle';
                var self = this;

                this._getContent().then(function (content) {
                    uPopup.closeAll();
                    _this.popup = uPopup({
                        addClass: cls,
                        name: name,
                        content: content,
                        onopen: function onopen(wrapper) {
                            _this.moduleAll = APP.modules.run(wrapper, 'data-PopupForm-modules');
                        },
                        oncloseBefore: function oncloseBefore() {
                            APP.modules.destroy(_this.moduleAll);
                            return true;
                        }
                    });
                }, function (xhr) {
                    console.log('pageModule reject, xhr status:', xhr.status);
                });
            }
        }, {
            key: 'addBtn',
            value: function addBtn(btn) {
                btn.addEventListener('click', this);
                this.btnAll.push(btn);
            }
        }]);

        return Page;
    }();

    var init = function init() {
        return new Page();'';
    };

    //
    init();
}

exports.page = page;

},{"./Form":18}],96:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pageBtn = undefined;

var _page = require('./page');

var pageBtn = function pageBtn(btn) {
    var onClick = function onClick(event) {
        event.preventDefault();
        var param = JSON.parse(btn.getAttribute('data-param'));
        (0, _page.page)(param);
    };

    //
    btn.addEventListener('click', onClick);
};

exports.pageBtn = pageBtn;

},{"./page":95}],97:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.poll = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Form = require('../modules/Form');

var _event = require('./event');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var poll = function poll(el) {
    var elForm = el.querySelector('[data-poll-form]'),
        elTotal = el.querySelector('[data-poll-total]'),
        oForm = new _Form.Form({
        wrapper: elForm,
        onsuccess: function onsuccess(data) {
            showResults(data);
        },
        onerror: function onerror(data) {
            alert(data.message);
        }
    }),
        answerAll = el.querySelectorAll('[data-poll-answer]'),
        answersObj = {},
        resultBtn = el.querySelector('[data-poll-resultBtn]'),
        checkAuth = function checkAuth(e) {
        if (APP.vars.isMobile) {
            if (APP.auth.tryAuth()) return true;else return false;
        } else {
            if (!regAuthObj.isAuth) {
                e.preventDefault();
                regAuthObj.authForm.showPopup();
                return false;
            }
            return true;
        }
    },
        Answer = function () {
        function Answer(el) {
            _classCallCheck(this, Answer);

            this.createElements(el);
            this.addEvents();
        }

        _createClass(Answer, [{
            key: 'addRes',
            value: function addRes(data) {
                this.elField.checked = data.uservoted;
                this.elField.setAttribute('disabled', true); /* на всякий случай. И так дисаблится стилем pointer-events */
                this.elProgress.style.width = data.percentage + '%';
            }
        }, {
            key: 'createElements',
            value: function createElements(el) {
                this.el = el;
                this.elProgress = this.el.querySelector('[data-poll-progress]');
                this.elField = this.el.querySelector('[data-poll-field]');
            }
        }, {
            key: 'addEvents',
            value: function addEvents() {
                this.el.addEventListener('click', function (e) {
                    checkAuth(e);
                });
            }
        }]);

        return Answer;
    }(),
        confirmResults = function confirmResults() {
        if (!regAuthObj.isAuth) {
            regAuthObj.authForm.showPopup();
        } else if (confirm('После просмотра результатов голосование невозможно')) {
            elForm.reset();
            elForm.submit();
            el.classList.add('js-loading');
        }
    },
        showResults = function showResults(data) {
        el.classList.remove('js-loading');
        el.classList.add('js-result');

        for (var key in answersObj) {
            answersObj[key].addRes(data.result[key]);
        }

        elTotal.innerHTML = data.result.total + ' ' + APP.helpers.decline(data.result.total, ['голос', 'голоса', 'голосов']);
    },
        submitForm = function submitForm(e) {
        e.preventDefault();

        if (!checkAuth(e)) return;

        if (!e.target.checkValidity()) {
            if (APP.vars.isMobile) {
                alert('Пожалуйста, ответьте на вопрос');
            } else {
                uPopup({
                    content: 'Пожалуйста, ответьте на вопрос'
                });
            }
        } else {
            elForm.submit();
            el.classList.add('js-loading');
        }
    };

    //
    elForm.addEventListener('submit', submitForm);

    for (var i = 0, j = answerAll.length; i < j; i++) {
        var key = answerAll[i].getAttribute('data-poll-answer');
        answersObj[key] = new Answer(answerAll[i]);
    }

    resultBtn.addEventListener('click', confirmResults);
};

exports.poll = poll;

},{"../modules/Form":18,"./event":79}],98:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.popupFormSimple = undefined;

var _PopupForm = require('../modules/PopupForm');

var popupFormSimple = function popupFormSimple(wrapper) {
	new _PopupForm.PopupForm({
		wrapper: wrapper,
		onsuccess: function onsuccess(data) {
			uPopup.closeAll();
			uPopup({
				content: data.message
			});
		}
	});
};

exports.popupFormSimple = popupFormSimple;

},{"../modules/PopupForm":31}],99:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.raskhlop = undefined;

require('../modules/uPopup');

var _cookie = require('../modules/cookie');

var raskhlop = function raskhlop(el) {
    var param = JSON.parse(el.getAttribute('data-param')),
        autostart = param.autostart === false ? false : true,
        install = function install() {
        var myPopup,
            closeBox,
            timeStart,
            timeDur = 2000,
            onopen = function onopen(wrapper) {
            window.scrollBy(0, 0);
            timeStart = new Date().getTime();
            countdown();
        },
            oncloseBefore = function oncloseBefore() {
            if (closeBox.innerHTML !== 'Закрыть') return false;
            return true;
        },
            onclose = function onclose() {
            try {
                document.body.removeChild(el);
            } catch (e) {};
        },
            countdown = function countdown() {
            var skipTime = Math.ceil((timeDur + timeStart - new Date().getTime()) / 1000);

            /* При открывании расхлопа через кнопку счетчик не нужен */
            if (skipTime > 0 && autostart) {
                closeBox.innerHTML = 'Закрыть через ' + skipTime;
                requestAnimationFrame(countdown);
            } else closeBox.innerHTML = 'Закрыть';
        },
            addPixel = function addPixel() {
            for (var i = 0, j = param.px.length; i < j; i++) {
                var img = document.createElement('IMG'),
                    src = param.px[i];

                img.setAttribute('class', 'px');
                img.setAttribute('src', src + '&rnd=' + new Date().getTime());
                document.body.appendChild(img);
            }
        },
            setCookie = function setCookie(expires) {
            var options = {},
                domains = ['.kinoafisha.spb.ru', '.kinoafisha.msk.ru', '.kinoafisha.info'],
                i = 0,
                l = domains.length;

            options.expires = expires;
            options.path = '/';

            for (i; i < l; i++) {
                options.domain = domains[i];
                _cookie.cookie.setCookie('branding_raskhlop', '1', options);
            }
        };

        //
        addPixel();
        setCookie(3600 * 12 / 2);
        myPopup = uPopup({
            addClass: 'popup-illumination',
            content: el,
            //onopen: onopen,
            //oncloseBefore: oncloseBefore,
            onclose: onclose
        });
        closeBox = myPopup.table.querySelector('.popup_close');
        //closeBox.innerHTML = '';
        closeBox.innerHTML = 'Закрыть';
        closeBox.className = closeBox.className + ' js-active';
    },
        start = function start() {
        if (document.readyState === "complete") {
            install();
        } else {
            window.addEventListener('load', install);
        }
    },
        returnObj = {
        start: start
    };

    //
    param.px = typeof param.px === 'string' ? [param.px] : param.px;

    if (autostart) {
        if (!navigator.cookieEnabled) return false;
        if (window.location.hostname.indexOf('kinoafishaspb.ru') !== -1) return false; /* на деве не показываем расхлоп */
        if (!_cookie.cookie.getCookie('branding_raskhlop') || window.location.pathname.indexOf('/branding/') !== -1) start();
    } else {
        return returnObj;
    }
};

exports.raskhlop = raskhlop;

},{"../modules/cookie":74,"../modules/uPopup":117}],100:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
* */

var ratingBlock = function ratingBlock(el) {
	var box = document.getElementById('illumination'),
	    nextBtn,
	    modules,
	    path = function () {
		var part = APP.vars.isDev ? '/_src/layouts/ratingBlockModule' : '';
		var path = part + '/widget/votes/';
		return path;
	}(),
	    xhr,
	    isSending = false,
	    isFirstPage = true,
	    addModules = function addModules() {
		modules = APP.modules.run(el, 'data-ratingBlock-modules');
		modules.Rating[0].successExec = showNext;
		nextBtn = el.querySelector('[data-ratingBlock-next]');
		nextBtn.addEventListener('click', showNext);
	},
	    destroyModules = function destroyModules() {
		APP.modules.destroy(modules);
		nextBtn.removeEventListener('click', showNext);
		nextBtn = null;
	},
	    showNext = function showNext() {
		if (isFirstPage) {
			var xhrPath = path + '?page=first';
		} else {
			var xhrPath = path;
			if (isSending) return false;
			isSending = true;
			el.classList.add('js-sending');
		}

		//чтобы подгружался нужный модуль
		if (APP.vars.isDev) {
			var sign = isFirstPage ? '&' : '?';
			xhrPath += sign + (APP.vars.isMobile ? 'isMobile=1' : '&isMobile=0');
		}

		xhr = new XMLHttpRequest();
		xhr.open("GET", xhrPath, true);
		xhr.setRequestHeader("X-Request-Ajax", "1");
		xhr.onload = addData;
		xhr.send('');
	},
	    addData = function addData() {
		var answer = JSON.parse(xhr.responseText);
		if (!isFirstPage) {
			destroyModules();
		}
		isFirstPage = false;
		if (!answer.status) {
			el.parentNode.removeChild(el);
		} else {
			el.innerHTML = answer.content;
			addModules();
			isSending = false;
			el.classList.remove('js-sending');
		}
	};
	//
	showNext();
};

exports.ratingBlock = ratingBlock;

},{}],101:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (func) {

	var isDOM,
	    detach = function detach() {
		if (document.addEventListener) {
			document.removeEventListener("DOMContentLoaded", checkDOM, false);
			window.removeEventListener("load", checkDOM, false);
		} else {
			document.detachEvent("onreadystatechange", checkDOM);
			window.detachEvent("onload", checkDOM);
		}
	},
	    checkDOM = function checkDOM() {
		if (document.addEventListener || event.type === "load" || document.readyState === "complete") {
			detach();
			DOMReady();
		}
	},
	    DOMReady = function DOMReady() {
		if (isDOM) return;
		isDOM = true;

		func();
	};

	//			
	if (document.readyState === "complete") {
		setTimeout(DOMReady);
	} else if (document.addEventListener) {
		document.addEventListener("DOMContentLoaded", checkDOM, false);
		window.addEventListener("load", checkDOM, false);
	} else {
		document.attachEvent("onreadystatechange", checkDOM);
		window.attachEvent("onload", checkDOM);

		var top = false;

		try {
			top = window.frameElement == null && document.documentElement;
		} catch (e) {}

		if (top && top.doScroll) {
			(function doScrollCheck() {
				if (!isDOM) {

					try {
						top.doScroll("left");
					} catch (e) {
						return setTimeout(doScrollCheck, 50);
					}

					detach();
					DOMReady();
				}
			})();
		}
	}
};

;
module.exports = exports.default;

},{}],102:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.regAuth = undefined;

var _PopupForm = require('../modules/PopupForm');

var regAuth = function regAuth() {
	var obj = {};

	obj.isAuth = APP.vars.isUserAuth; /* TODO много где используется это свойство */

	if (!APP.vars.isUserAuth) {
		obj.regForm = new _PopupForm.PopupForm({
			ajax: APP.vars.isDev ? '/_src/layouts/popupFormModule/reg/' : '/service/popup/register/',
			name: 'reg',
			//wrapper: document.querySelector('[data-popupForm="reg"]'),
			onsuccess: function onsuccess(data) {
				uPopup.closeAll();
				uPopup({
					content: data.message
				});
			}
		});
		obj.authForm = new _PopupForm.PopupForm({
			ajax: APP.vars.isDev ? '/_src/layouts/popupFormModule/auth/' : '/service/popup/auth/',
			name: 'auth'
			//wrapper: document.querySelector('[data-popupForm="auth"]')
		});
		obj.recoverForm = new _PopupForm.PopupForm({
			ajax: APP.vars.isDev ? '/_src/layouts/popupFormModule/recover/' : '/service/popup/recovery/',
			name: 'recover',
			//wrapper: document.querySelector('[data-popupForm="recover"]'),
			onsuccess: function onsuccess(data) {
				uPopup({
					content: data.message,
					oncloseBefore: function oncloseBefore() {
						uPopup.closeAll();
						obj.authForm.showPopup();
						return true;
					}
				});
			}
		});
	}
	//else localStorage.everLogin = 'login';

	return obj;
};

exports.regAuth = regAuth;

},{"../modules/PopupForm":31}],103:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reloadingIframe = undefined;

var _throttle = require('../modules/throttle');

/* DEPRECATED */

var reloadingIframe = function reloadingIframe(el) {
    var iframe = el.querySelector('[data-reloadingIframe-iframe]'),
        progressEl = el.querySelector('[data-reloadingIframe-progress]'),
        stopTime = false,
        durTimeMs = 30000,
        pastTimeMs = 0,
        startTimeMs = 0,
        checkVisibility = function checkVisibility() {
        var rect = iframe.getBoundingClientRect(),
            midY = rect.top + rect.height / 2,
            midX = rect.left + rect.width / 2;

        return midY > 0 && midX > 0 && midY < (window.innerHeight || document.documentElement.clientHeight) && midX < (window.innerWidth || document.documentElement.clientWidth);
    },
        checkReload = function checkReload() {
        if (checkVisibility()) {
            if (!stopTime) {
                startTimeMs = Date.now();
                var leftTimeMs = durTimeMs - pastTimeMs;
                progressEl.style.cssText = 'width:100%;transition-duration:' + leftTimeMs + 'ms';

                //console.log('Старт интервала, оставшееся время показа', leftTimeMs);

                stopTime = setTimeout(function () {
                    iframe.src = iframe.src;
                    pastTimeMs = 0;
                    progressEl.style.cssText = 'width:0%;transition-duration:0ms';
                    stopTime = false;
                    checkReload();
                    //console.log('Reload iframe', leftTimeMs);
                }, leftTimeMs);
            }
        } else {
            if (stopTime) {
                clearTimeout(stopTime);
                stopTime = false;
                pastTimeMs += Date.now() - startTimeMs;
                progressEl.style.cssText = 'width:' + pastTimeMs / durTimeMs * 100 + '%;transition-duration:0ms';
                //console.log('Остановка pastTimeMs',  pastTimeMs);
            }
        }
    },
        init = function init() {
        (0, _throttle.throttle)('scroll', checkReload);
        (0, _throttle.throttle)('resize', checkReload);
        checkReload();
    };

    //
    if (document.readyState === "complete") {
        init();
    } else {
        window.addEventListener('load', init);
    }
};

exports.reloadingIframe = reloadingIframe;

},{"../modules/throttle":115}],104:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rightContent = undefined;

var _event = require('../modules/event');

/* DEPRECATED */
/* использовалось для правоц колонки */

var rightContent = function rightContent(wrapper) {
    var mainWrapper = document.getElementById('main-frame'),
        leftWrapper = document.getElementById('main-left'),
        rightWrapper = document.getElementById('main-right'),
        firstWrapper = rightWrapper.querySelector('[data-rightContent="first"]'),
        secondWrapper = rightWrapper.querySelector('[data-rightContent="second"]'),
        getHeight = function getHeight(el) {
        var box = el.getBoundingClientRect();
        return box.bottom - box.top;
    },
        leftWrapperHeight = getHeight(leftWrapper),
        rightWrapperHeight = getHeight(rightWrapper),
        clearAdd,
        add = function add() {
        try {
            clearTimeout(clearAdd);
        } catch (e) {}
        clearAdd = setTimeout(function () {
            //checkFixed
            var top = leftWrapper.getBoundingClientRect().top;
            var newScrollTop = window.pageYOffset || document.documentElement.scrollTop - top;

            if (top < 0) {
                if (rightWrapper.className.indexOf('js-fixed') === -1) rightWrapper.className = rightWrapper.className + ' js-fixed';

                //checkMiddle
                var middle = (leftWrapperHeight - rightWrapperHeight) / 2;

                if (-top < leftWrapperHeight / 2) {
                    if (firstWrapper.className.indexOf('js-active') === -1) firstWrapper.className = firstWrapper.className + ' js-active';
                    if (secondWrapper.className.indexOf('js-active') !== -1) secondWrapper.className = secondWrapper.className.replace(/\s*js-active/, '');
                } else {
                    if (secondWrapper.className.indexOf('js-active') === -1) secondWrapper.className = secondWrapper.className + ' js-active';
                    if (firstWrapper.className.indexOf('js-active') !== -1) firstWrapper.className = firstWrapper.className.replace(/\s*js-active/, '');
                }
            } else {
                if (rightWrapper.className.indexOf('js-fixed') !== -1) {
                    rightWrapper.className = rightWrapper.className.replace(/ js-fixed/, '');
                }
                if (firstWrapper.className.indexOf('js-active') === -1) firstWrapper.className = firstWrapper.className + ' js-active';
                if (secondWrapper.className.indexOf('js-active') !== -1) secondWrapper.className = secondWrapper.className.replace(/\s*js-active/, '');
            }
        }, 0);
    };

    setTimeout(function () {
        if (!addEventListener) return false;

        addResizeListener(mainWrapper, function () {
            leftWrapperHeight = getHeight(leftWrapper);
            add();
        });

        _event.event.add(window, 'resize', function () {
            rightWrapperHeight = getHeight(rightWrapper);
            add();
        });

        _event.event.add(window, 'scroll', function () {
            add();
        });

        add();
    }, 0);
};

exports.rightContent = rightContent;

},{"../modules/event":79}],105:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var scheme = function scheme(btn) {
    btn.onclick = function () {
        if (document.body.className.indexOf(' main-reverseScheme') == -1) document.body.className = document.body.className + ' main-reverseScheme';else document.body.className = document.body.className.replace(' main-reverseScheme', '');
        return false;
    };
};

exports.scheme = scheme;

},{}],106:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var scriptonload = function scriptonload(srcAll, func) {
	if (typeof srcAll === 'string') srcAll = [srcAll];

	var total = srcAll.length,
	    counter = 0,
	    checkAll = function checkAll() {
		counter++;
		if (counter === total && func) func();
	},
	    loadCallback = function loadCallback(fname) {
		/* fname - for ie8 */
		if (this.addEventListener) {
			this.removeEventListener('load', loadCallback, false);
			this.isLoading = false;
			checkAll();
		} else if (this.readyState == "complete" || this.readyState == "loaded") {
			this.detachEvent('onreadystatechange', fname);
			this.isLoading = false;
			checkAll();
		}
	},
	    addEvent = function addEvent(script) {
		if (script.addEventListener) {
			script.addEventListener('load', loadCallback, false);
		} else {
			script.attachEvent('onreadystatechange', function fname() {
				loadCallback.call(script, fname);
			});
		}
	},
	    checkArr = function checkArr(arr) {
		var iMax = arr.length,
		    testobj = {},
		    result = false;

		for (var i = 0; i < iMax; i++) {
			result = result || testobj.hasOwnProperty(arr[i]);
			testobj[arr[i]] = arr[i];
		}
		return !result;
	};

	//
	if (!checkArr(srcAll)) {
		var msg = 'scriptonload.js: Scripts are not unique!';
		try {
			console.error(msg);
		} catch (e) {
			alert(msg);
		};
		return;
	}

	for (var i = 0; i < total; i++) {
		var id = 'scriptonload-' + srcAll[i].replace(/[^A-Za-z0-9]/g, '_'),
		    script = document.scripts[id];

		if (script) {
			if (script.isLoading) addEvent(script);else checkAll();
		} else {
			script = document.createElement('script');
			script.setAttribute('async', false);
			script.setAttribute('src', srcAll[i]);
			script.setAttribute('id', id);
			script.isLoading = true;
			addEvent(script);
			document.body.appendChild(script);
		}
	}
};
exports.scriptonload = scriptonload;

},{}],107:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var seriesSwitch = function () {
    _createClass(seriesSwitch, [{
        key: 'setListener',
        value: function setListener(trigger) {
            var openClass = 'seriesSwitch_list-open';

            trigger.addEventListener('click', function (e) {
                if (!trigger.classList.contains(openClass)) {
                    e.preventDefault();
                }

                trigger.classList.toggle(openClass);
            });

            window.addEventListener('click', function (e) {
                if (!e.target.classList.value.indexOf('seriesSwitch') <= 0) {
                    trigger.classList.remove(openClass);
                }
            });
        }
    }]);

    function seriesSwitch(wrapper) {
        _classCallCheck(this, seriesSwitch);

        this.el = wrapper;
        var trigger = wrapper.querySelector('[data-seriesSwitchTrigger]');

        this.setListener(trigger);
    }

    return seriesSwitch;
}();

exports.default = seriesSwitch;
module.exports = exports.default;

},{}],108:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var show = function show(el) {
    var btn = el.querySelector('[data-show-btn]'),
        toggle = function toggle() {
        el.classList.toggle('js-active');
    };

    //
    btn.addEventListener('click', toggle);
};

exports.show = show;

},{}],109:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
* Попап с содержимым
* Показываем по щедчку на кнопку
* Содержимое берется из разметки
* Существуют следующие попапы:
* - как добавлять в избранное
* - socialMarvell
*
* */

var showPopup = function showPopup(el) {
    var param = JSON.parse(el.getAttribute('data-param')),
        name = param.name,
        cls = param.cls || 'popup-middle',
        btnAll = document.querySelectorAll('[data-' + name + '-popupBtn]'),
        show = function show(e) {
        if (e) e.preventDefault();
        uPopup.closeAll();
        uPopup({
            addClass: cls,
            name: name,
            content: el
        });
    },
        addEvent = function addEvent() {
        for (var i = 0, j = btnAll.length; i < j; i++) {
            btnAll[i].addEventListener('click', show);
        }
    },
        checkHash = function checkHash() {
        if (location.hash === '#!' + name) show();
    },
        returnObj = {
        show: show
    };

    //
    addEvent();
    checkHash();
    return returnObj;
};
exports.showPopup = showPopup;

},{}],110:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function showSubContent(btn) {
    var ev;
    var init = function init() {
        if (!APP.objects.SubContent) {
            requestAnimationFrame(init);
        } else {
            var param = JSON.parse(btn.getAttribute('data-param'));
            APP.objects.SubContent.show(btn, ev, param.name, param.targetUid);
        }
    };

    //
    btn.onclick = function (e) {
        ev = e;
        init();
        return false;
    };
}

exports.showSubContent = showSubContent;

},{}],111:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sticky = function sticky(el) {
    var block = el.querySelector('[data-sticky-block]'),
        parent = block.parentNode,
        parentTop = 0,
        totalOffset = 0,
        checkPosition = function checkPosition() {
        var newParentTop = parent.getBoundingClientRect().top,
            initialTop = parent.getBoundingClientRect().top + pageYOffset,
            docHeight = document.documentElement.clientHeight,
            blockHeight = block.getBoundingClientRect().height,
            max = -initialTop,
            min = docHeight - blockHeight - initialTop,
            offset = newParentTop - parentTop,
            translate;

        //
        if (newParentTop >= 0) {
            // Если родительский элемент не в самом начале страницы, то, пока он видим, смещаем блок на величину прокрутки
            totalOffset = -pageYOffset;
        } else {
            if (docHeight >= blockHeight) totalOffset = max; //если блок меньше страницы, то оставляем наверху
            else totalOffset = Math.max(Math.min(max, totalOffset + offset), min);
        }

        block.style.transform = 'translate(0, ' + totalOffset + 'px)';
        parentTop = newParentTop;
    },
        addEvents = function addEvents() {
        APP.helpers.throttle('scroll', checkPosition);
        APP.helpers.throttle('resize', checkPosition);
    };

    //
    setTimeout(function () {
        addEvents();
        checkPosition();
        block.style.position = 'fixed';
        block.style.left = 'auto';
        block.style.top = 'auto';
    }, 15000);
};

exports.sticky = sticky;

},{}],112:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (document, uses, requestAnimationFrame, CACHE, IE9TO11) {
	function embed(svg, g) {
		if (g) {
			var viewBox = g.getAttribute('viewBox'),
			    fragment = document.createDocumentFragment(),
			    clone = g.cloneNode(true);

			if (viewBox) {
				svg.setAttribute('viewBox', viewBox);
			}

			while (clone.childNodes.length) {
				fragment.appendChild(clone.childNodes[0]);
			}

			svg.appendChild(fragment);
		}
	}

	function onload() {
		var xhr = this,
		    x = document.createElement('x'),
		    s = xhr.s;

		x.innerHTML = xhr.responseText;

		xhr.onload = function () {
			s.splice(0).map(function (array) {
				embed(array[0], x.querySelector('#' + array[1].replace(/(\W)/g, '\\$1')));
			});
		};

		xhr.onload();
	}

	function onframe() {
		var use;

		while (use = uses[0]) {
			var svg = use.parentNode,
			    url = use.getAttribute('xlink:href').split('#'),
			    url_root = url[0],
			    url_hash = url[1];

			svg.removeChild(use);

			if (url_root.length) {
				var xhr = CACHE[url_root] = CACHE[url_root] || new XMLHttpRequest();

				if (!xhr.s) {
					xhr.s = [];

					xhr.open('GET', url_root);

					xhr.onload = onload;

					xhr.send();
				}

				xhr.s.push([svg, url_hash]);

				if (xhr.readyState === 4) {
					xhr.onload();
				}
			} else {
				embed(svg, document.getElementById(url_hash));
			}
		}

		requestAnimationFrame(onframe);
	}

	if (IE9TO11) {
		onframe();
	}
};

; /*! svg4everybody v1.0.0 | github.com/jonathantneal/svg4everybody */

module.exports = exports.default;

},{}],113:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!    SWFObject v2.3.20130521 <http://github.com/swfobject/swfobject>
 is released under the MIT License <http://www.opensource.org/licenses/mit-license.php>
 */

/* global ActiveXObject: false */

var swfobject = function () {

	var UNDEF = "undefined",
	    OBJECT = "object",
	    SHOCKWAVE_FLASH = "Shockwave Flash",
	    SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash",
	    FLASH_MIME_TYPE = "application/x-shockwave-flash",
	    EXPRESS_INSTALL_ID = "SWFObjectExprInst",
	    ON_READY_STATE_CHANGE = "onreadystatechange",
	    win = window,
	    doc = document,
	    nav = navigator,
	    plugin = false,
	    domLoadFnArr = [],
	    regObjArr = [],
	    objIdArr = [],
	    listenersArr = [],
	    storedFbContent,
	    storedFbContentId,
	    storedCallbackFn,
	    storedCallbackObj,
	    isDomLoaded = false,
	    isExpressInstallActive = false,
	    dynamicStylesheet,
	    dynamicStylesheetMedia,
	    autoHideShow = true,
	    encodeURIEnabled = false,


	/* Centralized function for browser feature detection
  - User agent string detection is only used when no good alternative is possible
  - Is executed directly for optimal performance
  */
	ua = function () {
		var w3cdom = _typeof(doc.getElementById) !== UNDEF && _typeof(doc.getElementsByTagName) !== UNDEF && _typeof(doc.createElement) !== UNDEF,
		    u = nav.userAgent.toLowerCase(),
		    p = nav.platform.toLowerCase(),
		    windows = p ? /win/.test(p) : /win/.test(u),
		    mac = p ? /mac/.test(p) : /mac/.test(u),
		    webkit = /webkit/.test(u) ? parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : false,
		    // returns either the webkit version or false if not webkit
		ie = nav.appName === "Microsoft Internet Explorer",
		    playerVersion = [0, 0, 0],
		    d = null;
		if (_typeof(nav.plugins) !== UNDEF && _typeof(nav.plugins[SHOCKWAVE_FLASH]) === OBJECT) {
			d = nav.plugins[SHOCKWAVE_FLASH].description;
			// nav.mimeTypes["application/x-shockwave-flash"].enabledPlugin indicates whether plug-ins are enabled or disabled in Safari 3+
			if (d && _typeof(nav.mimeTypes) !== UNDEF && nav.mimeTypes[FLASH_MIME_TYPE] && nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin) {
				plugin = true;
				ie = false; // cascaded feature detection for Internet Explorer
				d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
				playerVersion[0] = toInt(d.replace(/^(.*)\..*$/, "$1"));
				playerVersion[1] = toInt(d.replace(/^.*\.(.*)\s.*$/, "$1"));
				playerVersion[2] = /[a-zA-Z]/.test(d) ? toInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1")) : 0;
			}
		} else if (_typeof(win.ActiveXObject) !== UNDEF) {
			try {
				var a = new ActiveXObject(SHOCKWAVE_FLASH_AX);
				if (a) {
					// a will return null when ActiveX is disabled
					d = a.GetVariable("$version");
					if (d) {
						ie = true; // cascaded feature detection for Internet Explorer
						d = d.split(" ")[1].split(",");
						playerVersion = [toInt(d[0]), toInt(d[1]), toInt(d[2])];
					}
				}
			} catch (e) {}
		}
		return { w3: w3cdom, pv: playerVersion, wk: webkit, ie: ie, win: windows, mac: mac };
	}(),


	/* Cross-browser onDomLoad
  - Will fire an event as soon as the DOM of a web page is loaded
  - Internet Explorer workaround based on Diego Perini's solution: http://javascript.nwbox.com/IEContentLoaded/
  - Regular onload serves as fallback
  */
	onDomLoad = function () {
		if (!ua.w3) {
			return;
		}
		if (_typeof(doc.readyState) !== UNDEF && (doc.readyState === "complete" || doc.readyState === "interactive") || _typeof(doc.readyState) === UNDEF && (doc.getElementsByTagName("body")[0] || doc.body)) {
			// function is fired after onload, e.g. when script is inserted dynamically
			callDomLoadFunctions();
		}
		if (!isDomLoaded) {
			if (_typeof(doc.addEventListener) !== UNDEF) {
				doc.addEventListener("DOMContentLoaded", callDomLoadFunctions, false);
			}
			if (ua.ie) {
				doc.attachEvent(ON_READY_STATE_CHANGE, function detach() {
					if (doc.readyState === "complete") {
						doc.detachEvent(ON_READY_STATE_CHANGE, detach);
						callDomLoadFunctions();
					}
				});
				if (win == top) {
					// if not inside an iframe
					(function checkDomLoadedIE() {
						if (isDomLoaded) {
							return;
						}
						try {
							doc.documentElement.doScroll("left");
						} catch (e) {
							setTimeout(checkDomLoadedIE, 0);
							return;
						}
						callDomLoadFunctions();
					})();
				}
			}
			if (ua.wk) {
				(function checkDomLoadedWK() {
					if (isDomLoaded) {
						return;
					}
					if (!/loaded|complete/.test(doc.readyState)) {
						setTimeout(checkDomLoadedWK, 0);
						return;
					}
					callDomLoadFunctions();
				})();
			}
		}
	}();

	function callDomLoadFunctions() {
		if (isDomLoaded || !document.getElementsByTagName("body")[0]) {
			return;
		}
		try {
			// test if we can really add/remove elements to/from the DOM; we don't want to fire it too early
			var t,
			    span = createElement("span");
			span.style.display = "none"; //hide the span in case someone has styled spans via CSS
			t = doc.getElementsByTagName("body")[0].appendChild(span);
			t.parentNode.removeChild(t);
			t = null; //clear the variables
			span = null;
		} catch (e) {
			return;
		}
		isDomLoaded = true;
		var dl = domLoadFnArr.length;
		for (var i = 0; i < dl; i++) {
			domLoadFnArr[i]();
		}
	}

	function addDomLoadEvent(fn) {
		if (isDomLoaded) {
			fn();
		} else {
			domLoadFnArr[domLoadFnArr.length] = fn; // Array.push() is only available in IE5.5+
		}
	}

	/* Cross-browser onload
  - Based on James Edwards' solution: http://brothercake.com/site/resources/scripts/onload/
  - Will fire an event as soon as a web page including all of its assets are loaded
  */
	function addLoadEvent(fn) {
		if (_typeof(win.addEventListener) !== UNDEF) {
			win.addEventListener("load", fn, false);
		} else if (_typeof(doc.addEventListener) !== UNDEF) {
			doc.addEventListener("load", fn, false);
		} else if (_typeof(win.attachEvent) !== UNDEF) {
			addListener(win, "onload", fn);
		} else if (typeof win.onload === "function") {
			var fnOld = win.onload;
			win.onload = function () {
				fnOld();
				fn();
			};
		} else {
			win.onload = fn;
		}
	}

	/* Detect the Flash Player version for non-Internet Explorer browsers
  - Detecting the plug-in version via the object element is more precise than using the plugins collection item's description:
  a. Both release and build numbers can be detected
  b. Avoid wrong descriptions by corrupt installers provided by Adobe
  c. Avoid wrong descriptions by multiple Flash Player entries in the plugin Array, caused by incorrect browser imports
  - Disadvantage of this method is that it depends on the availability of the DOM, while the plugins collection is immediately available
  */
	function testPlayerVersion() {
		var b = doc.getElementsByTagName("body")[0];
		var o = createElement(OBJECT);
		o.setAttribute("style", "visibility: hidden;");
		o.setAttribute("type", FLASH_MIME_TYPE);
		var t = b.appendChild(o);
		if (t) {
			var counter = 0;
			(function checkGetVariable() {
				if (_typeof(t.GetVariable) !== UNDEF) {
					try {
						var d = t.GetVariable("$version");
						if (d) {
							d = d.split(" ")[1].split(",");
							ua.pv = [toInt(d[0]), toInt(d[1]), toInt(d[2])];
						}
					} catch (e) {
						//t.GetVariable("$version") is known to fail in Flash Player 8 on Firefox
						//If this error is encountered, assume FP8 or lower. Time to upgrade.
						ua.pv = [8, 0, 0];
					}
				} else if (counter < 10) {
					counter++;
					setTimeout(checkGetVariable, 10);
					return;
				}
				b.removeChild(o);
				t = null;
				matchVersions();
			})();
		} else {
			matchVersions();
		}
	}

	/* Perform Flash Player and SWF version matching; static publishing only
  */
	function matchVersions() {
		var rl = regObjArr.length;
		if (rl > 0) {
			for (var i = 0; i < rl; i++) {
				// for each registered object element
				var id = regObjArr[i].id;
				var cb = regObjArr[i].callbackFn;
				var cbObj = { success: false, id: id };
				if (ua.pv[0] > 0) {
					var obj = getElementById(id);
					if (obj) {
						if (hasPlayerVersion(regObjArr[i].swfVersion) && !(ua.wk && ua.wk < 312)) {
							// Flash Player version >= published SWF version: Houston, we have a match!
							setVisibility(id, true);
							if (cb) {
								cbObj.success = true;
								cbObj.ref = _getObjectById(id);
								cbObj.id = id;
								cb(cbObj);
							}
						} else if (regObjArr[i].expressInstall && canExpressInstall()) {
							// show the Adobe Express Install dialog if set by the web page author and if supported
							var att = {};
							att.data = regObjArr[i].expressInstall;
							att.width = obj.getAttribute("width") || "0";
							att.height = obj.getAttribute("height") || "0";
							if (obj.getAttribute("class")) {
								att.styleclass = obj.getAttribute("class");
							}
							if (obj.getAttribute("align")) {
								att.align = obj.getAttribute("align");
							}
							// parse HTML object param element's name-value pairs
							var par = {};
							var p = obj.getElementsByTagName("param");
							var pl = p.length;
							for (var j = 0; j < pl; j++) {
								if (p[j].getAttribute("name").toLowerCase() !== "movie") {
									par[p[j].getAttribute("name")] = p[j].getAttribute("value");
								}
							}
							_showExpressInstall(att, par, id, cb);
						} else {
							// Flash Player and SWF version mismatch or an older Webkit engine that ignores the HTML object element's nested param elements: display fallback content instead of SWF
							displayFbContent(obj);
							if (cb) {
								cb(cbObj);
							}
						}
					}
				} else {
					// if no Flash Player is installed or the fp version cannot be detected we let the HTML object element do its job (either show a SWF or fallback content)
					setVisibility(id, true);
					if (cb) {
						var o = _getObjectById(id); // test whether there is an HTML object element or not
						if (o && _typeof(o.SetVariable) !== UNDEF) {
							cbObj.success = true;
							cbObj.ref = o;
							cbObj.id = o.id;
						}
						cb(cbObj);
					}
				}
			}
		}
	}

	/* Main function
  - Will preferably execute onDomLoad, otherwise onload (as a fallback)
  */
	domLoadFnArr[0] = function () {
		if (plugin) {
			testPlayerVersion();
		} else {
			matchVersions();
		}
	};

	function _getObjectById(objectIdStr) {
		var r = null,
		    o = getElementById(objectIdStr);

		if (o && o.nodeName.toUpperCase() === "OBJECT") {
			//If targeted object is valid Flash file
			if (_typeof(o.SetVariable) !== UNDEF) {
				r = o;
			} else {
				//If SetVariable is not working on targeted object but a nested object is
				//available, assume classic nested object markup. Return nested object.

				//If SetVariable is not working on targeted object and there is no nested object,
				//return the original object anyway. This is probably new simplified markup.

				r = o.getElementsByTagName(OBJECT)[0] || o;
			}
		}

		return r;
	}

	/* Requirements for Adobe Express Install
  - only one instance can be active at a time
  - fp 6.0.65 or higher
  - Win/Mac OS only
  - no Webkit engines older than version 312
  */
	function canExpressInstall() {
		return !isExpressInstallActive && hasPlayerVersion("6.0.65") && (ua.win || ua.mac) && !(ua.wk && ua.wk < 312);
	}

	/* Show the Adobe Express Install dialog
  - Reference: http://www.adobe.com/cfusion/knowledgebase/index.cfm?id=6a253b75
  */
	function _showExpressInstall(att, par, replaceElemIdStr, callbackFn) {

		var obj = getElementById(replaceElemIdStr);

		//Ensure that replaceElemIdStr is really a string and not an element
		replaceElemIdStr = getId(replaceElemIdStr);

		isExpressInstallActive = true;
		storedCallbackFn = callbackFn || null;
		storedCallbackObj = { success: false, id: replaceElemIdStr };

		if (obj) {
			if (obj.nodeName.toUpperCase() === "OBJECT") {
				// static publishing
				storedFbContent = abstractFbContent(obj);
				storedFbContentId = null;
			} else {
				// dynamic publishing
				storedFbContent = obj;
				storedFbContentId = replaceElemIdStr;
			}
			att.id = EXPRESS_INSTALL_ID;
			if (_typeof(att.width) === UNDEF || !/%$/.test(att.width) && toInt(att.width) < 310) {
				att.width = "310";
			}
			if (_typeof(att.height) === UNDEF || !/%$/.test(att.height) && toInt(att.height) < 137) {
				att.height = "137";
			}
			var pt = ua.ie ? "ActiveX" : "PlugIn",
			    fv = "MMredirectURL=" + encodeURIComponent(win.location.toString().replace(/&/g, "%26")) + "&MMplayerType=" + pt + "&MMdoctitle=" + encodeURIComponent(doc.title.slice(0, 47) + " - Flash Player Installation");
			if (_typeof(par.flashvars) !== UNDEF) {
				par.flashvars += "&" + fv;
			} else {
				par.flashvars = fv;
			}
			// IE only: when a SWF is loading (AND: not available in cache) wait for the readyState of the object element to become 4 before removing it,
			// because you cannot properly cancel a loading SWF file without breaking browser load references, also obj.onreadystatechange doesn't work
			if (ua.ie && obj.readyState != 4) {
				var newObj = createElement("div");
				replaceElemIdStr += "SWFObjectNew";
				newObj.setAttribute("id", replaceElemIdStr);
				obj.parentNode.insertBefore(newObj, obj); // insert placeholder div that will be replaced by the object element that loads expressinstall.swf
				obj.style.display = "none";
				_removeSWF(obj); //removeSWF accepts elements now
			}
			_createSWF(att, par, replaceElemIdStr);
		}
	}

	/* Functions to abstract and display fallback content
  */
	function displayFbContent(obj) {
		if (ua.ie && obj.readyState != 4) {
			// IE only: when a SWF is loading (AND: not available in cache) wait for the readyState of the object element to become 4 before removing it,
			// because you cannot properly cancel a loading SWF file without breaking browser load references, also obj.onreadystatechange doesn't work
			obj.style.display = "none";
			var el = createElement("div");
			obj.parentNode.insertBefore(el, obj); // insert placeholder div that will be replaced by the fallback content
			el.parentNode.replaceChild(abstractFbContent(obj), el);
			_removeSWF(obj); //removeSWF accepts elements now
		} else {
			obj.parentNode.replaceChild(abstractFbContent(obj), obj);
		}
	}

	function abstractFbContent(obj) {
		var ac = createElement("div");
		if (ua.win && ua.ie) {
			ac.innerHTML = obj.innerHTML;
		} else {
			var nestedObj = obj.getElementsByTagName(OBJECT)[0];
			if (nestedObj) {
				var c = nestedObj.childNodes;
				if (c) {
					var cl = c.length;
					for (var i = 0; i < cl; i++) {
						if (!(c[i].nodeType == 1 && c[i].nodeName === "PARAM") && !(c[i].nodeType == 8)) {
							ac.appendChild(c[i].cloneNode(true));
						}
					}
				}
			}
		}
		return ac;
	}

	function createIeObject(url, paramStr) {
		var div = createElement("div");
		div.innerHTML = "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000'><param name='movie' value='" + url + "'>" + paramStr + "</object>";
		return div.firstChild;
	}

	/* Cross-browser dynamic SWF creation
  */
	function _createSWF(attObj, parObj, id) {
		var r,
		    el = getElementById(id);
		id = getId(id); // ensure id is truly an ID and not an element

		if (ua.wk && ua.wk < 312) {
			return r;
		}

		if (el) {
			var o = ua.ie ? createElement("div") : createElement(OBJECT),
			    attr,
			    attrLower,
			    param;

			if (_typeof(attObj.id) === UNDEF) {
				// if no 'id' is defined for the object element, it will inherit the 'id' from the fallback content
				attObj.id = id;
			}

			//Add params
			for (param in parObj) {
				//filter out prototype additions from other potential libraries and IE specific param element
				if (parObj.hasOwnProperty(param) && param.toLowerCase() !== "movie") {
					createObjParam(o, param, parObj[param]);
				}
			}

			//Create IE object, complete with param nodes
			if (ua.ie) {
				o = createIeObject(attObj.data, o.innerHTML);
			}

			//Add attributes to object
			for (attr in attObj) {
				if (attObj.hasOwnProperty(attr)) {
					// filter out prototype additions from other potential libraries
					attrLower = attr.toLowerCase();

					// 'class' is an ECMA4 reserved keyword
					if (attrLower === "styleclass") {
						o.setAttribute("class", attObj[attr]);
					} else if (attrLower !== "classid" && attrLower !== "data") {
						o.setAttribute(attr, attObj[attr]);
					}
				}
			}

			if (ua.ie) {
				objIdArr[objIdArr.length] = attObj.id; // stored to fix object 'leaks' on unload (dynamic publishing only)
			} else {
				o.setAttribute("type", FLASH_MIME_TYPE);
				o.setAttribute("data", attObj.data);
			}

			el.parentNode.replaceChild(o, el);
			r = o;
		}

		return r;
	}

	function createObjParam(el, pName, pValue) {
		var p = createElement("param");
		p.setAttribute("name", pName);
		p.setAttribute("value", pValue);
		el.appendChild(p);
	}

	/* Cross-browser SWF removal
  - Especially needed to safely and completely remove a SWF in Internet Explorer
  */
	function _removeSWF(id) {
		var obj = getElementById(id);
		if (obj && obj.nodeName.toUpperCase() === "OBJECT") {
			if (ua.ie) {
				obj.style.display = "none";
				(function removeSWFInIE() {
					if (obj.readyState == 4) {
						//This step prevents memory leaks in Internet Explorer
						for (var i in obj) {
							if (typeof obj[i] === "function") {
								obj[i] = null;
							}
						}
						obj.parentNode.removeChild(obj);
					} else {
						setTimeout(removeSWFInIE, 10);
					}
				})();
			} else {
				obj.parentNode.removeChild(obj);
			}
		}
	}

	function isElement(id) {
		return id && id.nodeType && id.nodeType === 1;
	}

	function getId(thing) {
		return isElement(thing) ? thing.id : thing;
	}

	/* Functions to optimize JavaScript compression
  */
	function getElementById(id) {

		//Allow users to pass an element OR an element's ID
		if (isElement(id)) {
			return id;
		}

		var el = null;
		try {
			el = doc.getElementById(id);
		} catch (e) {}
		return el;
	}

	function createElement(el) {
		return doc.createElement(el);
	}

	//To aid compression; replaces 14 instances of pareseInt with radix
	function toInt(str) {
		return parseInt(str, 10);
	}

	/* Updated attachEvent function for Internet Explorer
  - Stores attachEvent information in an Array, so on unload the detachEvent functions can be called to avoid memory leaks
  */
	function addListener(target, eventType, fn) {
		target.attachEvent(eventType, fn);
		listenersArr[listenersArr.length] = [target, eventType, fn];
	}

	/* Flash Player and SWF content version matching
  */
	function hasPlayerVersion(rv) {
		rv += ""; //Coerce number to string, if needed.
		var pv = ua.pv,
		    v = rv.split(".");
		v[0] = toInt(v[0]);
		v[1] = toInt(v[1]) || 0; // supports short notation, e.g. "9" instead of "9.0.0"
		v[2] = toInt(v[2]) || 0;
		return pv[0] > v[0] || pv[0] == v[0] && pv[1] > v[1] || pv[0] == v[0] && pv[1] == v[1] && pv[2] >= v[2] ? true : false;
	}

	/* Cross-browser dynamic CSS creation
  - Based on Bobby van der Sluis' solution: http://www.bobbyvandersluis.com/articles/dynamicCSS.php
  */
	function _createCSS(sel, decl, media, newStyle) {
		var h = doc.getElementsByTagName("head")[0];
		if (!h) {
			return;
		} // to also support badly authored HTML pages that lack a head element
		var m = typeof media === "string" ? media : "screen";
		if (newStyle) {
			dynamicStylesheet = null;
			dynamicStylesheetMedia = null;
		}
		if (!dynamicStylesheet || dynamicStylesheetMedia != m) {
			// create dynamic stylesheet + get a global reference to it
			var s = createElement("style");
			s.setAttribute("type", "text/css");
			s.setAttribute("media", m);
			dynamicStylesheet = h.appendChild(s);
			if (ua.ie && _typeof(doc.styleSheets) !== UNDEF && doc.styleSheets.length > 0) {
				dynamicStylesheet = doc.styleSheets[doc.styleSheets.length - 1];
			}
			dynamicStylesheetMedia = m;
		}
		// add style rule
		if (dynamicStylesheet) {
			if (_typeof(dynamicStylesheet.addRule) !== UNDEF) {
				dynamicStylesheet.addRule(sel, decl);
			} else if (_typeof(doc.createTextNode) !== UNDEF) {
				dynamicStylesheet.appendChild(doc.createTextNode(sel + " {" + decl + "}"));
			}
		}
	}

	function setVisibility(id, isVisible) {
		if (!autoHideShow) {
			return;
		}
		var v = isVisible ? "visible" : "hidden",
		    el = getElementById(id);
		if (isDomLoaded && el) {
			el.style.visibility = v;
		} else if (typeof id === "string") {
			_createCSS("#" + id, "visibility:" + v);
		}
	}

	/* Filter to avoid XSS attacks
  */
	function urlEncodeIfNecessary(s) {
		var regex = /[\\\"<>\.;]/;
		var hasBadChars = regex.exec(s) !== null;
		return hasBadChars && (typeof encodeURIComponent === "undefined" ? "undefined" : _typeof(encodeURIComponent)) !== UNDEF ? encodeURIComponent(s) : s;
	}

	/* Release memory to avoid memory leaks caused by closures, fix hanging audio/video threads and force open sockets/NetConnections to disconnect (Internet Explorer only)
  */
	var cleanup = function () {
		if (ua.ie) {
			window.attachEvent("onunload", function () {
				// remove listeners to avoid memory leaks
				var ll = listenersArr.length;
				for (var i = 0; i < ll; i++) {
					listenersArr[i][0].detachEvent(listenersArr[i][1], listenersArr[i][2]);
				}
				// cleanup dynamically embedded objects to fix audio/video threads and force open sockets and NetConnections to disconnect
				var il = objIdArr.length;
				for (var j = 0; j < il; j++) {
					_removeSWF(objIdArr[j]);
				}
				// cleanup library's main closures to avoid memory leaks
				for (var k in ua) {
					ua[k] = null;
				}
				ua = null;
				for (var l in swfobject) {
					swfobject[l] = null;
				}
				exports.swfobject = swfobject = null;
			});
		}
	}();

	return {
		/* Public API
   - Reference: http://code.google.com/p/swfobject/wiki/documentation
   */
		registerObject: function registerObject(objectIdStr, swfVersionStr, xiSwfUrlStr, callbackFn) {
			if (ua.w3 && objectIdStr && swfVersionStr) {
				var regObj = {};
				regObj.id = objectIdStr;
				regObj.swfVersion = swfVersionStr;
				regObj.expressInstall = xiSwfUrlStr;
				regObj.callbackFn = callbackFn;
				regObjArr[regObjArr.length] = regObj;
				setVisibility(objectIdStr, false);
			} else if (callbackFn) {
				callbackFn({ success: false, id: objectIdStr });
			}
		},

		getObjectById: function getObjectById(objectIdStr) {
			if (ua.w3) {
				return _getObjectById(objectIdStr);
			}
		},

		embedSWF: function embedSWF(swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) {

			var id = getId(replaceElemIdStr),
			    callbackObj = { success: false, id: id };

			if (ua.w3 && !(ua.wk && ua.wk < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr) {
				setVisibility(id, false);
				addDomLoadEvent(function () {
					widthStr += ""; // auto-convert to string
					heightStr += "";
					var att = {};
					if (attObj && (typeof attObj === "undefined" ? "undefined" : _typeof(attObj)) === OBJECT) {
						for (var i in attObj) {
							// copy object to avoid the use of references, because web authors often reuse attObj for multiple SWFs
							att[i] = attObj[i];
						}
					}
					att.data = swfUrlStr;
					att.width = widthStr;
					att.height = heightStr;
					var par = {};
					if (parObj && (typeof parObj === "undefined" ? "undefined" : _typeof(parObj)) === OBJECT) {
						for (var j in parObj) {
							// copy object to avoid the use of references, because web authors often reuse parObj for multiple SWFs
							par[j] = parObj[j];
						}
					}
					if (flashvarsObj && (typeof flashvarsObj === "undefined" ? "undefined" : _typeof(flashvarsObj)) === OBJECT) {
						for (var k in flashvarsObj) {
							// copy object to avoid the use of references, because web authors often reuse flashvarsObj for multiple SWFs
							if (flashvarsObj.hasOwnProperty(k)) {

								var key = encodeURIEnabled ? encodeURIComponent(k) : k,
								    value = encodeURIEnabled ? encodeURIComponent(flashvarsObj[k]) : flashvarsObj[k];

								if (_typeof(par.flashvars) !== UNDEF) {
									par.flashvars += "&" + key + "=" + value;
								} else {
									par.flashvars = key + "=" + value;
								}
							}
						}
					}
					if (hasPlayerVersion(swfVersionStr)) {
						// create SWF
						var obj = _createSWF(att, par, replaceElemIdStr);
						if (att.id == id) {
							setVisibility(id, true);
						}
						callbackObj.success = true;
						callbackObj.ref = obj;
						callbackObj.id = obj.id;
					} else if (xiSwfUrlStr && canExpressInstall()) {
						// show Adobe Express Install
						att.data = xiSwfUrlStr;
						_showExpressInstall(att, par, replaceElemIdStr, callbackFn);
						return;
					} else {
						// show fallback content
						setVisibility(id, true);
					}
					if (callbackFn) {
						callbackFn(callbackObj);
					}
				});
			} else if (callbackFn) {
				callbackFn(callbackObj);
			}
		},

		switchOffAutoHideShow: function switchOffAutoHideShow() {
			autoHideShow = false;
		},

		enableUriEncoding: function enableUriEncoding(bool) {
			encodeURIEnabled = (typeof bool === "undefined" ? "undefined" : _typeof(bool)) === UNDEF ? true : bool;
		},

		ua: ua,

		getFlashPlayerVersion: function getFlashPlayerVersion() {
			return { major: ua.pv[0], minor: ua.pv[1], release: ua.pv[2] };
		},

		hasFlashPlayerVersion: hasPlayerVersion,

		createSWF: function createSWF(attObj, parObj, replaceElemIdStr) {
			if (ua.w3) {
				return _createSWF(attObj, parObj, replaceElemIdStr);
			} else {
				return undefined;
			}
		},

		showExpressInstall: function showExpressInstall(att, par, replaceElemIdStr, callbackFn) {
			if (ua.w3 && canExpressInstall()) {
				_showExpressInstall(att, par, replaceElemIdStr, callbackFn);
			}
		},

		removeSWF: function removeSWF(objElemIdStr) {
			if (ua.w3) {
				_removeSWF(objElemIdStr);
			}
		},

		createCSS: function createCSS(selStr, declStr, mediaStr, newStyleBoolean) {
			if (ua.w3) {
				_createCSS(selStr, declStr, mediaStr, newStyleBoolean);
			}
		},

		addDomLoadEvent: addDomLoadEvent,

		addLoadEvent: addLoadEvent,

		getQueryParamValue: function getQueryParamValue(param) {
			var q = doc.location.search || doc.location.hash;
			if (q) {
				if (/\?/.test(q)) {
					q = q.split("?")[1];
				} // strip question mark
				if (!param) {
					return urlEncodeIfNecessary(q);
				}
				var pairs = q.split("&");
				for (var i = 0; i < pairs.length; i++) {
					if (pairs[i].substring(0, pairs[i].indexOf("=")) == param) {
						return urlEncodeIfNecessary(pairs[i].substring(pairs[i].indexOf("=") + 1));
					}
				}
			}
			return "";
		},

		// For internal usage only
		expressInstallCallback: function expressInstallCallback() {
			if (isExpressInstallActive) {
				var obj = getElementById(EXPRESS_INSTALL_ID);
				if (obj && storedFbContent) {
					obj.parentNode.replaceChild(storedFbContent, obj);
					if (storedFbContentId) {
						setVisibility(storedFbContentId, true);
						if (ua.ie) {
							storedFbContent.style.display = "block";
						}
					}
					if (storedCallbackFn) {
						storedCallbackFn(storedCallbackObj);
					}
				}
				isExpressInstallActive = false;
			}
		},

		version: "2.3"

	};
}();
exports.swfobject = swfobject;

},{}],114:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var templateEngine = function templateEngine(html, options) {
    var re = /<%([^%>]+)?%>/g;
    var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;

    var code = 'var r=[];\n';
    var cursor = 0;
    var match = void 0;

    var add = function add(line, js) {
        js ? code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n' : code += line !== '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '';
        return add;
    };
    while (match = re.exec(html)) {
        add(html.slice(cursor, match.index))(match[1], true);
        cursor = match.index + match[0].length;
    }
    add(html.substr(cursor, html.length - cursor));
    code += 'return r.join("");';

    return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
};
exports.templateEngine = templateEngine;

},{}],115:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
function throttle(type, callback, obj) {
	obj = obj || window;
	var running = false;
	var func = function func() {
		if (running) {
			return;
		}
		running = true;
		requestAnimationFrame(function () {
			callback();
			running = false;
		});
	};
	obj.addEventListener(type, func);
}
exports.throttle = throttle;

},{}],116:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var thumbGallery = function thumbGallery(wrapper) {
    function swipedetect(param) {
        var touchsurface = param.el,
            startX,
            startY,
            distX,
            distY,
            threshold = 50,
            //required min distance traveled to be considered swipe
        restraint = 100,
            // maximum distance allowed at the same time in perpendicular direction
        allowedTime = 300,
            // maximum time allowed to travel that distance
        elapsedTime,
            startTime,
            onStart = param.onStart || function () {},
            onMove = param.onMove || function () {},
            onEnd = param.onEnd || function () {};

        touchsurface.addEventListener("touchstart", function (e) {
            var touchobj = e.changedTouches[0];
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = new Date().getTime(); // record time when finger first makes contact with surface
            onStart({ 'startX': startX, 'startY': startY });
            //e.preventDefault();
        }, false);

        touchsurface.addEventListener("touchmove", function (e) {
            var touchobj = e.changedTouches[0];
            distX = touchobj.pageX - startX;
            distY = touchobj.pageY - startY;
            onMove({ 'distX': distX, 'distY': distY });
            e.preventDefault(); // prevent scrolling when inside DIV
        }, false);

        touchsurface.addEventListener("touchend", function (e) {
            var touchobj = e.changedTouches[0];
            var swipeData = { 'swipe': false };
            distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
            distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
            elapsedTime = new Date().getTime() - startTime; // get time elapsed

            if (elapsedTime <= allowedTime) {
                // first condition for awipe met
                if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                    // 2nd condition for horizontal swipe met
                    swipeData.swipe = distX < 0 ? "left" : "right"; // if dist traveled is negative, it indicates left swipe
                } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
                    // 2nd condition for vertical swipe met
                    swipeData.swipe = distY < 0 ? "up" : "down"; // if dist traveled is negative, it indicates up swipe
                }
            }

            swipeData.distX = distX;
            swipeData.distY = distY;

            onEnd(swipeData);
            //e.preventDefault();
        }, false);
    };

    var frame = wrapper.querySelector('[data-thumbGallery-frame]'),
        navTag = wrapper.querySelector('[data-thumbGallery-nav]'),
        btnLeft = wrapper.querySelector('[data-thumbGallery-btnLeft]'),
        btnRight = wrapper.querySelector('[data-thumbGallery-btnRight]'),
        param = JSON.parse(wrapper.getAttribute('data-param')),
        itemAll = frame.querySelectorAll('[data-thumbGallery-item]'),
        /* TODO ?? */
    previewAll = navTag ? navTag.querySelectorAll('[data-thumbGallery-preview]') : undefined,
        curInd = 0,
        curNavInd = 0,
        maxInd = itemAll.length - 1,
        stopPlay = false,
        intervarDur = 5000,
        transitionDur = 180,
        isAnimated = false,
        offset = 0,
        //величина смещения галереи
    init = function init() {
        if (previewAll) {
            previewAll.forEach(function (preview, ind) {
                preview.addEventListener('click', function (e) {
                    //move(e, ind);
                });
            });
        }

        frame.addEventListener("transitionend", endTransition, false);

        if (btnLeft) {
            btnLeft.addEventListener('click', onLeft);
            btnRight.addEventListener('click', onRight);
        }

        if ('ontouchstart' in window) {
            swipedetect({
                el: frame,
                onStart: startByTouch,
                onMove: offsetByTouch,
                onEnd: endByTouch
            });
        }

        checkEdges();
        if (param.autoPlay) stopPlay = setInterval(onRight, intervarDur);

        wrapper.classList.add('js-active');
    },
        abort = function abort() {
        if (xhr) xhr.abort();
    },
        onLeft = function onLeft(e) {
        var nextInd = curInd - 1;
        var nextNavInd = curNavInd - 1;
        if (nextInd < 0) nextInd = maxInd;
        if (nextNavInd < 0) nextNavInd = maxInd;
        move(e, nextInd, nextNavInd);
        sendStat('left');
    },
        onRight = function onRight(e) {
        var nextInd = curInd + 1;
        var nextNavInd = curNavInd + 1;
        if (nextInd > maxInd) nextInd = 0;
        if (nextNavInd > maxInd) nextNavInd = 0;
        move(e, nextInd, nextNavInd);
        sendStat('right');
    },
        move = function move(e, nextInd, nextNavInd) {
        if (e && stopPlay) {
            //if user clicking everywhere - stop autoplay
            clearInterval(stopPlay);
            stopPlay = false;
        }

        if (isAnimated) return;

        if (previewAll) {
            previewAll[curNavInd].classList.remove('js-active');
            previewAll[nextNavInd].classList.add('js-active');
        }

        frame.style.transitionDuration = transitionDur + 'ms';
        isAnimated = true;

        offset = parseInt('-' + frame.getBoundingClientRect().width * nextInd);
        frame.style.transform = 'translate(' + offset + 'px, 0px)';

        curNavInd = nextNavInd;
        curInd = nextInd;
    },
        sendStat = function sendStat(dir) {
        var stat = param.stat;
        try {
            gtag('event', stat.name, {
                'event_category': stat.category,
                'event_label': dir
            });
        } catch (e) {}
    },
        endTransition = function endTransition() {
        checkEdges();
        isAnimated = false;
        frame.style.transitionDuration = '0ms';
    },
        startByTouch = function startByTouch(data) {
        if (stopPlay) {
            clearInterval(stopPlay);
            stopPlay = false;
        }
    },
        offsetByTouch = function offsetByTouch(data) {
        if (isAnimated) return;
        var tempOffset = offset + data.distX;
        frame.style.transform = 'translate(' + tempOffset + 'px, 0px)';
    },
        endByTouch = function endByTouch(data) {
        if (data.swipe == 'left') {
            onRight();
        } else if (data.swipe == 'right') {
            onLeft();
        } else {
            frame.style.transform = 'translate(' + offset + 'px, 0px)';
        }
    },
        checkEdges = function checkEdges() {
        /*
        * Проверяем крайние или нет элементы.
        * Если крайние - доставляем с края другие, чтобы красиво мотать по кругу
        * */

        if (curInd == maxInd) {
            frame.appendChild(itemAll[0]);
            curInd--;
            offset = parseInt('-' + frame.getBoundingClientRect().width * curInd);
            frame.style.transform = 'translate(' + offset + 'px, 0px)';
            itemAll = frame.querySelectorAll('[data-thumbGallery-item]');
        } else if (curInd == 0) {
            frame.insertBefore(itemAll[maxInd], itemAll[0]);
            curInd++;
            offset = parseInt('-' + frame.getBoundingClientRect().width * curInd);
            frame.style.transform = 'translate(' + offset + 'px, 0px)';
            itemAll = frame.querySelectorAll('[data-thumbGallery-item]');
        }
    },
        destroy = function destroy() {
        abort();

        /* TODO touch */
        if (btnLeft) {
            btnLeft.removeEventListener('click', onLeft);
            btnRight.removeEventListener('click', onRight);
        }
    },
        returnObj = {
        destroy: destroy
    };

    //
    if (maxInd > 0) init();
    return returnObj;
};

exports.thumbGallery = thumbGallery;

},{}],117:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.uPopupFunc = undefined;

var _Popup = require('../modules/Popup');

var uPopupFunc = function uPopupFunc(root, doc) {
	if (root.uPopup) return false;

	var uPopup = function uPopup(param) {
		if (!param.name) param.name = 'popup-' + new Date().getTime();
		if (!uPopup.all[param.name]) uPopup.all[param.name] = new _Popup.Popup(param);
		uPopup.all[param.name].open();
		return uPopup.all[param.name];
	};

	uPopup.count = 0;
	uPopup.all = {};
	uPopup.closeAll = function () {
		for (var name in uPopup.all) {
			uPopup.all[name].close();
		}
	};

	root.uPopup = uPopup;
};

exports.uPopupFunc = uPopupFunc;

},{"../modules/Popup":30}],118:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var userAgent = function userAgent() {
	var agent = {
		os: undefined,
		device: undefined
	},
	    define = function define() {
		var agentAll = ['ipod', 'iphone', 'ipad', 'android'],
		    i = 0;

		for (i; i < agentAll.length; i++) {
			var re = new RegExp(agentAll[i], 'i');
			if (re.test(navigator.userAgent)) {
				agent.device = agentAll[i];

				if (agentAll[i] === 'android') agent.os = 'android';else agent.os = 'ios';

				break;
			}
		}
	};

	//
	define();
	return agent;
};

exports.userAgent = userAgent;

},{}],119:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.vk = undefined;

var _scriptonload = require('../modules/scriptonload');

var vk = function vk(el) {
	var init = function init() {
		var uid = el.getAttribute('id');
		var param = JSON.parse(el.getAttribute('data-param'));
		var height = param && param.height ? param.height : 300;
		VK.Widgets.Group(uid, { mode: 0, width: "300", height: height, color1: '141414', color2: 'ffffff', color3: '5B7FA6' }, 52241390);
	};

	(0, _scriptonload.scriptonload)('//vk.com/js/api/openapi.js', init);
};

exports.vk = vk;

},{"../modules/scriptonload":106}],120:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.xhrForm = undefined;

var _Form = require('../modules/Form');

/*
* Модуль работает с формами, загружаемыми в попап
* В зависимости от типа формы, существуют различные варианты при успешном ответе и ошибке
* Например, при успешной регистрациии мы перегружаем страницу
* А при успешной отправке письма в поддержку - просто выводим сообщение бо успешной отправке
* Тип формы определеятся в атрибуте data-param
* */

var xhrForm = function xhrForm(wrapper) {
    var param = function () {
        var attr = wrapper.getAttribute('data-param');
        return attr ? JSON.parse(attr) : {};
    }();

    var onsuccess = function onsuccess(data) {
        if (param.type === 'reload') location.replace(location.protocol + '//' + location.host + location.pathname);else {
            formObj.resetCaptcha();
            uPopup.closeAll();
            uPopup({
                content: data.message
            });
        }
    };

    var onerror = function onerror(data) {
        formObj.resetCaptcha();
        uPopup({
            content: data.message
        });
    };

    var formObj = new _Form.Form({
        wrapper: wrapper,
        onsuccess: onsuccess,
        onerror: onerror
    });

    var destroy = function destroy() {
        formObj.destroy();
    };

    var returnObj = {
        destroy: destroy
    };

    return returnObj;
};

exports.xhrForm = xhrForm;

},{"../modules/Form":18}],121:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.yt = undefined;

var _scriptonload = require('../modules/scriptonload');

var yt = function yt() {
	var init = function init() {};

	(0, _scriptonload.scriptonload)('https://apis.google.com/js/platform.js', init);
};

exports.yt = yt;

},{"../modules/scriptonload":106}]},{},[1])

